// Generated by avro-typescript-cli
// Schemas:
//   ExperienceServedFallback:19
//   ExperienceInViewFlyer:19
//   ExperienceScrolledBeyondSlot:14
//   StorefrontHeartbeatFlyer:20
//   StorefrontOpenFlyer:19
//   StorefrontEngagedVisitFlyer:19
//   StorefrontImpressionFlyerItem:18
//   StorefrontClickFlyerItemDetails:18
//   StorefrontClickSeeFullFlyer:18
//   StorefrontClickSkipFlyer:18
//   ItemDetailsClickTransferToMerchant:18
//   ItemDetailsClickSave:18
//   AppInitialized:18
//   DecisionRequestContext:16
//   DecisionRequestMade:18
//   DecisionResponseSuccess:19
//   DecisionResponseFailure:18
//   LandingHeartbeatPage:17
//   LandingInView:17
//   LandingOpenPage:17
//   LandingItemClick:22
//   LandingItemClickSave:22
//   LandingItemClickTransferToMerchant:22
//   LandingEngagedVisitPage:17
//   LandingImpressionItem:22
//   LandingClickSeeFullPage:17
//   SurveyOpen:19
//   SurveyClick:19
//   ExperienceMeasuredTest:15
//   SlotImpressionExperience:16
//   BiddingHeaderLoaded:11
//   BiddingCallBidder:11
//   BiddingResponseSuccess:14
//   BiddingResponseFailure:12
//   BiddingWonAuction:14
//   BiddingBidRequest:12
//   BiddingServerSubmitBid:13
//   BoomboxRulesMatch:10
//   FixedHeightPageChanged:3
//   FixedHeightPageFiltered:4
//   DynamicModuleClickBannerSection:3
//   DynamicModuleClickEcomItemDetails:5
//   DynamicModuleClickEcomItemTransferToMerchant:3
//   DynamicModuleClickCouponDetails:3
//   DynamicModuleClickCouponTransferToMerchant:3
//   DynamicModuleClickMerchantItemTransferToMerchant:3
//   DynamicModuleClickMerchantItemDetails:3
//   DynamicModuleImpressionCoupon:2
//   DynamicModuleImpressionEcomItem:2
//   DynamicModuleImpressionMerchantItem:2
//   DynamicModuleVideoAdHeartbeat:2
//   DynamicModuleVideoAdImpression:2
//   DynamicModuleInView:2
//   FrontendBotFiltered:2
//   DynamicModuleRenderStatus:2
//   ContainerViewableImpression:1
var ApplicationID;
(function(ApplicationID) {
    ApplicationID["FlippApp"] = "FlippApp";
    ApplicationID["ReebeeApp"] = "ReebeeApp";
    ApplicationID["FlippWeb"] = "FlippWeb";
    ApplicationID["Flyers"] = "Flyers";
    ApplicationID["Hosted"] = "Hosted";
    ApplicationID["GMA"] = "GMA";
    ApplicationID["Editorials"] = "Editorials";
    ApplicationID["Hero"] = "Hero";
    ApplicationID["ShopperPlatform"] = "ShopperPlatform";
    ApplicationID["FlippPlatformSdk"] = "FlippPlatformSdk";
    ApplicationID["Other"] = "Other";
    ApplicationID["FlippAvroDefault"] = "FlippAvroDefault";
})(ApplicationID || (ApplicationID = {}));
var Environment$1;
(function(Environment) {
    Environment["Prod"] = "Prod";
    Environment["Dev"] = "Dev";
    Environment["Test"] = "Test";
})(Environment$1 || (Environment$1 = {}));
var ShopperPlatformUx;
(function(ShopperPlatformUx) {
    ShopperPlatformUx["StorefrontInline"] = "StorefrontInline";
    ShopperPlatformUx["StorefrontExpanded"] = "StorefrontExpanded";
    ShopperPlatformUx["UlpInline"] = "UlpInline";
    ShopperPlatformUx["UlpExpanded"] = "UlpExpanded";
})(ShopperPlatformUx || (ShopperPlatformUx = {}));
var ShopperPlatformAdView;
(function(ShopperPlatformAdView) {
    ShopperPlatformAdView["Default"] = "Default";
    ShopperPlatformAdView["Safeframe"] = "Safeframe";
    ShopperPlatformAdView["Enabler"] = "Enabler";
    ShopperPlatformAdView["WebView"] = "WebView";
})(ShopperPlatformAdView || (ShopperPlatformAdView = {}));
var ExperienceType$1;
(function(ExperienceType) {
    ExperienceType["Compact"] = "Compact";
    ExperienceType["Classic"] = "Classic";
    ExperienceType["MultiStandard"] = "MultiStandard";
    ExperienceType["FixedHeight"] = "FixedHeight";
    ExperienceType["VideoAd"] = "VideoAd";
    ExperienceType["Unknown"] = "Unknown";
})(ExperienceType$1 || (ExperienceType$1 = {}));
var Platform;
(function(Platform) {
    Platform["Desktop"] = "Desktop";
    Platform["Mobile"] = "Mobile";
    Platform["Tablet"] = "Tablet";
})(Platform || (Platform = {}));
var Country;
(function(Country) {
    Country["CA"] = "CA";
    Country["US"] = "US";
    Country["Other"] = "Other";
})(Country || (Country = {}));
var ItemType;
(function(ItemType) {
    ItemType["Flyer"] = "Flyer";
    ItemType["Merchant"] = "Merchant";
    ItemType["Ecom"] = "Ecom";
})(ItemType || (ItemType = {}));
var ExperienceServedFallbackSchemaId = 8706;
var ExperienceInViewFlyerSchemaId = 8703;
var ExperienceScrolledBeyondSlotSchemaId = 8705;
var StorefrontHeartbeatFlyerSchemaId = 8727;
var StorefrontOpenFlyerSchemaId = 8729;
var StorefrontEngagedVisitFlyerSchemaId = 8726;
var StorefrontImpressionFlyerItemSchemaId = 8728;
var StorefrontClickFlyerItemDetailsSchemaId = 8723;
var StorefrontClickSeeFullFlyerSchemaId = 8724;
var StorefrontClickSkipFlyerSchemaId = 8725;
var ItemDetailsClickTransferToMerchantSchemaId = 8711;
var ItemDetailsClickSaveSchemaId = 8710;
var AppInitializedSchemaId = 8674;
var DecisionRequestContextSchemaId = 8683;
var DecisionRequestMadeSchemaId = 8684;
var DecisionResponseSuccessSchemaId = 8687;
var DecisionResponseFailureSchemaId = 8686;
var LandingHeartbeatPageSchemaId = 8715;
var LandingInViewSchemaId = 8717;
var LandingOpenPageSchemaId = 8721;
var LandingItemClickSchemaId = 8718;
var LandingItemClickSaveSchemaId = 8719;
var LandingItemClickTransferToMerchantSchemaId = 8720;
var LandingEngagedVisitPageSchemaId = 8714;
var LandingImpressionItemSchemaId = 8716;
var LandingClickSeeFullPageSchemaId = 8713;
var SurveyOpenSchemaId = 8731;
var SurveyClickSchemaId = 8730;
var ExperienceMeasuredTestSchemaId = 8704;
var SlotImpressionExperienceSchemaId = 8722;
var BiddingHeaderLoadedSchemaId = 8677;
var BiddingCallBidderSchemaId = 8676;
var BiddingResponseSuccessSchemaId = 8679;
var BiddingResponseFailureSchemaId = 8678;
var BiddingWonAuctionSchemaId = 8681;
var BiddingBidRequestSchemaId = 8675;
var BiddingServerSubmitBidSchemaId = 8680;
var BoomboxRulesMatchSchemaId = 8682;
var FixedHeightPageChangedSchemaId = 8707;
var FixedHeightPageFilteredSchemaId = 8708;
var DynamicModuleClickBannerSectionSchemaId = 8688;
var DynamicModuleClickEcomItemDetailsSchemaId = 8691;
var DynamicModuleClickEcomItemTransferToMerchantSchemaId = 8692;
var DynamicModuleClickCouponDetailsSchemaId = 8689;
var DynamicModuleClickCouponTransferToMerchantSchemaId = 8690;
var DynamicModuleClickMerchantItemTransferToMerchantSchemaId = 8694;
var DynamicModuleClickMerchantItemDetailsSchemaId = 8693;
var DynamicModuleImpressionCouponSchemaId = 8695;
var DynamicModuleImpressionEcomItemSchemaId = 8696;
var DynamicModuleImpressionMerchantItemSchemaId = 8697;
var DynamicModuleVideoAdHeartbeatSchemaId = 8701;
var DynamicModuleVideoAdImpressionSchemaId = 8702;
var DynamicModuleInViewSchemaId = 8698;
var FrontendBotFilteredSchemaId = 8709;
var DynamicModuleRenderStatusSchemaId = 8700;
var ContainerViewableImpressionSchemaId = 8833;

var Beacons = /*#__PURE__*/Object.freeze({
    __proto__: null,
    AppInitializedSchemaId: AppInitializedSchemaId,
    get ApplicationID () { return ApplicationID; },
    BiddingBidRequestSchemaId: BiddingBidRequestSchemaId,
    BiddingCallBidderSchemaId: BiddingCallBidderSchemaId,
    BiddingHeaderLoadedSchemaId: BiddingHeaderLoadedSchemaId,
    BiddingResponseFailureSchemaId: BiddingResponseFailureSchemaId,
    BiddingResponseSuccessSchemaId: BiddingResponseSuccessSchemaId,
    BiddingServerSubmitBidSchemaId: BiddingServerSubmitBidSchemaId,
    BiddingWonAuctionSchemaId: BiddingWonAuctionSchemaId,
    BoomboxRulesMatchSchemaId: BoomboxRulesMatchSchemaId,
    ContainerViewableImpressionSchemaId: ContainerViewableImpressionSchemaId,
    get Country () { return Country; },
    DecisionRequestContextSchemaId: DecisionRequestContextSchemaId,
    DecisionRequestMadeSchemaId: DecisionRequestMadeSchemaId,
    DecisionResponseFailureSchemaId: DecisionResponseFailureSchemaId,
    DecisionResponseSuccessSchemaId: DecisionResponseSuccessSchemaId,
    DynamicModuleClickBannerSectionSchemaId: DynamicModuleClickBannerSectionSchemaId,
    DynamicModuleClickCouponDetailsSchemaId: DynamicModuleClickCouponDetailsSchemaId,
    DynamicModuleClickCouponTransferToMerchantSchemaId: DynamicModuleClickCouponTransferToMerchantSchemaId,
    DynamicModuleClickEcomItemDetailsSchemaId: DynamicModuleClickEcomItemDetailsSchemaId,
    DynamicModuleClickEcomItemTransferToMerchantSchemaId: DynamicModuleClickEcomItemTransferToMerchantSchemaId,
    DynamicModuleClickMerchantItemDetailsSchemaId: DynamicModuleClickMerchantItemDetailsSchemaId,
    DynamicModuleClickMerchantItemTransferToMerchantSchemaId: DynamicModuleClickMerchantItemTransferToMerchantSchemaId,
    DynamicModuleImpressionCouponSchemaId: DynamicModuleImpressionCouponSchemaId,
    DynamicModuleImpressionEcomItemSchemaId: DynamicModuleImpressionEcomItemSchemaId,
    DynamicModuleImpressionMerchantItemSchemaId: DynamicModuleImpressionMerchantItemSchemaId,
    DynamicModuleInViewSchemaId: DynamicModuleInViewSchemaId,
    DynamicModuleRenderStatusSchemaId: DynamicModuleRenderStatusSchemaId,
    DynamicModuleVideoAdHeartbeatSchemaId: DynamicModuleVideoAdHeartbeatSchemaId,
    DynamicModuleVideoAdImpressionSchemaId: DynamicModuleVideoAdImpressionSchemaId,
    get Environment () { return Environment$1; },
    ExperienceInViewFlyerSchemaId: ExperienceInViewFlyerSchemaId,
    ExperienceMeasuredTestSchemaId: ExperienceMeasuredTestSchemaId,
    ExperienceScrolledBeyondSlotSchemaId: ExperienceScrolledBeyondSlotSchemaId,
    ExperienceServedFallbackSchemaId: ExperienceServedFallbackSchemaId,
    get ExperienceType () { return ExperienceType$1; },
    FixedHeightPageChangedSchemaId: FixedHeightPageChangedSchemaId,
    FixedHeightPageFilteredSchemaId: FixedHeightPageFilteredSchemaId,
    FrontendBotFilteredSchemaId: FrontendBotFilteredSchemaId,
    ItemDetailsClickSaveSchemaId: ItemDetailsClickSaveSchemaId,
    ItemDetailsClickTransferToMerchantSchemaId: ItemDetailsClickTransferToMerchantSchemaId,
    get ItemType () { return ItemType; },
    LandingClickSeeFullPageSchemaId: LandingClickSeeFullPageSchemaId,
    LandingEngagedVisitPageSchemaId: LandingEngagedVisitPageSchemaId,
    LandingHeartbeatPageSchemaId: LandingHeartbeatPageSchemaId,
    LandingImpressionItemSchemaId: LandingImpressionItemSchemaId,
    LandingInViewSchemaId: LandingInViewSchemaId,
    LandingItemClickSaveSchemaId: LandingItemClickSaveSchemaId,
    LandingItemClickSchemaId: LandingItemClickSchemaId,
    LandingItemClickTransferToMerchantSchemaId: LandingItemClickTransferToMerchantSchemaId,
    LandingOpenPageSchemaId: LandingOpenPageSchemaId,
    get Platform () { return Platform; },
    get ShopperPlatformAdView () { return ShopperPlatformAdView; },
    get ShopperPlatformUx () { return ShopperPlatformUx; },
    SlotImpressionExperienceSchemaId: SlotImpressionExperienceSchemaId,
    StorefrontClickFlyerItemDetailsSchemaId: StorefrontClickFlyerItemDetailsSchemaId,
    StorefrontClickSeeFullFlyerSchemaId: StorefrontClickSeeFullFlyerSchemaId,
    StorefrontClickSkipFlyerSchemaId: StorefrontClickSkipFlyerSchemaId,
    StorefrontEngagedVisitFlyerSchemaId: StorefrontEngagedVisitFlyerSchemaId,
    StorefrontHeartbeatFlyerSchemaId: StorefrontHeartbeatFlyerSchemaId,
    StorefrontImpressionFlyerItemSchemaId: StorefrontImpressionFlyerItemSchemaId,
    StorefrontOpenFlyerSchemaId: StorefrontOpenFlyerSchemaId,
    SurveyClickSchemaId: SurveyClickSchemaId,
    SurveyOpenSchemaId: SurveyOpenSchemaId
});

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : undefined,
            done: true
        };
    }
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for(var i = 0, l = from.length, ar; i < l; i++){
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var environment = 'staging';
var TagType;
(function(TagType) {
    TagType["PIXEL"] = "pixel";
    TagType["SCRIPT"] = "script";
})(TagType || (TagType = {}));

var Service$3 = /** @class */ function() {
    function Service() {}
    // eslint-disable-next-line functional/functional-parameters
    Service.prototype.debug = function() {
        var params = [];
        for(var _i = 0; _i < arguments.length; _i++){
            params[_i] = arguments[_i];
        }
        console.debug.apply(console, params);
    };
    Service.prototype.warn = function(message) {
        console.warn(message);
        return null;
    };
    Service.prototype.error = function(message, error) {
        console.error(message, error);
        return null;
    };
    return Service;
}();
var Logger = new Service$3();

var LEGACY_ID_FALLBACK = 1;
var CLOUD_WATCH_SERVICES;
(function(CLOUD_WATCH_SERVICES) {
    CLOUD_WATCH_SERVICES["shopperAdWeb"] = "shopper-ad-web";
    CLOUD_WATCH_SERVICES["shopperAdWebBotd"] = "shopper-ad-web-botd";
    CLOUD_WATCH_SERVICES["shopperAdWebBlockedTraffic"] = "shopper-ad-web-blocked-traffic";
    CLOUD_WATCH_SERVICES["shopperAdWebBlockedBeacon"] = "shopper-ad-web-blocked-beacon";
})(CLOUD_WATCH_SERVICES || (CLOUD_WATCH_SERVICES = {}));

function isExternalScriptError(stack) {
    var _a;
    var combinedText = (_a = stack === null || stack === undefined ? undefined : stack.toLowerCase()) !== null && _a !== undefined ? _a : '';
    return combinedText.includes('@user-script:') || combinedText.includes('chrome-extension://') || combinedText.includes('moz-extension://') || combinedText.includes('safari-extension://') || combinedText.includes('edge-extension://') || combinedText.includes('extension://');
}
function getPageUrl() {
    if (window.top && window.top !== window) {
        try {
            return window.top.location.href;
        } catch (_a) {
        // Failures are fine here
        }
    }
    if (window.parent && window.parent !== window) {
        try {
            return window.parent.location.href;
        } catch (_b) {
            return document.referrer;
        // Failures are fine here as well
        }
    }
    return window.location.href;
}
var logUnknownError = function(error) {
    if (error instanceof Error) {
        void logError(error.message, error.stack);
    } else {
        void logError(JSON.stringify(error), new Error().stack);
    }
    return null;
};
var logError = function(message_1, stack_1, hostUrl_1) {
    var args_1 = [];
    for(var _i = 3; _i < arguments.length; _i++){
        args_1[_i - 3] = arguments[_i];
    }
    return __awaiter(undefined, __spreadArray([
        message_1,
        stack_1,
        hostUrl_1
    ], args_1, true), undefined, function(message, stack, hostUrl, service) {
        var payload, e_1;
        if (service === undefined) {
            service = CLOUD_WATCH_SERVICES.shopperAdWeb;
        }
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (isExternalScriptError(stack)) {
                        return [
                            2 /*return*/ 
                        ];
                    }
                    payload = {
                        service: service,
                        type: 'error',
                        message: message,
                        stack: stack !== null && stack !== undefined ? stack : '',
                        userAgent: window.navigator.userAgent,
                        host: hostUrl !== null && hostUrl !== undefined ? hostUrl : getPageUrl()
                    };
                    if (![
                        CLOUD_WATCH_SERVICES.shopperAdWebBotd,
                        CLOUD_WATCH_SERVICES.shopperAdWebBlockedTraffic
                    ].includes(service) && payload.userAgent.includes('bot')) {
                        Logger.debug('Bot detected. Not Sent Error: ', payload);
                        return [
                            2 /*return*/ 
                        ];
                    }
                    Logger.debug('Send Error: ', payload);
                    _a.label = 1;
                case 1:
                    _a.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4 /*yield*/ ,
                        fetch('https://frontend-logger-stg.flippback.com/api/logging', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'text/plain; charset=UTF-8'
                            },
                            body: JSON.stringify(payload)
                        })
                    ];
                case 2:
                    _a.sent();
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 3:
                    e_1 = _a.sent();
                    if (e_1 instanceof Error) Logger.error('Error when sending error', e_1);
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 4:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
};

var analyticsUrl = 'https://holodeck.flippback.com/json-beacon-stg/v1/nativex';
var debugAnalyticsURL = 'https://holodeck.flippback.com/json-beacon-stg/v1/nativex';
var MAX_SIZE = 200 * 1024; // 200KB
var AnalyticsQueue = /** @class */ function() {
    function AnalyticsQueue() {
        var _this = this;
        this.queue = [];
        this.beaconErrors = 0;
        this.isFlushing = false;
        this.prodAnalytics = false;
        this.sendBeaconBeforeHidden = function() {
            if (_this.queue.length) {
                navigator.sendBeacon(analyticsUrl, encodeURIComponent(JSON.stringify(_this.queue)));
                // Clear the queue after sending to prevent duplicate sends
                _this.queue = [];
            }
        };
    }
    AnalyticsQueue.prototype.enqueue = function(beacon) {
        if (!beacon) {
            return null;
        }
        this.queue.push(beacon);
        this.checkQueue();
    };
    AnalyticsQueue.prototype.start = function() {
        this.checkQueue();
        return null;
    };
    AnalyticsQueue.prototype.checkQueue = function() {
        if (!this.isFlushing && this.queue.length) {
            this.isFlushing = true;
            void this.flushQueue();
        }
    };
    AnalyticsQueue.prototype.flushQueue = function() {
        return __awaiter(this, undefined, undefined, function() {
            var beaconString, recycle, removedBeacon, currentQueue, e_1;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.queue.length) {
                            this.isFlushing = false;
                            return [
                                2 /*return*/ ,
                                null
                            ];
                        }
                        beaconString = encodeURIComponent(JSON.stringify(this.queue));
                        recycle = [];
                        while(new Blob([
                            beaconString
                        ]).size > MAX_SIZE){
                            removedBeacon = this.queue.pop();
                            if (removedBeacon) recycle.push(removedBeacon);
                            beaconString = encodeURIComponent(JSON.stringify(this.queue));
                        }
                        Logger.debug('Flushing analytics queue', this.queue);
                        currentQueue = __spreadArray([], this.queue, true);
                        this.queue = [];
                        if (recycle.length) {
                            this.queue = recycle.concat(this.queue);
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            6,
                            ,
                            7
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.sendBeacon(beaconString)
                        ];
                    case 2:
                        _a.sent();
                        if (!(this.queue.length > 0)) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            this.flushQueue()
                        ];
                    case 3:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        this.isFlushing = false;
                        _a.label = 5;
                    case 5:
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 6:
                        e_1 = _a.sent();
                        this.beaconErrors += 1;
                        this.queue = currentQueue.concat(this.queue);
                        this.isFlushing = false;
                        if (e_1 instanceof Error && this.beaconErrors <= 1) {
                            void logError("Unhandled Rejection: ".concat(e_1.message), e_1.stack, 'shopper-ad-web-blocked-beacon', CLOUD_WATCH_SERVICES.shopperAdWebBlockedBeacon);
                        }
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 7:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    // Fire beacons in form of encoded strings
    AnalyticsQueue.prototype.sendBeacon = function(beacon) {
        if (this.prodAnalytics) {
            void fetch(debugAnalyticsURL, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Content-Type': 'text/plain; charset=UTF-8'
                },
                body: beacon
            });
        }
        return fetch(analyticsUrl, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'text/plain; charset=UTF-8'
            },
            body: beacon
        });
    };
    return AnalyticsQueue;
}();
var analyticsQueue = new AnalyticsQueue();
analyticsQueue.start();

var generateUUID = function() {
    // rfc4122 version 4 compliant
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c === 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
};

var _a;
var MACRO_PATTERN = /\[\[(campaignId|flightId|merchantId|merchantName|country)\]\]/g;
var encodeMacro = function(value) {
    return value == null ? '' : encodeURIComponent(String(value));
};
var expandMacros = function(content, options) {
    var _a, _b, _c, _d;
    // 8 Digit Cache Buster
    var cb = Math.floor(10000000 + Math.random() * 90000000);
    var shouldUseDma = (options === null || options === undefined ? undefined : options.enableDma) && ((_a = options === null || options === undefined ? undefined : options.location) === null || _a === undefined ? undefined : _a.country) === 'US';
    var dmaReplacement = shouldUseDma ? (_c = (_b = options === null || options === undefined ? undefined : options.location) === null || _b === undefined ? undefined : _b.metro_code) !== null && _c !== undefined ? _c : '' : '';
    var macroValues = __assign(__assign({}, options === null || options === undefined ? undefined : options.macros), {
        country: (_d = options === null || options === undefined ? undefined : options.location) === null || _d === undefined ? undefined : _d.country
    });
    return content.replace(/\[\[random\]\]/g, cb.toString()).replace(/\[\[dmaCode\]\]/g, dmaReplacement).replace(MACRO_PATTERN, function(_, name) {
        return encodeMacro(macroValues[name]);
    });
};
var createPixel = function(content, options) {
    if (!content) return null;
    // eslint-disable-next-line functional/no-let
    var src = null;
    try {
        var url = expandMacros(content, options);
        src = new URL(url);
    } catch (_a) {
        console.error("Invalid pixel url: ".concat(content));
        return null;
    }
    if ((options === null || options === undefined ? undefined : options.params) && src) {
        for(var param in options.params){
            src.searchParams.set(param, options.params[param]);
        }
    }
    if (src) {
        var pixel = new Image(1, 1);
        pixel.src = src.toString();
    }
    return null;
};
var createScript = function(content) {
    var iframe = document.createElement('iframe');
    iframe.id = generateUUID();
    iframe.setAttribute('sandbox', 'allow-scripts');
    iframe.style.display = 'none';
    var isHtmlContent = /<script[\s>]/i.test(content);
    iframe.srcdoc = isHtmlContent ? content : "<script>".concat(content, "</script>");
    document.body.append(iframe);
    return null;
};
var tagTypeBuilderMap = (_a = {}, _a[TagType.PIXEL] = createPixel, _a[TagType.SCRIPT] = createScript, _a);
var createTagElement = function(type, content, options) {
    tagTypeBuilderMap[type](content, options);
    return null;
};

var Service$2 = /** @class */ function() {
    function Service() {
        var _this = this;
        this.processedTags = [];
        this.sent = {
            open: false,
            engagement: false,
            impression: false,
            viewableImpression: false
        };
        this.addTagsFromCampaignResponse = function(decision, payload, location) {
            var tags = _this.buildTags(decision, location);
            _this.addTags(tags, payload);
            return null;
        };
        this.addTags = function(tags, payload, location) {
            var _a;
            _this.parseTags(tags);
            _this.payload = payload;
            _this.location = location;
            _this.enableDma = payload.enableDma;
            _this.macros = (_a = payload.macros) !== null && _a !== undefined ? _a : _this.macros;
            return null;
        };
        this.sendOpen = function() {
            if (!_this.sent.open) {
                Logger.debug('Tags: Send open');
                _this.send('open');
                _this.sent.open = true;
            }
            return null;
        };
        this.sendEngagement = function() {
            if (!_this.sent.engagement) {
                Logger.debug('Tags: Send engagement');
                _this.send('engagement');
                _this.sent.engagement = true;
            }
            return null;
        };
        this.sendClick = function(flyerItemId) {
            Logger.debug('Tags: Send click');
            _this.send('click', {
                flyerItemId: flyerItemId
            });
            return null;
        };
        this.sendServedImpression = function() {
            if (!_this.sent.impression) {
                Logger.debug('Tags: Send served impression');
                _this.send('impression');
                _this.sent.impression = true;
            }
            return null;
        };
        this.sendViewableImpression = function() {
            if (!_this.sent.viewableImpression) {
                Logger.debug('Tags: Send viewable impression');
                _this.send('viewableImpression');
                _this.sent.viewableImpression = true;
            }
            return null;
        };
        this.sendAnswerClick = function(answer) {
            Logger.debug('Tags: Send Survey click: ' + answer);
            _this.send('engagement', {
                answer: answer
            });
            return null;
        };
        this.reset = function() {
            _this.sent.open = false;
            _this.sent.engagement = false;
            _this.sent.impression = false;
            _this.sent.viewableImpression = false;
            _this.processedTags = [];
            _this.payload = undefined;
            _this.macros = undefined;
            return null;
        };
        this.send = function(event, params) {
            _this.processedTags.filter(function(tag) {
                return tag.event === event;
            }).forEach(function(tag) {
                return createTagElement(tag.type, tag.content, {
                    // AdMixer's trackers get none of our query params.
                    params: tag.source === 'admixer' ? undefined : params,
                    location: _this.location,
                    enableDma: _this.enableDma,
                    macros: _this.macros
                });
            });
            return null;
        };
    }
    Service.prototype.buildTags = function(decision, location) {
        var _a, _b, _c, _d, _e, _f;
        this.location = location;
        this.macros = {
            campaignId: decision.campaignId,
            flightId: decision.flightId,
            merchantId: (_a = decision.storefront) === null || _a === undefined ? undefined : _a.merchant_id,
            merchantName: (_b = decision.storefront) === null || _b === undefined ? undefined : _b.merchant
        };
        var tags = (_d = (_c = decision.storefront) === null || _c === undefined ? undefined : _c.campaignConfig) === null || _d === undefined ? undefined : _d.tags;
        var advertiser = tags === null || tags === undefined ? undefined : tags.advertiser;
        var admixer = tags === null || tags === undefined ? undefined : tags.admixer;
        var transformedAdvertiser = advertiser ? {
            engagement: (_e = advertiser.engagement) !== null && _e !== undefined ? _e : [],
            open: (_f = advertiser.open) !== null && _f !== undefined ? _f : [],
            impression: advertiser.impression,
            click: advertiser.click
        } : undefined;
        return __assign(__assign(__assign({}, transformedAdvertiser ? {
            advertiser: transformedAdvertiser
        } : {}), admixer ? {
            admixer: {
                engagement: [],
                open: [],
                impression: admixer.impression,
                click: admixer.click,
                viewableImpression: admixer.viewableImpression
            }
        } : {}), {
            campaignManagement: {
                open: [
                    decision.impressionUrl
                ],
                engagement: [
                    decision.clickUrl
                ],
                impression: []
            }
        });
    };
    Service.prototype.parseTags = function(tags) {
        var _this = this;
        var _a;
        var _loop_1 = function(sourceKey) {
            var source = sourceKey;
            var _loop_2 = function(eventKey) {
                var event_1 = eventKey;
                var content = (_a = tags[source]) === null || _a === undefined ? undefined : _a[event_1];
                if (!content) {
                    return "continue";
                }
                if (!Array.isArray(content)) {
                    content = [
                        content
                    ];
                }
                content.forEach(function(tag) {
                    var type;
                    var pixelUrl;
                    if (typeof tag !== 'string') {
                        type = tag.type;
                        pixelUrl = tag.content;
                    } else {
                        pixelUrl = tag;
                        type = /<script[\s>]/i.test(tag) ? TagType.SCRIPT : TagType.PIXEL;
                    }
                    // A decision's tags can be added twice (slot impression and mobile
                    // swipe), so each AdMixer tracker is kept once.
                    if (source === 'admixer' && _this.processedTags.some(function(t) {
                        return t.source === source && t.event === event_1 && t.content === pixelUrl;
                    })) {
                        return;
                    }
                    _this.processedTags.push({
                        type: type,
                        source: source,
                        event: event_1,
                        content: pixelUrl
                    });
                });
            };
            for(var eventKey in tags[source]){
                _loop_2(eventKey);
            }
        };
        for(var sourceKey in tags){
            _loop_1(sourceKey);
        }
    };
    return Service;
}();

// Whitelist of countries where the LiveRamp identity sync can fire.
var LIVERAMP_ALLOWED_COUNTRIES = [
    'US',
    'CA',
    'DE',
    'MX',
    'CO'
];
var isLiveRampSyncAllowed = function() {
    var _a, _b;
    var country = (_b = (_a = window.flippxp) === null || _a === undefined ? undefined : _a.geo) === null || _b === undefined ? undefined : _b.country;
    return !!country && LIVERAMP_ALLOWED_COUNTRIES.includes(country);
};
// Store the user key in memory for the duration of the session to power the
// partner-provided user key case
// eslint-disable-next-line functional/no-let
var userKey = null;
var syncUserKey = function(userKey) {
    if (window.flippxp && !window.flippxp.cookieSynced && isLiveRampSyncAllowed()) {
        // Have to use a timeout here to pass e2e test
        setTimeout(function() {
            var pixel = new Image();
            pixel.src = "https://idsync.rlcdn.com/712559.gif?partner_uid=".concat(userKey);
            window.flippxp.cookieSynced = true;
            pixel.remove();
        }, 1);
    }
};
function getUserKey(options) {
    if (options === undefined) {
        options = {};
    }
    if (userKey) {
        syncUserKey(userKey);
        return userKey;
    }
    // If the partner provides the user key use it, otherwise fallback to cookies
    if ('userKey' in options && options.userKey) {
        if (isValidUserKey(options.userKey)) {
            userKey = options.userKey;
            syncUserKey(userKey);
            return options.userKey;
        }
    }
    var FLIPP_USER_KEY = 'flipp-uid';
    // Grab from Cookie
    // eslint-disable-next-line functional/no-let
    var foundUserKey = null;
    var allCookies = document.cookie.split(';');
    for(var _i = 0, allCookies_1 = allCookies; _i < allCookies_1.length; _i++){
        var cookie = allCookies_1[_i];
        var pair = cookie.split('=');
        var k = pair[0];
        var v = pair[1];
        if (k.trim() === FLIPP_USER_KEY) {
            foundUserKey = v;
            break;
        }
    }
    if (foundUserKey) {
        syncUserKey(foundUserKey);
        return foundUserKey;
    }
    // Generate if none found
    userKey = generateUUID();
    if (!userKey) {
        return null;
    }
    // Set cookie
    document.cookie = FLIPP_USER_KEY + '=' + userKey + '; max-age=31536000; path=/';
    syncUserKey(userKey);
    return userKey;
}
function isValidUserKey(userKey) {
    return !userKey.startsWith('#');
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var uaParser = {exports: {}};

(function(module, exports) {
    /////////////////////////////////////////////////////////////////////////////////
    /* UAParser.js v1.0.41
	   Copyright © 2012-2025 Faisal Salman <f@faisalman.com>
	   MIT License */ /*
	   Detect Browser, Engine, OS, CPU, and Device type/model from User-Agent data.
	   Supports browser & node.js environment. 
	   Demo   : https://faisalman.github.io/ua-parser-js
	   Source : https://github.com/faisalman/ua-parser-js */ /////////////////////////////////////////////////////////////////////////////////
    (function(window1, undefined$1) {
        //////////////
        // Constants
        /////////////
        var LIBVERSION = '1.0.41', EMPTY = '', UNKNOWN = '?', FUNC_TYPE = 'function', UNDEF_TYPE = 'undefined', OBJ_TYPE = 'object', STR_TYPE = 'string', MAJOR = 'major', MODEL = 'model', NAME = 'name', TYPE = 'type', VENDOR = 'vendor', VERSION = 'version', ARCHITECTURE = 'architecture', CONSOLE = 'console', MOBILE = 'mobile', TABLET = 'tablet', SMARTTV = 'smarttv', WEARABLE = 'wearable', EMBEDDED = 'embedded', UA_MAX_LENGTH = 500;
        var AMAZON = 'Amazon', APPLE = 'Apple', ASUS = 'ASUS', BLACKBERRY = 'BlackBerry', BROWSER = 'Browser', CHROME = 'Chrome', EDGE = 'Edge', FIREFOX = 'Firefox', GOOGLE = 'Google', HONOR = 'Honor', HUAWEI = 'Huawei', LENOVO = 'Lenovo', LG = 'LG', MICROSOFT = 'Microsoft', MOTOROLA = 'Motorola', NVIDIA = 'Nvidia', ONEPLUS = 'OnePlus', OPERA = 'Opera', OPPO = 'OPPO', SAMSUNG = 'Samsung', SHARP = 'Sharp', SONY = 'Sony', XIAOMI = 'Xiaomi', ZEBRA = 'Zebra', FACEBOOK = 'Facebook', CHROMIUM_OS = 'Chromium OS', MAC_OS = 'Mac OS', SUFFIX_BROWSER = ' Browser';
        ///////////
        // Helper
        //////////
        var extend = function(regexes, extensions) {
            var mergedRegexes = {};
            for(var i in regexes){
                if (extensions[i] && extensions[i].length % 2 === 0) {
                    mergedRegexes[i] = extensions[i].concat(regexes[i]);
                } else {
                    mergedRegexes[i] = regexes[i];
                }
            }
            return mergedRegexes;
        }, enumerize = function(arr) {
            var enums = {};
            for(var i = 0; i < arr.length; i++){
                enums[arr[i].toUpperCase()] = arr[i];
            }
            return enums;
        }, has = function(str1, str2) {
            return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
        }, lowerize = function(str) {
            return str.toLowerCase();
        }, majorize = function(version) {
            return typeof version === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split('.')[0] : undefined$1;
        }, trim = function(str, len) {
            if (typeof str === STR_TYPE) {
                str = str.replace(/^\s\s*/, EMPTY);
                return typeof len === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
            }
        };
        ///////////////
        // Map helper
        //////////////
        var rgxMapper = function(ua, arrays) {
            var i = 0, j, k, p, q, matches, match;
            // loop through all regexes maps
            while(i < arrays.length && !matches){
                var regex = arrays[i], props = arrays[i + 1]; // odd sequence (1,3,5,..)
                j = k = 0;
                // try matching uastring with regexes
                while(j < regex.length && !matches){
                    if (!regex[j]) {
                        break;
                    }
                    matches = regex[j++].exec(ua);
                    if (!!matches) {
                        for(p = 0; p < props.length; p++){
                            match = matches[++k];
                            q = props[p];
                            // check if given property is actually array
                            if (typeof q === OBJ_TYPE && q.length > 0) {
                                if (q.length === 2) {
                                    if (typeof q[1] == FUNC_TYPE) {
                                        // assign modified match
                                        this[q[0]] = q[1].call(this, match);
                                    } else {
                                        // assign given value, ignore regex match
                                        this[q[0]] = q[1];
                                    }
                                } else if (q.length === 3) {
                                    // check whether function or regex
                                    if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
                                        // call function (usually string mapper)
                                        this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined$1;
                                    } else {
                                        // sanitize match using given regex
                                        this[q[0]] = match ? match.replace(q[1], q[2]) : undefined$1;
                                    }
                                } else if (q.length === 4) {
                                    this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined$1;
                                }
                            } else {
                                this[q] = match ? match : undefined$1;
                            }
                        }
                    }
                }
                i += 2;
            }
        }, strMapper = function(str, map) {
            for(var i in map){
                // check if current value is array
                if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
                    for(var j = 0; j < map[i].length; j++){
                        if (has(map[i][j], str)) {
                            return i === UNKNOWN ? undefined$1 : i;
                        }
                    }
                } else if (has(map[i], str)) {
                    return i === UNKNOWN ? undefined$1 : i;
                }
            }
            return map.hasOwnProperty('*') ? map['*'] : str;
        };
        ///////////////
        // String map
        //////////////
        // Safari < 3.0
        var oldSafariMap = {
            '1.0': '/8',
            '1.2': '/1',
            '1.3': '/3',
            '2.0': '/412',
            '2.0.2': '/416',
            '2.0.3': '/417',
            '2.0.4': '/419',
            '?': '/'
        }, windowsVersionMap = {
            'ME': '4.90',
            'NT 3.11': 'NT3.51',
            'NT 4.0': 'NT4.0',
            '2000': 'NT 5.0',
            'XP': [
                'NT 5.1',
                'NT 5.2'
            ],
            'Vista': 'NT 6.0',
            '7': 'NT 6.1',
            '8': 'NT 6.2',
            '8.1': 'NT 6.3',
            '10': [
                'NT 6.4',
                'NT 10.0'
            ],
            'RT': 'ARM'
        };
        //////////////
        // Regex map
        /////////////
        var regexes = {
            browser: [
                [
                    /\b(?:crmo|crios)\/([\w\.]+)/i // Chrome for Android/iOS
                ],
                [
                    VERSION,
                    [
                        NAME,
                        'Chrome'
                    ]
                ],
                [
                    /edg(?:e|ios|a)?\/([\w\.]+)/i // Microsoft Edge
                ],
                [
                    VERSION,
                    [
                        NAME,
                        'Edge'
                    ]
                ],
                [
                    // Presto based
                    /(opera mini)\/([-\w\.]+)/i,
                    /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
                    /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i // Opera
                ],
                [
                    NAME,
                    VERSION
                ],
                [
                    /opios[\/ ]+([\w\.]+)/i // Opera mini on iphone >= 8.0
                ],
                [
                    VERSION,
                    [
                        NAME,
                        OPERA + ' Mini'
                    ]
                ],
                [
                    /\bop(?:rg)?x\/([\w\.]+)/i // Opera GX
                ],
                [
                    VERSION,
                    [
                        NAME,
                        OPERA + ' GX'
                    ]
                ],
                [
                    /\bopr\/([\w\.]+)/i // Opera Webkit
                ],
                [
                    VERSION,
                    [
                        NAME,
                        OPERA
                    ]
                ],
                [
                    // Mixed
                    /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i // Baidu
                ],
                [
                    VERSION,
                    [
                        NAME,
                        'Baidu'
                    ]
                ],
                [
                    /\b(?:mxbrowser|mxios|myie2)\/?([-\w\.]*)\b/i // Maxthon
                ],
                [
                    VERSION,
                    [
                        NAME,
                        'Maxthon'
                    ]
                ],
                [
                    /(kindle)\/([\w\.]+)/i,
                    /(lunascape|maxthon|netfront|jasmine|blazer|sleipnir)[\/ ]?([\w\.]*)/i,
                    // Lunascape/Maxthon/Netfront/Jasmine/Blazer/Sleipnir
                    // Trident based
                    /(avant|iemobile|slim(?:browser|boat|jet))[\/ ]?([\d\.]*)/i,
                    /(?:ms|\()(ie) ([\w\.]+)/i,
                    // Blink/Webkit/KHTML based                                         // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
                    /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|duckduckgo|klar|helio|(?=comodo_)?dragon)\/([-\w\.]+)/i,
                    // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ//Vivaldi/DuckDuckGo/Klar/Helio/Dragon
                    /(heytap|ovi|115)browser\/([\d\.]+)/i,
                    /(weibo)__([\d\.]+)/i // Weibo
                ],
                [
                    NAME,
                    VERSION
                ],
                [
                    /quark(?:pc)?\/([-\w\.]+)/i // Quark
                ],
                [
                    VERSION,
                    [
                        NAME,
                        'Quark'
                    ]
                ],
                [
                    /\bddg\/([\w\.]+)/i // DuckDuckGo
                ],
                [
                    VERSION,
                    [
                        NAME,
                        'DuckDuckGo'
                    ]
                ],
                [
                    /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i // UCBrowser
                ],
                [
                    VERSION,
                    [
                        NAME,
                        'UC' + BROWSER
                    ]
                ],
                [
                    /microm.+\bqbcore\/([\w\.]+)/i,
                    /\bqbcore\/([\w\.]+).+microm/i,
                    /micromessenger\/([\w\.]+)/i // WeChat
                ],
                [
                    VERSION,
                    [
                        NAME,
                        'WeChat'
                    ]
                ],
                [
                    /konqueror\/([\w\.]+)/i // Konqueror
                ],
                [
                    VERSION,
                    [
                        NAME,
                        'Konqueror'
                    ]
                ],
                [
                    /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i // IE11
                ],
                [
                    VERSION,
                    [
                        NAME,
                        'IE'
                    ]
                ],
                [
                    /ya(?:search)?browser\/([\w\.]+)/i // Yandex
                ],
                [
                    VERSION,
                    [
                        NAME,
                        'Yandex'
                    ]
                ],
                [
                    /slbrowser\/([\w\.]+)/i // Smart Lenovo Browser
                ],
                [
                    VERSION,
                    [
                        NAME,
                        'Smart Lenovo ' + BROWSER
                    ]
                ],
                [
                    /(avast|avg)\/([\w\.]+)/i // Avast/AVG Secure Browser
                ],
                [
                    [
                        NAME,
                        /(.+)/,
                        '$1 Secure ' + BROWSER
                    ],
                    VERSION
                ],
                [
                    /\bfocus\/([\w\.]+)/i // Firefox Focus
                ],
                [
                    VERSION,
                    [
                        NAME,
                        FIREFOX + ' Focus'
                    ]
                ],
                [
                    /\bopt\/([\w\.]+)/i // Opera Touch
                ],
                [
                    VERSION,
                    [
                        NAME,
                        OPERA + ' Touch'
                    ]
                ],
                [
                    /coc_coc\w+\/([\w\.]+)/i // Coc Coc Browser
                ],
                [
                    VERSION,
                    [
                        NAME,
                        'Coc Coc'
                    ]
                ],
                [
                    /dolfin\/([\w\.]+)/i // Dolphin
                ],
                [
                    VERSION,
                    [
                        NAME,
                        'Dolphin'
                    ]
                ],
                [
                    /coast\/([\w\.]+)/i // Opera Coast
                ],
                [
                    VERSION,
                    [
                        NAME,
                        OPERA + ' Coast'
                    ]
                ],
                [
                    /miuibrowser\/([\w\.]+)/i // MIUI Browser
                ],
                [
                    VERSION,
                    [
                        NAME,
                        'MIUI' + SUFFIX_BROWSER
                    ]
                ],
                [
                    /fxios\/([\w\.-]+)/i // Firefox for iOS
                ],
                [
                    VERSION,
                    [
                        NAME,
                        FIREFOX
                    ]
                ],
                [
                    /\bqihoobrowser\/?([\w\.]*)/i // 360
                ],
                [
                    VERSION,
                    [
                        NAME,
                        '360'
                    ]
                ],
                [
                    /\b(qq)\/([\w\.]+)/i // QQ
                ],
                [
                    [
                        NAME,
                        /(.+)/,
                        '$1Browser'
                    ],
                    VERSION
                ],
                [
                    /(oculus|sailfish|huawei|vivo|pico)browser\/([\w\.]+)/i
                ],
                [
                    [
                        NAME,
                        /(.+)/,
                        '$1' + SUFFIX_BROWSER
                    ],
                    VERSION
                ],
                [
                    /samsungbrowser\/([\w\.]+)/i // Samsung Internet
                ],
                [
                    VERSION,
                    [
                        NAME,
                        SAMSUNG + ' Internet'
                    ]
                ],
                [
                    /metasr[\/ ]?([\d\.]+)/i // Sogou Explorer
                ],
                [
                    VERSION,
                    [
                        NAME,
                        'Sogou Explorer'
                    ]
                ],
                [
                    /(sogou)mo\w+\/([\d\.]+)/i // Sogou Mobile
                ],
                [
                    [
                        NAME,
                        'Sogou Mobile'
                    ],
                    VERSION
                ],
                [
                    /(electron)\/([\w\.]+) safari/i,
                    /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
                    /m?(qqbrowser|2345(?=browser|chrome|explorer))\w*[\/ ]?v?([\w\.]+)/i // QQ/2345
                ],
                [
                    NAME,
                    VERSION
                ],
                [
                    /(lbbrowser|rekonq)/i,
                    /\[(linkedin)app\]/i // LinkedIn App for iOS & Android
                ],
                [
                    NAME
                ],
                [
                    /ome\/([\w\.]+) \w* ?(iron) saf/i,
                    /ome\/([\w\.]+).+qihu (360)[es]e/i // 360
                ],
                [
                    VERSION,
                    NAME
                ],
                [
                    // WebView
                    /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i // Facebook App for iOS & Android
                ],
                [
                    [
                        NAME,
                        FACEBOOK
                    ],
                    VERSION
                ],
                [
                    /(Klarna)\/([\w\.]+)/i,
                    /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
                    /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
                    /(daum)apps[\/ ]([\w\.]+)/i,
                    /safari (line)\/([\w\.]+)/i,
                    /\b(line)\/([\w\.]+)\/iab/i,
                    /(alipay)client\/([\w\.]+)/i,
                    /(twitter)(?:and| f.+e\/([\w\.]+))/i,
                    /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i // Chromium/Instagram/Snapchat
                ],
                [
                    NAME,
                    VERSION
                ],
                [
                    /\bgsa\/([\w\.]+) .*safari\//i // Google Search Appliance on iOS
                ],
                [
                    VERSION,
                    [
                        NAME,
                        'GSA'
                    ]
                ],
                [
                    /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i // TikTok
                ],
                [
                    VERSION,
                    [
                        NAME,
                        'TikTok'
                    ]
                ],
                [
                    /headlesschrome(?:\/([\w\.]+)| )/i // Chrome Headless
                ],
                [
                    VERSION,
                    [
                        NAME,
                        CHROME + ' Headless'
                    ]
                ],
                [
                    / wv\).+(chrome)\/([\w\.]+)/i // Chrome WebView
                ],
                [
                    [
                        NAME,
                        CHROME + ' WebView'
                    ],
                    VERSION
                ],
                [
                    /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i // Android Browser
                ],
                [
                    VERSION,
                    [
                        NAME,
                        'Android ' + BROWSER
                    ]
                ],
                [
                    /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i // Chrome/OmniWeb/Arora/Tizen/Nokia
                ],
                [
                    NAME,
                    VERSION
                ],
                [
                    /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i // Mobile Safari
                ],
                [
                    VERSION,
                    [
                        NAME,
                        'Mobile Safari'
                    ]
                ],
                [
                    /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i // Safari & Safari Mobile
                ],
                [
                    VERSION,
                    NAME
                ],
                [
                    /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i // Safari < 3.0
                ],
                [
                    NAME,
                    [
                        VERSION,
                        strMapper,
                        oldSafariMap
                    ]
                ],
                [
                    /(webkit|khtml)\/([\w\.]+)/i
                ],
                [
                    NAME,
                    VERSION
                ],
                [
                    // Gecko based
                    /(navigator|netscape\d?)\/([-\w\.]+)/i // Netscape
                ],
                [
                    [
                        NAME,
                        'Netscape'
                    ],
                    VERSION
                ],
                [
                    /(wolvic|librewolf)\/([\w\.]+)/i // Wolvic/LibreWolf
                ],
                [
                    NAME,
                    VERSION
                ],
                [
                    /mobile vr; rv:([\w\.]+)\).+firefox/i // Firefox Reality
                ],
                [
                    VERSION,
                    [
                        NAME,
                        FIREFOX + ' Reality'
                    ]
                ],
                [
                    /ekiohf.+(flow)\/([\w\.]+)/i,
                    /(swiftfox)/i,
                    /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror)[\/ ]?([\w\.\+]+)/i,
                    // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
                    /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                    // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
                    /(firefox)\/([\w\.]+)/i,
                    /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
                    // Other
                    /(amaya|dillo|doris|icab|ladybird|lynx|mosaic|netsurf|obigo|polaris|w3m|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                    // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Obigo/Mosaic/Go/ICE/UP.Browser/Ladybird
                    /\b(links) \(([\w\.]+)/i // Links
                ],
                [
                    NAME,
                    [
                        VERSION,
                        /_/g,
                        '.'
                    ]
                ],
                [
                    /(cobalt)\/([\w\.]+)/i // Cobalt
                ],
                [
                    NAME,
                    [
                        VERSION,
                        /master.|lts./,
                        ""
                    ]
                ]
            ],
            cpu: [
                [
                    /\b((amd|x|x86[-_]?|wow|win)64)\b/i // AMD64 (x64)
                ],
                [
                    [
                        ARCHITECTURE,
                        'amd64'
                    ]
                ],
                [
                    /(ia32(?=;))/i,
                    /\b((i[346]|x)86)(pc)?\b/i // IA32 (x86)
                ],
                [
                    [
                        ARCHITECTURE,
                        'ia32'
                    ]
                ],
                [
                    /\b(aarch64|arm(v?[89]e?l?|_?64))\b/i // ARM64
                ],
                [
                    [
                        ARCHITECTURE,
                        'arm64'
                    ]
                ],
                [
                    /\b(arm(v[67])?ht?n?[fl]p?)\b/i // ARMHF
                ],
                [
                    [
                        ARCHITECTURE,
                        'armhf'
                    ]
                ],
                [
                    // PocketPC mistakenly identified as PowerPC
                    /( (ce|mobile); ppc;|\/[\w\.]+arm\b)/i
                ],
                [
                    [
                        ARCHITECTURE,
                        'arm'
                    ]
                ],
                [
                    /((ppc|powerpc)(64)?)( mac|;|\))/i // PowerPC
                ],
                [
                    [
                        ARCHITECTURE,
                        /ower/,
                        EMPTY,
                        lowerize
                    ]
                ],
                [
                    / sun4\w[;\)]/i // SPARC
                ],
                [
                    [
                        ARCHITECTURE,
                        'sparc'
                    ]
                ],
                [
                    /\b(avr32|ia64(?=;)|68k(?=\))|\barm(?=v([1-7]|[5-7]1)l?|;|eabi)|(irix|mips|sparc)(64)?\b|pa-risc)/i
                ],
                [
                    [
                        ARCHITECTURE,
                        lowerize
                    ]
                ]
            ],
            device: [
                [
                    //////////////////////////
                    // MOBILES & TABLETS
                    /////////////////////////
                    // Samsung
                    /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        SAMSUNG
                    ],
                    [
                        TYPE,
                        TABLET
                    ]
                ],
                [
                    /\b((?:s[cgp]h|gt|sm)-(?![lr])\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
                    /samsung[- ]((?!sm-[lr])[-\w]+)/i,
                    /sec-(sgh\w+)/i
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        SAMSUNG
                    ],
                    [
                        TYPE,
                        MOBILE
                    ]
                ],
                [
                    // Apple
                    /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i // iPod/iPhone
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        APPLE
                    ],
                    [
                        TYPE,
                        MOBILE
                    ]
                ],
                [
                    /\((ipad);[-\w\),; ]+apple/i,
                    /applecoremedia\/[\w\.]+ \((ipad)/i,
                    /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        APPLE
                    ],
                    [
                        TYPE,
                        TABLET
                    ]
                ],
                [
                    /(macintosh);/i
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        APPLE
                    ]
                ],
                [
                    // Sharp
                    /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        SHARP
                    ],
                    [
                        TYPE,
                        MOBILE
                    ]
                ],
                [
                    // Honor
                    /\b((?:brt|eln|hey2?|gdi|jdn)-a?[lnw]09|(?:ag[rm]3?|jdn2|kob2)-a?[lw]0[09]hn)(?: bui|\)|;)/i
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        HONOR
                    ],
                    [
                        TYPE,
                        TABLET
                    ]
                ],
                [
                    /honor([-\w ]+)[;\)]/i
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        HONOR
                    ],
                    [
                        TYPE,
                        MOBILE
                    ]
                ],
                [
                    // Huawei
                    /\b((?:ag[rs][2356]?k?|bah[234]?|bg[2o]|bt[kv]|cmr|cpn|db[ry]2?|jdn2|got|kob2?k?|mon|pce|scm|sht?|[tw]gr|vrd)-[ad]?[lw][0125][09]b?|605hw|bg2-u03|(?:gem|fdr|m2|ple|t1)-[7a]0[1-4][lu]|t1-a2[13][lw]|mediapad[\w\. ]*(?= bui|\)))\b(?!.+d\/s)/i
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        HUAWEI
                    ],
                    [
                        TYPE,
                        TABLET
                    ]
                ],
                [
                    /(?:huawei)([-\w ]+)[;\)]/i,
                    /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        HUAWEI
                    ],
                    [
                        TYPE,
                        MOBILE
                    ]
                ],
                [
                    // Xiaomi
                    /oid[^\)]+; (2[\dbc]{4}(182|283|rp\w{2})[cgl]|m2105k81a?c)(?: bui|\))/i,
                    /\b((?:red)?mi[-_ ]?pad[\w- ]*)(?: bui|\))/i // Mi Pad tablets
                ],
                [
                    [
                        MODEL,
                        /_/g,
                        ' '
                    ],
                    [
                        VENDOR,
                        XIAOMI
                    ],
                    [
                        TYPE,
                        TABLET
                    ]
                ],
                [
                    /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
                    /\b; (\w+) build\/hm\1/i,
                    /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
                    /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
                    /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
                    /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite|pro)?)(?: bui|\))/i,
                    / ([\w ]+) miui\/v?\d/i
                ],
                [
                    [
                        MODEL,
                        /_/g,
                        ' '
                    ],
                    [
                        VENDOR,
                        XIAOMI
                    ],
                    [
                        TYPE,
                        MOBILE
                    ]
                ],
                [
                    // OPPO
                    /; (\w+) bui.+ oppo/i,
                    /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        OPPO
                    ],
                    [
                        TYPE,
                        MOBILE
                    ]
                ],
                [
                    /\b(opd2(\d{3}a?))(?: bui|\))/i
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        strMapper,
                        {
                            'OnePlus': [
                                '304',
                                '403',
                                '203'
                            ],
                            '*': OPPO
                        }
                    ],
                    [
                        TYPE,
                        TABLET
                    ]
                ],
                [
                    // Vivo
                    /vivo (\w+)(?: bui|\))/i,
                    /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        'Vivo'
                    ],
                    [
                        TYPE,
                        MOBILE
                    ]
                ],
                [
                    // Realme
                    /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        'Realme'
                    ],
                    [
                        TYPE,
                        MOBILE
                    ]
                ],
                [
                    // Motorola
                    /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
                    /\bmot(?:orola)?[- ](\w*)/i,
                    /((?:moto(?! 360)[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        MOTOROLA
                    ],
                    [
                        TYPE,
                        MOBILE
                    ]
                ],
                [
                    /\b(mz60\d|xoom[2 ]{0,2}) build\//i
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        MOTOROLA
                    ],
                    [
                        TYPE,
                        TABLET
                    ]
                ],
                [
                    // LG
                    /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        LG
                    ],
                    [
                        TYPE,
                        TABLET
                    ]
                ],
                [
                    /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
                    /\blg[-e;\/ ]+((?!browser|netcast|android tv|watch)\w+)/i,
                    /\blg-?([\d\w]+) bui/i
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        LG
                    ],
                    [
                        TYPE,
                        MOBILE
                    ]
                ],
                [
                    // Lenovo
                    /(ideatab[-\w ]+|602lv|d-42a|a101lv|a2109a|a3500-hv|s[56]000|pb-6505[my]|tb-?x?\d{3,4}(?:f[cu]|xu|[av])|yt\d?-[jx]?\d+[lfmx])( bui|;|\)|\/)/i,
                    /lenovo ?(b[68]0[08]0-?[hf]?|tab(?:[\w- ]+?)|tb[\w-]{6,7})( bui|;|\)|\/)/i
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        LENOVO
                    ],
                    [
                        TYPE,
                        TABLET
                    ]
                ],
                [
                    // Nokia
                    /(nokia) (t[12][01])/i
                ],
                [
                    VENDOR,
                    MODEL,
                    [
                        TYPE,
                        TABLET
                    ]
                ],
                [
                    /(?:maemo|nokia).*(n900|lumia \d+|rm-\d+)/i,
                    /nokia[-_ ]?(([-\w\. ]*))/i
                ],
                [
                    [
                        MODEL,
                        /_/g,
                        ' '
                    ],
                    [
                        TYPE,
                        MOBILE
                    ],
                    [
                        VENDOR,
                        'Nokia'
                    ]
                ],
                [
                    // Google
                    /(pixel (c|tablet))\b/i // Google Pixel C/Tablet
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        GOOGLE
                    ],
                    [
                        TYPE,
                        TABLET
                    ]
                ],
                [
                    /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i // Google Pixel
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        GOOGLE
                    ],
                    [
                        TYPE,
                        MOBILE
                    ]
                ],
                [
                    // Sony
                    /droid.+; (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        SONY
                    ],
                    [
                        TYPE,
                        MOBILE
                    ]
                ],
                [
                    /sony tablet [ps]/i,
                    /\b(?:sony)?sgp\w+(?: bui|\))/i
                ],
                [
                    [
                        MODEL,
                        'Xperia Tablet'
                    ],
                    [
                        VENDOR,
                        SONY
                    ],
                    [
                        TYPE,
                        TABLET
                    ]
                ],
                [
                    // OnePlus
                    / (kb2005|in20[12]5|be20[12][59])\b/i,
                    /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        ONEPLUS
                    ],
                    [
                        TYPE,
                        MOBILE
                    ]
                ],
                [
                    // Amazon
                    /(alexa)webm/i,
                    /(kf[a-z]{2}wi|aeo(?!bc)\w\w)( bui|\))/i,
                    /(kf[a-z]+)( bui|\)).+silk\//i // Kindle Fire HD
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        AMAZON
                    ],
                    [
                        TYPE,
                        TABLET
                    ]
                ],
                [
                    /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i // Fire Phone
                ],
                [
                    [
                        MODEL,
                        /(.+)/g,
                        'Fire Phone $1'
                    ],
                    [
                        VENDOR,
                        AMAZON
                    ],
                    [
                        TYPE,
                        MOBILE
                    ]
                ],
                [
                    // BlackBerry
                    /(playbook);[-\w\),; ]+(rim)/i // BlackBerry PlayBook
                ],
                [
                    MODEL,
                    VENDOR,
                    [
                        TYPE,
                        TABLET
                    ]
                ],
                [
                    /\b((?:bb[a-f]|st[hv])100-\d)/i,
                    /\(bb10; (\w+)/i // BlackBerry 10
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        BLACKBERRY
                    ],
                    [
                        TYPE,
                        MOBILE
                    ]
                ],
                [
                    // Asus
                    /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        ASUS
                    ],
                    [
                        TYPE,
                        TABLET
                    ]
                ],
                [
                    / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        ASUS
                    ],
                    [
                        TYPE,
                        MOBILE
                    ]
                ],
                [
                    // HTC
                    /(nexus 9)/i // HTC Nexus 9
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        'HTC'
                    ],
                    [
                        TYPE,
                        TABLET
                    ]
                ],
                [
                    /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
                    // ZTE
                    /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
                    /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
                ],
                [
                    VENDOR,
                    [
                        MODEL,
                        /_/g,
                        ' '
                    ],
                    [
                        TYPE,
                        MOBILE
                    ]
                ],
                [
                    // TCL
                    /droid [\w\.]+; ((?:8[14]9[16]|9(?:0(?:48|60|8[01])|1(?:3[27]|66)|2(?:6[69]|9[56])|466))[gqswx])\w*(\)| bui)/i
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        'TCL'
                    ],
                    [
                        TYPE,
                        TABLET
                    ]
                ],
                [
                    // itel
                    /(itel) ((\w+))/i
                ],
                [
                    [
                        VENDOR,
                        lowerize
                    ],
                    MODEL,
                    [
                        TYPE,
                        strMapper,
                        {
                            'tablet': [
                                'p10001l',
                                'w7001'
                            ],
                            '*': 'mobile'
                        }
                    ]
                ],
                [
                    // Acer
                    /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        'Acer'
                    ],
                    [
                        TYPE,
                        TABLET
                    ]
                ],
                [
                    // Meizu
                    /droid.+; (m[1-5] note) bui/i,
                    /\bmz-([-\w]{2,})/i
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        'Meizu'
                    ],
                    [
                        TYPE,
                        MOBILE
                    ]
                ],
                [
                    // Ulefone
                    /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        'Ulefone'
                    ],
                    [
                        TYPE,
                        MOBILE
                    ]
                ],
                [
                    // Energizer
                    /; (energy ?\w+)(?: bui|\))/i,
                    /; energizer ([\w ]+)(?: bui|\))/i
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        'Energizer'
                    ],
                    [
                        TYPE,
                        MOBILE
                    ]
                ],
                [
                    // Cat
                    /; cat (b35);/i,
                    /; (b15q?|s22 flip|s48c|s62 pro)(?: bui|\))/i
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        'Cat'
                    ],
                    [
                        TYPE,
                        MOBILE
                    ]
                ],
                [
                    // Smartfren
                    /((?:new )?andromax[\w- ]+)(?: bui|\))/i
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        'Smartfren'
                    ],
                    [
                        TYPE,
                        MOBILE
                    ]
                ],
                [
                    // Nothing
                    /droid.+; (a(?:015|06[35]|142p?))/i
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        'Nothing'
                    ],
                    [
                        TYPE,
                        MOBILE
                    ]
                ],
                [
                    // Archos
                    /; (x67 5g|tikeasy \w+|ac[1789]\d\w+)( b|\))/i,
                    /archos ?(5|gamepad2?|([\w ]*[t1789]|hello) ?\d+[\w ]*)( b|\))/i
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        'Archos'
                    ],
                    [
                        TYPE,
                        TABLET
                    ]
                ],
                [
                    /archos ([\w ]+)( b|\))/i,
                    /; (ac[3-6]\d\w{2,8})( b|\))/i
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        'Archos'
                    ],
                    [
                        TYPE,
                        MOBILE
                    ]
                ],
                [
                    // MIXED
                    /(imo) (tab \w+)/i,
                    /(infinix) (x1101b?)/i // Infinix XPad
                ],
                [
                    VENDOR,
                    MODEL,
                    [
                        TYPE,
                        TABLET
                    ]
                ],
                [
                    /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus(?! zenw)|dell|jolla|meizu|motorola|polytron|infinix|tecno|micromax|advan)[-_ ]?([-\w]*)/i,
                    // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron/Infinix/Tecno/Micromax/Advan
                    /; (hmd|imo) ([\w ]+?)(?: bui|\))/i,
                    /(hp) ([\w ]+\w)/i,
                    /(microsoft); (lumia[\w ]+)/i,
                    /(lenovo)[-_ ]?([-\w ]+?)(?: bui|\)|\/)/i,
                    /(oppo) ?([\w ]+) bui/i // OPPO
                ],
                [
                    VENDOR,
                    MODEL,
                    [
                        TYPE,
                        MOBILE
                    ]
                ],
                [
                    /(kobo)\s(ereader|touch)/i,
                    /(hp).+(touchpad(?!.+tablet)|tablet)/i,
                    /(kindle)\/([\w\.]+)/i,
                    /(nook)[\w ]+build\/(\w+)/i,
                    /(dell) (strea[kpr\d ]*[\dko])/i,
                    /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
                    /(trinity)[- ]*(t\d{3}) bui/i,
                    /(gigaset)[- ]+(q\w{1,9}) bui/i,
                    /(vodafone) ([\w ]+)(?:\)| bui)/i // Vodafone
                ],
                [
                    VENDOR,
                    MODEL,
                    [
                        TYPE,
                        TABLET
                    ]
                ],
                [
                    /(surface duo)/i // Surface Duo
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        MICROSOFT
                    ],
                    [
                        TYPE,
                        TABLET
                    ]
                ],
                [
                    /droid [\d\.]+; (fp\du?)(?: b|\))/i // Fairphone
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        'Fairphone'
                    ],
                    [
                        TYPE,
                        MOBILE
                    ]
                ],
                [
                    /(u304aa)/i // AT&T
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        'AT&T'
                    ],
                    [
                        TYPE,
                        MOBILE
                    ]
                ],
                [
                    /\bsie-(\w*)/i // Siemens
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        'Siemens'
                    ],
                    [
                        TYPE,
                        MOBILE
                    ]
                ],
                [
                    /\b(rct\w+) b/i // RCA Tablets
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        'RCA'
                    ],
                    [
                        TYPE,
                        TABLET
                    ]
                ],
                [
                    /\b(venue[\d ]{2,7}) b/i // Dell Venue Tablets
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        'Dell'
                    ],
                    [
                        TYPE,
                        TABLET
                    ]
                ],
                [
                    /\b(q(?:mv|ta)\w+) b/i // Verizon Tablet
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        'Verizon'
                    ],
                    [
                        TYPE,
                        TABLET
                    ]
                ],
                [
                    /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i // Barnes & Noble Tablet
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        'Barnes & Noble'
                    ],
                    [
                        TYPE,
                        TABLET
                    ]
                ],
                [
                    /\b(tm\d{3}\w+) b/i
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        'NuVision'
                    ],
                    [
                        TYPE,
                        TABLET
                    ]
                ],
                [
                    /\b(k88) b/i // ZTE K Series Tablet
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        'ZTE'
                    ],
                    [
                        TYPE,
                        TABLET
                    ]
                ],
                [
                    /\b(nx\d{3}j) b/i // ZTE Nubia
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        'ZTE'
                    ],
                    [
                        TYPE,
                        MOBILE
                    ]
                ],
                [
                    /\b(gen\d{3}) b.+49h/i // Swiss GEN Mobile
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        'Swiss'
                    ],
                    [
                        TYPE,
                        MOBILE
                    ]
                ],
                [
                    /\b(zur\d{3}) b/i // Swiss ZUR Tablet
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        'Swiss'
                    ],
                    [
                        TYPE,
                        TABLET
                    ]
                ],
                [
                    /\b((zeki)?tb.*\b) b/i // Zeki Tablets
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        'Zeki'
                    ],
                    [
                        TYPE,
                        TABLET
                    ]
                ],
                [
                    /\b([yr]\d{2}) b/i,
                    /\b(dragon[- ]+touch |dt)(\w{5}) b/i // Dragon Touch Tablet
                ],
                [
                    [
                        VENDOR,
                        'Dragon Touch'
                    ],
                    MODEL,
                    [
                        TYPE,
                        TABLET
                    ]
                ],
                [
                    /\b(ns-?\w{0,9}) b/i // Insignia Tablets
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        'Insignia'
                    ],
                    [
                        TYPE,
                        TABLET
                    ]
                ],
                [
                    /\b((nxa|next)-?\w{0,9}) b/i // NextBook Tablets
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        'NextBook'
                    ],
                    [
                        TYPE,
                        TABLET
                    ]
                ],
                [
                    /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i // Voice Xtreme Phones
                ],
                [
                    [
                        VENDOR,
                        'Voice'
                    ],
                    MODEL,
                    [
                        TYPE,
                        MOBILE
                    ]
                ],
                [
                    /\b(lvtel\-)?(v1[12]) b/i // LvTel Phones
                ],
                [
                    [
                        VENDOR,
                        'LvTel'
                    ],
                    MODEL,
                    [
                        TYPE,
                        MOBILE
                    ]
                ],
                [
                    /\b(ph-1) /i // Essential PH-1
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        'Essential'
                    ],
                    [
                        TYPE,
                        MOBILE
                    ]
                ],
                [
                    /\b(v(100md|700na|7011|917g).*\b) b/i // Envizen Tablets
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        'Envizen'
                    ],
                    [
                        TYPE,
                        TABLET
                    ]
                ],
                [
                    /\b(trio[-\w\. ]+) b/i // MachSpeed Tablets
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        'MachSpeed'
                    ],
                    [
                        TYPE,
                        TABLET
                    ]
                ],
                [
                    /\btu_(1491) b/i // Rotor Tablets
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        'Rotor'
                    ],
                    [
                        TYPE,
                        TABLET
                    ]
                ],
                [
                    /((?:tegranote|shield t(?!.+d tv))[\w- ]*?)(?: b|\))/i // Nvidia Tablets
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        NVIDIA
                    ],
                    [
                        TYPE,
                        TABLET
                    ]
                ],
                [
                    /(sprint) (\w+)/i // Sprint Phones
                ],
                [
                    VENDOR,
                    MODEL,
                    [
                        TYPE,
                        MOBILE
                    ]
                ],
                [
                    /(kin\.[onetw]{3})/i // Microsoft Kin
                ],
                [
                    [
                        MODEL,
                        /\./g,
                        ' '
                    ],
                    [
                        VENDOR,
                        MICROSOFT
                    ],
                    [
                        TYPE,
                        MOBILE
                    ]
                ],
                [
                    /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i // Zebra
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        ZEBRA
                    ],
                    [
                        TYPE,
                        TABLET
                    ]
                ],
                [
                    /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        ZEBRA
                    ],
                    [
                        TYPE,
                        MOBILE
                    ]
                ],
                [
                    ///////////////////
                    // SMARTTVS
                    ///////////////////
                    /smart-tv.+(samsung)/i // Samsung
                ],
                [
                    VENDOR,
                    [
                        TYPE,
                        SMARTTV
                    ]
                ],
                [
                    /hbbtv.+maple;(\d+)/i
                ],
                [
                    [
                        MODEL,
                        /^/,
                        'SmartTV'
                    ],
                    [
                        VENDOR,
                        SAMSUNG
                    ],
                    [
                        TYPE,
                        SMARTTV
                    ]
                ],
                [
                    /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i // LG SmartTV
                ],
                [
                    [
                        VENDOR,
                        LG
                    ],
                    [
                        TYPE,
                        SMARTTV
                    ]
                ],
                [
                    /(apple) ?tv/i // Apple TV
                ],
                [
                    VENDOR,
                    [
                        MODEL,
                        APPLE + ' TV'
                    ],
                    [
                        TYPE,
                        SMARTTV
                    ]
                ],
                [
                    /crkey/i // Google Chromecast
                ],
                [
                    [
                        MODEL,
                        CHROME + 'cast'
                    ],
                    [
                        VENDOR,
                        GOOGLE
                    ],
                    [
                        TYPE,
                        SMARTTV
                    ]
                ],
                [
                    /droid.+aft(\w+)( bui|\))/i // Fire TV
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        AMAZON
                    ],
                    [
                        TYPE,
                        SMARTTV
                    ]
                ],
                [
                    /(shield \w+ tv)/i // Nvidia Shield TV
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        NVIDIA
                    ],
                    [
                        TYPE,
                        SMARTTV
                    ]
                ],
                [
                    /\(dtv[\);].+(aquos)/i,
                    /(aquos-tv[\w ]+)\)/i // Sharp
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        SHARP
                    ],
                    [
                        TYPE,
                        SMARTTV
                    ]
                ],
                [
                    /(bravia[\w ]+)( bui|\))/i // Sony
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        SONY
                    ],
                    [
                        TYPE,
                        SMARTTV
                    ]
                ],
                [
                    /(mi(tv|box)-?\w+) bui/i // Xiaomi
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        XIAOMI
                    ],
                    [
                        TYPE,
                        SMARTTV
                    ]
                ],
                [
                    /Hbbtv.*(technisat) (.*);/i // TechniSAT
                ],
                [
                    VENDOR,
                    MODEL,
                    [
                        TYPE,
                        SMARTTV
                    ]
                ],
                [
                    /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
                    /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i // HbbTV devices
                ],
                [
                    [
                        VENDOR,
                        trim
                    ],
                    [
                        MODEL,
                        trim
                    ],
                    [
                        TYPE,
                        SMARTTV
                    ]
                ],
                [
                    // SmartTV from Unidentified Vendors
                    /droid.+; ([\w- ]+) (?:android tv|smart[- ]?tv)/i
                ],
                [
                    MODEL,
                    [
                        TYPE,
                        SMARTTV
                    ]
                ],
                [
                    /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
                ],
                [
                    [
                        TYPE,
                        SMARTTV
                    ]
                ],
                [
                    ///////////////////
                    // CONSOLES
                    ///////////////////
                    /(ouya)/i,
                    /(nintendo) ([wids3utch]+)/i // Nintendo
                ],
                [
                    VENDOR,
                    MODEL,
                    [
                        TYPE,
                        CONSOLE
                    ]
                ],
                [
                    /droid.+; (shield)( bui|\))/i // Nvidia Portable
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        NVIDIA
                    ],
                    [
                        TYPE,
                        CONSOLE
                    ]
                ],
                [
                    /(playstation \w+)/i // Playstation
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        SONY
                    ],
                    [
                        TYPE,
                        CONSOLE
                    ]
                ],
                [
                    /\b(xbox(?: one)?(?!; xbox))[\); ]/i // Microsoft Xbox
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        MICROSOFT
                    ],
                    [
                        TYPE,
                        CONSOLE
                    ]
                ],
                [
                    ///////////////////
                    // WEARABLES
                    ///////////////////
                    /\b(sm-[lr]\d\d[0156][fnuw]?s?|gear live)\b/i // Samsung Galaxy Watch
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        SAMSUNG
                    ],
                    [
                        TYPE,
                        WEARABLE
                    ]
                ],
                [
                    /((pebble))app/i,
                    /(asus|google|lg|oppo) ((pixel |zen)?watch[\w ]*)( bui|\))/i // Asus ZenWatch / LG Watch / Pixel Watch
                ],
                [
                    VENDOR,
                    MODEL,
                    [
                        TYPE,
                        WEARABLE
                    ]
                ],
                [
                    /(ow(?:19|20)?we?[1-3]{1,3})/i // Oppo Watch
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        OPPO
                    ],
                    [
                        TYPE,
                        WEARABLE
                    ]
                ],
                [
                    /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i // Apple Watch
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        APPLE
                    ],
                    [
                        TYPE,
                        WEARABLE
                    ]
                ],
                [
                    /(opwwe\d{3})/i // OnePlus Watch
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        ONEPLUS
                    ],
                    [
                        TYPE,
                        WEARABLE
                    ]
                ],
                [
                    /(moto 360)/i // Motorola 360
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        MOTOROLA
                    ],
                    [
                        TYPE,
                        WEARABLE
                    ]
                ],
                [
                    /(smartwatch 3)/i // Sony SmartWatch
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        SONY
                    ],
                    [
                        TYPE,
                        WEARABLE
                    ]
                ],
                [
                    /(g watch r)/i // LG G Watch R
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        LG
                    ],
                    [
                        TYPE,
                        WEARABLE
                    ]
                ],
                [
                    /droid.+; (wt63?0{2,3})\)/i
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        ZEBRA
                    ],
                    [
                        TYPE,
                        WEARABLE
                    ]
                ],
                [
                    ///////////////////
                    // XR
                    ///////////////////
                    /droid.+; (glass) \d/i // Google Glass
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        GOOGLE
                    ],
                    [
                        TYPE,
                        WEARABLE
                    ]
                ],
                [
                    /(pico) (4|neo3(?: link|pro)?)/i // Pico
                ],
                [
                    VENDOR,
                    MODEL,
                    [
                        TYPE,
                        WEARABLE
                    ]
                ],
                [
                    /; (quest( \d| pro)?)/i // Oculus Quest
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        FACEBOOK
                    ],
                    [
                        TYPE,
                        WEARABLE
                    ]
                ],
                [
                    ///////////////////
                    // EMBEDDED
                    ///////////////////
                    /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i // Tesla
                ],
                [
                    VENDOR,
                    [
                        TYPE,
                        EMBEDDED
                    ]
                ],
                [
                    /(aeobc)\b/i // Echo Dot
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        AMAZON
                    ],
                    [
                        TYPE,
                        EMBEDDED
                    ]
                ],
                [
                    /(homepod).+mac os/i // Apple HomePod
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        APPLE
                    ],
                    [
                        TYPE,
                        EMBEDDED
                    ]
                ],
                [
                    /windows iot/i
                ],
                [
                    [
                        TYPE,
                        EMBEDDED
                    ]
                ],
                [
                    ////////////////////
                    // MIXED (GENERIC)
                    ///////////////////
                    /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i // Android Phones from Unidentified Vendors
                ],
                [
                    MODEL,
                    [
                        TYPE,
                        MOBILE
                    ]
                ],
                [
                    /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i // Android Tablets from Unidentified Vendors
                ],
                [
                    MODEL,
                    [
                        TYPE,
                        TABLET
                    ]
                ],
                [
                    /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i // Unidentifiable Tablet
                ],
                [
                    [
                        TYPE,
                        TABLET
                    ]
                ],
                [
                    /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i // Unidentifiable Mobile
                ],
                [
                    [
                        TYPE,
                        MOBILE
                    ]
                ],
                [
                    /droid .+?; ([\w\. -]+)( bui|\))/i // Generic Android Device
                ],
                [
                    MODEL,
                    [
                        VENDOR,
                        'Generic'
                    ]
                ]
            ],
            engine: [
                [
                    /windows.+ edge\/([\w\.]+)/i // EdgeHTML
                ],
                [
                    VERSION,
                    [
                        NAME,
                        EDGE + 'HTML'
                    ]
                ],
                [
                    /(arkweb)\/([\w\.]+)/i // ArkWeb
                ],
                [
                    NAME,
                    VERSION
                ],
                [
                    /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i // Blink
                ],
                [
                    VERSION,
                    [
                        NAME,
                        'Blink'
                    ]
                ],
                [
                    /(presto)\/([\w\.]+)/i,
                    /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna|servo)\/([\w\.]+)/i,
                    /ekioh(flow)\/([\w\.]+)/i,
                    /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
                    /(icab)[\/ ]([23]\.[\d\.]+)/i,
                    /\b(libweb)/i // LibWeb
                ],
                [
                    NAME,
                    VERSION
                ],
                [
                    /ladybird\//i
                ],
                [
                    [
                        NAME,
                        'LibWeb'
                    ]
                ],
                [
                    /rv\:([\w\.]{1,9})\b.+(gecko)/i // Gecko
                ],
                [
                    VERSION,
                    NAME
                ]
            ],
            os: [
                [
                    // Windows
                    /microsoft (windows) (vista|xp)/i // Windows (iTunes)
                ],
                [
                    NAME,
                    VERSION
                ],
                [
                    /(windows (?:phone(?: os)?|mobile|iot))[\/ ]?([\d\.\w ]*)/i // Windows Phone
                ],
                [
                    NAME,
                    [
                        VERSION,
                        strMapper,
                        windowsVersionMap
                    ]
                ],
                [
                    /windows nt 6\.2; (arm)/i,
                    /windows[\/ ]([ntce\d\. ]+\w)(?!.+xbox)/i,
                    /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
                ],
                [
                    [
                        VERSION,
                        strMapper,
                        windowsVersionMap
                    ],
                    [
                        NAME,
                        'Windows'
                    ]
                ],
                [
                    // iOS/macOS
                    /[adehimnop]{4,7}\b(?:.*os ([\w]+) like mac|; opera)/i,
                    /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
                    /cfnetwork\/.+darwin/i
                ],
                [
                    [
                        VERSION,
                        /_/g,
                        '.'
                    ],
                    [
                        NAME,
                        'iOS'
                    ]
                ],
                [
                    /(mac os x) ?([\w\. ]*)/i,
                    /(macintosh|mac_powerpc\b)(?!.+haiku)/i // Mac OS
                ],
                [
                    [
                        NAME,
                        MAC_OS
                    ],
                    [
                        VERSION,
                        /_/g,
                        '.'
                    ]
                ],
                [
                    // Mobile OSes
                    /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i // Android-x86/HarmonyOS
                ],
                [
                    VERSION,
                    NAME
                ],
                [
                    /(ubuntu) ([\w\.]+) like android/i // Ubuntu Touch
                ],
                [
                    [
                        NAME,
                        /(.+)/,
                        '$1 Touch'
                    ],
                    VERSION
                ],
                [
                    // Android/Blackberry/WebOS/QNX/Bada/RIM/KaiOS/Maemo/MeeGo/S40/Sailfish OS/OpenHarmony/Tizen
                    /(android|bada|blackberry|kaios|maemo|meego|openharmony|qnx|rim tablet os|sailfish|series40|symbian|tizen|webos)\w*[-\/; ]?([\d\.]*)/i
                ],
                [
                    NAME,
                    VERSION
                ],
                [
                    /\(bb(10);/i // BlackBerry 10
                ],
                [
                    VERSION,
                    [
                        NAME,
                        BLACKBERRY
                    ]
                ],
                [
                    /(?:symbian ?os|symbos|s60(?=;)|series ?60)[-\/ ]?([\w\.]*)/i // Symbian
                ],
                [
                    VERSION,
                    [
                        NAME,
                        'Symbian'
                    ]
                ],
                [
                    /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i // Firefox OS
                ],
                [
                    VERSION,
                    [
                        NAME,
                        FIREFOX + ' OS'
                    ]
                ],
                [
                    /web0s;.+rt(tv)/i,
                    /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i // WebOS
                ],
                [
                    VERSION,
                    [
                        NAME,
                        'webOS'
                    ]
                ],
                [
                    /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i // watchOS
                ],
                [
                    VERSION,
                    [
                        NAME,
                        'watchOS'
                    ]
                ],
                [
                    // Google Chromecast
                    /crkey\/([\d\.]+)/i // Google Chromecast
                ],
                [
                    VERSION,
                    [
                        NAME,
                        CHROME + 'cast'
                    ]
                ],
                [
                    /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i // Chromium OS
                ],
                [
                    [
                        NAME,
                        CHROMIUM_OS
                    ],
                    VERSION
                ],
                [
                    // Smart TVs
                    /panasonic;(viera)/i,
                    /(netrange)mmh/i,
                    /(nettv)\/(\d+\.[\w\.]+)/i,
                    // Console
                    /(nintendo|playstation) ([wids345portablevuch]+)/i,
                    /(xbox); +xbox ([^\);]+)/i,
                    // Other
                    /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
                    /(mint)[\/\(\) ]?(\w*)/i,
                    /(mageia|vectorlinux)[; ]/i,
                    /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                    // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
                    /(hurd|linux)(?: arm\w*| x86\w*| ?)([\w\.]*)/i,
                    /(gnu) ?([\w\.]*)/i,
                    /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
                    /(haiku) (\w+)/i // Haiku
                ],
                [
                    NAME,
                    VERSION
                ],
                [
                    /(sunos) ?([\w\.\d]*)/i // Solaris
                ],
                [
                    [
                        NAME,
                        'Solaris'
                    ],
                    VERSION
                ],
                [
                    /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
                    /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
                    /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
                    /(unix) ?([\w\.]*)/i // UNIX
                ],
                [
                    NAME,
                    VERSION
                ]
            ]
        };
        /////////////////
        // Constructor
        ////////////////
        var UAParser = function(ua, extensions) {
            if (typeof ua === OBJ_TYPE) {
                extensions = ua;
                ua = undefined$1;
            }
            if (!(this instanceof UAParser)) {
                return new UAParser(ua, extensions).getResult();
            }
            var _navigator = typeof window1 !== UNDEF_TYPE && window1.navigator ? window1.navigator : undefined$1;
            var _ua = ua || (_navigator && _navigator.userAgent ? _navigator.userAgent : EMPTY);
            var _uach = _navigator && _navigator.userAgentData ? _navigator.userAgentData : undefined$1;
            var _rgxmap = extensions ? extend(regexes, extensions) : regexes;
            var _isSelfNav = _navigator && _navigator.userAgent == _ua;
            this.getBrowser = function() {
                var _browser = {};
                _browser[NAME] = undefined$1;
                _browser[VERSION] = undefined$1;
                rgxMapper.call(_browser, _ua, _rgxmap.browser);
                _browser[MAJOR] = majorize(_browser[VERSION]);
                // Brave-specific detection
                if (_isSelfNav && _navigator && _navigator.brave && typeof _navigator.brave.isBrave == FUNC_TYPE) {
                    _browser[NAME] = 'Brave';
                }
                return _browser;
            };
            this.getCPU = function() {
                var _cpu = {};
                _cpu[ARCHITECTURE] = undefined$1;
                rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
                return _cpu;
            };
            this.getDevice = function() {
                var _device = {};
                _device[VENDOR] = undefined$1;
                _device[MODEL] = undefined$1;
                _device[TYPE] = undefined$1;
                rgxMapper.call(_device, _ua, _rgxmap.device);
                if (_isSelfNav && !_device[TYPE] && _uach && _uach.mobile) {
                    _device[TYPE] = MOBILE;
                }
                // iPadOS-specific detection: identified as Mac, but has some iOS-only properties
                if (_isSelfNav && _device[MODEL] == 'Macintosh' && _navigator && typeof _navigator.standalone !== UNDEF_TYPE && _navigator.maxTouchPoints && _navigator.maxTouchPoints > 2) {
                    _device[MODEL] = 'iPad';
                    _device[TYPE] = TABLET;
                }
                return _device;
            };
            this.getEngine = function() {
                var _engine = {};
                _engine[NAME] = undefined$1;
                _engine[VERSION] = undefined$1;
                rgxMapper.call(_engine, _ua, _rgxmap.engine);
                return _engine;
            };
            this.getOS = function() {
                var _os = {};
                _os[NAME] = undefined$1;
                _os[VERSION] = undefined$1;
                rgxMapper.call(_os, _ua, _rgxmap.os);
                if (_isSelfNav && !_os[NAME] && _uach && _uach.platform && _uach.platform != 'Unknown') {
                    _os[NAME] = _uach.platform.replace(/chrome os/i, CHROMIUM_OS).replace(/macos/i, MAC_OS); // backward compatibility
                }
                return _os;
            };
            this.getResult = function() {
                return {
                    ua: this.getUA(),
                    browser: this.getBrowser(),
                    engine: this.getEngine(),
                    os: this.getOS(),
                    device: this.getDevice(),
                    cpu: this.getCPU()
                };
            };
            this.getUA = function() {
                return _ua;
            };
            this.setUA = function(ua) {
                _ua = typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH ? trim(ua, UA_MAX_LENGTH) : ua;
                return this;
            };
            this.setUA(_ua);
            return this;
        };
        UAParser.VERSION = LIBVERSION;
        UAParser.BROWSER = enumerize([
            NAME,
            VERSION,
            MAJOR
        ]);
        UAParser.CPU = enumerize([
            ARCHITECTURE
        ]);
        UAParser.DEVICE = enumerize([
            MODEL,
            VENDOR,
            TYPE,
            CONSOLE,
            MOBILE,
            SMARTTV,
            TABLET,
            WEARABLE,
            EMBEDDED
        ]);
        UAParser.ENGINE = UAParser.OS = enumerize([
            NAME,
            VERSION
        ]);
        ///////////
        // Export
        //////////
        // check js environment
        {
            // nodejs env
            if (module.exports) {
                exports = module.exports = UAParser;
            }
            exports.UAParser = UAParser;
        }
        // jQuery/Zepto specific (optional)
        // Note:
        //   In AMD env the global scope should be kept clean, but jQuery is an exception.
        //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
        //   and we should catch that.
        var $ = typeof window1 !== UNDEF_TYPE && (window1.jQuery || window1.Zepto);
        if ($ && !$.ua) {
            var parser = new UAParser();
            $.ua = parser.getResult();
            $.ua.get = function() {
                return parser.getUA();
            };
            $.ua.set = function(ua) {
                parser.setUA(ua);
                var result = parser.getResult();
                for(var prop in result){
                    $.ua[prop] = result[prop];
                }
            };
        }
    })(typeof window === 'object' ? window : commonjsGlobal);
})(uaParser, uaParser.exports);
var uaParserExports = uaParser.exports;
var UAParser = /*@__PURE__*/ getDefaultExportFromCjs(uaParserExports);

// NOTE: Since, we are strict on types for avro schema, it's safer to fallback
// on higher range of empty types (empty string, false, etc.)
var UNKNOWN_VALUE = 'UNKNOWN';
var NA_VALUE = 'NA';
var getDeviceType = function(userAgentType) {
    if (userAgentType !== 'mobile') {
        // mobile we can determine more likely reliably
        return getDeviceTypeByDimension();
    }
    return userAgentType;
};
var getDeviceTypeByDimension = function() {
    var screenWidth = window.screen.width || document.documentElement.clientWidth || document.body.clientWidth;
    var screenHeight = window.screen.height || document.documentElement.clientHeight || document.body.clientHeight;
    if (screenWidth >= 1024 && screenHeight >= 768) {
        return 'desktop';
    } else if (screenWidth >= 768 && screenHeight >= 1024) {
        return 'tablet';
    } else {
        return 'mobile';
    }
};
var getSystemInfoWithUaParser = function() {
    var _a;
    try {
        var parser = new UAParser();
        var systemInfo = parser.getResult();
        var browserInfo = systemInfo.browser;
        var osInfo = systemInfo.os;
        var deviceInfo = systemInfo.device;
        return {
            browser: browserInfo.name,
            browserVersion: browserInfo.version,
            system: osInfo.name,
            systemModel: deviceInfo.vendor,
            systemVersion: osInfo.version,
            type: (_a = deviceInfo.type) !== null && _a !== void 0 ? _a : 'desktop'
        };
    } catch (error) {
        console.error('Failed to load ua-parser-js for system info:', error);
        return {
            browser: undefined,
            browserVersion: undefined,
            system: undefined,
            systemModel: undefined,
            systemVersion: undefined,
            type: 'desktop'
        };
    }
};
var getSystemInfo = function() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    if ((_a = window.flippxp) === null || _a === undefined ? undefined : _a.useragent) {
        return {
            browser: (_c = (_b = window.flippxp) === null || _b === undefined ? undefined : _b.useragent) === null || _c === undefined ? undefined : _c.browser,
            browserVersion: (_e = (_d = window.flippxp) === null || _d === undefined ? undefined : _d.useragent) === null || _e === undefined ? undefined : _e.browserVersion,
            system: (_g = (_f = window.flippxp) === null || _f === undefined ? undefined : _f.useragent) === null || _g === undefined ? undefined : _g.system,
            systemModel: (_j = (_h = window.flippxp) === null || _h === undefined ? undefined : _h.useragent) === null || _j === undefined ? undefined : _j.systemModel,
            systemVersion: (_l = (_k = window.flippxp) === null || _k === undefined ? undefined : _k.useragent) === null || _l === undefined ? undefined : _l.systemVersion,
            type: getDeviceType((_o = (_m = window.flippxp) === null || _m === undefined ? undefined : _m.useragent) === null || _o === undefined ? undefined : _o.type)
        };
    }
    return getSystemInfoWithUaParser();
};
var Service$1 = /** @class */ function() {
    function Service() {}
    Service.prototype.getDeviceInfo = function(overrides) {
        if (this.deviceInfo) {
            return this.deviceInfo;
        }
        var _a = getSystemInfo(), browser = _a.browser, browserVersion = _a.browserVersion, system = _a.system, systemModel = _a.systemModel, systemVersion = _a.systemVersion, type = _a.type;
        this.deviceInfo = __assign({
            browser: browser !== null && browser !== undefined ? browser : UNKNOWN_VALUE,
            browserVersion: browserVersion !== null && browserVersion !== undefined ? browserVersion : NA_VALUE,
            devicePixelRatio: Math.round(window.devicePixelRatio * 1000) || 0,
            host: document.referrer,
            iframeWidth: window.innerWidth,
            screenHeight: window.screen.height,
            screenWidth: window.screen.width,
            system: system !== null && system !== undefined ? system : UNKNOWN_VALUE,
            systemModel: systemModel !== null && systemModel !== undefined ? systemModel : UNKNOWN_VALUE,
            systemVersion: systemVersion !== null && systemVersion !== undefined ? systemVersion : NA_VALUE,
            type: type !== null && type !== undefined ? type : 'desktop'
        }, overrides);
        return this.deviceInfo;
    };
    return Service;
}();
var DeviceService = new Service$1();

var asNumber = function(value, defaultValue) {
    if (defaultValue === undefined) {
        defaultValue = 0;
    }
    if (typeof value === 'number') return value;
    if (typeof value === 'string') {
        var converted = parseInt(value, 10);
        return isNaN(converted) ? defaultValue : converted;
    }
    return defaultValue;
};

var UXType;
(function(UXType) {
    UXType["INLINE"] = "inline";
    UXType["DEFAULT"] = "default";
    UXType["ULP"] = "ulp";
    UXType["SURVEY"] = "survey";
})(UXType || (UXType = {}));
var Environment;
(function(Environment) {
    Environment["development"] = "development";
    Environment["staging"] = "staging";
    Environment["production"] = "production";
})(Environment || (Environment = {}));
var TimedActionType;
(function(TimedActionType) {
    TimedActionType["SCROLL"] = "scroll";
    TimedActionType["ENGAGEMENT"] = "engagement";
    TimedActionType["OPEN"] = "open";
    TimedActionType["HEARTBEAT"] = "heartbeat";
})(TimedActionType || (TimedActionType = {}));
var ExperienceType;
(function(ExperienceType) {
    ExperienceType["Compact"] = "Compact";
    ExperienceType["Classic"] = "Classic";
    ExperienceType["MultiStandard"] = "MultiStandard";
    ExperienceType["Unknown"] = "Unknown";
    ExperienceType["FixedHeight"] = "FixedHeight";
    ExperienceType["VideoAd"] = "VideoAd";
})(ExperienceType || (ExperienceType = {}));
var IntegrationType;
(function(IntegrationType) {
    IntegrationType["PREBID"] = "prebid";
    IntegrationType["NESTED_IFRAME"] = "nestedIframe";
    IntegrationType["GOOGLE_AMP"] = "googleAmp";
    IntegrationType["STANDALONE"] = "standalone";
    IntegrationType["NATIVE"] = "native";
    IntegrationType["OPENRTB"] = "openrtb";
})(IntegrationType || (IntegrationType = {}));
var FixedHeightInteractionType;
(function(FixedHeightInteractionType) {
    FixedHeightInteractionType["PROGRESS_BAR_CLICK"] = "progressBarClick";
    FixedHeightInteractionType["SWIPE"] = "swipe";
})(FixedHeightInteractionType || (FixedHeightInteractionType = {}));

function getIntegrationType(options) {
    if (options.integrationType === IntegrationType.PREBID) return IntegrationType.PREBID;
    if (options.integrationType === IntegrationType.OPENRTB) return IntegrationType.OPENRTB;
    if (options.prebid) return IntegrationType.PREBID;
    if (options.nestedIframe) return IntegrationType.NESTED_IFRAME;
    if (options.isGoogleAmp) return IntegrationType.GOOGLE_AMP;
    if (options.standalone) return IntegrationType.STANDALONE;
    return IntegrationType.NATIVE;
}
var isFullScreenExperience = function(integrationType) {
    return integrationType === IntegrationType.STANDALONE;
};

var isInIframe = function() {
    return window !== window.parent;
};

var getParentHostname = function() {
    try {
        return window.parent.location.hostname || null;
    } catch (error) {
        Logger.debug("Error accessing parent hostname: ".concat(error instanceof Error ? error.message : String(error)));
        return null;
    }
};
var getReferrerHostname = function() {
    if (!document.referrer) {
        return null;
    }
    try {
        var referrerUrl = new URL(document.referrer);
        return referrerUrl.hostname;
    } catch (error) {
        Logger.warn("Error accessing referrer hostname: ".concat(error instanceof Error ? error.message : String(error)));
        return null;
    }
};
var getIframeHostname = function() {
    var parentHostname = getParentHostname();
    if (parentHostname) {
        return parentHostname;
    }
    return getReferrerHostname();
};
var getSiteDomain = function(overrideHostname) {
    if (overrideHostname) {
        return overrideHostname;
    }
    if (isInIframe()) {
        var iframeHostname = getIframeHostname();
        if (iframeHostname) {
            return iframeHostname;
        }
    }
    return window.location.hostname || 'none';
};

var ULPMessageType;
(function(ULPMessageType) {
    ULPMessageType["CLICK_MEATBALL"] = "CLICK_MEATBALL";
    ULPMessageType["SHARE_ITEM"] = "SHARE_ITEM";
    ULPMessageType["SEE_ITEM"] = "SEE_ITEM";
    ULPMessageType["CLIP_ITEM"] = "CLIP_ITEM";
    ULPMessageType["SEE_MERCHANT_ITEM"] = "SEE_MERCHANT_ITEM";
    ULPMessageType["CLIP_MERCHANT_ITEM"] = "CLIP_MERCHANT_ITEM";
    ULPMessageType["CLICK"] = "CLICK";
    ULPMessageType["CLIP_ECOM_ITEM"] = "CLIP_ECOM_ITEM";
    ULPMessageType["ITEM_IMPRESSION"] = "ITEM_IMPRESSION";
    ULPMessageType["SEE_ALL_DEALS"] = "SEE_ALL_DEALS";
})(ULPMessageType || (ULPMessageType = {}));
var createFlyerItemData = function(detail) {
    return {
        'com.flipp.beacon.shopperPlatform.entity.FlyerItemData': {
            flyer: {
                flyerId: asNumber(detail.flyer_id, 0),
                flyerRunId: -1,
                flyerTypeId: -1,
                storeId: null,
                premium: !!detail.premium
            },
            flyerItem: {
                id: asNumber(detail.flyer_item_id, 0)
            }
        }
    };
};
var createMerchantItemData = function(detail) {
    var _a, _b, _c, _d, _e;
    return {
        'com.flipp.beacon.shopperPlatform.entity.MerchantItemData': {
            merchantItem: {
                globalID: (_a = detail.global_id) !== null && _a !== undefined ? _a : '-1',
                price: {
                    double: (_b = detail.price) !== null && _b !== undefined ? _b : -1
                }
            },
            storeId: detail.store_code ? asNumber(detail.store_code) : -1,
            url: (_c = detail.link) !== null && _c !== undefined ? _c : '',
            itemName: '',
            position: -1,
            offerId: (_e = (_d = detail.global_id) !== null && _d !== undefined ? _d : detail.global_id_int) !== null && _e !== undefined ? _e : ''
        }
    };
};
var getItemId = function(detail) {
    if ('item_id' in detail && detail.item_id) return {
        string: detail.item_id
    };
    if ('global_id_int' in detail && detail.global_id_int) return {
        string: detail.global_id_int
    };
    if ('global_id' in detail && detail.global_id) return {
        string: detail.global_id
    };
    return null;
};
var getGlobalId = function(detail) {
    if ('global_id_int' in detail && detail.global_id_int) return {
        string: detail.global_id_int
    };
    if ('global_id' in detail && detail.global_id) return {
        string: detail.global_id
    };
    return null;
};
var createEcomItemData = function(detail) {
    var _a, _b, _c, _d;
    return {
        'com.flipp.beacon.shopperPlatform.entity.EcomItemData': {
            ecomItem: {
                id: 'id' in detail && detail.id ? asNumber(detail.id) : -1,
                itemId: getItemId(detail),
                sku: 'sku' in detail && detail.sku ? {
                    string: detail.sku || ''
                } : null,
                globalId: getGlobalId(detail)
            },
            url: (_b = (_a = detail.link) !== null && _a !== undefined ? _a : 'url' in detail ? detail.url : '') !== null && _b !== undefined ? _b : '',
            itemName: '',
            price: null,
            position: -1,
            offerId: (_d = (_c = 'global_id' in detail ? detail.global_id : undefined) !== null && _c !== undefined ? _c : 'global_id_int' in detail ? detail.global_id_int : undefined) !== null && _d !== undefined ? _d : ''
        }
    };
};
var processItemData = function(itemType, detail) {
    var merchant = {
        merchantId: detail.merchant_id
    };
    var flyerItemData = itemType === ItemType.Flyer ? createFlyerItemData(detail) : null;
    var merchantItemData = itemType === ItemType.Merchant ? createMerchantItemData(detail) : null;
    var ecomItemData = itemType === ItemType.Ecom ? createEcomItemData(detail) : null;
    return {
        itemType: itemType,
        merchant: merchant,
        flyerItemData: flyerItemData,
        merchantItemData: merchantItemData,
        ecomItemData: ecomItemData
    };
};
var processImpressionItemData = function(items) {
    return items.map(function(item) {
        var itemType = getUlpItemType(item.itemType);
        return processItemData(itemType, item);
    });
};
var getUlpItemType = function(type) {
    switch(type){
        case 'flyer':
            return ItemType.Flyer;
        case 'merchant_item':
        case 'merchant':
            return ItemType.Merchant;
        case 'ecom':
            return ItemType.Ecom;
        default:
            // eslint-disable-next-line functional/no-throw-statements
            throw new Error('ULP item type not recognized');
    }
};
var getULPSchemaId = function(type) {
    switch(type){
        case ULPMessageType.CLICK_MEATBALL:
            return LandingItemClickSchemaId;
        case ULPMessageType.SHARE_ITEM:
            return LandingItemClickSaveSchemaId;
        case ULPMessageType.CLIP_ITEM:
        case ULPMessageType.CLIP_MERCHANT_ITEM:
        case ULPMessageType.CLIP_ECOM_ITEM:
            return LandingItemClickSaveSchemaId;
        case ULPMessageType.SEE_ITEM:
        case ULPMessageType.SEE_MERCHANT_ITEM:
        case ULPMessageType.CLICK:
            return LandingItemClickTransferToMerchantSchemaId;
        case ULPMessageType.SEE_ALL_DEALS:
        case ULPMessageType.ITEM_IMPRESSION:
        default:
            // eslint-disable-next-line functional/no-throw-statements
            throw new Error('No schema associated with ULP message');
    }
};
var translateDecisionToAvro = function(_a) {
    var _b, _c;
    var _d = _a.decision, campaignId = _d.campaignId, flightId = _d.flightId, advertiserId = _d.advertiserId, creativeId = _d.creativeId, adId = _d.adId, storefront = _d.storefront, siteId = _a.siteId, zoneId = _a.zoneId, positionIndex = _a.positionIndex, customUrl = _a.customUrl;
    return {
        campaignId: campaignId,
        flightId: flightId,
        advertiserId: advertiserId,
        creativeId: creativeId,
        adId: adId,
        siteId: siteId,
        zoneId: zoneId,
        customUrl: customUrl ? {
            string: customUrl
        } : null,
        positionIndex: positionIndex ? {
            int: positionIndex
        } : null,
        flyerId: (_b = storefront === null || storefront === undefined ? undefined : storefront.flyer_id) !== null && _b !== undefined ? _b : 0,
        merchantId: (_c = storefront === null || storefront === undefined ? undefined : storefront.merchant_id) !== null && _c !== undefined ? _c : 0
    };
};
var createUlpHeartbeatBeacon = function(_a) {
    var partnerNameIdentifier = _a.partnerNameIdentifier, elapsedSeconds = _a.elapsedSeconds, decision = _a.decision, siteId = _a.siteId, zoneId = _a.zoneId, customUrl = _a.customUrl, options = _a.options, postalCode = _a.postalCode, campaignNameIdentifier = _a.campaignNameIdentifier, positionIndex = _a.positionIndex;
    return __assign(__assign({}, createBaseBeacon({
        schemaId: LandingHeartbeatPageSchemaId,
        partnerNameIdentifier: partnerNameIdentifier,
        siteId: siteId,
        zoneId: zoneId,
        options: options,
        postalCode: postalCode,
        campaignNameIdentifier: campaignNameIdentifier,
        shopperPlatformUx: ShopperPlatformUx.UlpInline
    })), {
        elapsedSeconds: elapsedSeconds,
        decision: getDecisionParameters(translateDecisionToAvro({
            decision: decision,
            siteId: siteId,
            zoneId: zoneId,
            positionIndex: positionIndex,
            customUrl: customUrl
        }))
    });
};
var createUlpViewBeacon = function(_a) {
    var partnerNameIdentifier = _a.partnerNameIdentifier, decision = _a.decision, siteId = _a.siteId, zoneId = _a.zoneId, customUrl = _a.customUrl, options = _a.options, postalCode = _a.postalCode, campaignNameIdentifier = _a.campaignNameIdentifier, positionIndex = _a.positionIndex;
    return __assign(__assign({}, createBaseBeacon({
        schemaId: LandingInViewSchemaId,
        partnerNameIdentifier: partnerNameIdentifier,
        siteId: siteId,
        zoneId: zoneId,
        options: options,
        postalCode: postalCode,
        campaignNameIdentifier: campaignNameIdentifier,
        shopperPlatformUx: ShopperPlatformUx.UlpInline
    })), {
        decision: getDecisionParameters(translateDecisionToAvro({
            decision: decision,
            siteId: siteId,
            zoneId: zoneId,
            positionIndex: positionIndex,
            customUrl: customUrl
        }))
    });
};
var createUlpOpenBeacon = function(_a) {
    var partnerNameIdentifier = _a.partnerNameIdentifier, decision = _a.decision, siteId = _a.siteId, zoneId = _a.zoneId, customUrl = _a.customUrl, options = _a.options, postalCode = _a.postalCode, campaignNameIdentifier = _a.campaignNameIdentifier, positionIndex = _a.positionIndex;
    return __assign(__assign({}, createBaseBeacon({
        schemaId: LandingOpenPageSchemaId,
        partnerNameIdentifier: partnerNameIdentifier,
        siteId: siteId,
        zoneId: zoneId,
        options: options,
        postalCode: postalCode,
        campaignNameIdentifier: campaignNameIdentifier,
        shopperPlatformUx: ShopperPlatformUx.UlpInline
    })), {
        decision: getDecisionParameters(translateDecisionToAvro({
            decision: decision,
            siteId: siteId,
            zoneId: zoneId,
            positionIndex: positionIndex,
            customUrl: customUrl
        }))
    });
};
var createUlpClickBeacon = function(_a) {
    var partnerNameIdentifier = _a.partnerNameIdentifier, decision = _a.decision, siteId = _a.siteId, zoneId = _a.zoneId, customUrl = _a.customUrl, message = _a.message, itemType = _a.itemType, options = _a.options, postalCode = _a.postalCode, campaignNameIdentifier = _a.campaignNameIdentifier, positionIndex = _a.positionIndex;
    return __assign(__assign({}, createBaseBeacon(//! Type assertion is an ugly hack here, but a real fix invoves a massive refactor ¯\_(ツ)_/¯
    {
        schemaId: getULPSchemaId(message.type),
        partnerNameIdentifier: partnerNameIdentifier,
        siteId: siteId,
        zoneId: zoneId,
        options: options,
        postalCode: postalCode,
        campaignNameIdentifier: campaignNameIdentifier,
        shopperPlatformUx: ShopperPlatformUx.UlpInline
    })), {
        itemData: processItemData(itemType, message.detail),
        decision: getDecisionParameters(translateDecisionToAvro({
            decision: decision,
            siteId: siteId,
            zoneId: zoneId,
            positionIndex: positionIndex,
            customUrl: customUrl
        }))
    });
};
var createUlpClickSaveBeacon = function(_a) {
    var partnerNameIdentifier = _a.partnerNameIdentifier, decision = _a.decision, siteId = _a.siteId, zoneId = _a.zoneId, customUrl = _a.customUrl, message = _a.message, itemType = _a.itemType, options = _a.options, postalCode = _a.postalCode, campaignNameIdentifier = _a.campaignNameIdentifier, positionIndex = _a.positionIndex;
    return __assign(__assign({}, createBaseBeacon(//! Type assertion is an ugly hack here, but a real fix invoves a massive refactor ¯\_(ツ)_/¯
    {
        schemaId: getULPSchemaId(message.type),
        partnerNameIdentifier: partnerNameIdentifier,
        siteId: siteId,
        zoneId: zoneId,
        options: options,
        postalCode: postalCode,
        campaignNameIdentifier: campaignNameIdentifier,
        shopperPlatformUx: ShopperPlatformUx.UlpInline
    })), {
        itemData: processItemData(itemType, message.detail),
        decision: getDecisionParameters(translateDecisionToAvro({
            decision: decision,
            siteId: siteId,
            zoneId: zoneId,
            positionIndex: positionIndex,
            customUrl: customUrl
        }))
    });
};
var createUlpEngagementBeacon = function(_a) {
    var partnerNameIdentifier = _a.partnerNameIdentifier, decision = _a.decision, siteId = _a.siteId, zoneId = _a.zoneId, customUrl = _a.customUrl, options = _a.options, postalCode = _a.postalCode, campaignNameIdentifier = _a.campaignNameIdentifier, positionIndex = _a.positionIndex;
    return __assign(__assign({}, createBaseBeacon({
        schemaId: LandingEngagedVisitPageSchemaId,
        partnerNameIdentifier: partnerNameIdentifier,
        siteId: siteId,
        zoneId: zoneId,
        options: options,
        postalCode: postalCode,
        campaignNameIdentifier: campaignNameIdentifier,
        shopperPlatformUx: ShopperPlatformUx.UlpInline
    })), {
        decision: getDecisionParameters(translateDecisionToAvro({
            decision: decision,
            siteId: siteId,
            zoneId: zoneId,
            positionIndex: positionIndex,
            customUrl: customUrl
        }))
    });
};
var createUlpItemImpressionBeacon = function(_a) {
    var partnerNameIdentifier = _a.partnerNameIdentifier, decision = _a.decision, siteId = _a.siteId, zoneId = _a.zoneId, customUrl = _a.customUrl, message = _a.message, options = _a.options, postalCode = _a.postalCode, campaignNameIdentifier = _a.campaignNameIdentifier, positionIndex = _a.positionIndex;
    return __assign(__assign({}, createBaseBeacon({
        schemaId: LandingImpressionItemSchemaId,
        partnerNameIdentifier: partnerNameIdentifier,
        siteId: siteId,
        zoneId: zoneId,
        options: options,
        postalCode: postalCode,
        campaignNameIdentifier: campaignNameIdentifier,
        shopperPlatformUx: ShopperPlatformUx.UlpInline
    })), {
        itemData: processImpressionItemData(message.detail.items),
        decision: getDecisionParameters(translateDecisionToAvro({
            decision: decision,
            siteId: siteId,
            zoneId: zoneId,
            positionIndex: positionIndex,
            customUrl: customUrl
        }))
    });
};
var createUlpErrorBeacon = function(_a) {
    var partnerNameIdentifier = _a.partnerNameIdentifier, decision = _a.decision, siteId = _a.siteId, zoneId = _a.zoneId, customUrl = _a.customUrl, options = _a.options, postalCode = _a.postalCode, campaignNameIdentifier = _a.campaignNameIdentifier, errorMessage = _a.errorMessage, positionIndex = _a.positionIndex;
    return __assign(__assign({}, createBaseBeacon({
        schemaId: ExperienceServedFallbackSchemaId,
        partnerNameIdentifier: partnerNameIdentifier,
        siteId: siteId,
        zoneId: zoneId,
        options: options,
        postalCode: postalCode,
        campaignNameIdentifier: campaignNameIdentifier,
        shopperPlatformUx: ShopperPlatformUx.UlpInline
    })), {
        decision: getDecisionParameters(translateDecisionToAvro({
            decision: decision,
            siteId: siteId,
            zoneId: zoneId,
            positionIndex: positionIndex,
            customUrl: customUrl
        })),
        errorMessage: errorMessage
    });
};
var createUlpSeeAllDealsBeacon = function(_a) {
    var partnerNameIdentifier = _a.partnerNameIdentifier, decision = _a.decision, siteId = _a.siteId, zoneId = _a.zoneId, customUrl = _a.customUrl, options = _a.options, postalCode = _a.postalCode, campaignNameIdentifier = _a.campaignNameIdentifier, positionIndex = _a.positionIndex;
    return __assign(__assign({}, createBaseBeacon({
        schemaId: LandingClickSeeFullPageSchemaId,
        partnerNameIdentifier: partnerNameIdentifier,
        siteId: siteId,
        zoneId: zoneId,
        options: options,
        postalCode: postalCode,
        campaignNameIdentifier: campaignNameIdentifier,
        shopperPlatformUx: ShopperPlatformUx.UlpInline
    })), {
        decision: getDecisionParameters(translateDecisionToAvro({
            decision: decision,
            siteId: siteId,
            zoneId: zoneId,
            positionIndex: positionIndex,
            customUrl: customUrl
        }))
    });
};

// Track the beacon sequence
var sequenceId = 0;
// An identifier that's reset on each page load
var sessionId = generateUUID();
var getSessionId = function() {
    return sessionId;
};
var setSessionId = function(id) {
    sessionId = id;
};
var platform = null;
var getPlatform = function() {
    if (!platform) {
        var deviceInfo = DeviceService.getDeviceInfo();
        switch(deviceInfo.type){
            case 'mobile':
                platform = {
                    'com.flipp.beacon.shopperPlatform.enumeration.Platform': Platform.Mobile
                };
                break;
            case 'tablet':
                platform = {
                    'com.flipp.beacon.shopperPlatform.enumeration.Platform': Platform.Tablet
                };
                break;
            case 'desktop':
                platform = {
                    'com.flipp.beacon.shopperPlatform.enumeration.Platform': Platform.Desktop
                };
                break;
            default:
                platform = null;
        }
    }
    return platform;
};
function createBeaconCountry(country) {
    if (country === 'CA') {
        return {
            'com.flipp.beacon.shopperPlatform.enumeration.Country': Country.CA
        };
    } else if (country === 'US') {
        return {
            'com.flipp.beacon.shopperPlatform.enumeration.Country': Country.US
        };
    }
    return null;
}
// note: the asset should be delivered from asset-delivery-service to get appropriate data
function getPostalCode() {
    var _a;
    return (_a = window.flippxp.geo) === null || _a === undefined ? undefined : _a.postal_code;
}
function getCountry() {
    var _a;
    return (_a = window.flippxp.geo) === null || _a === undefined ? undefined : _a.country;
}
function getClientParameters() {
    var _a = DeviceService.getDeviceInfo(), browser = _a.browser, browserVersion = _a.browserVersion, system = _a.system, systemModel = _a.systemModel, systemVersion = _a.systemVersion;
    return {
        browser: browser,
        browserVersion: browserVersion,
        system: system,
        systemModel: systemModel,
        systemVersion: systemVersion
    };
}
function getDecisionParameters(decision) {
    if (!decision) {
        return null;
    }
    return {
        'com.flipp.beacon.shopperPlatform.entity.ShopperPlatformDecision': decision
    };
}
function getEnvironment() {
    var environment$1;
    switch(environment){
        case 'development':
            environment$1 = Environment$1.Dev;
            break;
        case 'staging':
            environment$1 = Environment$1.Test;
            break;
        case 'production':
        default:
            environment$1 = Environment$1.Prod;
            break;
    }
    return environment$1;
}
function getShopperPlatformCampaign(partnerNameIdentifier, campaignNameIdentifier) {
    return {
        partnerNameIdentifier: partnerNameIdentifier !== null && partnerNameIdentifier !== undefined ? partnerNameIdentifier : '',
        campaignNameIdentifier: campaignNameIdentifier !== null && campaignNameIdentifier !== undefined ? campaignNameIdentifier : ''
    };
}
function getViewSize() {
    var _a = DeviceService.getDeviceInfo(), screenWidth = _a.screenWidth, screenHeight = _a.screenHeight;
    var viewWidth = screenWidth && screenWidth > 0 ? screenWidth : document.documentElement.clientWidth || window.innerWidth || 0;
    var viewHeight = screenHeight && screenHeight > 0 ? screenHeight : document.documentElement.clientHeight || window.innerHeight || 0;
    return {
        viewWidth: viewWidth,
        viewHeight: viewHeight
    };
}
function getQueryParamArray(queryParams) {
    var validQueryParamPairs = queryParams.filter(function(pair) {
        var key = pair[0], value = pair[1];
        return pair.length === 2 && key && value;
    });
    return validQueryParamPairs.map(function(_a) {
        var key = _a[0], value = _a[1];
        return {
            paramName: key,
            paramValue: value
        };
    });
}
function getBase(postalCode) {
    return {
        aid: ApplicationID.ShopperPlatform,
        rnd: Math.random().toString(),
        postalCode: postalCode ? {
            string: postalCode
        } : null
    };
}
function getSchemaInfo(schema) {
    return {
        schemaId: schema,
        schemaName: null
    };
}
function getShopperPlatformBase(_a) {
    var usedFallbackPostalCode = _a.usedFallbackPostalCode, sessionId = _a.sessionId, appVersion = _a.appVersion, shopperPlatformCampaign = _a.shopperPlatformCampaign, shopperPlatformConfig = _a.shopperPlatformConfig, shopperPlatformUx = _a.shopperPlatformUx, site = _a.site, uid = _a.uid, experienceType = _a.experienceType, integrationType = _a.integrationType, _b = _a.auctionId, auctionId = _b === undefined ? 'FlippAvroDefault' : _b, mediaPartnerDescriptiveValueTag = _a.mediaPartnerDescriptiveValueTag, _c = _a.countryCode, countryCode = _c === undefined ? 'FlippAvroDefault' : _c, uuid = _a.uuid;
    var devicePixelRatio = DeviceService.getDeviceInfo().devicePixelRatio;
    return {
        integrationType: integrationType,
        experienceType: experienceType,
        environment: getEnvironment(),
        clientParameters: getClientParameters(),
        epochMilliseconds: Date.now(),
        uuid: uuid !== null && uuid !== undefined ? uuid : generateUUID(),
        usedFallbackPostalCode: usedFallbackPostalCode,
        sessionId: sessionId,
        sequenceId: sequenceId++,
        viewSize: getViewSize(),
        devicePixelRatio: devicePixelRatio,
        appVersion: appVersion,
        shopperPlatformCampaign: shopperPlatformCampaign,
        shopperPlatformConfig: shopperPlatformConfig,
        shopperPlatformUx: shopperPlatformUx,
        shopperPlatformAdView: ShopperPlatformAdView.Default,
        site: site,
        uid: uid,
        auctionId: auctionId,
        mediaPartnerDescriptiveValueTag: mediaPartnerDescriptiveValueTag ? {
            string: mediaPartnerDescriptiveValueTag
        } : null,
        countryCode: countryCode
    };
}
var getExperienceType = function(options) {
    // V1 avro enum has no MobileSwipe value yet
    if (options.mobileSwipe) {
        return ExperienceType$1.Unknown;
    }
    if (options.fixedHeightUnit) {
        return ExperienceType$1.FixedHeight;
    }
    if (options.startCompact) {
        return ExperienceType$1.Compact;
    }
    return ExperienceType$1.Classic;
};
var createBaseBeacon = function(_a) {
    var _b, _c;
    var schemaId = _a.schemaId, partnerNameIdentifier = _a.partnerNameIdentifier, siteId = _a.siteId, zoneId = _a.zoneId, options = _a.options, postalCode = _a.postalCode, campaignNameIdentifier = _a.campaignNameIdentifier, shopperPlatformUx = _a.shopperPlatformUx, country = _a.country;
    var experienceType = getExperienceType(options);
    var urlParams = new URLSearchParams(window.location.search);
    var site = urlParams.get('site');
    return {
        base: getBase(postalCode),
        shopperPlatformBase: getShopperPlatformBase({
            usedFallbackPostalCode: false,
            sessionId: sessionId,
            appVersion: '__appVersion',
            shopperPlatformCampaign: getShopperPlatformCampaign(partnerNameIdentifier, campaignNameIdentifier),
            shopperPlatformConfig: {
                openViewRatio: 0,
                openTimerMs: 0,
                evTimerMs: 0
            },
            shopperPlatformUx: shopperPlatformUx !== null && shopperPlatformUx !== undefined ? shopperPlatformUx : ShopperPlatformUx.StorefrontInline,
            site: site !== null && site !== undefined ? site : getSiteDomain(options.overrideHostname),
            uid: (_b = getUserKey(options)) !== null && _b !== undefined ? _b : 'unknown',
            experienceType: experienceType,
            integrationType: getIntegrationType(options),
            auctionId: (_c = options.prebid) === null || _c === undefined ? undefined : _c.requestId,
            mediaPartnerDescriptiveValueTag: options.mediaPartnerDescriptiveValueTag,
            countryCode: country
        }),
        siteId: asNumber(siteId),
        zoneId: asNumber(zoneId),
        schemaInfo: getSchemaInfo(schemaId),
        platform: getPlatform()
    };
};
var createAppInitializedBeacon = function(_a) {
    var partnerNameIdentifier = _a.partnerNameIdentifier, siteId = _a.siteId, zoneId = _a.zoneId, options = _a.options, postalCode = _a.postalCode, country = _a.country;
    return __assign({}, createBaseBeacon({
        partnerNameIdentifier: partnerNameIdentifier,
        siteId: siteId,
        zoneId: zoneId,
        options: options,
        schemaId: AppInitializedSchemaId,
        postalCode: postalCode,
        country: country
    }));
};
var createDecisionRequestContextBeacon = function(_a) {
    var _b;
    var partnerNameIdentifier = _a.partnerNameIdentifier, siteId = _a.siteId, zoneId = _a.zoneId, country = _a.country, postalCode = _a.postalCode, keywords = _a.keywords, category = _a.category, pageUrl = _a.pageUrl, queryParams = _a.queryParams, options = _a.options;
    var beacon = __assign(__assign({}, createBaseBeacon({
        partnerNameIdentifier: partnerNameIdentifier,
        siteId: siteId,
        zoneId: zoneId,
        options: options,
        postalCode: postalCode,
        schemaId: DecisionRequestContextSchemaId,
        country: country
    })), {
        country: createBeaconCountry(country),
        keywords: keywords,
        category: category,
        pageUrl: pageUrl,
        queryParams: getQueryParamArray(queryParams),
        referrer: 'FlippAvroDefault'
    });
    var url = new URL(window.location.toString());
    var referrer = (_b = url.searchParams.get('utm_source')) !== null && _b !== undefined ? _b : url.searchParams.get('referrer');
    if (referrer && referrer.length > 0) {
        beacon.referrer = referrer;
    }
    return beacon;
};
var createDecisionRequestMadeBeacon = function(_a) {
    var partnerNameIdentifier = _a.partnerNameIdentifier, siteId = _a.siteId, zoneId = _a.zoneId, country = _a.country, postalCode = _a.postalCode, options = _a.options;
    return __assign(__assign({}, createBaseBeacon({
        partnerNameIdentifier: partnerNameIdentifier,
        siteId: siteId,
        zoneId: zoneId,
        postalCode: postalCode,
        options: options,
        schemaId: DecisionRequestMadeSchemaId,
        country: country
    })), {
        country: createBeaconCountry(country)
    });
};
var createDecisionResponseFailureBeacon = function(_a) {
    var partnerNameIdentifier = _a.partnerNameIdentifier, siteId = _a.siteId, zoneId = _a.zoneId, country = _a.country, postalCode = _a.postalCode, errorMessage = _a.errorMessage, responseCode = _a.responseCode, options = _a.options;
    return __assign(__assign({}, createBaseBeacon({
        partnerNameIdentifier: partnerNameIdentifier,
        siteId: siteId,
        zoneId: zoneId,
        options: options,
        postalCode: postalCode,
        schemaId: DecisionResponseFailureSchemaId,
        country: country
    })), {
        country: createBeaconCountry(country),
        errorMessage: errorMessage,
        responseCode: responseCode
    });
};
var createDecisionResponseSuccessBeacon = function(_a) {
    var partnerNameIdentifier = _a.partnerNameIdentifier, campaignNameIdentifier = _a.campaignNameIdentifier, siteId = _a.siteId, zoneId = _a.zoneId, country = _a.country, postalCode = _a.postalCode, decisions = _a.decisions, options = _a.options;
    return __assign(__assign({}, createBaseBeacon({
        campaignNameIdentifier: campaignNameIdentifier,
        partnerNameIdentifier: partnerNameIdentifier,
        siteId: siteId,
        zoneId: zoneId,
        options: options,
        postalCode: postalCode,
        schemaId: DecisionResponseSuccessSchemaId,
        country: country
    })), {
        country: createBeaconCountry(country),
        decisions: decisions
    });
};
var createSlotImpressionExperienceBeacon = function(_a) {
    var partnerNameIdentifier = _a.partnerNameIdentifier, siteId = _a.siteId, zoneId = _a.zoneId, options = _a.options, cpm = _a.cpm, postalCode = _a.postalCode, campaignId = _a.campaignId, decisions = _a.decisions, country = _a.country;
    return __assign(__assign({}, createBaseBeacon({
        partnerNameIdentifier: partnerNameIdentifier,
        siteId: siteId,
        zoneId: zoneId,
        options: options,
        country: country,
        schemaId: SlotImpressionExperienceSchemaId,
        postalCode: postalCode
    })), {
        CPM: null,
        float_CPM: cpm ? {
            float: cpm
        } : null,
        campaignId: campaignId,
        decisions: decisions
    });
};
var createExperienceMeasuredTestBeacon = function(_a) {
    var partnerNameIdentifier = _a.partnerNameIdentifier, siteId = _a.siteId, zoneId = _a.zoneId, postalCode = _a.postalCode, options = _a.options, testName = _a.testName, resultName = _a.resultName, resultLabel = _a.resultLabel, resultPayload = _a.resultPayload, testIdentifier = _a.testIdentifier, country = _a.country;
    return __assign(__assign({}, createBaseBeacon({
        partnerNameIdentifier: partnerNameIdentifier,
        siteId: siteId,
        zoneId: zoneId,
        postalCode: postalCode,
        options: options,
        country: country,
        schemaId: ExperienceMeasuredTestSchemaId
    })), {
        testName: testName,
        resultName: resultName,
        resultLabel: resultLabel,
        testIdentifier: testIdentifier ? {
            long: testIdentifier
        } : null,
        resultPayload: resultPayload ? {
            string: JSON.stringify(resultPayload)
        } : null
    });
};
var resetPlatformCache = function() {
    platform = null;
};
var createBlockedTrafficBeacon = function(_a) {
    var partnerNameIdentifier = _a.partnerNameIdentifier, siteId = _a.siteId, zoneId = _a.zoneId, options = _a.options, postalCode = _a.postalCode, country = _a.country;
    var decision = null;
    var campaigns = options.campaigns ? JSON.parse(options.campaigns) : null;
    if (campaigns) {
        decision = getDecisionParameters(translateDecisionToAvro({
            decision: campaigns.decisions.inline[0],
            siteId: siteId,
            zoneId: zoneId,
            positionIndex: 0,
            customUrl: 'no-url'
        }));
    }
    return __assign(__assign({}, createBaseBeacon({
        partnerNameIdentifier: partnerNameIdentifier,
        siteId: siteId,
        zoneId: zoneId,
        options: options,
        schemaId: FrontendBotFilteredSchemaId,
        postalCode: postalCode,
        country: country
    })), {
        botFilteredPageUrl: getPageUrl(),
        userAgent: navigator.userAgent || 'not-available',
        decision: decision
    });
};
var createContainerViewableImpressionBeacon = function(_a) {
    var _b, _c;
    var partnerNameIdentifier = _a.partnerNameIdentifier, siteId = _a.siteId, zoneId = _a.zoneId, options = _a.options, postalCode = _a.postalCode, country = _a.country;
    var decision = null;
    var campaigns = options.campaigns ? JSON.parse(options.campaigns) : null;
    if (campaigns) {
        decision = getDecisionParameters(translateDecisionToAvro({
            decision: campaigns.decisions.inline[0],
            siteId: siteId,
            zoneId: zoneId,
            positionIndex: 0,
            customUrl: 'no-url'
        }));
    }
    var storefront = (_b = campaigns === null || campaigns === undefined ? undefined : campaigns.decisions.inline[0]) === null || _b === undefined ? undefined : _b.storefront;
    return __assign(__assign({
        storefront: {
            sfmlUUID: (_c = storefront === null || storefront === undefined ? undefined : storefront.sfml_uuid) !== null && _c !== undefined ? _c : '',
            version: null,
            contentHash: null
        }
    }, createBaseBeacon({
        partnerNameIdentifier: partnerNameIdentifier,
        siteId: siteId,
        zoneId: zoneId,
        options: options,
        schemaId: ContainerViewableImpressionSchemaId,
        postalCode: postalCode,
        country: country
    })), {
        merchant: {
            merchantId: asNumber(storefront === null || storefront === undefined ? undefined : storefront.merchant_id, -1)
        },
        flyer: {
            flyerId: asNumber(storefront === null || storefront === undefined ? undefined : storefront.flyer_id, -1),
            flyerRunId: asNumber(storefront === null || storefront === undefined ? undefined : storefront.flyer_run_id, 0),
            flyerTypeId: asNumber(storefront === null || storefront === undefined ? undefined : storefront.flyer_type_id, 0),
            storeId: null,
            premium: true
        },
        decision: decision
    });
};

/**
 * Finds the nearest store from a list of stores.
 * Returns the store with the minimum distance value.
 * Filters out stores with undefined distances.
 *
 * @param nearestStores - Array of store objects with id and distance properties.
 * @returns The nearest store object, or null if no valid stores are found
 */ var findNearestStore = function(nearestStores) {
    var _a;
    if (!(nearestStores === null || nearestStores === undefined ? undefined : nearestStores.length)) return null;
    var distances = nearestStores.map(function(store) {
        return store.distance;
    }).filter(function(distance) {
        return distance !== undefined;
    });
    if (distances.length === 0) return null;
    var minDistance = Math.min.apply(Math, distances);
    return (_a = nearestStores.find(function(store) {
        return store.distance === minDistance;
    })) !== null && _a !== undefined ? _a : null;
};

// example https://di.rlcdn.com/api/segment?pid=712773
var urls = [
    'https://di.rlcdn.com/api/segment?pid='
];
var buildLiveRampTag = function(decision, location) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    var kevelMetadata = decision.contents[0].data.customData;
    if (kevelMetadata === null || kevelMetadata === undefined ? undefined : kevelMetadata.liveRampTagId) {
        var campaignId = decision.campaignId;
        var flyerRunId = (_b = (_a = decision.storefront) === null || _a === undefined ? undefined : _a.flyer_run_id) !== null && _b !== undefined ? _b : -1;
        var flyerTypeId = (_d = (_c = decision.storefront) === null || _c === undefined ? undefined : _c.flyer_type_id) !== null && _d !== undefined ? _d : -1;
        var postalCode = location.postal_code;
        var country = location.country;
        var nearestStore = findNearestStore(decision.nearestStores);
        var storeId = (_f = (_e = nearestStore === null || nearestStore === undefined ? undefined : nearestStore.id) === null || _e === undefined ? undefined : _e.toString()) !== null && _f !== undefined ? _f : '';
        var storeCode = (_h = (_g = kevelMetadata.storeCode) !== null && _g !== undefined ? _g : nearestStore === null || nearestStore === undefined ? undefined : nearestStore.code) !== null && _h !== undefined ? _h : '';
        var pdataParts = [
            "campaignId=".concat(campaignId),
            "flyerRunId=".concat(flyerRunId),
            "flyerTypeId=".concat(flyerTypeId),
            "postalCode=".concat(postalCode),
            "country=".concat(country)
        ];
        if (storeId) pdataParts.push("storeId=".concat(storeId));
        if (storeCode) pdataParts.push("storeCode=".concat(storeCode));
        var queryParams = new URLSearchParams({
            pid: kevelMetadata.liveRampTagId.toString(),
            pdata: pdataParts.join(',')
        });
        return "https://di.rlcdn.com/api/segment?".concat(queryParams.toString());
    }
    return null;
};
var LiveRampService = /** @class */ function(_super) {
    __extends(LiveRampService, _super);
    function LiveRampService() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.send = function(event, params) {
            _this.processedTags.filter(function(tag) {
                return tag.event === event;
            }).forEach(function(tag) {
                // AdMixer's trackers get none of our query params.
                var payload = tag.source === 'admixer' ? undefined : _this.extendPayload(tag, params);
                createTagElement(tag.type, tag.content, {
                    params: payload,
                    location: _this.location,
                    enableDma: _this.enableDma,
                    macros: _this.macros
                });
            });
            return null;
        };
        _this.addTagsFromCampaignResponse = function(decision, payload, location) {
            _this.location = location;
            var tags = _this.buildTags(decision, location);
            _this.addTags(tags, payload, location);
            return null;
        };
        return _this;
    }
    LiveRampService.prototype.buildTags = function(decision, location) {
        var _a, _b;
        var tags = _super.prototype.buildTags.call(this, decision, location);
        if (this.location) {
            var liveRampTag = buildLiveRampTag(decision, this.location);
            if (liveRampTag) {
                (_b = (_a = tags.campaignManagement) === null || _a === undefined ? undefined : _a.impression) === null || _b === undefined ? undefined : _b.push(liveRampTag);
            }
        }
        return tags;
    };
    LiveRampService.prototype.extendPayload = function(tag, params) {
        if (this.shouldAttachPayload(tag.content)) {
            if (!params) {
                params = {};
            }
            params.pdata = this.constructPayload(tag.event);
        }
        return params;
    };
    LiveRampService.prototype.constructPayload = function(event) {
        var platformBeacon = getPlatform();
        var platform = platformBeacon ? Object.values(platformBeacon)[0] : 'null';
        var experience = this.getExperience();
        return "event=".concat(event, ",platform=").concat(platform, ",experience=").concat(experience);
    };
    LiveRampService.prototype.getExperience = function() {
        var _a;
        return ((_a = this.payload) === null || _a === undefined ? undefined : _a.startCompact) ? 'compact' : 'standard';
    };
    LiveRampService.prototype.shouldAttachPayload = function(url) {
        var includes = urls.some(function(u) {
            return url.includes(u);
        });
        return includes && !url.includes('pdata');
    };
    return LiveRampService;
}(Service$2);
var liveRampPayloadTags = new LiveRampService();

var REQUEST_PREFIX = 'request-';
var PostMessageEvent;
(function(PostMessageEvent) {
    PostMessageEvent["ANALYTICS_CONFIG"] = "analytics-config";
    PostMessageEvent["INLINE_GEOMETRY"] = "inline-geometry";
    PostMessageEvent["SFML_VIEWPORT"] = "sfml-viewport";
    PostMessageEvent["IFRAME_HEIGHT_RESIZE"] = "iframe-height-resize";
    PostMessageEvent["IFRAME_WIDTH_RESIZE"] = "iframe-width-resize";
    PostMessageEvent["REQUEST_EXPAND"] = "request-expand";
    PostMessageEvent["END_PREVIEW"] = "end-preview";
    PostMessageEvent["COUNTDOWN_STATE"] = "countdown-state";
    PostMessageEvent["ULP"] = "flipp-ulp";
    PostMessageEvent["MEASURE_TEST"] = "measure-test";
    PostMessageEvent["DYNAMIC_HEADER_ITEMS"] = "dynamic-header-items";
    PostMessageEvent["RESIZE_IFRAME"] = "resize-iframe";
    PostMessageEvent["CALLBACK"] = "callback";
    PostMessageEvent["SEND_EV"] = "send-ev";
    PostMessageEvent["VIMP"] = "flipp-vimp";
    PostMessageEvent["CANVASES_MUTATED"] = "canvases-mutated";
    PostMessageEvent["FILMSTRIP_CLICK"] = "filmstrip-click";
    PostMessageEvent["SOME_EVENT"] = "SOME_EVENT";
    PostMessageEvent["REQUEST_NEW_EXPERIENCE"] = "request-new-experience";
    PostMessageEvent["HIDE_IFRAME"] = "hide-iframe";
    PostMessageEvent["PUBLICATION_RENDERED"] = "publication-rendered";
})(PostMessageEvent || (PostMessageEvent = {}));
var ULPMessageEvent = {
    CLICK_MEATBALL: 'CLICK_MEATBALL',
    SHARE_ITEM: 'SHARE_ITEM',
    SEE_FLYER_ITEM: 'SEE_ITEM',
    CLIP_FLYER_ITEM: 'CLIP_ITEM',
    SEE_MERCHANT_ITEM: 'SEE_MERCHANT_ITEM',
    CLIP_MERCHANT_ITEM: 'CLIP_MERCHANT_ITEM',
    SEE_ECOM_ITEM: 'CLICK',
    CLIP_ECOM_ITEM: 'CLIP_ECOM_ITEM',
    ITEM_IMPRESSION: 'ITEM_IMPRESSION',
    SEE_ALL_DEALS: 'SEE_ALL_DEALS',
    ERROR: 'ERROR'
};

var EventSubscription = /** @class */ function() {
    function EventSubscription(emitter, eventType, listerner, key, options, context) {
        this.emitter = emitter;
        this.eventType = eventType;
        this.listener = listerner;
        this.key = key;
        this.options = options;
        this.context = context;
    }
    EventSubscription.prototype.remove = function() {
        var subscriptions = this.emitter.getSubscriptions(this.eventType);
        if (subscriptions) {
            // eslint-disable-next-line @typescript-eslint/no-array-delete
            delete subscriptions[this.key];
        }
        return null;
    };
    return EventSubscription;
}();

// eslint-disable-next-line @typescript-eslint/no-explicit-any
var EventEmitter = /** @class */ function() {
    function EventEmitter() {
        this.subscriptionsForType = new Map();
    }
    EventEmitter.prototype.addListener = function(event, listener, options, context) {
        var _a;
        var subscriptions = (_a = this.subscriptionsForType.get(event)) !== null && _a !== undefined ? _a : [];
        var subscription = new EventSubscription(this, event, listener, subscriptions.length, options, context);
        subscriptions.push(subscription);
        this.subscriptionsForType.set(event, subscriptions);
        return subscription;
    };
    EventEmitter.prototype.emit = function(event, payload) {
        var _a, _b;
        var subscriptions = (_a = this.subscriptionsForType.get(event)) !== null && _a !== undefined ? _a : [];
        for(var _i = 0, subscriptions_1 = subscriptions; _i < subscriptions_1.length; _i++){
            var s = subscriptions_1[_i];
            s.listener.call(s.context, new CustomEvent(event.toString(), {
                detail: payload
            }));
            if ((_b = s.options) === null || _b === undefined ? undefined : _b.once) {
                s.remove();
            }
        }
        return null;
    };
    EventEmitter.prototype.getSubscriptions = function(event) {
        return this.subscriptionsForType.get(event);
    };
    return EventEmitter;
}();

var REQUEST_MESSAGE_PREFIX = 'request-';
var POSTMESSAGE_EVENT = 'message';
var Service = /** @class */ function() {
    function Service() {
        var _this = this;
        this.addEventListener = function(event, listener, options) {
            var sub = _this.eventEmmiter.addListener(event, listener, options);
            if ((options === null || options === undefined ? undefined : options.sendRequest) && options.target) {
                _this.sendMessage(REQUEST_MESSAGE_PREFIX + event, options.requestData, options.target);
            }
            return sub;
        };
        this.sendMessage = function(type, data, target) {
            if (target === undefined) {
                target = window;
            }
            target.postMessage({
                type: type,
                data: data
            }, '*');
            return null;
        };
        this.handleMessage = function(event) {
            if (!_this.isMessageRelevant(event.data)) {
                return;
            }
            _this.eventEmmiter.emit(event.data.type, event.data.data);
        };
        this.isMessageRelevant = function(message) {
            if (!message.type) {
                return false;
            }
            for(var _i = 0, _a = Object.values(PostMessageEvent); _i < _a.length; _i++){
                var eventType = _a[_i];
                if (eventType === message.type) {
                    return true;
                }
            }
            return false;
        };
        this.eventEmmiter = new EventEmitter();
        this.start();
    }
    Service.prototype.start = function() {
        window.addEventListener(POSTMESSAGE_EVENT, this.handleMessage);
        return null;
    };
    Service.prototype.stop = function() {
        window.removeEventListener(POSTMESSAGE_EVENT, this.handleMessage);
        return null;
    };
    return Service;
}();
var PostMessageService = new Service();

var BannerTypes;
(function(BannerTypes) {
    BannerTypes["BRAND_AD"] = "brand-ad";
})(BannerTypes || (BannerTypes = {}));
var DynamicModuleType;
(function(DynamicModuleType) {
    DynamicModuleType["BANNER"] = "banner";
    DynamicModuleType["ITEM_FEED"] = "item_feed";
    DynamicModuleType["CUSTOM_CONTENT"] = "custom_content";
    DynamicModuleType["VIDEO_AD"] = "video_ad";
})(DynamicModuleType || (DynamicModuleType = {}));

var getCustomUrl = function(decision) {
    var _a, _b, _c;
    return (_c = (_b = (_a = decision.ulpUrl) !== null && _a !== undefined ? _a : decision.contents[0].data.customData.ulpUrl) !== null && _b !== undefined ? _b : decision.contents[0].data.customData.campaignConfigUrl) !== null && _c !== undefined ? _c : 'no-url';
};
var createBiddingCallBidderBeacon = function(_a) {
    var partnerNameIdentifier = _a.partnerNameIdentifier, siteId = _a.siteId, zoneId = _a.zoneId, options = _a.options, creativeType = _a.creativeType;
    return __assign(__assign({}, createBaseBeacon({
        schemaId: BiddingCallBidderSchemaId,
        partnerNameIdentifier: partnerNameIdentifier,
        siteId: siteId,
        zoneId: zoneId,
        options: options
    })), {
        creativeType: creativeType
    });
};
var createBiddingHeaderLoadedBeacon = function(auctionId) {
    var _a;
    return {
        base: getBase(),
        shopperPlatformBase: getShopperPlatformBase({
            usedFallbackPostalCode: false,
            sessionId: getSessionId(),
            appVersion: '__appVersion',
            shopperPlatformCampaign: getShopperPlatformCampaign(),
            shopperPlatformConfig: {
                openViewRatio: 0,
                openTimerMs: 0,
                evTimerMs: 0
            },
            shopperPlatformUx: ShopperPlatformUx.StorefrontInline,
            site: window.location.hostname,
            uid: (_a = getUserKey({})) !== null && _a !== undefined ? _a : 'unknown',
            experienceType: ExperienceType$1.Unknown,
            integrationType: 'prebid',
            auctionId: auctionId
        }),
        schemaInfo: getSchemaInfo(BiddingHeaderLoadedSchemaId),
        platform: getPlatform()
    };
};
var createBiddingResponseSuccessBeacon = function(_a) {
    var partnerNameIdentifier = _a.partnerNameIdentifier, siteId = _a.siteId, zoneId = _a.zoneId, options = _a.options, postalCode = _a.postalCode, creativeType = _a.creativeType, decisions = _a.decisions, cpm = _a.cpm, country = _a.country, auctionId = _a.auctionId;
    return __assign(__assign({}, createBaseBeacon({
        schemaId: BiddingResponseSuccessSchemaId,
        partnerNameIdentifier: partnerNameIdentifier,
        siteId: siteId,
        zoneId: zoneId,
        options: options,
        postalCode: postalCode,
        auctionId: auctionId,
        country: country
    })), {
        creativeType: creativeType,
        decisions: decisions.map(function(decision) {
            var _a, _b;
            return {
                campaignId: decision.campaignId,
                flightId: decision.flightId,
                advertiserId: decision.advertiserId,
                creativeId: decision.creativeId,
                adId: decision.adId,
                siteId: siteId,
                zoneId: zoneId,
                customUrl: {
                    string: getCustomUrl(decision)
                },
                positionIndex: null,
                flyerId: asNumber((_a = decision.storefront) === null || _a === undefined ? undefined : _a.flyer_id),
                merchantId: asNumber((_b = decision.storefront) === null || _b === undefined ? undefined : _b.merchant_id)
            };
        }),
        country: createBeaconCountry(country),
        CPM: null,
        float_CPM: cpm ? {
            float: cpm
        } : null
    });
};
var createBiddingResponseFailureBeacon = function(_a) {
    var partnerNameIdentifier = _a.partnerNameIdentifier, siteId = _a.siteId, zoneId = _a.zoneId, options = _a.options, creativeType = _a.creativeType, reason = _a.reason, country = _a.country, auctionId = _a.auctionId;
    return __assign(__assign({}, createBaseBeacon({
        schemaId: BiddingResponseFailureSchemaId,
        partnerNameIdentifier: partnerNameIdentifier,
        siteId: siteId,
        zoneId: zoneId,
        options: options,
        auctionId: auctionId,
        country: country
    })), {
        creativeType: creativeType,
        reason: reason,
        country: createBeaconCountry(country)
    });
};
var createBiddingWonAuctionBeacon = function(_a) {
    var partnerNameIdentifier = _a.partnerNameIdentifier, siteId = _a.siteId, zoneId = _a.zoneId, options = _a.options, postalCode = _a.postalCode, creativeType = _a.creativeType, country = _a.country, decisions = _a.decisions, cpm = _a.cpm, auctionId = _a.auctionId;
    return __assign(__assign({}, createBaseBeacon({
        schemaId: BiddingWonAuctionSchemaId,
        partnerNameIdentifier: partnerNameIdentifier,
        siteId: siteId,
        zoneId: zoneId,
        options: options,
        postalCode: postalCode,
        auctionId: auctionId,
        country: country
    })), {
        creativeType: creativeType,
        country: createBeaconCountry(country),
        decisions: decisions.map(function(decision) {
            var _a, _b, _c, _d;
            return {
                campaignId: decision.campaignId,
                flightId: decision.flightId,
                advertiserId: decision.advertiserId,
                creativeId: decision.creativeId,
                adId: decision.adId,
                siteId: siteId,
                zoneId: zoneId,
                customUrl: {
                    string: getCustomUrl(decision)
                },
                positionIndex: null,
                flyerId: (_b = (_a = decision.storefront) === null || _a === undefined ? undefined : _a.flyer_id) !== null && _b !== undefined ? _b : 0,
                merchantId: (_d = (_c = decision.storefront) === null || _c === undefined ? undefined : _c.merchant_id) !== null && _d !== undefined ? _d : 0
            };
        }),
        CPM: null,
        float_CPM: cpm ? {
            float: cpm
        } : null
    });
};

var sparkMd5 = {exports: {}};

(function(module, exports) {
    (function(factory) {
        {
            // Node/CommonJS
            module.exports = factory();
        }
    })(function(undefined1) {
        /*
	     * Fastest md5 implementation around (JKM md5).
	     * Credits: Joseph Myers
	     *
	     * @see http://www.myersdaily.org/joseph/javascript/md5-text.html
	     * @see http://jsperf.com/md5-shootout/7
	     */ /* this function is much faster,
	      so if possible we use it. Some IEs
	      are the only ones I know of that
	      need the idiotic second function,
	      generated by an if clause.  */ var hex_chr = [
            '0',
            '1',
            '2',
            '3',
            '4',
            '5',
            '6',
            '7',
            '8',
            '9',
            'a',
            'b',
            'c',
            'd',
            'e',
            'f'
        ];
        function md5cycle(x, k) {
            var a = x[0], b = x[1], c = x[2], d = x[3];
            a += (b & c | ~b & d) + k[0] - 680876936 | 0;
            a = (a << 7 | a >>> 25) + b | 0;
            d += (a & b | ~a & c) + k[1] - 389564586 | 0;
            d = (d << 12 | d >>> 20) + a | 0;
            c += (d & a | ~d & b) + k[2] + 606105819 | 0;
            c = (c << 17 | c >>> 15) + d | 0;
            b += (c & d | ~c & a) + k[3] - 1044525330 | 0;
            b = (b << 22 | b >>> 10) + c | 0;
            a += (b & c | ~b & d) + k[4] - 176418897 | 0;
            a = (a << 7 | a >>> 25) + b | 0;
            d += (a & b | ~a & c) + k[5] + 1200080426 | 0;
            d = (d << 12 | d >>> 20) + a | 0;
            c += (d & a | ~d & b) + k[6] - 1473231341 | 0;
            c = (c << 17 | c >>> 15) + d | 0;
            b += (c & d | ~c & a) + k[7] - 45705983 | 0;
            b = (b << 22 | b >>> 10) + c | 0;
            a += (b & c | ~b & d) + k[8] + 1770035416 | 0;
            a = (a << 7 | a >>> 25) + b | 0;
            d += (a & b | ~a & c) + k[9] - 1958414417 | 0;
            d = (d << 12 | d >>> 20) + a | 0;
            c += (d & a | ~d & b) + k[10] - 42063 | 0;
            c = (c << 17 | c >>> 15) + d | 0;
            b += (c & d | ~c & a) + k[11] - 1990404162 | 0;
            b = (b << 22 | b >>> 10) + c | 0;
            a += (b & c | ~b & d) + k[12] + 1804603682 | 0;
            a = (a << 7 | a >>> 25) + b | 0;
            d += (a & b | ~a & c) + k[13] - 40341101 | 0;
            d = (d << 12 | d >>> 20) + a | 0;
            c += (d & a | ~d & b) + k[14] - 1502002290 | 0;
            c = (c << 17 | c >>> 15) + d | 0;
            b += (c & d | ~c & a) + k[15] + 1236535329 | 0;
            b = (b << 22 | b >>> 10) + c | 0;
            a += (b & d | c & ~d) + k[1] - 165796510 | 0;
            a = (a << 5 | a >>> 27) + b | 0;
            d += (a & c | b & ~c) + k[6] - 1069501632 | 0;
            d = (d << 9 | d >>> 23) + a | 0;
            c += (d & b | a & ~b) + k[11] + 643717713 | 0;
            c = (c << 14 | c >>> 18) + d | 0;
            b += (c & a | d & ~a) + k[0] - 373897302 | 0;
            b = (b << 20 | b >>> 12) + c | 0;
            a += (b & d | c & ~d) + k[5] - 701558691 | 0;
            a = (a << 5 | a >>> 27) + b | 0;
            d += (a & c | b & ~c) + k[10] + 38016083 | 0;
            d = (d << 9 | d >>> 23) + a | 0;
            c += (d & b | a & ~b) + k[15] - 660478335 | 0;
            c = (c << 14 | c >>> 18) + d | 0;
            b += (c & a | d & ~a) + k[4] - 405537848 | 0;
            b = (b << 20 | b >>> 12) + c | 0;
            a += (b & d | c & ~d) + k[9] + 568446438 | 0;
            a = (a << 5 | a >>> 27) + b | 0;
            d += (a & c | b & ~c) + k[14] - 1019803690 | 0;
            d = (d << 9 | d >>> 23) + a | 0;
            c += (d & b | a & ~b) + k[3] - 187363961 | 0;
            c = (c << 14 | c >>> 18) + d | 0;
            b += (c & a | d & ~a) + k[8] + 1163531501 | 0;
            b = (b << 20 | b >>> 12) + c | 0;
            a += (b & d | c & ~d) + k[13] - 1444681467 | 0;
            a = (a << 5 | a >>> 27) + b | 0;
            d += (a & c | b & ~c) + k[2] - 51403784 | 0;
            d = (d << 9 | d >>> 23) + a | 0;
            c += (d & b | a & ~b) + k[7] + 1735328473 | 0;
            c = (c << 14 | c >>> 18) + d | 0;
            b += (c & a | d & ~a) + k[12] - 1926607734 | 0;
            b = (b << 20 | b >>> 12) + c | 0;
            a += (b ^ c ^ d) + k[5] - 378558 | 0;
            a = (a << 4 | a >>> 28) + b | 0;
            d += (a ^ b ^ c) + k[8] - 2022574463 | 0;
            d = (d << 11 | d >>> 21) + a | 0;
            c += (d ^ a ^ b) + k[11] + 1839030562 | 0;
            c = (c << 16 | c >>> 16) + d | 0;
            b += (c ^ d ^ a) + k[14] - 35309556 | 0;
            b = (b << 23 | b >>> 9) + c | 0;
            a += (b ^ c ^ d) + k[1] - 1530992060 | 0;
            a = (a << 4 | a >>> 28) + b | 0;
            d += (a ^ b ^ c) + k[4] + 1272893353 | 0;
            d = (d << 11 | d >>> 21) + a | 0;
            c += (d ^ a ^ b) + k[7] - 155497632 | 0;
            c = (c << 16 | c >>> 16) + d | 0;
            b += (c ^ d ^ a) + k[10] - 1094730640 | 0;
            b = (b << 23 | b >>> 9) + c | 0;
            a += (b ^ c ^ d) + k[13] + 681279174 | 0;
            a = (a << 4 | a >>> 28) + b | 0;
            d += (a ^ b ^ c) + k[0] - 358537222 | 0;
            d = (d << 11 | d >>> 21) + a | 0;
            c += (d ^ a ^ b) + k[3] - 722521979 | 0;
            c = (c << 16 | c >>> 16) + d | 0;
            b += (c ^ d ^ a) + k[6] + 76029189 | 0;
            b = (b << 23 | b >>> 9) + c | 0;
            a += (b ^ c ^ d) + k[9] - 640364487 | 0;
            a = (a << 4 | a >>> 28) + b | 0;
            d += (a ^ b ^ c) + k[12] - 421815835 | 0;
            d = (d << 11 | d >>> 21) + a | 0;
            c += (d ^ a ^ b) + k[15] + 530742520 | 0;
            c = (c << 16 | c >>> 16) + d | 0;
            b += (c ^ d ^ a) + k[2] - 995338651 | 0;
            b = (b << 23 | b >>> 9) + c | 0;
            a += (c ^ (b | ~d)) + k[0] - 198630844 | 0;
            a = (a << 6 | a >>> 26) + b | 0;
            d += (b ^ (a | ~c)) + k[7] + 1126891415 | 0;
            d = (d << 10 | d >>> 22) + a | 0;
            c += (a ^ (d | ~b)) + k[14] - 1416354905 | 0;
            c = (c << 15 | c >>> 17) + d | 0;
            b += (d ^ (c | ~a)) + k[5] - 57434055 | 0;
            b = (b << 21 | b >>> 11) + c | 0;
            a += (c ^ (b | ~d)) + k[12] + 1700485571 | 0;
            a = (a << 6 | a >>> 26) + b | 0;
            d += (b ^ (a | ~c)) + k[3] - 1894986606 | 0;
            d = (d << 10 | d >>> 22) + a | 0;
            c += (a ^ (d | ~b)) + k[10] - 1051523 | 0;
            c = (c << 15 | c >>> 17) + d | 0;
            b += (d ^ (c | ~a)) + k[1] - 2054922799 | 0;
            b = (b << 21 | b >>> 11) + c | 0;
            a += (c ^ (b | ~d)) + k[8] + 1873313359 | 0;
            a = (a << 6 | a >>> 26) + b | 0;
            d += (b ^ (a | ~c)) + k[15] - 30611744 | 0;
            d = (d << 10 | d >>> 22) + a | 0;
            c += (a ^ (d | ~b)) + k[6] - 1560198380 | 0;
            c = (c << 15 | c >>> 17) + d | 0;
            b += (d ^ (c | ~a)) + k[13] + 1309151649 | 0;
            b = (b << 21 | b >>> 11) + c | 0;
            a += (c ^ (b | ~d)) + k[4] - 145523070 | 0;
            a = (a << 6 | a >>> 26) + b | 0;
            d += (b ^ (a | ~c)) + k[11] - 1120210379 | 0;
            d = (d << 10 | d >>> 22) + a | 0;
            c += (a ^ (d | ~b)) + k[2] + 718787259 | 0;
            c = (c << 15 | c >>> 17) + d | 0;
            b += (d ^ (c | ~a)) + k[9] - 343485551 | 0;
            b = (b << 21 | b >>> 11) + c | 0;
            x[0] = a + x[0] | 0;
            x[1] = b + x[1] | 0;
            x[2] = c + x[2] | 0;
            x[3] = d + x[3] | 0;
        }
        function md5blk(s) {
            var md5blks = [], i; /* Andy King said do it this way. */ 
            for(i = 0; i < 64; i += 4){
                md5blks[i >> 2] = s.charCodeAt(i) + (s.charCodeAt(i + 1) << 8) + (s.charCodeAt(i + 2) << 16) + (s.charCodeAt(i + 3) << 24);
            }
            return md5blks;
        }
        function md5blk_array(a) {
            var md5blks = [], i; /* Andy King said do it this way. */ 
            for(i = 0; i < 64; i += 4){
                md5blks[i >> 2] = a[i] + (a[i + 1] << 8) + (a[i + 2] << 16) + (a[i + 3] << 24);
            }
            return md5blks;
        }
        function md51(s) {
            var n = s.length, state = [
                1732584193,
                -271733879,
                -1732584194,
                271733878
            ], i, length, tail, tmp, lo, hi;
            for(i = 64; i <= n; i += 64){
                md5cycle(state, md5blk(s.substring(i - 64, i)));
            }
            s = s.substring(i - 64);
            length = s.length;
            tail = [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ];
            for(i = 0; i < length; i += 1){
                tail[i >> 2] |= s.charCodeAt(i) << (i % 4 << 3);
            }
            tail[i >> 2] |= 0x80 << (i % 4 << 3);
            if (i > 55) {
                md5cycle(state, tail);
                for(i = 0; i < 16; i += 1){
                    tail[i] = 0;
                }
            }
            // Beware that the final length might not fit in 32 bits so we take care of that
            tmp = n * 8;
            tmp = tmp.toString(16).match(/(.*?)(.{0,8})$/);
            lo = parseInt(tmp[2], 16);
            hi = parseInt(tmp[1], 16) || 0;
            tail[14] = lo;
            tail[15] = hi;
            md5cycle(state, tail);
            return state;
        }
        function md51_array(a) {
            var n = a.length, state = [
                1732584193,
                -271733879,
                -1732584194,
                271733878
            ], i, length, tail, tmp, lo, hi;
            for(i = 64; i <= n; i += 64){
                md5cycle(state, md5blk_array(a.subarray(i - 64, i)));
            }
            // Not sure if it is a bug, however IE10 will always produce a sub array of length 1
            // containing the last element of the parent array if the sub array specified starts
            // beyond the length of the parent array - weird.
            // https://connect.microsoft.com/IE/feedback/details/771452/typed-array-subarray-issue
            a = i - 64 < n ? a.subarray(i - 64) : new Uint8Array(0);
            length = a.length;
            tail = [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ];
            for(i = 0; i < length; i += 1){
                tail[i >> 2] |= a[i] << (i % 4 << 3);
            }
            tail[i >> 2] |= 0x80 << (i % 4 << 3);
            if (i > 55) {
                md5cycle(state, tail);
                for(i = 0; i < 16; i += 1){
                    tail[i] = 0;
                }
            }
            // Beware that the final length might not fit in 32 bits so we take care of that
            tmp = n * 8;
            tmp = tmp.toString(16).match(/(.*?)(.{0,8})$/);
            lo = parseInt(tmp[2], 16);
            hi = parseInt(tmp[1], 16) || 0;
            tail[14] = lo;
            tail[15] = hi;
            md5cycle(state, tail);
            return state;
        }
        function rhex(n) {
            var s = '', j;
            for(j = 0; j < 4; j += 1){
                s += hex_chr[n >> j * 8 + 4 & 0x0F] + hex_chr[n >> j * 8 & 0x0F];
            }
            return s;
        }
        function hex(x) {
            var i;
            for(i = 0; i < x.length; i += 1){
                x[i] = rhex(x[i]);
            }
            return x.join('');
        }
        // In some cases the fast add32 function cannot be used..
        if (hex(md51('hello')) !== '5d41402abc4b2a76b9719d911017c592') ;
        // ---------------------------------------------------
        /**
	     * ArrayBuffer slice polyfill.
	     *
	     * @see https://github.com/ttaubert/node-arraybuffer-slice
	     */ if (typeof ArrayBuffer !== 'undefined' && !ArrayBuffer.prototype.slice) {
            (function() {
                function clamp(val, length) {
                    val = val | 0 || 0;
                    if (val < 0) {
                        return Math.max(val + length, 0);
                    }
                    return Math.min(val, length);
                }
                ArrayBuffer.prototype.slice = function(from, to) {
                    var length = this.byteLength, begin = clamp(from, length), end = length, num, target, targetArray, sourceArray;
                    if (to !== undefined1) {
                        end = clamp(to, length);
                    }
                    if (begin > end) {
                        return new ArrayBuffer(0);
                    }
                    num = end - begin;
                    target = new ArrayBuffer(num);
                    targetArray = new Uint8Array(target);
                    sourceArray = new Uint8Array(this, begin, num);
                    targetArray.set(sourceArray);
                    return target;
                };
            })();
        }
        // ---------------------------------------------------
        /**
	     * Helpers.
	     */ function toUtf8(str) {
            if (/[\u0080-\uFFFF]/.test(str)) {
                str = unescape(encodeURIComponent(str));
            }
            return str;
        }
        function utf8Str2ArrayBuffer(str, returnUInt8Array) {
            var length = str.length, buff = new ArrayBuffer(length), arr = new Uint8Array(buff), i;
            for(i = 0; i < length; i += 1){
                arr[i] = str.charCodeAt(i);
            }
            return returnUInt8Array ? arr : buff;
        }
        function arrayBuffer2Utf8Str(buff) {
            return String.fromCharCode.apply(null, new Uint8Array(buff));
        }
        function concatenateArrayBuffers(first, second, returnUInt8Array) {
            var result = new Uint8Array(first.byteLength + second.byteLength);
            result.set(new Uint8Array(first));
            result.set(new Uint8Array(second), first.byteLength);
            return result ;
        }
        function hexToBinaryString(hex) {
            var bytes = [], length = hex.length, x;
            for(x = 0; x < length - 1; x += 2){
                bytes.push(parseInt(hex.substr(x, 2), 16));
            }
            return String.fromCharCode.apply(String, bytes);
        }
        // ---------------------------------------------------
        /**
	     * SparkMD5 OOP implementation.
	     *
	     * Use this class to perform an incremental md5, otherwise use the
	     * static methods instead.
	     */ function SparkMD5() {
            // call reset to init the instance
            this.reset();
        }
        /**
	     * Appends a string.
	     * A conversion will be applied if an utf8 string is detected.
	     *
	     * @param {String} str The string to be appended
	     *
	     * @return {SparkMD5} The instance itself
	     */ SparkMD5.prototype.append = function(str) {
            // Converts the string to utf8 bytes if necessary
            // Then append as binary
            this.appendBinary(toUtf8(str));
            return this;
        };
        /**
	     * Appends a binary string.
	     *
	     * @param {String} contents The binary string to be appended
	     *
	     * @return {SparkMD5} The instance itself
	     */ SparkMD5.prototype.appendBinary = function(contents) {
            this._buff += contents;
            this._length += contents.length;
            var length = this._buff.length, i;
            for(i = 64; i <= length; i += 64){
                md5cycle(this._hash, md5blk(this._buff.substring(i - 64, i)));
            }
            this._buff = this._buff.substring(i - 64);
            return this;
        };
        /**
	     * Finishes the incremental computation, reseting the internal state and
	     * returning the result.
	     *
	     * @param {Boolean} raw True to get the raw string, false to get the hex string
	     *
	     * @return {String} The result
	     */ SparkMD5.prototype.end = function(raw) {
            var buff = this._buff, length = buff.length, i, tail = [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ], ret;
            for(i = 0; i < length; i += 1){
                tail[i >> 2] |= buff.charCodeAt(i) << (i % 4 << 3);
            }
            this._finish(tail, length);
            ret = hex(this._hash);
            if (raw) {
                ret = hexToBinaryString(ret);
            }
            this.reset();
            return ret;
        };
        /**
	     * Resets the internal state of the computation.
	     *
	     * @return {SparkMD5} The instance itself
	     */ SparkMD5.prototype.reset = function() {
            this._buff = '';
            this._length = 0;
            this._hash = [
                1732584193,
                -271733879,
                -1732584194,
                271733878
            ];
            return this;
        };
        /**
	     * Gets the internal state of the computation.
	     *
	     * @return {Object} The state
	     */ SparkMD5.prototype.getState = function() {
            return {
                buff: this._buff,
                length: this._length,
                hash: this._hash.slice()
            };
        };
        /**
	     * Gets the internal state of the computation.
	     *
	     * @param {Object} state The state
	     *
	     * @return {SparkMD5} The instance itself
	     */ SparkMD5.prototype.setState = function(state) {
            this._buff = state.buff;
            this._length = state.length;
            this._hash = state.hash;
            return this;
        };
        /**
	     * Releases memory used by the incremental buffer and other additional
	     * resources. If you plan to use the instance again, use reset instead.
	     */ SparkMD5.prototype.destroy = function() {
            delete this._hash;
            delete this._buff;
            delete this._length;
        };
        /**
	     * Finish the final calculation based on the tail.
	     *
	     * @param {Array}  tail   The tail (will be modified)
	     * @param {Number} length The length of the remaining buffer
	     */ SparkMD5.prototype._finish = function(tail, length) {
            var i = length, tmp, lo, hi;
            tail[i >> 2] |= 0x80 << (i % 4 << 3);
            if (i > 55) {
                md5cycle(this._hash, tail);
                for(i = 0; i < 16; i += 1){
                    tail[i] = 0;
                }
            }
            // Do the final computation based on the tail and length
            // Beware that the final length may not fit in 32 bits so we take care of that
            tmp = this._length * 8;
            tmp = tmp.toString(16).match(/(.*?)(.{0,8})$/);
            lo = parseInt(tmp[2], 16);
            hi = parseInt(tmp[1], 16) || 0;
            tail[14] = lo;
            tail[15] = hi;
            md5cycle(this._hash, tail);
        };
        /**
	     * Performs the md5 hash on a string.
	     * A conversion will be applied if utf8 string is detected.
	     *
	     * @param {String}  str The string
	     * @param {Boolean} [raw] True to get the raw string, false to get the hex string
	     *
	     * @return {String} The result
	     */ SparkMD5.hash = function(str, raw) {
            // Converts the string to utf8 bytes if necessary
            // Then compute it using the binary function
            return SparkMD5.hashBinary(toUtf8(str), raw);
        };
        /**
	     * Performs the md5 hash on a binary string.
	     *
	     * @param {String}  content The binary string
	     * @param {Boolean} [raw]     True to get the raw string, false to get the hex string
	     *
	     * @return {String} The result
	     */ SparkMD5.hashBinary = function(content, raw) {
            var hash = md51(content), ret = hex(hash);
            return raw ? hexToBinaryString(ret) : ret;
        };
        // ---------------------------------------------------
        /**
	     * SparkMD5 OOP implementation for array buffers.
	     *
	     * Use this class to perform an incremental md5 ONLY for array buffers.
	     */ SparkMD5.ArrayBuffer = function() {
            // call reset to init the instance
            this.reset();
        };
        /**
	     * Appends an array buffer.
	     *
	     * @param {ArrayBuffer} arr The array to be appended
	     *
	     * @return {SparkMD5.ArrayBuffer} The instance itself
	     */ SparkMD5.ArrayBuffer.prototype.append = function(arr) {
            var buff = concatenateArrayBuffers(this._buff.buffer, arr), length = buff.length, i;
            this._length += arr.byteLength;
            for(i = 64; i <= length; i += 64){
                md5cycle(this._hash, md5blk_array(buff.subarray(i - 64, i)));
            }
            this._buff = i - 64 < length ? new Uint8Array(buff.buffer.slice(i - 64)) : new Uint8Array(0);
            return this;
        };
        /**
	     * Finishes the incremental computation, reseting the internal state and
	     * returning the result.
	     *
	     * @param {Boolean} raw True to get the raw string, false to get the hex string
	     *
	     * @return {String} The result
	     */ SparkMD5.ArrayBuffer.prototype.end = function(raw) {
            var buff = this._buff, length = buff.length, tail = [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ], i, ret;
            for(i = 0; i < length; i += 1){
                tail[i >> 2] |= buff[i] << (i % 4 << 3);
            }
            this._finish(tail, length);
            ret = hex(this._hash);
            if (raw) {
                ret = hexToBinaryString(ret);
            }
            this.reset();
            return ret;
        };
        /**
	     * Resets the internal state of the computation.
	     *
	     * @return {SparkMD5.ArrayBuffer} The instance itself
	     */ SparkMD5.ArrayBuffer.prototype.reset = function() {
            this._buff = new Uint8Array(0);
            this._length = 0;
            this._hash = [
                1732584193,
                -271733879,
                -1732584194,
                271733878
            ];
            return this;
        };
        /**
	     * Gets the internal state of the computation.
	     *
	     * @return {Object} The state
	     */ SparkMD5.ArrayBuffer.prototype.getState = function() {
            var state = SparkMD5.prototype.getState.call(this);
            // Convert buffer to a string
            state.buff = arrayBuffer2Utf8Str(state.buff);
            return state;
        };
        /**
	     * Gets the internal state of the computation.
	     *
	     * @param {Object} state The state
	     *
	     * @return {SparkMD5.ArrayBuffer} The instance itself
	     */ SparkMD5.ArrayBuffer.prototype.setState = function(state) {
            // Convert string to buffer
            state.buff = utf8Str2ArrayBuffer(state.buff, true);
            return SparkMD5.prototype.setState.call(this, state);
        };
        SparkMD5.ArrayBuffer.prototype.destroy = SparkMD5.prototype.destroy;
        SparkMD5.ArrayBuffer.prototype._finish = SparkMD5.prototype._finish;
        /**
	     * Performs the md5 hash on an array buffer.
	     *
	     * @param {ArrayBuffer} arr The array buffer
	     * @param {Boolean}     [raw] True to get the raw string, false to get the hex one
	     *
	     * @return {String} The result
	     */ SparkMD5.ArrayBuffer.hash = function(arr, raw) {
            var hash = md51_array(new Uint8Array(arr)), ret = hex(hash);
            return raw ? hexToBinaryString(ret) : ret;
        };
        return SparkMD5;
    });
})(sparkMd5);
var sparkMd5Exports = sparkMd5.exports;
var Mn = /*@__PURE__*/ getDefaultExportFromCjs(sparkMd5Exports);

// Copyright 2021-2026 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * Determine whether the given `arg` is a message.
 * If `desc` is set, determine whether `arg` is this specific message.
 */ function isMessage(arg, schema) {
    const isMessage = arg !== null && typeof arg == "object" && "$typeName" in arg && typeof arg.$typeName == "string";
    if (!isMessage) {
        return false;
    }
    if (schema === undefined) {
        return true;
    }
    return schema.typeName === arg.$typeName;
}

// Copyright 2021-2026 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * Scalar value types. This is a subset of field types declared by protobuf
 * enum google.protobuf.FieldDescriptorProto.Type The types GROUP and MESSAGE
 * are omitted, but the numerical values are identical.
 */ var ScalarType;
(function(ScalarType) {
    // 0 is reserved for errors.
    // Order is weird for historical reasons.
    ScalarType[ScalarType["DOUBLE"] = 1] = "DOUBLE";
    ScalarType[ScalarType["FLOAT"] = 2] = "FLOAT";
    // Not ZigZag encoded.  Negative numbers take 10 bytes.  Use TYPE_SINT64 if
    // negative values are likely.
    ScalarType[ScalarType["INT64"] = 3] = "INT64";
    ScalarType[ScalarType["UINT64"] = 4] = "UINT64";
    // Not ZigZag encoded.  Negative numbers take 10 bytes.  Use TYPE_SINT32 if
    // negative values are likely.
    ScalarType[ScalarType["INT32"] = 5] = "INT32";
    ScalarType[ScalarType["FIXED64"] = 6] = "FIXED64";
    ScalarType[ScalarType["FIXED32"] = 7] = "FIXED32";
    ScalarType[ScalarType["BOOL"] = 8] = "BOOL";
    ScalarType[ScalarType["STRING"] = 9] = "STRING";
    // Tag-delimited aggregate.
    // Group type is deprecated and not supported in proto3. However, Proto3
    // implementations should still be able to parse the group wire format and
    // treat group fields as unknown fields.
    // TYPE_GROUP = 10,
    // TYPE_MESSAGE = 11,  // Length-delimited aggregate.
    // New in version 2.
    ScalarType[ScalarType["BYTES"] = 12] = "BYTES";
    ScalarType[ScalarType["UINT32"] = 13] = "UINT32";
    // TYPE_ENUM = 14,
    ScalarType[ScalarType["SFIXED32"] = 15] = "SFIXED32";
    ScalarType[ScalarType["SFIXED64"] = 16] = "SFIXED64";
    ScalarType[ScalarType["SINT32"] = 17] = "SINT32";
    ScalarType[ScalarType["SINT64"] = 18] = "SINT64";
})(ScalarType || (ScalarType = {}));

// Copyright 2008 Google Inc.  All rights reserved.
//
// Redistribution and use in source and binary forms, with or without
// modification, are permitted provided that the following conditions are
// met:
//
// * Redistributions of source code must retain the above copyright
// notice, this list of conditions and the following disclaimer.
// * Redistributions in binary form must reproduce the above
// copyright notice, this list of conditions and the following disclaimer
// in the documentation and/or other materials provided with the
// distribution.
// * Neither the name of Google Inc. nor the names of its
// contributors may be used to endorse or promote products derived from
// this software without specific prior written permission.
//
// THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
// "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
// LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
// A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
// OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
// SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
// LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
// DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
// THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
// (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
// OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
//
// Code generated by the Protocol Buffer compiler is owned by the owner
// of the input file used when generating it.  This code is not
// standalone and requires a support library to be linked with it.  This
// support library is itself covered by the above license.
/**
 * Write a 64 bit varint, given as two JS numbers, to the given bytes array.
 *
 * Copyright 2008 Google Inc.  All rights reserved.
 *
 * See https://github.com/protocolbuffers/protobuf/blob/8a71927d74a4ce34efe2d8769fda198f52d20d12/js/experimental/runtime/kernel/writer.js#L344
 */ function varint64write(lo, hi, bytes) {
    for(let i = 0; i < 28; i = i + 7){
        const shift = lo >>> i;
        const hasNext = !(shift >>> 7 == 0 && hi == 0);
        const byte = (hasNext ? shift | 0x80 : shift) & 0xff;
        bytes.push(byte);
        if (!hasNext) {
            return;
        }
    }
    const splitBits = lo >>> 28 & 0x0f | (hi & 0x07) << 4;
    const hasMoreBits = !(hi >> 3 == 0);
    bytes.push((hasMoreBits ? splitBits | 0x80 : splitBits) & 0xff);
    if (!hasMoreBits) {
        return;
    }
    for(let i = 3; i < 31; i = i + 7){
        const shift = hi >>> i;
        const hasNext = !(shift >>> 7 == 0);
        const byte = (hasNext ? shift | 0x80 : shift) & 0xff;
        bytes.push(byte);
        if (!hasNext) {
            return;
        }
    }
    bytes.push(hi >>> 31 & 0x01);
}
// constants for binary math
const TWO_PWR_32_DBL = 0x100000000;
/**
 * Parse decimal string of 64 bit integer value as two JS numbers.
 *
 * Copyright 2008 Google Inc.  All rights reserved.
 *
 * See https://github.com/protocolbuffers/protobuf-javascript/blob/a428c58273abad07c66071d9753bc4d1289de426/experimental/runtime/int64.js#L10
 */ function int64FromString(dec) {
    // Check for minus sign.
    const minus = dec[0] === "-";
    if (minus) {
        dec = dec.slice(1);
    }
    // Work 6 decimal digits at a time, acting like we're converting base 1e6
    // digits to binary. This is safe to do with floating point math because
    // Number.isSafeInteger(ALL_32_BITS * 1e6) == true.
    const base = 1e6;
    let lowBits = 0;
    let highBits = 0;
    function add1e6digit(begin, end) {
        // Note: Number('') is 0.
        const digit1e6 = Number(dec.slice(begin, end));
        highBits *= base;
        lowBits = lowBits * base + digit1e6;
        // Carry bits from lowBits to
        if (lowBits >= TWO_PWR_32_DBL) {
            highBits = highBits + (lowBits / TWO_PWR_32_DBL | 0);
            lowBits = lowBits % TWO_PWR_32_DBL;
        }
    }
    add1e6digit(-24, -18);
    add1e6digit(-18, -12);
    add1e6digit(-12, -6);
    add1e6digit(-6);
    return minus ? negate(lowBits, highBits) : newBits(lowBits, highBits);
}
/**
 * Losslessly converts a 64-bit signed integer in 32:32 split representation
 * into a decimal string.
 *
 * Copyright 2008 Google Inc.  All rights reserved.
 *
 * See https://github.com/protocolbuffers/protobuf-javascript/blob/a428c58273abad07c66071d9753bc4d1289de426/experimental/runtime/int64.js#L10
 */ function int64ToString(lo, hi) {
    let bits = newBits(lo, hi);
    // If we're treating the input as a signed value and the high bit is set, do
    // a manual two's complement conversion before the decimal conversion.
    const negative = bits.hi & 0x80000000;
    if (negative) {
        bits = negate(bits.lo, bits.hi);
    }
    const result = uInt64ToString(bits.lo, bits.hi);
    return negative ? "-" + result : result;
}
/**
 * Losslessly converts a 64-bit unsigned integer in 32:32 split representation
 * into a decimal string.
 *
 * Copyright 2008 Google Inc.  All rights reserved.
 *
 * See https://github.com/protocolbuffers/protobuf-javascript/blob/a428c58273abad07c66071d9753bc4d1289de426/experimental/runtime/int64.js#L10
 */ function uInt64ToString(lo, hi) {
    ({ lo, hi } = toUnsigned(lo, hi));
    // Skip the expensive conversion if the number is small enough to use the
    // built-in conversions.
    // Number.MAX_SAFE_INTEGER = 0x001FFFFF FFFFFFFF, thus any number with
    // highBits <= 0x1FFFFF can be safely expressed with a double and retain
    // integer precision.
    // Proven by: Number.isSafeInteger(0x1FFFFF * 2**32 + 0xFFFFFFFF) == true.
    if (hi <= 0x1fffff) {
        return String(TWO_PWR_32_DBL * hi + lo);
    }
    // What this code is doing is essentially converting the input number from
    // base-2 to base-1e7, which allows us to represent the 64-bit range with
    // only 3 (very large) digits. Those digits are then trivial to convert to
    // a base-10 string.
    // The magic numbers used here are -
    // 2^24 = 16777216 = (1,6777216) in base-1e7.
    // 2^48 = 281474976710656 = (2,8147497,6710656) in base-1e7.
    // Split 32:32 representation into 16:24:24 representation so our
    // intermediate digits don't overflow.
    const low = lo & 0xffffff;
    const mid = (lo >>> 24 | hi << 8) & 0xffffff;
    const high = hi >> 16 & 0xffff;
    // Assemble our three base-1e7 digits, ignoring carries. The maximum
    // value in a digit at this step is representable as a 48-bit integer, which
    // can be stored in a 64-bit floating point number.
    let digitA = low + mid * 6777216 + high * 6710656;
    let digitB = mid + high * 8147497;
    let digitC = high * 2;
    // Apply carries from A to B and from B to C.
    const base = 10000000;
    if (digitA >= base) {
        digitB += Math.floor(digitA / base);
        digitA %= base;
    }
    if (digitB >= base) {
        digitC += Math.floor(digitB / base);
        digitB %= base;
    }
    // If digitC is 0, then we should have returned in the trivial code path
    // at the top for non-safe integers. Given this, we can assume both digitB
    // and digitA need leading zeros.
    return digitC.toString() + decimalFrom1e7WithLeadingZeros(digitB) + decimalFrom1e7WithLeadingZeros(digitA);
}
function toUnsigned(lo, hi) {
    return {
        lo: lo >>> 0,
        hi: hi >>> 0
    };
}
function newBits(lo, hi) {
    return {
        lo: lo | 0,
        hi: hi | 0
    };
}
/**
 * Returns two's compliment negation of input.
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Bitwise_Operators#Signed_32-bit_integers
 */ function negate(lowBits, highBits) {
    highBits = ~highBits;
    if (lowBits) {
        lowBits = ~lowBits + 1;
    } else {
        // If lowBits is 0, then bitwise-not is 0xFFFFFFFF,
        // adding 1 to that, results in 0x100000000, which leaves
        // the low bits 0x0 and simply adds one to the high bits.
        highBits += 1;
    }
    return newBits(lowBits, highBits);
}
/**
 * Returns decimal representation of digit1e7 with leading zeros.
 */ const decimalFrom1e7WithLeadingZeros = (digit1e7)=>{
    const partial = String(digit1e7);
    return "0000000".slice(partial.length) + partial;
};
/**
 * Write a 32 bit varint, signed or unsigned. Same as `varint64write(0, value, bytes)`
 *
 * Copyright 2008 Google Inc.  All rights reserved.
 *
 * See https://github.com/protocolbuffers/protobuf/blob/1b18833f4f2a2f681f4e4a25cdf3b0a43115ec26/js/binary/encoder.js#L144
 */ function varint32write(value, bytes) {
    if (value >= 0) {
        // write value as varint 32
        while(value > 0x7f){
            bytes.push(value & 0x7f | 0x80);
            value = value >>> 7;
        }
        bytes.push(value);
    } else {
        for(let i = 0; i < 9; i++){
            bytes.push(value & 127 | 128);
            value = value >> 7;
        }
        bytes.push(1);
    }
}

// Copyright 2021-2026 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * Int64Support for the current environment.
 */ const protoInt64 = /*@__PURE__*/ makeInt64Support();
function makeInt64Support() {
    const dv = new DataView(new ArrayBuffer(8));
    // note that Safari 14 implements BigInt, but not the DataView methods
    const ok = typeof BigInt === "function" && typeof dv.getBigInt64 === "function" && typeof dv.getBigUint64 === "function" && typeof dv.setBigInt64 === "function" && typeof dv.setBigUint64 === "function" && (!!globalThis.Deno || !!globalThis.Bun || typeof process != "object" || typeof process.env != "object" || process.env.BUF_BIGINT_DISABLE !== "1");
    if (ok) {
        const MIN = BigInt("-9223372036854775808");
        const MAX = BigInt("9223372036854775807");
        const UMIN = BigInt("0");
        const UMAX = BigInt("18446744073709551615");
        return {
            zero: BigInt(0),
            supported: true,
            parse (value) {
                const bi = typeof value == "bigint" ? value : BigInt(value);
                if (bi > MAX || bi < MIN) {
                    throw new Error(`invalid int64: ${value}`);
                }
                return bi;
            },
            uParse (value) {
                const bi = typeof value == "bigint" ? value : BigInt(value);
                if (bi > UMAX || bi < UMIN) {
                    throw new Error(`invalid uint64: ${value}`);
                }
                return bi;
            },
            enc (value) {
                dv.setBigInt64(0, this.parse(value), true);
                return {
                    lo: dv.getInt32(0, true),
                    hi: dv.getInt32(4, true)
                };
            },
            uEnc (value) {
                dv.setBigInt64(0, this.uParse(value), true);
                return {
                    lo: dv.getInt32(0, true),
                    hi: dv.getInt32(4, true)
                };
            },
            dec (lo, hi) {
                dv.setInt32(0, lo, true);
                dv.setInt32(4, hi, true);
                return dv.getBigInt64(0, true);
            },
            uDec (lo, hi) {
                dv.setInt32(0, lo, true);
                dv.setInt32(4, hi, true);
                return dv.getBigUint64(0, true);
            }
        };
    }
    return {
        zero: "0",
        supported: false,
        parse (value) {
            if (typeof value != "string") {
                value = value.toString();
            }
            assertInt64String(value);
            return value;
        },
        uParse (value) {
            if (typeof value != "string") {
                value = value.toString();
            }
            assertUInt64String(value);
            return value;
        },
        enc (value) {
            if (typeof value != "string") {
                value = value.toString();
            }
            assertInt64String(value);
            return int64FromString(value);
        },
        uEnc (value) {
            if (typeof value != "string") {
                value = value.toString();
            }
            assertUInt64String(value);
            return int64FromString(value);
        },
        dec (lo, hi) {
            return int64ToString(lo, hi);
        },
        uDec (lo, hi) {
            return uInt64ToString(lo, hi);
        }
    };
}
function assertInt64String(value) {
    if (!/^-?[0-9]+$/.test(value)) {
        throw new Error("invalid int64: " + value);
    }
}
function assertUInt64String(value) {
    if (!/^[0-9]+$/.test(value)) {
        throw new Error("invalid uint64: " + value);
    }
}

// Copyright 2021-2026 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * Returns the zero value for the given scalar type, the value a field of this
 * type has when unset: 0 for numeric types, "" for strings, false for
 * booleans, and an empty Uint8Array for bytes. For 64-bit integer types, the
 * result is "0" when longAsString is true, otherwise 0n.
 *
 * This is the type's zero value, not a proto2 custom field default. For float
 * and double it is +0; isScalarZeroValue treats only +0, not -0, as this value.
 */ function scalarZeroValue(type, longAsString) {
    switch(type){
        case ScalarType.STRING:
            return "";
        case ScalarType.BOOL:
            return false;
        case ScalarType.DOUBLE:
        case ScalarType.FLOAT:
            return 0.0;
        case ScalarType.INT64:
        case ScalarType.UINT64:
        case ScalarType.SFIXED64:
        case ScalarType.FIXED64:
        case ScalarType.SINT64:
            return longAsString ? "0" : protoInt64.zero;
        case ScalarType.BYTES:
            return new Uint8Array(0);
        default:
            // Handles INT32, UINT32, SINT32, FIXED32, SFIXED32.
            // We do not use individual cases to save a few bytes code size.
            return 0;
    }
}
/**
 * Returns true if the value is the zero value for the given scalar type: `0`
 * for numeric types, `false` for booleans, `""` for strings, and an empty
 * Uint8Array for bytes.
 *
 * This is the implicit-presence default check. A singular field with implicit
 * presence is treated as unset, and omitted from the wire, when its value is
 * the zero value. With explicit presence, or in repeated and map fields,
 * presence is structural and this function does not apply.
 *
 * Note that -0 is NOT a zero value for float and double: under implicit
 * presence, +0 is omitted from the wire but -0 is written, following the
 * proto3 specification. As a result this can disagree with scalarEquals, which
 * compares by value and treats -0 as equal to 0.
 */ function isScalarZeroValue(type, value) {
    switch(type){
        case ScalarType.BOOL:
            return value === false;
        case ScalarType.STRING:
            return value === "";
        case ScalarType.BYTES:
            return value instanceof Uint8Array && !value.byteLength;
        case ScalarType.DOUBLE:
        case ScalarType.FLOAT:
            // Object.is distinguishes -0 from 0.
            return Object.is(value, 0);
        default:
            // Loose comparison matches 0n, 0 and "0".
            return value == 0;
    }
}

// Copyright 2021-2026 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// bootstrap-inject google.protobuf.FeatureSet.FieldPresence.IMPLICIT: const $name = $number;
const IMPLICIT$1 = 2;
const unsafeLocal = Symbol.for("reflect unsafe local");
/**
 * Return the selected field of a oneof group.
 *
 * @private
 */ function unsafeOneofCase(// biome-ignore lint/suspicious/noExplicitAny: `any` is the best choice for dynamic access
target, oneof) {
    const c = target[oneof.localName].case;
    if (c === undefined) {
        return c;
    }
    return oneof.fields.find((f)=>f.localName === c);
}
/**
 * Returns true if the field is set.
 *
 * @private
 */ function unsafeIsSet(// biome-ignore lint/suspicious/noExplicitAny: `any` is the best choice for dynamic access
target, field) {
    const name = field.localName;
    if (field.oneof) {
        return target[field.oneof.localName].case === name;
    }
    if (field.presence != IMPLICIT$1) {
        // Fields with explicit presence have properties on the prototype chain
        // for default / zero values (except for proto3).
        return target[name] !== undefined && Object.prototype.hasOwnProperty.call(target, name);
    }
    switch(field.fieldKind){
        case "list":
            return target[name].length > 0;
        case "map":
            return Object.keys(target[name]).length > 0;
        case "scalar":
            return !isScalarZeroValue(field.scalar, target[name]);
        case "enum":
            return target[name] !== field.enum.values[0].number;
    }
    throw new Error("message field with implicit presence");
}
/**
 * Return a field value, respecting oneof groups.
 *
 * @private
 */ function unsafeGet(target, field) {
    if (field.oneof) {
        const oneof = target[field.oneof.localName];
        if (oneof.case === field.localName) {
            return oneof.value;
        }
        return undefined;
    }
    return target[field.localName];
}
/**
 * Set a field value, respecting oneof groups.
 *
 * @private
 */ function unsafeSet(target, field, value) {
    if (field.oneof) {
        target[field.oneof.localName] = {
            case: field.localName,
            value: value
        };
    } else {
        target[field.localName] = value;
    }
}
/**
 * Resets the field, so that unsafeIsSet() will return false.
 *
 * @private
 */ function unsafeClear(// biome-ignore lint/suspicious/noExplicitAny: `any` is the best choice for dynamic access
target, field) {
    const name = field.localName;
    if (field.oneof) {
        const oneofLocalName = field.oneof.localName;
        if (target[oneofLocalName].case === name) {
            target[oneofLocalName] = {
                case: undefined
            };
        }
    } else if (field.presence != IMPLICIT$1) {
        // Fields with explicit presence have properties on the prototype chain
        // for default / zero values (except for proto3). By deleting their own
        // property, the field is reset.
        delete target[name];
    } else {
        switch(field.fieldKind){
            case "map":
                target[name] = {};
                break;
            case "list":
                target[name] = [];
                break;
            case "enum":
                target[name] = field.enum.values[0].number;
                break;
            case "scalar":
                target[name] = scalarZeroValue(field.scalar, field.longAsString);
                break;
        }
    }
}

// Copyright 2021-2026 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
function isObject(arg) {
    return arg !== null && typeof arg == "object" && !Array.isArray(arg);
}
function isReflectList(arg, field) {
    var _a, _b, _c, _d;
    if (isObject(arg) && unsafeLocal in arg && "add" in arg && "field" in arg && typeof arg.field == "function") {
        if (field !== undefined) {
            const a = field;
            const b = arg.field();
            return a.listKind == b.listKind && a.scalar === b.scalar && ((_a = a.message) === null || _a === undefined ? undefined : _a.typeName) === ((_b = b.message) === null || _b === undefined ? undefined : _b.typeName) && ((_c = a.enum) === null || _c === undefined ? undefined : _c.typeName) === ((_d = b.enum) === null || _d === undefined ? undefined : _d.typeName);
        }
        return true;
    }
    return false;
}
function isReflectMap(arg, field) {
    var _a, _b, _c, _d;
    if (isObject(arg) && unsafeLocal in arg && "has" in arg && "field" in arg && typeof arg.field == "function") {
        if (field !== undefined) {
            const a = field, b = arg.field();
            return a.mapKey === b.mapKey && a.mapKind == b.mapKind && a.scalar === b.scalar && ((_a = a.message) === null || _a === undefined ? undefined : _a.typeName) === ((_b = b.message) === null || _b === undefined ? undefined : _b.typeName) && ((_c = a.enum) === null || _c === undefined ? undefined : _c.typeName) === ((_d = b.enum) === null || _d === undefined ? undefined : _d.typeName);
        }
        return true;
    }
    return false;
}
function isReflectMessage(arg, messageDesc) {
    return isObject(arg) && unsafeLocal in arg && "desc" in arg && isObject(arg.desc) && arg.desc.kind === "message" && (messageDesc === undefined || arg.desc.typeName == messageDesc.typeName);
}

// Copyright 2021-2026 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
function isWrapper(arg) {
    return isWrapperTypeName(arg.$typeName);
}
function isWrapperDesc(messageDesc) {
    const f = messageDesc.fields[0];
    return isWrapperTypeName(messageDesc.typeName) && f !== undefined && f.fieldKind == "scalar" && f.name == "value" && f.number == 1;
}
function isWrapperTypeName(name) {
    return name.startsWith("google.protobuf.") && [
        "DoubleValue",
        "FloatValue",
        "Int64Value",
        "UInt64Value",
        "Int32Value",
        "UInt32Value",
        "BoolValue",
        "StringValue",
        "BytesValue"
    ].includes(name.substring(16));
}

// Copyright 2021-2026 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// bootstrap-inject google.protobuf.Edition.EDITION_PROTO3: const $name = $number;
const EDITION_PROTO3 = 999;
// bootstrap-inject google.protobuf.Edition.EDITION_PROTO2: const $name = $number;
const EDITION_PROTO2 = 998;
// bootstrap-inject google.protobuf.FeatureSet.FieldPresence.IMPLICIT: const $name = $number;
const IMPLICIT = 2;
/**
 * Create a new message instance.
 *
 * The second argument is an optional initializer object, where all fields are
 * optional.
 */ function create(schema, init) {
    if (isMessage(init, schema)) {
        return init;
    }
    const message = createZeroMessage(schema);
    if (init !== undefined) {
        initMessage(schema, message, init);
    }
    return message;
}
/**
 * Sets field values from a MessageInitShape on a zero message.
 */ function initMessage(messageDesc, message, init) {
    for (const member of messageDesc.members){
        let value = init[member.localName];
        if (value == null) {
            continue;
        }
        let field;
        if (member.kind == "oneof") {
            const oneofField = unsafeOneofCase(init, member);
            if (!oneofField) {
                continue;
            }
            field = oneofField;
            value = unsafeGet(init, oneofField);
        } else {
            field = member;
        }
        switch(field.fieldKind){
            case "message":
                value = toMessage(field, value);
                break;
            case "scalar":
                value = initScalar(field, value);
                break;
            case "list":
                value = initList(field, value);
                break;
            case "map":
                value = initMap(field, value);
                break;
        }
        unsafeSet(message, field, value);
    }
    return message;
}
function initScalar(field, value) {
    if (field.scalar == ScalarType.BYTES) {
        return toU8Arr(value);
    }
    return value;
}
function initMap(field, value) {
    if (isObject(value)) {
        if (field.scalar == ScalarType.BYTES) {
            return convertObjectValues(value, toU8Arr);
        }
        if (field.mapKind == "message") {
            return convertObjectValues(value, (val)=>toMessage(field, val));
        }
    }
    return value;
}
function initList(field, value) {
    if (Array.isArray(value)) {
        if (field.scalar == ScalarType.BYTES) {
            return value.map(toU8Arr);
        }
        if (field.listKind == "message") {
            return value.map((item)=>toMessage(field, item));
        }
    }
    return value;
}
function toMessage(field, value) {
    if (field.fieldKind == "message" && !field.oneof && isWrapperDesc(field.message)) {
        // Types from google/protobuf/wrappers.proto are unwrapped when used in
        // a singular field that is not part of a oneof group.
        return initScalar(field.message.fields[0], value);
    }
    if (isObject(value)) {
        if (field.message.typeName == "google.protobuf.Struct" && field.parent.typeName !== "google.protobuf.Value") {
            // google.protobuf.Struct is represented with JsonObject when used in a
            // field, except when used in google.protobuf.Value.
            return value;
        }
        if (!isMessage(value, field.message)) {
            return create(field.message, value);
        }
    }
    return value;
}
// converts any ArrayLike<number> to Uint8Array if necessary.
function toU8Arr(value) {
    return Array.isArray(value) ? new Uint8Array(value) : value;
}
function convertObjectValues(obj, fn) {
    const ret = {};
    for (const entry of Object.entries(obj)){
        ret[entry[0]] = fn(entry[1]);
    }
    return ret;
}
const tokenZeroMessageField = Symbol();
const messagePrototypes = new WeakMap();
/**
 * Create a zero message.
 */ function createZeroMessage(desc) {
    let msg;
    if (!needsPrototypeChain(desc)) {
        msg = {
            $typeName: desc.typeName
        };
        for (const member of desc.members){
            if (member.kind == "oneof" || member.presence == IMPLICIT) {
                msg[member.localName] = createZeroField(member);
            }
        }
    } else {
        // Support default values and track presence via the prototype chain
        const cached = messagePrototypes.get(desc);
        let prototype;
        let members;
        if (cached) {
            ({ prototype, members } = cached);
        } else {
            prototype = {};
            members = new Set();
            for (const member of desc.members){
                if (member.kind == "oneof") {
                    continue;
                }
                if (member.fieldKind != "scalar" && member.fieldKind != "enum") {
                    continue;
                }
                if (member.presence == IMPLICIT) {
                    continue;
                }
                members.add(member);
                prototype[member.localName] = createZeroField(member);
            }
            messagePrototypes.set(desc, {
                prototype,
                members
            });
        }
        msg = Object.create(prototype);
        msg.$typeName = desc.typeName;
        for (const member of desc.members){
            if (members.has(member)) {
                continue;
            }
            if (member.kind == "field") {
                if (member.fieldKind == "message") {
                    continue;
                }
                if (member.fieldKind == "scalar" || member.fieldKind == "enum") {
                    if (member.presence != IMPLICIT) {
                        continue;
                    }
                }
            }
            msg[member.localName] = createZeroField(member);
        }
    }
    return msg;
}
/**
 * Do we need the prototype chain to track field presence?
 */ function needsPrototypeChain(desc) {
    switch(desc.file.edition){
        case EDITION_PROTO3:
            // proto3 always uses implicit presence, we never need the prototype chain.
            return false;
        case EDITION_PROTO2:
            // proto2 never uses implicit presence, we always need the prototype chain.
            return true;
        default:
            // If a message uses scalar or enum fields with explicit presence, we need
            // the prototype chain to track presence. This rule does not apply to fields
            // in a oneof group - they use a different mechanism to track presence.
            return desc.fields.some((f)=>f.presence != IMPLICIT && f.fieldKind != "message" && !f.oneof);
    }
}
/**
 * Returns a zero value for oneof groups, and for every field kind except
 * messages. Scalar and enum fields can have default values.
 */ function createZeroField(field) {
    if (field.kind == "oneof") {
        return {
            case: undefined
        };
    }
    if (field.fieldKind == "list") {
        return [];
    }
    if (field.fieldKind == "map") {
        return {}; // Object.create(null) would be desirable here, but is unsupported by react https://react.dev/reference/react/use-server#serializable-parameters-and-return-values
    }
    if (field.fieldKind == "message") {
        return tokenZeroMessageField;
    }
    const defaultValue = field.getDefaultValue();
    if (defaultValue !== undefined) {
        return field.fieldKind == "scalar" && field.longAsString ? defaultValue.toString() : defaultValue;
    }
    return field.fieldKind == "scalar" ? scalarZeroValue(field.scalar, field.longAsString) : field.enum.values[0].number;
}

// Copyright 2021-2026 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
class FieldError extends Error {
    constructor(fieldOrOneof, message, name = "FieldValueInvalidError"){
        super(message);
        this.name = name;
        this.field = ()=>fieldOrOneof;
    }
}

// Copyright 2021-2026 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
const symbol = Symbol.for("@bufbuild/protobuf/text-encoding");
function getTextEncoding() {
    if (globalThis[symbol] == undefined) {
        const te = new globalThis.TextEncoder();
        const td = new globalThis.TextDecoder();
        let tdStrict;
        globalThis[symbol] = {
            encodeUtf8 (text) {
                return te.encode(text);
            },
            decodeUtf8 (bytes, strict) {
                if (strict) {
                    if (tdStrict === undefined) {
                        tdStrict = new globalThis.TextDecoder("utf-8", {
                            fatal: true
                        });
                    }
                    return tdStrict.decode(bytes);
                }
                return td.decode(bytes);
            },
            checkUtf8 (text) {
                try {
                    encodeURIComponent(text);
                    return true;
                } catch (_) {
                    return false;
                }
            }
        };
    }
    return globalThis[symbol];
}

// Copyright 2021-2026 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * Protobuf binary format wire types.
 *
 * A wire type provides just enough information to find the length of the
 * following value.
 *
 * See https://developers.google.com/protocol-buffers/docs/encoding#structure
 */ var WireType;
(function(WireType) {
    /**
     * Used for int32, int64, uint32, uint64, sint32, sint64, bool, enum
     */ WireType[WireType["Varint"] = 0] = "Varint";
    /**
     * Used for fixed64, sfixed64, double.
     * Always 8 bytes with little-endian byte order.
     */ WireType[WireType["Bit64"] = 1] = "Bit64";
    /**
     * Used for string, bytes, embedded messages, packed repeated fields
     *
     * Only repeated numeric types (types which use the varint, 32-bit,
     * or 64-bit wire types) can be packed. In proto3, such fields are
     * packed by default.
     */ WireType[WireType["LengthDelimited"] = 2] = "LengthDelimited";
    /**
     * Start of a tag-delimited aggregate, such as a proto2 group, or a message
     * in editions with message_encoding = DELIMITED.
     */ WireType[WireType["StartGroup"] = 3] = "StartGroup";
    /**
     * End of a tag-delimited aggregate.
     */ WireType[WireType["EndGroup"] = 4] = "EndGroup";
    /**
     * Used for fixed32, sfixed32, float.
     * Always 4 bytes with little-endian byte order.
     */ WireType[WireType["Bit32"] = 5] = "Bit32";
})(WireType || (WireType = {}));
/**
 * Maximum value for a 32-bit floating point value (Protobuf FLOAT).
 */ const FLOAT32_MAX = 3.4028234663852886e38;
/**
 * Minimum value for a 32-bit floating point value (Protobuf FLOAT).
 */ const FLOAT32_MIN = -34028234663852886e22;
/**
 * Maximum value for an unsigned 32-bit integer (Protobuf UINT32, FIXED32).
 */ const UINT32_MAX = 0xffffffff;
/**
 * Maximum value for a signed 32-bit integer (Protobuf INT32, SFIXED32, SINT32).
 */ const INT32_MAX = 0x7fffffff;
/**
 * Minimum value for a signed 32-bit integer (Protobuf INT32, SFIXED32, SINT32).
 */ const INT32_MIN = -2147483648;
class BinaryWriter {
    /**
     * Return all bytes written and reset this writer.
     */ finish() {
        if (this.buf.length) {
            this.chunks.push(new Uint8Array(this.buf)); // flush the buffer
            this.buf = [];
        }
        let len = 0;
        for(let i = 0; i < this.chunks.length; i++)len += this.chunks[i].length;
        let bytes = new Uint8Array(len);
        let offset = 0;
        for(let i = 0; i < this.chunks.length; i++){
            bytes.set(this.chunks[i], offset);
            offset += this.chunks[i].length;
        }
        this.chunks = [];
        return bytes;
    }
    /**
     * Start a new fork for length-delimited data like a message
     * or a packed repeated field.
     *
     * Must be joined later with `join()`.
     */ fork() {
        this.stack.push({
            chunks: this.chunks,
            buf: this.buf
        });
        this.chunks = [];
        this.buf = [];
        return this;
    }
    /**
     * Join the last fork. Write its length and bytes, then
     * return to the previous state.
     */ join() {
        // get chunk of fork
        let chunk = this.finish();
        // restore previous state
        let prev = this.stack.pop();
        if (!prev) throw new Error("invalid state, fork stack empty");
        this.chunks = prev.chunks;
        this.buf = prev.buf;
        // write length of chunk as varint
        this.uint32(chunk.byteLength);
        return this.raw(chunk);
    }
    /**
     * Writes a tag (field number and wire type).
     *
     * Equivalent to `uint32( (fieldNo << 3 | type) >>> 0 )`.
     *
     * Generated code should compute the tag ahead of time and call `uint32()`.
     */ tag(fieldNo, type) {
        return this.uint32((fieldNo << 3 | type) >>> 0);
    }
    /**
     * Write a chunk of raw bytes.
     */ raw(chunk) {
        if (this.buf.length) {
            this.chunks.push(new Uint8Array(this.buf));
            this.buf = [];
        }
        this.chunks.push(chunk);
        return this;
    }
    /**
     * Write a `uint32` value, an unsigned 32 bit varint.
     */ uint32(value) {
        assertUInt32(value);
        // write value as varint 32, inlined for speed
        while(value > 0x7f){
            this.buf.push(value & 0x7f | 0x80);
            value = value >>> 7;
        }
        this.buf.push(value);
        return this;
    }
    /**
     * Write a `int32` value, a signed 32 bit varint.
     */ int32(value) {
        assertInt32(value);
        varint32write(value, this.buf);
        return this;
    }
    /**
     * Write a `bool` value, a varint.
     */ bool(value) {
        this.buf.push(value ? 1 : 0);
        return this;
    }
    /**
     * Write a `bytes` value, length-delimited arbitrary data.
     */ bytes(value) {
        this.uint32(value.byteLength); // write length of chunk as varint
        return this.raw(value);
    }
    /**
     * Write a `string` value, length-delimited data converted to UTF-8 text.
     */ string(value) {
        let chunk = this.encodeUtf8(value);
        this.uint32(chunk.byteLength); // write length of chunk as varint
        return this.raw(chunk);
    }
    /**
     * Write a `float` value, 32-bit floating point number.
     */ float(value) {
        assertFloat32(value);
        let chunk = new Uint8Array(4);
        new DataView(chunk.buffer).setFloat32(0, value, true);
        return this.raw(chunk);
    }
    /**
     * Write a `double` value, a 64-bit floating point number.
     */ double(value) {
        let chunk = new Uint8Array(8);
        new DataView(chunk.buffer).setFloat64(0, value, true);
        return this.raw(chunk);
    }
    /**
     * Write a `fixed32` value, an unsigned, fixed-length 32-bit integer.
     */ fixed32(value) {
        assertUInt32(value);
        let chunk = new Uint8Array(4);
        new DataView(chunk.buffer).setUint32(0, value, true);
        return this.raw(chunk);
    }
    /**
     * Write a `sfixed32` value, a signed, fixed-length 32-bit integer.
     */ sfixed32(value) {
        assertInt32(value);
        let chunk = new Uint8Array(4);
        new DataView(chunk.buffer).setInt32(0, value, true);
        return this.raw(chunk);
    }
    /**
     * Write a `sint32` value, a signed, zigzag-encoded 32-bit varint.
     */ sint32(value) {
        assertInt32(value);
        // zigzag encode
        value = (value << 1 ^ value >> 31) >>> 0;
        varint32write(value, this.buf);
        return this;
    }
    /**
     * Write a `sfixed64` value, a signed, fixed-length 64-bit integer.
     */ sfixed64(value) {
        let chunk = new Uint8Array(8), view = new DataView(chunk.buffer), tc = protoInt64.enc(value);
        view.setInt32(0, tc.lo, true);
        view.setInt32(4, tc.hi, true);
        return this.raw(chunk);
    }
    /**
     * Write a `fixed64` value, an unsigned, fixed-length 64 bit integer.
     */ fixed64(value) {
        let chunk = new Uint8Array(8), view = new DataView(chunk.buffer), tc = protoInt64.uEnc(value);
        view.setInt32(0, tc.lo, true);
        view.setInt32(4, tc.hi, true);
        return this.raw(chunk);
    }
    /**
     * Write a `int64` value, a signed 64-bit varint.
     */ int64(value) {
        let tc = protoInt64.enc(value);
        varint64write(tc.lo, tc.hi, this.buf);
        return this;
    }
    /**
     * Write a `sint64` value, a signed, zig-zag-encoded 64-bit varint.
     */ sint64(value) {
        const tc = protoInt64.enc(value), // zigzag encode
        sign = tc.hi >> 31, lo = tc.lo << 1 ^ sign, hi = (tc.hi << 1 | tc.lo >>> 31) ^ sign;
        varint64write(lo, hi, this.buf);
        return this;
    }
    /**
     * Write a `uint64` value, an unsigned 64-bit varint.
     */ uint64(value) {
        const tc = protoInt64.uEnc(value);
        varint64write(tc.lo, tc.hi, this.buf);
        return this;
    }
    constructor(encodeUtf8 = getTextEncoding().encodeUtf8){
        this.encodeUtf8 = encodeUtf8;
        /**
         * Previous fork states.
         */ this.stack = [];
        this.chunks = [];
        this.buf = [];
    }
}
/**
 * Assert a valid signed protobuf 32-bit integer as a number or string.
 */ function assertInt32(arg) {
    if (typeof arg == "string") {
        arg = Number(arg);
    } else if (typeof arg != "number") {
        throw new Error("invalid int32: " + typeof arg);
    }
    if (!Number.isInteger(arg) || arg > INT32_MAX || arg < INT32_MIN) throw new Error("invalid int32: " + arg);
}
/**
 * Assert a valid unsigned protobuf 32-bit integer as a number or string.
 */ function assertUInt32(arg) {
    if (typeof arg == "string") {
        arg = Number(arg);
    } else if (typeof arg != "number") {
        throw new Error("invalid uint32: " + typeof arg);
    }
    if (!Number.isInteger(arg) || arg > UINT32_MAX || arg < 0) throw new Error("invalid uint32: " + arg);
}
/**
 * Assert a valid protobuf float value as a number or string.
 */ function assertFloat32(arg) {
    if (typeof arg == "string") {
        const o = arg;
        arg = Number(arg);
        if (Number.isNaN(arg) && o !== "NaN") {
            throw new Error("invalid float32: " + o);
        }
    } else if (typeof arg != "number") {
        throw new Error("invalid float32: " + typeof arg);
    }
    if (Number.isFinite(arg) && (arg > FLOAT32_MAX || arg < FLOAT32_MIN)) throw new Error("invalid float32: " + arg);
}

// Copyright 2021-2026 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * Check whether the given field value is valid for the reflect API.
 */ function checkField(field, value) {
    const check = field.fieldKind == "list" ? isReflectList(value, field) : field.fieldKind == "map" ? isReflectMap(value, field) : checkSingular(field, value);
    if (check === true) {
        return undefined;
    }
    let reason;
    switch(field.fieldKind){
        case "list":
            reason = `expected ${formatReflectList(field)}, got ${formatVal(value)}`;
            break;
        case "map":
            reason = `expected ${formatReflectMap(field)}, got ${formatVal(value)}`;
            break;
        default:
            {
                reason = reasonSingular(field, value, check);
            }
    }
    return new FieldError(field, reason);
}
/**
 * Check whether the given list item is valid for the reflect API.
 */ function checkListItem(field, index, value) {
    const check = checkSingular(field, value);
    if (check !== true) {
        return new FieldError(field, `list item #${index + 1}: ${reasonSingular(field, value, check)}`);
    }
    return undefined;
}
/**
 * Check whether the given map key and value are valid for the reflect API.
 */ function checkMapEntry(field, key, value) {
    const checkKey = checkScalarValue(key, field.mapKey);
    if (checkKey !== true) {
        return new FieldError(field, `invalid map key: ${reasonSingular({
            scalar: field.mapKey
        }, key, checkKey)}`);
    }
    const checkVal = checkSingular(field, value);
    if (checkVal !== true) {
        return new FieldError(field, `map entry ${formatVal(key)}: ${reasonSingular(field, value, checkVal)}`);
    }
    return undefined;
}
function checkSingular(field, value) {
    if (field.scalar !== undefined) {
        return checkScalarValue(value, field.scalar);
    }
    if (field.enum !== undefined) {
        if (field.enum.open) {
            // Open enums accept unrecognized values, but enum values are always
            // int32 (see https://protobuf.dev/programming-guides/proto3/#enum).
            return checkScalarValue(value, ScalarType.INT32);
        }
        return field.enum.values.some((v)=>v.number === value);
    }
    return isReflectMessage(value, field.message);
}
function checkScalarValue(value, scalar) {
    switch(scalar){
        case ScalarType.DOUBLE:
            return typeof value == "number";
        case ScalarType.FLOAT:
            if (typeof value != "number") {
                return false;
            }
            if (Number.isNaN(value) || !Number.isFinite(value)) {
                return true;
            }
            if (value > FLOAT32_MAX || value < FLOAT32_MIN) {
                return `${value.toFixed()} out of range`;
            }
            return true;
        case ScalarType.INT32:
        case ScalarType.SFIXED32:
        case ScalarType.SINT32:
            // signed
            if (typeof value !== "number" || !Number.isInteger(value)) {
                return false;
            }
            if (value > INT32_MAX || value < INT32_MIN) {
                return `${value.toFixed()} out of range`;
            }
            return true;
        case ScalarType.FIXED32:
        case ScalarType.UINT32:
            // unsigned
            if (typeof value !== "number" || !Number.isInteger(value)) {
                return false;
            }
            if (value > UINT32_MAX || value < 0) {
                return `${value.toFixed()} out of range`;
            }
            return true;
        case ScalarType.BOOL:
            return typeof value == "boolean";
        case ScalarType.STRING:
            if (typeof value != "string") {
                return false;
            }
            return getTextEncoding().checkUtf8(value) || "invalid UTF8";
        case ScalarType.BYTES:
            return value instanceof Uint8Array;
        case ScalarType.INT64:
        case ScalarType.SFIXED64:
        case ScalarType.SINT64:
            // signed
            if (typeof value == "bigint" || typeof value == "number" || typeof value == "string" && value.length > 0) {
                try {
                    protoInt64.parse(value);
                    return true;
                } catch (_) {
                    return `${value} out of range`;
                }
            }
            return false;
        case ScalarType.FIXED64:
        case ScalarType.UINT64:
            // unsigned
            if (typeof value == "bigint" || typeof value == "number" || typeof value == "string" && value.length > 0) {
                try {
                    protoInt64.uParse(value);
                    return true;
                } catch (_) {
                    return `${value} out of range`;
                }
            }
            return false;
    }
}
function reasonSingular(field, val, details) {
    details = typeof details == "string" ? `: ${details}` : `, got ${formatVal(val)}`;
    if (field.scalar !== undefined) {
        return `expected ${scalarTypeDescription(field.scalar)}` + details;
    }
    if (field.enum !== undefined) {
        return `expected ${field.enum.toString()}` + details;
    }
    return `expected ${formatReflectMessage(field.message)}` + details;
}
function formatVal(val) {
    switch(typeof val){
        case "object":
            if (val === null) {
                return "null";
            }
            if (val instanceof Uint8Array) {
                return `Uint8Array(${val.length})`;
            }
            if (Array.isArray(val)) {
                return `Array(${val.length})`;
            }
            if (isReflectList(val)) {
                return formatReflectList(val.field());
            }
            if (isReflectMap(val)) {
                return formatReflectMap(val.field());
            }
            if (isReflectMessage(val)) {
                return formatReflectMessage(val.desc);
            }
            if (isMessage(val)) {
                return `message ${val.$typeName}`;
            }
            return "object";
        case "string":
            return val.length > 30 ? "string" : `"${val.split('"').join('\\"')}"`;
        case "boolean":
            return String(val);
        case "number":
            return String(val);
        case "bigint":
            return String(val) + "n";
        default:
            // "symbol" | "undefined" | "object" | "function"
            return typeof val;
    }
}
function formatReflectMessage(desc) {
    return `ReflectMessage (${desc.typeName})`;
}
function formatReflectList(field) {
    switch(field.listKind){
        case "message":
            return `ReflectList (${field.message.toString()})`;
        case "enum":
            return `ReflectList (${field.enum.toString()})`;
        case "scalar":
            return `ReflectList (${ScalarType[field.scalar]})`;
    }
}
function formatReflectMap(field) {
    switch(field.mapKind){
        case "message":
            return `ReflectMap (${ScalarType[field.mapKey]}, ${field.message.toString()})`;
        case "enum":
            return `ReflectMap (${ScalarType[field.mapKey]}, ${field.enum.toString()})`;
        case "scalar":
            return `ReflectMap (${ScalarType[field.mapKey]}, ${ScalarType[field.scalar]})`;
    }
}
function scalarTypeDescription(scalar) {
    switch(scalar){
        case ScalarType.STRING:
            return "string";
        case ScalarType.BOOL:
            return "boolean";
        case ScalarType.INT64:
        case ScalarType.SINT64:
        case ScalarType.SFIXED64:
            return "bigint (int64)";
        case ScalarType.UINT64:
        case ScalarType.FIXED64:
            return "bigint (uint64)";
        case ScalarType.BYTES:
            return "Uint8Array";
        case ScalarType.DOUBLE:
            return "number (float64)";
        case ScalarType.FLOAT:
            return "number (float32)";
        case ScalarType.FIXED32:
        case ScalarType.UINT32:
            return "number (uint32)";
        case ScalarType.INT32:
        case ScalarType.SFIXED32:
        case ScalarType.SINT32:
            return "number (int32)";
    }
}

// Copyright 2021-2026 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// google.protobuf.NullValue.NULL_VALUE;
const NULL_VALUE = 0;
/**
 * Create a ReflectMessage.
 */ function reflect(messageDesc, message, /**
 * By default, field values are validated when setting them. For example,
 * a value for an uint32 field must be a ECMAScript Number >= 0.
 *
 * When field values are trusted, performance can be improved by disabling
 * checks.
 */ check = true) {
    return new ReflectMessageImpl(messageDesc, message, check);
}
const messageSortedFields = new WeakMap();
class ReflectMessageImpl {
    get sortedFields() {
        const cached = messageSortedFields.get(this.desc);
        if (cached) {
            return cached;
        }
        const sortedFields = this.desc.fields.concat().sort((a, b)=>a.number - b.number);
        messageSortedFields.set(this.desc, sortedFields);
        return sortedFields;
    }
    findNumber(number) {
        if (!this._fieldsByNumber) {
            this._fieldsByNumber = new Map(this.desc.fields.map((f)=>[
                    f.number,
                    f
                ]));
        }
        return this._fieldsByNumber.get(number);
    }
    oneofCase(oneof) {
        assertOwn(this.message, oneof);
        return unsafeOneofCase(this.message, oneof);
    }
    isSet(field) {
        assertOwn(this.message, field);
        return unsafeIsSet(this.message, field);
    }
    clear(field) {
        assertOwn(this.message, field);
        unsafeClear(this.message, field);
    }
    get(field) {
        assertOwn(this.message, field);
        const value = unsafeGet(this.message, field);
        switch(field.fieldKind){
            case "list":
                // eslint-disable-next-line no-case-declarations
                let list = this.lists.get(field);
                if (!list || list[unsafeLocal] !== value) {
                    this.lists.set(field, // biome-ignore lint/suspicious/noAssignInExpressions: no
                    list = new ReflectListImpl(field, value, this.check));
                }
                return list;
            case "map":
                let map = this.maps.get(field);
                if (!map || map[unsafeLocal] !== value) {
                    this.maps.set(field, // biome-ignore lint/suspicious/noAssignInExpressions: no
                    map = new ReflectMapImpl(field, value, this.check));
                }
                return map;
            case "message":
                return messageToReflect(field, value, this.check);
            case "scalar":
                return value === undefined ? scalarZeroValue(field.scalar, false) : longToReflect(field, value);
            case "enum":
                return value !== null && value !== undefined ? value : field.enum.values[0].number;
        }
    }
    set(field, value) {
        assertOwn(this.message, field);
        if (this.check) {
            const err = checkField(field, value);
            if (err) {
                throw err;
            }
        }
        let local;
        if (field.fieldKind == "message") {
            local = messageToLocal(field, value);
        } else if (isReflectMap(value) || isReflectList(value)) {
            local = value[unsafeLocal];
        } else {
            local = longToLocal(field, value);
        }
        unsafeSet(this.message, field, local);
    }
    getUnknown() {
        return this.message.$unknown;
    }
    setUnknown(value) {
        this.message.$unknown = value;
    }
    constructor(messageDesc, message, check = true){
        this.lists = new Map();
        this.maps = new Map();
        this.check = check;
        this.desc = messageDesc;
        this.message = this[unsafeLocal] = message !== null && message !== undefined ? message : create(messageDesc);
        this.fields = messageDesc.fields;
        this.oneofs = messageDesc.oneofs;
        this.members = messageDesc.members;
    }
}
function assertOwn(owner, member) {
    if (member.parent.typeName !== owner.$typeName) {
        throw new FieldError(member, `cannot use ${member.toString()} with message ${owner.$typeName}`, "ForeignFieldError");
    }
}
class ReflectListImpl {
    field() {
        return this._field;
    }
    get size() {
        return this._arr.length;
    }
    get(index) {
        const item = this._arr[index];
        return item === undefined ? undefined : listItemToReflect(this._field, item, this.check);
    }
    set(index, item) {
        if (index < 0 || index >= this._arr.length) {
            throw new FieldError(this._field, `list item #${index + 1}: out of range`);
        }
        if (this.check) {
            const err = checkListItem(this._field, index, item);
            if (err) {
                throw err;
            }
        }
        this._arr[index] = listItemToLocal(this._field, item);
    }
    add(item) {
        if (this.check) {
            const err = checkListItem(this._field, this._arr.length, item);
            if (err) {
                throw err;
            }
        }
        this._arr.push(listItemToLocal(this._field, item));
        return undefined;
    }
    clear() {
        this._arr.splice(0, this._arr.length);
    }
    [Symbol.iterator]() {
        return this.values();
    }
    keys() {
        return this._arr.keys();
    }
    *values() {
        for (const item of this._arr){
            yield listItemToReflect(this._field, item, this.check);
        }
    }
    *entries() {
        for(let i = 0; i < this._arr.length; i++){
            yield [
                i,
                listItemToReflect(this._field, this._arr[i], this.check)
            ];
        }
    }
    constructor(field, unsafeInput, check){
        this._field = field;
        this._arr = this[unsafeLocal] = unsafeInput;
        this.check = check;
    }
}
class ReflectMapImpl {
    field() {
        return this._field;
    }
    set(key, value) {
        if (this.check) {
            const err = checkMapEntry(this._field, key, value);
            if (err) {
                throw err;
            }
        }
        this.obj[mapKeyToLocal(key)] = mapValueToLocal(this._field, value);
        return this;
    }
    delete(key) {
        const k = mapKeyToLocal(key);
        const has = Object.prototype.hasOwnProperty.call(this.obj, k);
        if (has) {
            delete this.obj[k];
        }
        return has;
    }
    clear() {
        for (const key of Object.keys(this.obj)){
            delete this.obj[key];
        }
    }
    get(key) {
        let val = this.obj[mapKeyToLocal(key)];
        if (val !== undefined) {
            val = mapValueToReflect(this._field, val, this.check);
        }
        return val;
    }
    has(key) {
        return Object.prototype.hasOwnProperty.call(this.obj, mapKeyToLocal(key));
    }
    *keys() {
        for (const objKey of Object.keys(this.obj)){
            yield mapKeyToReflect(objKey, this._field.mapKey);
        }
    }
    *entries() {
        for (const objEntry of Object.entries(this.obj)){
            yield [
                mapKeyToReflect(objEntry[0], this._field.mapKey),
                mapValueToReflect(this._field, objEntry[1], this.check)
            ];
        }
    }
    [Symbol.iterator]() {
        return this.entries();
    }
    get size() {
        return Object.keys(this.obj).length;
    }
    *values() {
        for (const val of Object.values(this.obj)){
            yield mapValueToReflect(this._field, val, this.check);
        }
    }
    forEach(callbackfn, thisArg) {
        for (const mapEntry of this.entries()){
            callbackfn.call(thisArg, mapEntry[1], mapEntry[0], this);
        }
    }
    constructor(field, unsafeInput, check = true){
        this.obj = this[unsafeLocal] = unsafeInput !== null && unsafeInput !== undefined ? unsafeInput : {};
        this.check = check;
        this._field = field;
    }
}
function messageToLocal(field, value) {
    if (!isReflectMessage(value)) {
        return value;
    }
    if (isWrapper(value.message) && !field.oneof && field.fieldKind == "message") {
        // Types from google/protobuf/wrappers.proto are unwrapped when used in
        // a singular field that is not part of a oneof group.
        return value.message.value;
    }
    if (value.desc.typeName == "google.protobuf.Struct" && field.parent.typeName != "google.protobuf.Value") {
        // google.protobuf.Struct is represented with JsonObject when used in a
        // field, except when used in google.protobuf.Value.
        return wktStructToLocal(value.message);
    }
    return value.message;
}
function messageToReflect(field, value, check) {
    if (value !== undefined) {
        if (isWrapperDesc(field.message) && !field.oneof && field.fieldKind == "message") {
            // Types from google/protobuf/wrappers.proto are unwrapped when used in
            // a singular field that is not part of a oneof group.
            value = {
                $typeName: field.message.typeName,
                value: longToReflect(field.message.fields[0], value)
            };
        } else if (field.message.typeName == "google.protobuf.Struct" && field.parent.typeName != "google.protobuf.Value" && isObject(value)) {
            // google.protobuf.Struct is represented with JsonObject when used in a
            // field, except when used in google.protobuf.Value.
            value = wktStructToReflect(value);
        }
    }
    return new ReflectMessageImpl(field.message, value, check);
}
function listItemToLocal(field, value) {
    if (field.listKind == "message") {
        return messageToLocal(field, value);
    }
    return longToLocal(field, value);
}
function listItemToReflect(field, value, check) {
    if (field.listKind == "message") {
        return messageToReflect(field, value, check);
    }
    return longToReflect(field, value);
}
function mapValueToLocal(field, value) {
    if (field.mapKind == "message") {
        return messageToLocal(field, value);
    }
    return longToLocal(field, value);
}
function mapValueToReflect(field, value, check) {
    if (field.mapKind == "message") {
        return messageToReflect(field, value, check);
    }
    return value;
}
function mapKeyToLocal(key) {
    return typeof key == "string" || typeof key == "number" ? key : String(key);
}
/**
 * Converts a map key (any scalar value except float, double, or bytes) from its
 * representation in a message (string or number, the only possible object key
 * types) to the closest possible type in ECMAScript.
 */ function mapKeyToReflect(key, type) {
    switch(type){
        case ScalarType.STRING:
            return key;
        case ScalarType.INT32:
        case ScalarType.FIXED32:
        case ScalarType.UINT32:
        case ScalarType.SFIXED32:
        case ScalarType.SINT32:
            {
                const n = Number.parseInt(key);
                if (Number.isFinite(n)) {
                    return n;
                }
                break;
            }
        case ScalarType.BOOL:
            switch(key){
                case "true":
                    return true;
                case "false":
                    return false;
            }
            break;
        case ScalarType.UINT64:
        case ScalarType.FIXED64:
            try {
                return protoInt64.uParse(key);
            } catch (_a) {
            //
            }
            break;
        default:
            // INT64, SFIXED64, SINT64
            try {
                return protoInt64.parse(key);
            } catch (_b) {
            //
            }
            break;
    }
    return key;
}
function longToReflect(field, value) {
    switch(field.scalar){
        case ScalarType.INT64:
        case ScalarType.SFIXED64:
        case ScalarType.SINT64:
            if ("longAsString" in field && field.longAsString && typeof value == "string") {
                value = protoInt64.parse(value);
            }
            break;
        case ScalarType.FIXED64:
        case ScalarType.UINT64:
            if ("longAsString" in field && field.longAsString && typeof value == "string") {
                value = protoInt64.uParse(value);
            }
            break;
    }
    return value;
}
function longToLocal(field, value) {
    switch(field.scalar){
        case ScalarType.INT64:
        case ScalarType.SFIXED64:
        case ScalarType.SINT64:
            if ("longAsString" in field && field.longAsString) {
                value = String(value);
            } else if (typeof value == "string" || typeof value == "number") {
                value = protoInt64.parse(value);
            }
            break;
        case ScalarType.FIXED64:
        case ScalarType.UINT64:
            if ("longAsString" in field && field.longAsString) {
                value = String(value);
            } else if (typeof value == "string" || typeof value == "number") {
                value = protoInt64.uParse(value);
            }
            break;
    }
    return value;
}
function wktStructToReflect(json) {
    const struct = {
        $typeName: "google.protobuf.Struct",
        fields: {}
    };
    if (isObject(json)) {
        for (const [k, v] of Object.entries(json)){
            struct.fields[k] = wktValueToReflect(v);
        }
    }
    return struct;
}
function wktStructToLocal(val) {
    const json = {};
    for (const [k, v] of Object.entries(val.fields)){
        json[k] = wktValueToLocal(v);
    }
    return json;
}
function wktValueToLocal(val) {
    switch(val.kind.case){
        case "structValue":
            return wktStructToLocal(val.kind.value);
        case "listValue":
            return val.kind.value.values.map(wktValueToLocal);
        case "nullValue":
        case undefined:
            return null;
        default:
            return val.kind.value;
    }
}
function wktValueToReflect(json) {
    const value = {
        $typeName: "google.protobuf.Value",
        kind: {
            case: undefined
        }
    };
    switch(typeof json){
        case "number":
            value.kind = {
                case: "numberValue",
                value: json
            };
            break;
        case "string":
            value.kind = {
                case: "stringValue",
                value: json
            };
            break;
        case "boolean":
            value.kind = {
                case: "boolValue",
                value: json
            };
            break;
        case "object":
            if (json === null) {
                value.kind = {
                    case: "nullValue",
                    value: NULL_VALUE
                };
            } else if (Array.isArray(json)) {
                const listValue = {
                    $typeName: "google.protobuf.ListValue",
                    values: []
                };
                if (Array.isArray(json)) {
                    for (const e of json){
                        listValue.values.push(wktValueToReflect(e));
                    }
                }
                value.kind = {
                    case: "listValue",
                    value: listValue
                };
            } else {
                value.kind = {
                    case: "structValue",
                    value: wktStructToReflect(json)
                };
            }
            break;
    }
    return value;
}

// Copyright 2021-2026 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// bootstrap-inject google.protobuf.FeatureSet.FieldPresence.LEGACY_REQUIRED: const $name = $number;
const LEGACY_REQUIRED = 3;
// Default options for serializing binary data.
const writeDefaults = {
    writeUnknownFields: true
};
function makeWriteOptions(options) {
    return options ? Object.assign(Object.assign({}, writeDefaults), options) : writeDefaults;
}
function toBinary(schema, message, options) {
    return writeFields(new BinaryWriter(), makeWriteOptions(options), reflect(schema, message)).finish();
}
function writeFields(writer, opts, msg) {
    var _a;
    for (const f of msg.sortedFields){
        if (!msg.isSet(f)) {
            if (f.presence == LEGACY_REQUIRED) {
                throw new Error(`cannot encode ${f} to binary: required field not set`);
            }
            continue;
        }
        writeField(writer, opts, msg, f);
    }
    if (opts.writeUnknownFields) {
        for (const { no, wireType, data } of (_a = msg.getUnknown()) !== null && _a !== undefined ? _a : []){
            writer.tag(no, wireType).raw(data);
        }
    }
    return writer;
}
/**
 * @private
 */ function writeField(writer, opts, msg, field) {
    var _a;
    switch(field.fieldKind){
        case "scalar":
        case "enum":
            writeScalar(writer, msg.desc.typeName, field.name, (_a = field.scalar) !== null && _a !== undefined ? _a : ScalarType.INT32, field.number, msg.get(field));
            break;
        case "list":
            writeListField(writer, opts, field, msg.get(field));
            break;
        case "message":
            writeMessageField(writer, opts, field, msg.get(field));
            break;
        case "map":
            for (const [key, val] of msg.get(field)){
                writeMapEntry(writer, opts, field, key, val);
            }
            break;
    }
}
function writeScalar(writer, msgName, fieldName, scalarType, fieldNo, value) {
    writeScalarValue(writer.tag(fieldNo, writeTypeOfScalar(scalarType)), msgName, fieldName, scalarType, value);
}
function writeMessageField(writer, opts, field, message) {
    if (field.delimitedEncoding) {
        writeFields(writer.tag(field.number, WireType.StartGroup), opts, message).tag(field.number, WireType.EndGroup);
    } else {
        writeFields(writer.tag(field.number, WireType.LengthDelimited).fork(), opts, message).join();
    }
}
function writeListField(writer, opts, field, list) {
    var _a;
    if (field.listKind == "message") {
        for (const item of list){
            writeMessageField(writer, opts, field, item);
        }
        return;
    }
    const scalarType = (_a = field.scalar) !== null && _a !== undefined ? _a : ScalarType.INT32;
    if (field.packed) {
        if (!list.size) {
            return;
        }
        writer.tag(field.number, WireType.LengthDelimited).fork();
        for (const item of list){
            writeScalarValue(writer, field.parent.typeName, field.name, scalarType, item);
        }
        writer.join();
        return;
    }
    for (const item of list){
        writeScalar(writer, field.parent.typeName, field.name, scalarType, field.number, item);
    }
}
function writeMapEntry(writer, opts, field, key, value) {
    var _a;
    writer.tag(field.number, WireType.LengthDelimited).fork();
    // write key, expecting key field number = 1
    writeScalar(writer, field.parent.typeName, field.name, field.mapKey, 1, key);
    // write value, expecting value field number = 2
    switch(field.mapKind){
        case "scalar":
        case "enum":
            writeScalar(writer, field.parent.typeName, field.name, (_a = field.scalar) !== null && _a !== undefined ? _a : ScalarType.INT32, 2, value);
            break;
        case "message":
            writeFields(writer.tag(2, WireType.LengthDelimited).fork(), opts, value).join();
            break;
    }
    writer.join();
}
function writeScalarValue(writer, msgName, fieldName, type, value) {
    try {
        switch(type){
            case ScalarType.STRING:
                writer.string(value);
                break;
            case ScalarType.BOOL:
                writer.bool(value);
                break;
            case ScalarType.DOUBLE:
                writer.double(value);
                break;
            case ScalarType.FLOAT:
                writer.float(value);
                break;
            case ScalarType.INT32:
                writer.int32(value);
                break;
            case ScalarType.INT64:
                writer.int64(value);
                break;
            case ScalarType.UINT64:
                writer.uint64(value);
                break;
            case ScalarType.FIXED64:
                writer.fixed64(value);
                break;
            case ScalarType.BYTES:
                writer.bytes(value);
                break;
            case ScalarType.FIXED32:
                writer.fixed32(value);
                break;
            case ScalarType.SFIXED32:
                writer.sfixed32(value);
                break;
            case ScalarType.SFIXED64:
                writer.sfixed64(value);
                break;
            case ScalarType.SINT64:
                writer.sint64(value);
                break;
            case ScalarType.UINT32:
                writer.uint32(value);
                break;
            case ScalarType.SINT32:
                writer.sint32(value);
                break;
        }
    } catch (e) {
        if (e instanceof Error) {
            throw new Error(`cannot encode field ${msgName}.${fieldName} to binary: ${e.message}`);
        }
        throw e;
    }
}
function writeTypeOfScalar(type) {
    switch(type){
        case ScalarType.BYTES:
        case ScalarType.STRING:
            return WireType.LengthDelimited;
        case ScalarType.DOUBLE:
        case ScalarType.FIXED64:
        case ScalarType.SFIXED64:
            return WireType.Bit64;
        case ScalarType.FIXED32:
        case ScalarType.SFIXED32:
        case ScalarType.FLOAT:
            return WireType.Bit32;
        default:
            return WireType.Varint;
    }
}

const Kn = 0, xn = 1, Dn = 2, Pn = {
    maxSize: 50,
    url: "https://ingestion-endpoint-a.lab.services.external.data.shopfully.com/",
    batchWaitTime: 150,
    delayBetweenBatches: 17,
    // Default to 1/60th of a second (~1 frame)
    fireOnPageHide: true,
    fireOnVisibilityChange: true,
    maxRetries: 2,
    retryBackoffMs: 250,
    logLevel: xn,
    // Default to logging errors only
    logFunction: console.info,
    signingKey: "7A2B46DD-3EFD-452D-9428-F9EC3A14C75B"
};
function $n(e) {
    return function() {
        const n = Math.floor(Date.now() / 1e3).toFixed(0), t = `${n}:${e}`;
        return {
            timestamp: n,
            hash: Mn.hash(t).slice(16)
        };
    };
}
function qn(e, n) {
    const t = $n(n);
    return ()=>{
        const l = new URL(e), o = t();
        return l.searchParams.set("rt", o.timestamp), l.searchParams.set("rs", o.hash), l;
    };
}
function J(e) {
    let n = false;
    const t = [];
    for(let l = 0; l < e.length; l++){
        let o = e.charAt(l);
        switch(o){
            case "_":
                n = true;
                break;
            case "0":
            case "1":
            case "2":
            case "3":
            case "4":
            case "5":
            case "6":
            case "7":
            case "8":
            case "9":
                t.push(o), n = false;
                break;
            default:
                n && (n = false, o = o.toUpperCase()), t.push(o);
                break;
        }
    }
    return t.join("");
}
const et = /* @__PURE__ */ new Set([
    // names reserved by JavaScript
    "constructor",
    "toString",
    "toJSON",
    "valueOf"
]);
function Y(e) {
    return et.has(e) ? e + "$" : e;
}
function nt() {
    let e = 0, n = 0;
    for(let l = 0; l < 28; l += 7){
        let o = this.buf[this.pos++];
        if (e |= (o & 127) << l, (o & 128) == 0) return this.assertBounds(), [
            e,
            n
        ];
    }
    let t = this.buf[this.pos++];
    if (e |= (t & 15) << 28, n = (t & 112) >> 4, (t & 128) == 0) return this.assertBounds(), [
        e,
        n
    ];
    for(let l = 3; l <= 31; l += 7){
        let o = this.buf[this.pos++];
        if (n |= (o & 127) << l, (o & 128) == 0) return this.assertBounds(), [
            e,
            n
        ];
    }
    throw new Error("invalid varint");
}
const C = 4294967296;
function Ee(e) {
    const n = e[0] === "-";
    n && (e = e.slice(1));
    const t = 1e6;
    let l = 0, o = 0;
    function c(u, a) {
        const m = Number(e.slice(u, a));
        o *= t, l = l * t + m, l >= C && (o = o + (l / C | 0), l = l % C);
    }
    return c(-24, -18), c(-18, -12), c(-12, -6), c(-6), n ? Pe(l, o) : ne(l, o);
}
function tt(e, n) {
    let t = ne(e, n);
    const l = t.hi & 2147483648;
    l && (t = Pe(t.lo, t.hi));
    const o = De(t.lo, t.hi);
    return l ? "-" + o : o;
}
function De(e, n) {
    if ({ lo: e, hi: n } = lt(e, n), n <= 2097151) return String(C * n + e);
    const t = e & 16777215, l = (e >>> 24 | n << 8) & 16777215, o = n >> 16 & 65535;
    let c = t + l * 6777216 + o * 6710656, u = l + o * 8147497, a = o * 2;
    const m = 1e7;
    return c >= m && (u += Math.floor(c / m), c %= m), u >= m && (a += Math.floor(u / m), u %= m), a.toString() + Ve(u) + Ve(c);
}
function lt(e, n) {
    return {
        lo: e >>> 0,
        hi: n >>> 0
    };
}
function ne(e, n) {
    return {
        lo: e | 0,
        hi: n | 0
    };
}
function Pe(e, n) {
    return n = ~n, e ? e = ~e + 1 : n += 1, ne(e, n);
}
const Ve = (e)=>{
    const n = String(e);
    return "0000000".slice(n.length) + n;
};
function ot(e, n) {
    if (e >= 0) {
        for(; e > 127;)n.push(e & 127 | 128), e = e >>> 7;
        n.push(e);
    } else {
        for(let t = 0; t < 9; t++)n.push(e & 127 | 128), e = e >> 7;
        n.push(1);
    }
}
function ct() {
    let e = this.buf[this.pos++], n = e & 127;
    if ((e & 128) == 0) return this.assertBounds(), n;
    if (e = this.buf[this.pos++], n |= (e & 127) << 7, (e & 128) == 0) return this.assertBounds(), n;
    if (e = this.buf[this.pos++], n |= (e & 127) << 14, (e & 128) == 0) return this.assertBounds(), n;
    if (e = this.buf[this.pos++], n |= (e & 127) << 21, (e & 128) == 0) return this.assertBounds(), n;
    e = this.buf[this.pos++], n |= (e & 15) << 28;
    for(let t = 5; (e & 128) !== 0 && t < 10; t++)e = this.buf[this.pos++];
    if ((e & 128) != 0) throw new Error("invalid varint");
    return this.assertBounds(), n >>> 0;
}
const V = /* @__PURE__ */ ut();
function ut() {
    const e = new DataView(new ArrayBuffer(8));
    if (typeof BigInt == "function" && typeof e.getBigInt64 == "function" && typeof e.getBigUint64 == "function" && typeof e.setBigInt64 == "function" && typeof e.setBigUint64 == "function" && (!!globalThis.Deno || !!globalThis.Bun || typeof process != "object" || typeof process.env != "object" || process.env.BUF_BIGINT_DISABLE !== "1")) {
        const t = BigInt("-9223372036854775808"), l = BigInt("9223372036854775807"), o = BigInt("0"), c = BigInt("18446744073709551615");
        return {
            zero: BigInt(0),
            supported: true,
            parse (u) {
                const a = typeof u == "bigint" ? u : BigInt(u);
                if (a > l || a < t) throw new Error(`invalid int64: ${u}`);
                return a;
            },
            uParse (u) {
                const a = typeof u == "bigint" ? u : BigInt(u);
                if (a > c || a < o) throw new Error(`invalid uint64: ${u}`);
                return a;
            },
            enc (u) {
                return e.setBigInt64(0, this.parse(u), true), {
                    lo: e.getInt32(0, true),
                    hi: e.getInt32(4, true)
                };
            },
            uEnc (u) {
                return e.setBigInt64(0, this.uParse(u), true), {
                    lo: e.getInt32(0, true),
                    hi: e.getInt32(4, true)
                };
            },
            dec (u, a) {
                return e.setInt32(0, u, true), e.setInt32(4, a, true), e.getBigInt64(0, true);
            },
            uDec (u, a) {
                return e.setInt32(0, u, true), e.setInt32(4, a, true), e.getBigUint64(0, true);
            }
        };
    }
    return {
        zero: "0",
        supported: false,
        parse (t) {
            return typeof t != "string" && (t = t.toString()), Re(t), t;
        },
        uParse (t) {
            return typeof t != "string" && (t = t.toString()), pe(t), t;
        },
        enc (t) {
            return typeof t != "string" && (t = t.toString()), Re(t), Ee(t);
        },
        uEnc (t) {
            return typeof t != "string" && (t = t.toString()), pe(t), Ee(t);
        },
        dec (t, l) {
            return tt(t, l);
        },
        uDec (t, l) {
            return De(t, l);
        }
    };
}
function Re(e) {
    if (!/^-?[0-9]+$/.test(e)) throw new Error("invalid int64: " + e);
}
function pe(e) {
    if (!/^[0-9]+$/.test(e)) throw new Error("invalid uint64: " + e);
}
var s;
(function(e) {
    e[e.DOUBLE = 1] = "DOUBLE", e[e.FLOAT = 2] = "FLOAT", e[e.INT64 = 3] = "INT64", e[e.UINT64 = 4] = "UINT64", e[e.INT32 = 5] = "INT32", e[e.FIXED64 = 6] = "FIXED64", e[e.FIXED32 = 7] = "FIXED32", e[e.BOOL = 8] = "BOOL", e[e.STRING = 9] = "STRING", e[e.BYTES = 12] = "BYTES", e[e.UINT32 = 13] = "UINT32", e[e.SFIXED32 = 15] = "SFIXED32", e[e.SFIXED64 = 16] = "SFIXED64", e[e.SINT32 = 17] = "SINT32", e[e.SINT64 = 18] = "SINT64";
})(s || (s = {}));
function U(e, n) {
    switch(e){
        case s.STRING:
            return "";
        case s.BOOL:
            return false;
        case s.DOUBLE:
        case s.FLOAT:
            return 0;
        case s.INT64:
        case s.UINT64:
        case s.SFIXED64:
        case s.FIXED64:
        case s.SINT64:
            return n ? "0" : V.zero;
        case s.BYTES:
            return new Uint8Array(0);
        default:
            return 0;
    }
}
function at(e, n) {
    switch(e){
        case s.BOOL:
            return n === false;
        case s.STRING:
            return n === "";
        case s.BYTES:
            return n instanceof Uint8Array && !n.byteLength;
        case s.DOUBLE:
        case s.FLOAT:
            return Object.is(n, 0);
        default:
            return n == 0;
    }
}
const $e = 2, A = /* @__PURE__ */ Symbol.for("reflect unsafe local");
function st(e, n) {
    const t = e[n.localName].case;
    return t === undefined ? t : n.fields.find((l)=>l.localName === t);
}
function it(e, n) {
    const t = n.localName;
    if (n.oneof) return e[n.oneof.localName].case === t;
    if (n.presence != $e) return e[t] !== undefined && Object.prototype.hasOwnProperty.call(e, t);
    switch(n.fieldKind){
        case "list":
            return e[t].length > 0;
        case "map":
            return Object.keys(e[t]).length > 0;
        case "scalar":
            return !at(n.scalar, e[t]);
        case "enum":
            return e[t] !== n.enum.values[0].number;
    }
    throw new Error("message field with implicit presence");
}
function W(e, n) {
    return Object.prototype.hasOwnProperty.call(e, n) && e[n] !== undefined;
}
function dt(e, n) {
    if (n.oneof) {
        const t = e[n.oneof.localName];
        return t.case === n.localName ? t.value : undefined;
    }
    return e[n.localName];
}
function mt(e, n, t) {
    n.oneof ? e[n.oneof.localName] = {
        case: n.localName,
        value: t
    } : e[n.localName] = t;
}
function rt(e, n) {
    const t = n.localName;
    if (n.oneof) {
        const l = n.oneof.localName;
        e[l].case === t && (e[l] = {
            case: undefined
        });
    } else if (n.presence != $e) delete e[t];
    else switch(n.fieldKind){
        case "map":
            e[t] = {};
            break;
        case "list":
            e[t] = [];
            break;
        case "enum":
            e[t] = n.enum.values[0].number;
            break;
        case "scalar":
            e[t] = U(n.scalar, n.longAsString);
            break;
    }
}
function te(e) {
    for (const n of e.field)W(n, "jsonName") || (n.jsonName = J(n.name));
    e.nestedType.forEach(te);
}
function bt(e, n) {
    const t = e.values.find((l)=>l.name === n);
    if (!t) throw new Error(`cannot parse ${e} default value: ${n}`);
    return t.number;
}
function ft(e, n) {
    switch(e){
        case s.STRING:
            return n;
        case s.BYTES:
            {
                const t = Et(n);
                if (t === false) throw new Error(`cannot parse ${s[e]} default value: ${n}`);
                return t;
            }
        case s.INT64:
        case s.SFIXED64:
        case s.SINT64:
            return V.parse(n);
        case s.UINT64:
        case s.FIXED64:
            return V.uParse(n);
        case s.DOUBLE:
        case s.FLOAT:
            switch(n){
                case "inf":
                    return Number.POSITIVE_INFINITY;
                case "-inf":
                    return Number.NEGATIVE_INFINITY;
                case "nan":
                    return Number.NaN;
                default:
                    return parseFloat(n);
            }
        case s.BOOL:
            return n === "true";
        case s.INT32:
        case s.UINT32:
        case s.SINT32:
        case s.FIXED32:
        case s.SFIXED32:
            return parseInt(n, 10);
    }
}
function Et(e) {
    const n = [], t = {
        tail: e,
        c: "",
        next () {
            return this.tail.length == 0 ? false : (this.c = this.tail[0], this.tail = this.tail.substring(1), true);
        },
        take (l) {
            if (this.tail.length >= l) {
                const o = this.tail.substring(0, l);
                return this.tail = this.tail.substring(l), o;
            }
            return false;
        }
    };
    for(; t.next();)switch(t.c){
        case "\\":
            if (t.next()) switch(t.c){
                case "\\":
                    n.push(t.c.charCodeAt(0));
                    break;
                case "b":
                    n.push(8);
                    break;
                case "f":
                    n.push(12);
                    break;
                case "n":
                    n.push(10);
                    break;
                case "r":
                    n.push(13);
                    break;
                case "t":
                    n.push(9);
                    break;
                case "v":
                    n.push(11);
                    break;
                case "0":
                case "1":
                case "2":
                case "3":
                case "4":
                case "5":
                case "6":
                case "7":
                    {
                        const l = t.c, o = t.take(2);
                        if (o === false) return false;
                        const c = parseInt(l + o, 8);
                        if (Number.isNaN(c)) return false;
                        n.push(c);
                        break;
                    }
                case "x":
                    {
                        const l = t.c, o = t.take(2);
                        if (o === false) return false;
                        const c = parseInt(l + o, 16);
                        if (Number.isNaN(c)) return false;
                        n.push(c);
                        break;
                    }
                case "u":
                    {
                        const l = t.c, o = t.take(4);
                        if (o === false) return false;
                        const c = parseInt(l + o, 16);
                        if (Number.isNaN(c)) return false;
                        const u = new Uint8Array(4);
                        new DataView(u.buffer).setInt32(0, c, true), n.push(u[0], u[1], u[2], u[3]);
                        break;
                    }
                case "U":
                    {
                        const l = t.c, o = t.take(8);
                        if (o === false) return false;
                        const c = V.uEnc(l + o), u = new Uint8Array(8), a = new DataView(u.buffer);
                        a.setInt32(0, c.lo, true), a.setInt32(4, c.hi, true), n.push(u[0], u[1], u[2], u[3], u[4], u[5], u[6], u[7]);
                        break;
                    }
            }
            break;
        default:
            n.push(t.c.charCodeAt(0));
    }
    return new Uint8Array(n);
}
function* D(e) {
    switch(e.kind){
        case "file":
            for (const n of e.messages)yield n, yield* D(n);
            yield* e.enums, yield* e.services, yield* e.extensions;
            break;
        case "message":
            for (const n of e.nestedMessages)yield n, yield* D(n);
            yield* e.nestedEnums, yield* e.nestedExtensions;
            break;
    }
}
function qe(...e) {
    const n = Vt();
    if (!e.length) return n;
    if ("$typeName" in e[0] && e[0].$typeName == "google.protobuf.FileDescriptorSet") {
        for (const t of e[0].file)ve(t, n);
        return n;
    }
    if ("$typeName" in e[0]) {
        let c = function(u) {
            const a = [];
            for (const m of u.dependency){
                if (n.getFile(m) != null || o.has(m)) continue;
                const d = l(m);
                if (!d) throw new Error(`Unable to resolve ${m}, imported by ${u.name}`);
                "kind" in d ? n.addFile(d, false, true) : (o.add(d.name), a.push(d));
            }
            return a.concat(...a.map(c));
        };
        const t = e[0], l = e[1], o = /* @__PURE__ */ new Set();
        for (const u of [
            t,
            ...c(t)
        ].reverse())ve(u, n);
    } else for (const t of e)for (const l of t.files)n.addFile(l);
    return n;
}
function Vt() {
    const e = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Map();
    return {
        kind: "registry",
        types: e,
        extendees: n,
        [Symbol.iterator] () {
            return e.values();
        },
        get files () {
            return t.values();
        },
        addFile (l, o, c) {
            if (t.set(l.proto.name, l), !o) for (const u of D(l))this.add(u);
            if (c) for (const u of l.dependencies)this.addFile(u, o, c);
        },
        add (l) {
            if (l.kind == "extension") {
                let o = n.get(l.extendee.typeName);
                o || n.set(l.extendee.typeName, // biome-ignore lint/suspicious/noAssignInExpressions: no
                o = /* @__PURE__ */ new Map()), o.set(l.number, l);
            }
            e.set(l.typeName, l);
        },
        get (l) {
            return e.get(l);
        },
        getFile (l) {
            return t.get(l);
        },
        getMessage (l) {
            const o = e.get(l);
            return o?.kind == "message" ? o : undefined;
        },
        getEnum (l) {
            const o = e.get(l);
            return o?.kind == "enum" ? o : undefined;
        },
        getExtension (l) {
            const o = e.get(l);
            return o?.kind == "extension" ? o : undefined;
        },
        getExtensionFor (l, o) {
            var c;
            return (c = n.get(l.typeName)) === null || c === undefined ? undefined : c.get(o);
        },
        getService (l) {
            const o = e.get(l);
            return o?.kind == "service" ? o : undefined;
        }
    };
}
const Rt = 998, pt = 999, Zt = 9999, Nt = 9, F = 10, S = 11, gt = 12, Ze = 14, le = 3, vt = 2, Ne = 1, yt = 0, M = 1, ge = 2, At = 3, _t = 1, ht = 2, Gt = 1, Bt = 2, It = 1001, en = {
    // EDITION_PROTO2
    998: {
        fieldPresence: 1,
        // EXPLICIT,
        enumType: 2,
        // CLOSED,
        repeatedFieldEncoding: 2,
        // EXPANDED,
        utf8Validation: 3,
        // NONE,
        messageEncoding: 1,
        // LENGTH_PREFIXED,
        jsonFormat: 2,
        // LEGACY_BEST_EFFORT,
        enforceNamingStyle: 2,
        // STYLE_LEGACY,
        defaultSymbolVisibility: 1
    },
    // EDITION_PROTO3
    999: {
        fieldPresence: 2,
        // IMPLICIT,
        enumType: 1,
        // OPEN,
        repeatedFieldEncoding: 1,
        // PACKED,
        utf8Validation: 2,
        // VERIFY,
        messageEncoding: 1,
        // LENGTH_PREFIXED,
        jsonFormat: 1,
        // ALLOW,
        enforceNamingStyle: 2,
        // STYLE_LEGACY,
        defaultSymbolVisibility: 1
    },
    // EDITION_2023
    1e3: {
        fieldPresence: 1,
        // EXPLICIT,
        enumType: 1,
        // OPEN,
        repeatedFieldEncoding: 1,
        // PACKED,
        utf8Validation: 2,
        // VERIFY,
        messageEncoding: 1,
        // LENGTH_PREFIXED,
        jsonFormat: 1,
        // ALLOW,
        enforceNamingStyle: 2,
        // STYLE_LEGACY,
        defaultSymbolVisibility: 1
    },
    // EDITION_2024
    1001: {
        fieldPresence: 1,
        // EXPLICIT,
        enumType: 1,
        // OPEN,
        repeatedFieldEncoding: 1,
        // PACKED,
        utf8Validation: 2,
        // VERIFY,
        messageEncoding: 1,
        // LENGTH_PREFIXED,
        jsonFormat: 1,
        // ALLOW,
        enforceNamingStyle: 1,
        // STYLE2024,
        defaultSymbolVisibility: 2
    }
};
function ve(e, n) {
    var t, l;
    const o = {
        kind: "file",
        proto: e,
        deprecated: (l = (t = e.options) === null || t === undefined ? undefined : t.deprecated) !== null && l !== undefined ? l : false,
        edition: Ut(e),
        name: e.name.replace(/\.proto$/, ""),
        dependencies: Wt(e, n),
        enums: [],
        messages: [],
        extensions: [],
        services: [],
        toString () {
            return `file ${e.name}`;
        }
    }, c = /* @__PURE__ */ new Map(), u = {
        get (a) {
            return c.get(a);
        },
        add (a) {
            var m;
            N(((m = a.proto.options) === null || m === undefined ? undefined : m.mapEntry) === true), c.set(a.typeName, a);
        }
    };
    for (const a of e.enumType)nn(a, o, undefined, n);
    for (const a of e.messageType)tn(a, o, undefined, n, u);
    for (const a of e.service)Xt(a, o, n);
    P(o, n);
    for (const a of c.values())$(a, n, u);
    for (const a of o.messages)$(a, n, u), P(a, n);
    n.addFile(o, true);
}
function P(e, n) {
    switch(e.kind){
        case "file":
            for (const t of e.proto.extension){
                const l = q(t, e, n);
                e.extensions.push(l), n.add(l);
            }
            break;
        case "message":
            for (const t of e.proto.extension){
                const l = q(t, e, n);
                e.nestedExtensions.push(l), n.add(l);
            }
            for (const t of e.nestedMessages)P(t, n);
            break;
    }
}
function $(e, n, t) {
    const l = e.proto.oneofDecl.map((c)=>Yt(c, e)), o = /* @__PURE__ */ new Set();
    for (const c of e.proto.field){
        const u = Lt(c, l), a = q(c, e, n, u, t);
        e.fields.push(a), e.field[a.localName] = a, u === undefined ? e.members.push(a) : (u.fields.push(a), o.has(u) || (o.add(u), e.members.push(u)));
    }
    for (const c of l.filter((u)=>o.has(u)))e.oneofs.push(c);
    for (const c of e.nestedMessages)$(c, n, t);
}
function nn(e, n, t, l) {
    var o, c, u, a, m;
    const d = Ft(e.name, e.value), r = {
        kind: "enum",
        proto: e,
        deprecated: (c = (o = e.options) === null || o === undefined ? undefined : o.deprecated) !== null && c !== undefined ? c : false,
        file: n,
        parent: t,
        open: true,
        name: e.name,
        typeName: Q(e, t, n),
        value: {},
        values: [],
        sharedPrefix: d,
        toString () {
            return `enum ${this.typeName}`;
        }
    };
    r.open = Ht(r), l.add(r);
    for (const E of e.value){
        const p = E.name;
        r.values.push(// biome-ignore lint/suspicious/noAssignInExpressions: no
        r.value[E.number] = {
            kind: "enum_value",
            proto: E,
            deprecated: (a = (u = E.options) === null || u === undefined ? undefined : u.deprecated) !== null && a !== undefined ? a : false,
            parent: r,
            name: p,
            localName: Y(d == null ? p : p.substring(d.length)),
            number: E.number,
            toString () {
                return `enum value ${r.typeName}.${p}`;
            }
        });
    }
    ((m = t?.nestedEnums) !== null && m !== undefined ? m : n.enums).push(r);
}
function tn(e, n, t, l, o) {
    var c, u, a, m;
    const d = {
        kind: "message",
        proto: e,
        deprecated: (u = (c = e.options) === null || c === undefined ? undefined : c.deprecated) !== null && u !== undefined ? u : false,
        file: n,
        parent: t,
        name: e.name,
        typeName: Q(e, t, n),
        fields: [],
        field: {},
        oneofs: [],
        members: [],
        nestedEnums: [],
        nestedMessages: [],
        nestedExtensions: [],
        toString () {
            return `message ${this.typeName}`;
        }
    };
    ((a = e.options) === null || a === undefined ? undefined : a.mapEntry) === true ? o.add(d) : (((m = t?.nestedMessages) !== null && m !== undefined ? m : n.messages).push(d), l.add(d));
    for (const r of e.enumType)nn(r, n, d, l);
    for (const r of e.nestedType)tn(r, n, d, l, o);
}
function Xt(e, n, t) {
    var l, o;
    const c = {
        kind: "service",
        proto: e,
        deprecated: (o = (l = e.options) === null || l === undefined ? undefined : l.deprecated) !== null && o !== undefined ? o : false,
        file: n,
        name: e.name,
        typeName: Q(e, undefined, n),
        methods: [],
        method: {},
        toString () {
            return `service ${this.typeName}`;
        }
    };
    n.services.push(c), t.add(c);
    for (const u of e.method){
        const a = St(u, c, t);
        c.methods.push(a), c.method[a.localName] = a;
    }
}
function St(e, n, t) {
    var l, o, c, u;
    let a;
    e.clientStreaming && e.serverStreaming ? a = "bidi_streaming" : e.clientStreaming ? a = "client_streaming" : e.serverStreaming ? a = "server_streaming" : a = "unary";
    const m = t.getMessage(y(e.inputType)), d = t.getMessage(y(e.outputType));
    N(m, `invalid MethodDescriptorProto: input_type ${e.inputType} not found`), N(d, `invalid MethodDescriptorProto: output_type ${e.inputType} not found`);
    const r = e.name;
    return {
        kind: "rpc",
        proto: e,
        deprecated: (o = (l = e.options) === null || l === undefined ? undefined : l.deprecated) !== null && o !== undefined ? o : false,
        parent: n,
        name: r,
        localName: Y(r.length ? Y(r[0].toLowerCase() + r.substring(1)) : r),
        methodKind: a,
        input: m,
        output: d,
        idempotency: (u = (c = e.options) === null || c === undefined ? undefined : c.idempotencyLevel) !== null && u !== undefined ? u : yt,
        toString () {
            return `rpc ${n.typeName}.${r}`;
        }
    };
}
function Yt(e, n) {
    return {
        kind: "oneof",
        proto: e,
        deprecated: false,
        parent: n,
        fields: [],
        name: e.name,
        localName: Y(J(e.name)),
        toString () {
            return `oneof ${n.typeName}.${this.name}`;
        }
    };
}
function q(e, n, t, l, o) {
    var c, u, a;
    const m = o === undefined, d = {
        kind: "field",
        proto: e,
        deprecated: (u = (c = e.options) === null || c === undefined ? undefined : c.deprecated) !== null && u !== undefined ? u : false,
        name: e.name,
        number: e.number,
        scalar: undefined,
        message: undefined,
        enum: undefined,
        presence: Ct(e, l, m, n),
        utf8Validation: jt(e, n),
        listKind: undefined,
        mapKind: undefined,
        mapKey: undefined,
        delimitedEncoding: undefined,
        packed: undefined,
        longAsString: false,
        getDefaultValue: undefined
    };
    if (m) {
        const R = n.kind == "file" ? n : n.file, v = n.kind == "file" ? undefined : n, Z = Q(e, v, R);
        d.kind = "extension", d.file = R, d.parent = v, d.oneof = undefined, d.typeName = Z, d.jsonName = `[${Z}]`, d.toString = ()=>`extension ${Z}`;
        const k = t.getMessage(y(e.extendee));
        N(k, `invalid FieldDescriptorProto: extendee ${e.extendee} not found`), d.extendee = k;
    } else {
        const R = n;
        N(R.kind == "message"), d.parent = R, d.oneof = l, d.localName = l ? J(e.name) : Y(J(e.name)), d.jsonName = e.jsonName, d.toString = ()=>`field ${R.typeName}.${e.name}`;
    }
    const r = e.label, E = e.type, p = (a = e.options) === null || a === undefined ? undefined : a.jstype;
    if (r === le) {
        const R = E == S ? o?.get(y(e.typeName)) : undefined;
        if (R) {
            d.fieldKind = "map";
            const { key: v, value: Z } = Jt(R);
            return d.mapKey = v.scalar, d.mapKind = Z.fieldKind, d.message = Z.message, d.delimitedEncoding = false, d.enum = Z.enum, d.scalar = Z.scalar, d;
        }
        switch(d.fieldKind = "list", E){
            case S:
            case F:
                d.listKind = "message", d.message = t.getMessage(y(e.typeName)), N(d.message), d.delimitedEncoding = ye(e, n);
                break;
            case Ze:
                d.listKind = "enum", d.enum = t.getEnum(y(e.typeName)), N(d.enum);
                break;
            default:
                d.listKind = "scalar", d.scalar = E, d.longAsString = p == Ne;
                break;
        }
        return d.packed = wt(e, n), d;
    }
    switch(E){
        case S:
        case F:
            d.fieldKind = "message", d.message = t.getMessage(y(e.typeName)), N(d.message, `invalid FieldDescriptorProto: type_name ${e.typeName} not found`), d.delimitedEncoding = ye(e, n), d.getDefaultValue = ()=>{};
            break;
        case Ze:
            {
                const R = t.getEnum(y(e.typeName));
                N(R !== undefined, `invalid FieldDescriptorProto: type_name ${e.typeName} not found`), d.fieldKind = "enum", d.enum = t.getEnum(y(e.typeName)), d.getDefaultValue = ()=>W(e, "defaultValue") ? bt(R, e.defaultValue) : undefined;
                break;
            }
        default:
            {
                d.fieldKind = "scalar", d.scalar = E, d.longAsString = p == Ne, d.getDefaultValue = ()=>W(e, "defaultValue") ? ft(E, e.defaultValue) : undefined;
                break;
            }
    }
    return d;
}
function Ut(e) {
    switch(e.syntax){
        case "":
        case "proto2":
            return Rt;
        case "proto3":
            return pt;
        case "editions":
            if (e.edition === Zt) return It;
            if (e.edition in en) return e.edition;
            throw new Error(`${e.name}: unsupported edition`);
        default:
            throw new Error(`${e.name}: unsupported syntax "${e.syntax}"`);
    }
}
function Wt(e, n) {
    return e.dependency.map((t)=>{
        const l = n.getFile(t);
        if (!l) throw new Error(`Cannot find ${t}, imported by ${e.name}`);
        return l;
    });
}
function Ft(e, n) {
    const t = Tt(e) + "_";
    for (const l of n){
        if (!l.name.toLowerCase().startsWith(t)) return;
        const o = l.name.substring(t.length);
        if (o.length == 0 || /^\d/.test(o)) return;
    }
    return t;
}
function Tt(e) {
    return (e.substring(0, 1) + e.substring(1).replace(/[A-Z]/g, (n)=>"_" + n)).toLowerCase();
}
function Q(e, n, t) {
    let l;
    return n ? l = `${n.typeName}.${e.name}` : t.proto.package.length > 0 ? l = `${t.proto.package}.${e.name}` : l = `${e.name}`, l;
}
function y(e) {
    return e.startsWith(".") ? e.substring(1) : e;
}
function Lt(e, n) {
    if (!W(e, "oneofIndex") || e.proto3Optional) return;
    const t = n[e.oneofIndex];
    return N(t, `invalid FieldDescriptorProto: oneof #${e.oneofIndex} for field #${e.number} not found`), t;
}
function Ct(e, n, t, l) {
    if (e.label == vt) return At;
    if (e.label == le) return ge;
    if (n || e.proto3Optional || t) return M;
    const o = _("fieldPresence", {
        proto: e,
        parent: l
    });
    return o == ge && (e.type == S || e.type == F) ? M : o;
}
function wt(e, n) {
    if (e.label != le) return false;
    switch(e.type){
        case Nt:
        case gt:
        case F:
        case S:
            return false;
    }
    const t = e.options;
    return t && W(t, "packed") ? t.packed : _t == _("repeatedFieldEncoding", {
        proto: e,
        parent: n
    });
}
function Jt(e) {
    const n = e.fields.find((l)=>l.number === 1), t = e.fields.find((l)=>l.number === 2);
    return N(n && n.fieldKind == "scalar" && n.scalar != s.BYTES && n.scalar != s.FLOAT && n.scalar != s.DOUBLE && t && t.fieldKind != "list" && t.fieldKind != "map"), {
        key: n,
        value: t
    };
}
function Ht(e) {
    var n;
    return Gt == _("enumType", {
        proto: e.proto,
        parent: (n = e.parent) !== null && n !== undefined ? n : e.file
    });
}
function ye(e, n) {
    return e.type == F ? true : ht == _("messageEncoding", {
        proto: e,
        parent: n
    });
}
function jt(e, n) {
    return Bt == _("utf8Validation", {
        proto: e,
        parent: n
    });
}
function _(e, n) {
    var t, l;
    const o = (t = n.proto.options) === null || t === undefined ? undefined : t.features;
    if (o) {
        const c = o[e];
        if (c != 0) return c;
    }
    if ("kind" in n) {
        if (n.kind == "message") return _(e, (l = n.parent) !== null && l !== undefined ? l : n.file);
        const c = en[n.edition];
        if (!c) throw new Error(`feature default for edition ${n.edition} not found`);
        return c[e];
    }
    return _(e, n.parent);
}
function N(e, n) {
    if (!e) throw new Error(n);
}
function Qt(e) {
    const n = kt(e);
    return n.messageType.forEach(te), qe(n, ()=>{}).getFile(n.name);
}
function kt(e) {
    return Object.assign(/* @__PURE__ */ Object.create({
        syntax: "",
        edition: 0
    }), Object.assign(Object.assign({
        $typeName: "google.protobuf.FileDescriptorProto",
        dependency: [],
        publicDependency: [],
        weakDependency: [],
        optionDependency: [],
        service: [],
        extension: []
    }, e), {
        messageType: e.messageType.map(ln),
        enumType: e.enumType.map(on)
    }));
}
function ln(e) {
    var n, t, l, o, c, u, a, m;
    return Object.assign(/* @__PURE__ */ Object.create({
        visibility: 0
    }), {
        $typeName: "google.protobuf.DescriptorProto",
        name: e.name,
        field: (t = (n = e.field) === null || n === undefined ? undefined : n.map(Mt)) !== null && t !== undefined ? t : [],
        extension: [],
        nestedType: (o = (l = e.nestedType) === null || l === undefined ? undefined : l.map(ln)) !== null && o !== undefined ? o : [],
        enumType: (u = (c = e.enumType) === null || c === undefined ? undefined : c.map(on)) !== null && u !== undefined ? u : [],
        extensionRange: (m = (a = e.extensionRange) === null || a === undefined ? undefined : a.map((r)=>Object.assign({
                $typeName: "google.protobuf.DescriptorProto.ExtensionRange"
            }, r))) !== null && m !== undefined ? m : [],
        oneofDecl: [],
        reservedRange: [],
        reservedName: []
    });
}
function Mt(e) {
    return Object.assign(/* @__PURE__ */ Object.create({
        label: 1,
        typeName: "",
        extendee: "",
        defaultValue: "",
        oneofIndex: 0,
        jsonName: "",
        proto3Optional: false
    }), Object.assign(Object.assign({
        $typeName: "google.protobuf.FieldDescriptorProto"
    }, e), {
        options: e.options ? zt(e.options) : undefined
    }));
}
function zt(e) {
    var n, t, l;
    return Object.assign(/* @__PURE__ */ Object.create({
        ctype: 0,
        packed: false,
        jstype: 0,
        lazy: false,
        unverifiedLazy: false,
        deprecated: false,
        weak: false,
        debugRedact: false,
        retention: 0
    }), Object.assign(Object.assign({
        $typeName: "google.protobuf.FieldOptions"
    }, e), {
        targets: (n = e.targets) !== null && n !== undefined ? n : [],
        editionDefaults: (l = (t = e.editionDefaults) === null || t === undefined ? undefined : t.map((c)=>Object.assign({
                $typeName: "google.protobuf.FieldOptions.EditionDefault"
            }, c))) !== null && l !== undefined ? l : [],
        uninterpretedOption: []
    }));
}
function on(e) {
    return Object.assign(/* @__PURE__ */ Object.create({
        visibility: 0
    }), {
        $typeName: "google.protobuf.EnumDescriptorProto",
        name: e.name,
        reservedName: [],
        reservedRange: [],
        value: e.value.map((t)=>Object.assign({
                $typeName: "google.protobuf.EnumValueDescriptorProto"
            }, t))
    });
}
function Ot(e) {
    const n = xt();
    let t = e.length * 3 / 4;
    e[e.length - 2] == "=" ? t -= 2 : e[e.length - 1] == "=" && (t -= 1);
    let l = new Uint8Array(t), o = 0, c = 0, u, a = 0;
    for(let m = 0; m < e.length; m++){
        if (u = n[e.charCodeAt(m)], u === undefined) switch(e[m]){
            // @ts-ignore TS7029: Fallthrough case in switch -- ignore instead of expect-error for compiler settings without noFallthroughCasesInSwitch: true
            case "=":
                c = 0;
            // reset state when padding found
            case `
`:
            case "\r":
            case "	":
            case " ":
                continue;
            // skip white-space, and padding
            default:
                throw Error("invalid base64 string");
        }
        switch(c){
            case 0:
                a = u, c = 1;
                break;
            case 1:
                l[o++] = a << 2 | (u & 48) >> 4, a = u, c = 2;
                break;
            case 2:
                l[o++] = (a & 15) << 4 | (u & 60) >> 2, a = u, c = 3;
                break;
            case 3:
                l[o++] = (a & 3) << 6 | u, c = 0;
                break;
        }
    }
    if (c == 1) throw Error("invalid base64 string");
    return l.subarray(0, o);
}
let T, h;
function Kt(e) {
    return T || (T = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".split(""), T.slice(0, -2).concat("-", "_")), T;
}
function xt() {
    if (!h) {
        h = [];
        const e = Kt();
        for(let n = 0; n < e.length; n++)h[e[n].charCodeAt(0)] = n;
        h[45] = e.indexOf("+"), h[95] = e.indexOf("/");
    }
    return h;
}
function cn(e, n) {
    return e !== null && typeof e == "object" && "$typeName" in e && typeof e.$typeName == "string" ? n === undefined ? true : n.typeName === e.$typeName : false;
}
class G extends Error {
    constructor(n, t, l = "FieldValueInvalidError"){
        super(t), this.name = l, this.field = ()=>n;
    }
}
function B(e) {
    return e !== null && typeof e == "object" && !Array.isArray(e);
}
function oe(e, n) {
    var t, l, o, c;
    if (B(e) && A in e && "add" in e && "field" in e && typeof e.field == "function") {
        if (n !== undefined) {
            const u = n, a = e.field();
            return u.listKind == a.listKind && u.scalar === a.scalar && ((t = u.message) === null || t === undefined ? undefined : t.typeName) === ((l = a.message) === null || l === undefined ? undefined : l.typeName) && ((o = u.enum) === null || o === undefined ? undefined : o.typeName) === ((c = a.enum) === null || c === undefined ? undefined : c.typeName);
        }
        return true;
    }
    return false;
}
function ce(e, n) {
    var t, l, o, c;
    if (B(e) && A in e && "has" in e && "field" in e && typeof e.field == "function") {
        if (n !== undefined) {
            const u = n, a = e.field();
            return u.mapKey === a.mapKey && u.mapKind == a.mapKind && u.scalar === a.scalar && ((t = u.message) === null || t === undefined ? undefined : t.typeName) === ((l = a.message) === null || l === undefined ? undefined : l.typeName) && ((o = u.enum) === null || o === undefined ? undefined : o.typeName) === ((c = a.enum) === null || c === undefined ? undefined : c.typeName);
        }
        return true;
    }
    return false;
}
function ue(e, n) {
    return B(e) && A in e && "desc" in e && B(e.desc) && e.desc.kind === "message" && (n === undefined || e.desc.typeName == n.typeName);
}
const z = /* @__PURE__ */ Symbol.for("@bufbuild/protobuf/text-encoding");
function un() {
    if (globalThis[z] == null) {
        const e = new globalThis.TextEncoder(), n = new globalThis.TextDecoder();
        let t;
        globalThis[z] = {
            encodeUtf8 (l) {
                return e.encode(l);
            },
            decodeUtf8 (l, o) {
                return o ? (t === undefined && (t = new globalThis.TextDecoder("utf-8", {
                    fatal: true
                })), t.decode(l)) : n.decode(l);
            },
            checkUtf8 (l) {
                try {
                    return encodeURIComponent(l), !0;
                } catch  {
                    return false;
                }
            }
        };
    }
    return globalThis[z];
}
var g;
(function(e) {
    e[e.Varint = 0] = "Varint", e[e.Bit64 = 1] = "Bit64", e[e.LengthDelimited = 2] = "LengthDelimited", e[e.StartGroup = 3] = "StartGroup", e[e.EndGroup = 4] = "EndGroup", e[e.Bit32 = 5] = "Bit32";
})(g || (g = {}));
const Dt = 34028234663852886e22, Pt = -34028234663852886e22, $t = 4294967295, qt = 2147483647, el = -2147483648;
class nl {
    /**
   * Reads a tag - field number and wire type. Tags are uint32 varints; values
   * that do not fit in uint32 are rejected.
   */ tag() {
        const n = this.pos, t = this.uint32(), l = this.pos - n;
        if (l > 5 || l == 5 && this.buf[this.pos - 1] > 15) throw new Error("illegal tag: varint overflows uint32");
        const o = t >>> 3, c = t & 7;
        if (o <= 0 || c > 5) throw new Error("illegal tag: field no " + o + " wire type " + c);
        return [
            o,
            c
        ];
    }
    /**
   * Skip one element and return the skipped data.
   *
   * When skipping StartGroup, provide the tags field number to check for
   * matching field number in the EndGroup tag. Recursion into nested groups
   * is guarded by the `recursionLimit` argument: When the limit is reached,
   * this method throws.
   */ skip(n, t, l = 100) {
        let o = this.pos;
        switch(n){
            case g.Varint:
                for(; this.buf[this.pos++] & 128;);
                break;
            // @ts-ignore TS7029: Fallthrough case in switch -- ignore instead of expect-error for compiler settings without noFallthroughCasesInSwitch: true
            case g.Bit64:
                this.pos += 4;
            case g.Bit32:
                this.pos += 4;
                break;
            case g.LengthDelimited:
                let c = this.uint32();
                this.pos += c;
                break;
            case g.StartGroup:
                if (l <= 0) throw new Error("maximum recursion depth reached");
                for(;;){
                    const [u, a] = this.tag();
                    if (a === g.EndGroup) {
                        if (t !== undefined && u !== t) throw new Error("invalid end group tag");
                        break;
                    }
                    this.skip(a, u, l - 1);
                }
                break;
            default:
                throw new Error("cant skip wire type " + n);
        }
        return this.assertBounds(), this.buf.subarray(o, this.pos);
    }
    /**
   * Throws error if position in byte array is out of range.
   */ assertBounds() {
        if (this.pos > this.len) throw new RangeError("premature EOF");
    }
    /**
   * Read a `int32` field, a signed 32 bit varint.
   */ int32() {
        return this.uint32() | 0;
    }
    /**
   * Read a `sint32` field, a signed, zigzag-encoded 32-bit varint.
   */ sint32() {
        let n = this.uint32();
        return n >>> 1 ^ -(n & 1);
    }
    /**
   * Read a `int64` field, a signed 64-bit varint.
   */ int64() {
        return V.dec(...this.varint64());
    }
    /**
   * Read a `uint64` field, an unsigned 64-bit varint.
   */ uint64() {
        return V.uDec(...this.varint64());
    }
    /**
   * Read a `sint64` field, a signed, zig-zag-encoded 64-bit varint.
   */ sint64() {
        let [n, t] = this.varint64(), l = -(n & 1);
        return n = (n >>> 1 | (t & 1) << 31) ^ l, t = t >>> 1 ^ l, V.dec(n, t);
    }
    /**
   * Read a `bool` field, a variant.
   */ bool() {
        let [n, t] = this.varint64();
        return n !== 0 || t !== 0;
    }
    /**
   * Read a `fixed32` field, an unsigned, fixed-length 32-bit integer.
   */ fixed32() {
        return this.view.getUint32((this.pos += 4) - 4, true);
    }
    /**
   * Read a `sfixed32` field, a signed, fixed-length 32-bit integer.
   */ sfixed32() {
        return this.view.getInt32((this.pos += 4) - 4, true);
    }
    /**
   * Read a `fixed64` field, an unsigned, fixed-length 64 bit integer.
   */ fixed64() {
        return V.uDec(this.sfixed32(), this.sfixed32());
    }
    /**
   * Read a `fixed64` field, a signed, fixed-length 64-bit integer.
   */ sfixed64() {
        return V.dec(this.sfixed32(), this.sfixed32());
    }
    /**
   * Read a `float` field, 32-bit floating point number.
   */ float() {
        return this.view.getFloat32((this.pos += 4) - 4, true);
    }
    /**
   * Read a `double` field, a 64-bit floating point number.
   */ double() {
        return this.view.getFloat64((this.pos += 8) - 8, true);
    }
    /**
   * Read a `bytes` field, length-delimited arbitrary data.
   */ bytes() {
        let n = this.uint32(), t = this.pos;
        return this.pos += n, this.assertBounds(), this.buf.subarray(t, t + n);
    }
    /**
   * Read a `string` field, length-delimited data converted to UTF-8 text. If
   * `strict` is true, throw on invalid UTF-8 instead of substituting U+FFFD.
   */ string(n) {
        return this.decodeUtf8(this.bytes(), n);
    }
    constructor(n, t = un().decodeUtf8){
        this.decodeUtf8 = t, this.varint64 = nt, this.uint32 = ct, this.buf = n, this.len = n.length, this.pos = 0, this.view = new DataView(n.buffer, n.byteOffset, n.byteLength);
    }
}
function tl(e, n) {
    const t = e.fieldKind == "list" ? oe(n, e) : e.fieldKind == "map" ? ce(n, e) : ae(e, n);
    if (t === true) return;
    let l;
    switch(e.fieldKind){
        case "list":
            l = `expected ${sn(e)}, got ${j(n)}`;
            break;
        case "map":
            l = `expected ${dn(e)}, got ${j(n)}`;
            break;
        default:
            l = H(e, n, t);
    }
    return new G(e, l);
}
function Ae(e, n, t) {
    const l = ae(e, t);
    if (l !== true) return new G(e, `list item #${n + 1}: ${H(e, t, l)}`);
}
function ll(e, n, t) {
    const l = ee(n, e.mapKey);
    if (l !== true) return new G(e, `invalid map key: ${H({
        scalar: e.mapKey
    }, n, l)}`);
    const o = ae(e, t);
    if (o !== true) return new G(e, `map entry ${j(n)}: ${H(e, t, o)}`);
}
function ae(e, n) {
    return e.scalar !== undefined ? ee(n, e.scalar) : e.enum !== undefined ? e.enum.open ? ee(n, s.INT32) : e.enum.values.some((t)=>t.number === n) : ue(n, e.message);
}
function ee(e, n) {
    switch(n){
        case s.DOUBLE:
            return typeof e == "number";
        case s.FLOAT:
            return typeof e != "number" ? false : Number.isNaN(e) || !Number.isFinite(e) ? true : e > Dt || e < Pt ? `${e.toFixed()} out of range` : true;
        case s.INT32:
        case s.SFIXED32:
        case s.SINT32:
            return typeof e != "number" || !Number.isInteger(e) ? false : e > qt || e < el ? `${e.toFixed()} out of range` : true;
        case s.FIXED32:
        case s.UINT32:
            return typeof e != "number" || !Number.isInteger(e) ? false : e > $t || e < 0 ? `${e.toFixed()} out of range` : true;
        case s.BOOL:
            return typeof e == "boolean";
        case s.STRING:
            return typeof e != "string" ? false : un().checkUtf8(e) || "invalid UTF8";
        case s.BYTES:
            return e instanceof Uint8Array;
        case s.INT64:
        case s.SFIXED64:
        case s.SINT64:
            if (typeof e == "bigint" || typeof e == "number" || typeof e == "string" && e.length > 0) try {
                return V.parse(e), !0;
            } catch  {
                return `${e} out of range`;
            }
            return false;
        case s.FIXED64:
        case s.UINT64:
            if (typeof e == "bigint" || typeof e == "number" || typeof e == "string" && e.length > 0) try {
                return V.uParse(e), !0;
            } catch  {
                return `${e} out of range`;
            }
            return false;
    }
}
function H(e, n, t) {
    return t = typeof t == "string" ? `: ${t}` : `, got ${j(n)}`, e.scalar !== undefined ? `expected ${ol(e.scalar)}` + t : e.enum !== undefined ? `expected ${e.enum.toString()}` + t : `expected ${an(e.message)}` + t;
}
function j(e) {
    switch(typeof e){
        case "object":
            return e === null ? "null" : e instanceof Uint8Array ? `Uint8Array(${e.length})` : Array.isArray(e) ? `Array(${e.length})` : oe(e) ? sn(e.field()) : ce(e) ? dn(e.field()) : ue(e) ? an(e.desc) : cn(e) ? `message ${e.$typeName}` : "object";
        case "string":
            return e.length > 30 ? "string" : `"${e.split('"').join('\\"')}"`;
        case "boolean":
            return String(e);
        case "number":
            return String(e);
        case "bigint":
            return String(e) + "n";
        default:
            return typeof e;
    }
}
function an(e) {
    return `ReflectMessage (${e.typeName})`;
}
function sn(e) {
    switch(e.listKind){
        case "message":
            return `ReflectList (${e.message.toString()})`;
        case "enum":
            return `ReflectList (${e.enum.toString()})`;
        case "scalar":
            return `ReflectList (${s[e.scalar]})`;
    }
}
function dn(e) {
    switch(e.mapKind){
        case "message":
            return `ReflectMap (${s[e.mapKey]}, ${e.message.toString()})`;
        case "enum":
            return `ReflectMap (${s[e.mapKey]}, ${e.enum.toString()})`;
        case "scalar":
            return `ReflectMap (${s[e.mapKey]}, ${s[e.scalar]})`;
    }
}
function ol(e) {
    switch(e){
        case s.STRING:
            return "string";
        case s.BOOL:
            return "boolean";
        case s.INT64:
        case s.SINT64:
        case s.SFIXED64:
            return "bigint (int64)";
        case s.UINT64:
        case s.FIXED64:
            return "bigint (uint64)";
        case s.BYTES:
            return "Uint8Array";
        case s.DOUBLE:
            return "number (float64)";
        case s.FLOAT:
            return "number (float32)";
        case s.FIXED32:
        case s.UINT32:
            return "number (uint32)";
        case s.INT32:
        case s.SFIXED32:
        case s.SINT32:
            return "number (int32)";
    }
}
function cl(e) {
    return mn(e.$typeName);
}
function ul(e) {
    const n = e.fields[0];
    return mn(e.typeName) && n !== undefined && n.fieldKind == "scalar" && n.name == "value" && n.number == 1;
}
function mn(e) {
    return e.startsWith("google.protobuf.") && [
        "DoubleValue",
        "FloatValue",
        "Int64Value",
        "UInt64Value",
        "Int32Value",
        "UInt32Value",
        "BoolValue",
        "StringValue",
        "BytesValue"
    ].includes(e.substring(16));
}
const al = 999, sl = 998, w = 2;
function il(e, n) {
    return cn(n, e) ? n : ml(e);
}
const dl = /* @__PURE__ */ Symbol(), _e = /* @__PURE__ */ new WeakMap();
function ml(e) {
    let n;
    if (rl(e)) {
        const t = _e.get(e);
        let l, o;
        if (t) ({ prototype: l, members: o } = t);
        else {
            l = {}, o = /* @__PURE__ */ new Set();
            for (const c of e.members)c.kind != "oneof" && (c.fieldKind != "scalar" && c.fieldKind != "enum" || c.presence != w && (o.add(c), l[c.localName] = O(c)));
            _e.set(e, {
                prototype: l,
                members: o
            });
        }
        n = Object.create(l), n.$typeName = e.typeName;
        for (const c of e.members)o.has(c) || c.kind == "field" && (c.fieldKind == "message" || (c.fieldKind == "scalar" || c.fieldKind == "enum") && c.presence != w) || (n[c.localName] = O(c));
    } else {
        n = {
            $typeName: e.typeName
        };
        for (const t of e.members)(t.kind == "oneof" || t.presence == w) && (n[t.localName] = O(t));
    }
    return n;
}
function rl(e) {
    switch(e.file.edition){
        case al:
            return false;
        case sl:
            return true;
        default:
            return e.fields.some((n)=>n.presence != w && n.fieldKind != "message" && !n.oneof);
    }
}
function O(e) {
    if (e.kind == "oneof") return {
        case: undefined
    };
    if (e.fieldKind == "list") return [];
    if (e.fieldKind == "map") return {};
    if (e.fieldKind == "message") return dl;
    const n = e.getDefaultValue();
    return n !== undefined ? e.fieldKind == "scalar" && e.longAsString ? n.toString() : n : e.fieldKind == "scalar" ? U(e.scalar, e.longAsString) : e.enum.values[0].number;
}
const bl = 0;
function se(e, n, t = true) {
    return new rn(e, n, t);
}
const he = /* @__PURE__ */ new WeakMap();
class rn {
    get sortedFields() {
        const n = he.get(this.desc);
        if (n) return n;
        const t = this.desc.fields.concat().sort((l, o)=>l.number - o.number);
        return he.set(this.desc, t), t;
    }
    findNumber(n) {
        return this._fieldsByNumber || (this._fieldsByNumber = new Map(this.desc.fields.map((t)=>[
                t.number,
                t
            ]))), this._fieldsByNumber.get(n);
    }
    oneofCase(n) {
        return X(this.message, n), st(this.message, n);
    }
    isSet(n) {
        return X(this.message, n), it(this.message, n);
    }
    clear(n) {
        X(this.message, n), rt(this.message, n);
    }
    get(n) {
        X(this.message, n);
        const t = dt(this.message, n);
        switch(n.fieldKind){
            case "list":
                let l = this.lists.get(n);
                return (!l || l[A] !== t) && this.lists.set(n, // biome-ignore lint/suspicious/noAssignInExpressions: no
                l = new fl(n, t, this.check)), l;
            case "map":
                let o = this.maps.get(n);
                return (!o || o[A] !== t) && this.maps.set(n, // biome-ignore lint/suspicious/noAssignInExpressions: no
                o = new El(n, t, this.check)), o;
            case "message":
                return de(n, t, this.check);
            case "scalar":
                return t === undefined ? U(n.scalar, false) : me(n, t);
            case "enum":
                return t ?? n.enum.values[0].number;
        }
    }
    set(n, t) {
        if (X(this.message, n), this.check) {
            const o = tl(n, t);
            if (o) throw o;
        }
        let l;
        n.fieldKind == "message" ? l = ie(n, t) : ce(t) || oe(t) ? l = t[A] : l = re(n, t), mt(this.message, n, l);
    }
    getUnknown() {
        return this.message.$unknown;
    }
    setUnknown(n) {
        this.message.$unknown = n;
    }
    constructor(n, t, l = true){
        this.lists = /* @__PURE__ */ new Map(), this.maps = /* @__PURE__ */ new Map(), this.check = l, this.desc = n, this.message = this[A] = t ?? il(n), this.fields = n.fields, this.oneofs = n.oneofs, this.members = n.members;
    }
}
function X(e, n) {
    if (n.parent.typeName !== e.$typeName) throw new G(n, `cannot use ${n.toString()} with message ${e.$typeName}`, "ForeignFieldError");
}
class fl {
    field() {
        return this._field;
    }
    get size() {
        return this._arr.length;
    }
    get(n) {
        const t = this._arr[n];
        return t === undefined ? undefined : K(this._field, t, this.check);
    }
    set(n, t) {
        if (n < 0 || n >= this._arr.length) throw new G(this._field, `list item #${n + 1}: out of range`);
        if (this.check) {
            const l = Ae(this._field, n, t);
            if (l) throw l;
        }
        this._arr[n] = Ge(this._field, t);
    }
    add(n) {
        if (this.check) {
            const t = Ae(this._field, this._arr.length, n);
            if (t) throw t;
        }
        this._arr.push(Ge(this._field, n));
    }
    clear() {
        this._arr.splice(0, this._arr.length);
    }
    [Symbol.iterator]() {
        return this.values();
    }
    keys() {
        return this._arr.keys();
    }
    *values() {
        for (const n of this._arr)yield K(this._field, n, this.check);
    }
    *entries() {
        for(let n = 0; n < this._arr.length; n++)yield [
            n,
            K(this._field, this._arr[n], this.check)
        ];
    }
    constructor(n, t, l){
        this._field = n, this._arr = this[A] = t, this.check = l;
    }
}
class El {
    field() {
        return this._field;
    }
    set(n, t) {
        if (this.check) {
            const l = ll(this._field, n, t);
            if (l) throw l;
        }
        return this.obj[L(n)] = Vl(this._field, t), this;
    }
    delete(n) {
        const t = L(n), l = Object.prototype.hasOwnProperty.call(this.obj, t);
        return l && delete this.obj[t], l;
    }
    clear() {
        for (const n of Object.keys(this.obj))delete this.obj[n];
    }
    get(n) {
        let t = this.obj[L(n)];
        return t !== undefined && (t = x(this._field, t, this.check)), t;
    }
    has(n) {
        return Object.prototype.hasOwnProperty.call(this.obj, L(n));
    }
    *keys() {
        for (const n of Object.keys(this.obj))yield Be(n, this._field.mapKey);
    }
    *entries() {
        for (const n of Object.entries(this.obj))yield [
            Be(n[0], this._field.mapKey),
            x(this._field, n[1], this.check)
        ];
    }
    [Symbol.iterator]() {
        return this.entries();
    }
    get size() {
        return Object.keys(this.obj).length;
    }
    *values() {
        for (const n of Object.values(this.obj))yield x(this._field, n, this.check);
    }
    forEach(n, t) {
        for (const l of this.entries())n.call(t, l[1], l[0], this);
    }
    constructor(n, t, l = true){
        this.obj = this[A] = t ?? {}, this.check = l, this._field = n;
    }
}
function ie(e, n) {
    return ue(n) ? cl(n.message) && !e.oneof && e.fieldKind == "message" ? n.message.value : n.desc.typeName == "google.protobuf.Struct" && e.parent.typeName != "google.protobuf.Value" ? fn(n.message) : n.message : n;
}
function de(e, n, t) {
    return n !== undefined && (ul(e.message) && !e.oneof && e.fieldKind == "message" ? n = {
        $typeName: e.message.typeName,
        value: me(e.message.fields[0], n)
    } : e.message.typeName == "google.protobuf.Struct" && e.parent.typeName != "google.protobuf.Value" && B(n) && (n = bn(n))), new rn(e.message, n, t);
}
function Ge(e, n) {
    return e.listKind == "message" ? ie(e, n) : re(e, n);
}
function K(e, n, t) {
    return e.listKind == "message" ? de(e, n, t) : me(e, n);
}
function Vl(e, n) {
    return e.mapKind == "message" ? ie(e, n) : re(e, n);
}
function x(e, n, t) {
    return e.mapKind == "message" ? de(e, n, t) : n;
}
function L(e) {
    return typeof e == "string" || typeof e == "number" ? e : String(e);
}
function Be(e, n) {
    switch(n){
        case s.STRING:
            return e;
        case s.INT32:
        case s.FIXED32:
        case s.UINT32:
        case s.SFIXED32:
        case s.SINT32:
            {
                const t = Number.parseInt(e);
                if (Number.isFinite(t)) return t;
                break;
            }
        case s.BOOL:
            switch(e){
                case "true":
                    return true;
                case "false":
                    return false;
            }
            break;
        case s.UINT64:
        case s.FIXED64:
            try {
                return V.uParse(e);
            } catch  {}
            break;
        default:
            try {
                return V.parse(e);
            } catch  {}
            break;
    }
    return e;
}
function me(e, n) {
    switch(e.scalar){
        case s.INT64:
        case s.SFIXED64:
        case s.SINT64:
            "longAsString" in e && e.longAsString && typeof n == "string" && (n = V.parse(n));
            break;
        case s.FIXED64:
        case s.UINT64:
            "longAsString" in e && e.longAsString && typeof n == "string" && (n = V.uParse(n));
            break;
    }
    return n;
}
function re(e, n) {
    switch(e.scalar){
        case s.INT64:
        case s.SFIXED64:
        case s.SINT64:
            "longAsString" in e && e.longAsString ? n = String(n) : (typeof n == "string" || typeof n == "number") && (n = V.parse(n));
            break;
        case s.FIXED64:
        case s.UINT64:
            "longAsString" in e && e.longAsString ? n = String(n) : (typeof n == "string" || typeof n == "number") && (n = V.uParse(n));
            break;
    }
    return n;
}
function bn(e) {
    const n = {
        $typeName: "google.protobuf.Struct",
        fields: {}
    };
    if (B(e)) for (const [t, l] of Object.entries(e))n.fields[t] = Vn(l);
    return n;
}
function fn(e) {
    const n = {};
    for (const [t, l] of Object.entries(e.fields))n[t] = En(l);
    return n;
}
function En(e) {
    switch(e.kind.case){
        case "structValue":
            return fn(e.kind.value);
        case "listValue":
            return e.kind.value.values.map(En);
        case "nullValue":
        case undefined:
            return null;
        default:
            return e.kind.value;
    }
}
function Vn(e) {
    const n = {
        $typeName: "google.protobuf.Value",
        kind: {
            case: undefined
        }
    };
    switch(typeof e){
        case "number":
            n.kind = {
                case: "numberValue",
                value: e
            };
            break;
        case "string":
            n.kind = {
                case: "stringValue",
                value: e
            };
            break;
        case "boolean":
            n.kind = {
                case: "boolValue",
                value: e
            };
            break;
        case "object":
            if (e === null) n.kind = {
                case: "nullValue",
                value: bl
            };
            else if (Array.isArray(e)) {
                const t = {
                    $typeName: "google.protobuf.ListValue",
                    values: []
                };
                if (Array.isArray(e)) for (const l of e)t.values.push(Vn(l));
                n.kind = {
                    case: "listValue",
                    value: t
                };
            } else n.kind = {
                case: "structValue",
                value: bn(e)
            };
            break;
    }
    return n;
}
function Rn(e, n, ...t) {
    return t.reduce((l, o)=>l.nestedMessages[o], e.messages[n]);
}
function b(e, n, ...t) {
    if (t.length == 0) return e.enums[n];
    const l = t.pop();
    return t.reduce((o, c)=>o.nestedMessages[c], e.messages[n]).nestedEnums[l];
}
function f(e) {
    const n = {};
    for (const t of e.values)n[t.localName] = t.number, n[t.number] = t.localName;
    return n;
}
const Rl = /* @__PURE__ */ Qt({
    name: "google/protobuf/descriptor.proto",
    package: "google.protobuf",
    messageType: [
        {
            name: "FileDescriptorSet",
            field: [
                {
                    name: "file",
                    number: 1,
                    type: 11,
                    label: 3,
                    typeName: ".google.protobuf.FileDescriptorProto"
                }
            ],
            extensionRange: [
                {
                    start: 536e6,
                    end: 536000001
                }
            ]
        },
        {
            name: "FileDescriptorProto",
            field: [
                {
                    name: "name",
                    number: 1,
                    type: 9,
                    label: 1
                },
                {
                    name: "package",
                    number: 2,
                    type: 9,
                    label: 1
                },
                {
                    name: "dependency",
                    number: 3,
                    type: 9,
                    label: 3
                },
                {
                    name: "public_dependency",
                    number: 10,
                    type: 5,
                    label: 3
                },
                {
                    name: "weak_dependency",
                    number: 11,
                    type: 5,
                    label: 3
                },
                {
                    name: "option_dependency",
                    number: 15,
                    type: 9,
                    label: 3
                },
                {
                    name: "message_type",
                    number: 4,
                    type: 11,
                    label: 3,
                    typeName: ".google.protobuf.DescriptorProto"
                },
                {
                    name: "enum_type",
                    number: 5,
                    type: 11,
                    label: 3,
                    typeName: ".google.protobuf.EnumDescriptorProto"
                },
                {
                    name: "service",
                    number: 6,
                    type: 11,
                    label: 3,
                    typeName: ".google.protobuf.ServiceDescriptorProto"
                },
                {
                    name: "extension",
                    number: 7,
                    type: 11,
                    label: 3,
                    typeName: ".google.protobuf.FieldDescriptorProto"
                },
                {
                    name: "options",
                    number: 8,
                    type: 11,
                    label: 1,
                    typeName: ".google.protobuf.FileOptions"
                },
                {
                    name: "source_code_info",
                    number: 9,
                    type: 11,
                    label: 1,
                    typeName: ".google.protobuf.SourceCodeInfo"
                },
                {
                    name: "syntax",
                    number: 12,
                    type: 9,
                    label: 1
                },
                {
                    name: "edition",
                    number: 14,
                    type: 14,
                    label: 1,
                    typeName: ".google.protobuf.Edition"
                }
            ]
        },
        {
            name: "DescriptorProto",
            field: [
                {
                    name: "name",
                    number: 1,
                    type: 9,
                    label: 1
                },
                {
                    name: "field",
                    number: 2,
                    type: 11,
                    label: 3,
                    typeName: ".google.protobuf.FieldDescriptorProto"
                },
                {
                    name: "extension",
                    number: 6,
                    type: 11,
                    label: 3,
                    typeName: ".google.protobuf.FieldDescriptorProto"
                },
                {
                    name: "nested_type",
                    number: 3,
                    type: 11,
                    label: 3,
                    typeName: ".google.protobuf.DescriptorProto"
                },
                {
                    name: "enum_type",
                    number: 4,
                    type: 11,
                    label: 3,
                    typeName: ".google.protobuf.EnumDescriptorProto"
                },
                {
                    name: "extension_range",
                    number: 5,
                    type: 11,
                    label: 3,
                    typeName: ".google.protobuf.DescriptorProto.ExtensionRange"
                },
                {
                    name: "oneof_decl",
                    number: 8,
                    type: 11,
                    label: 3,
                    typeName: ".google.protobuf.OneofDescriptorProto"
                },
                {
                    name: "options",
                    number: 7,
                    type: 11,
                    label: 1,
                    typeName: ".google.protobuf.MessageOptions"
                },
                {
                    name: "reserved_range",
                    number: 9,
                    type: 11,
                    label: 3,
                    typeName: ".google.protobuf.DescriptorProto.ReservedRange"
                },
                {
                    name: "reserved_name",
                    number: 10,
                    type: 9,
                    label: 3
                },
                {
                    name: "visibility",
                    number: 11,
                    type: 14,
                    label: 1,
                    typeName: ".google.protobuf.SymbolVisibility"
                }
            ],
            nestedType: [
                {
                    name: "ExtensionRange",
                    field: [
                        {
                            name: "start",
                            number: 1,
                            type: 5,
                            label: 1
                        },
                        {
                            name: "end",
                            number: 2,
                            type: 5,
                            label: 1
                        },
                        {
                            name: "options",
                            number: 3,
                            type: 11,
                            label: 1,
                            typeName: ".google.protobuf.ExtensionRangeOptions"
                        }
                    ]
                },
                {
                    name: "ReservedRange",
                    field: [
                        {
                            name: "start",
                            number: 1,
                            type: 5,
                            label: 1
                        },
                        {
                            name: "end",
                            number: 2,
                            type: 5,
                            label: 1
                        }
                    ]
                }
            ]
        },
        {
            name: "ExtensionRangeOptions",
            field: [
                {
                    name: "uninterpreted_option",
                    number: 999,
                    type: 11,
                    label: 3,
                    typeName: ".google.protobuf.UninterpretedOption"
                },
                {
                    name: "declaration",
                    number: 2,
                    type: 11,
                    label: 3,
                    typeName: ".google.protobuf.ExtensionRangeOptions.Declaration",
                    options: {
                        retention: 2
                    }
                },
                {
                    name: "features",
                    number: 50,
                    type: 11,
                    label: 1,
                    typeName: ".google.protobuf.FeatureSet"
                },
                {
                    name: "verification",
                    number: 3,
                    type: 14,
                    label: 1,
                    typeName: ".google.protobuf.ExtensionRangeOptions.VerificationState",
                    defaultValue: "UNVERIFIED",
                    options: {
                        retention: 2
                    }
                }
            ],
            nestedType: [
                {
                    name: "Declaration",
                    field: [
                        {
                            name: "number",
                            number: 1,
                            type: 5,
                            label: 1
                        },
                        {
                            name: "full_name",
                            number: 2,
                            type: 9,
                            label: 1
                        },
                        {
                            name: "type",
                            number: 3,
                            type: 9,
                            label: 1
                        },
                        {
                            name: "reserved",
                            number: 5,
                            type: 8,
                            label: 1
                        },
                        {
                            name: "repeated",
                            number: 6,
                            type: 8,
                            label: 1
                        }
                    ]
                }
            ],
            enumType: [
                {
                    name: "VerificationState",
                    value: [
                        {
                            name: "DECLARATION",
                            number: 0
                        },
                        {
                            name: "UNVERIFIED",
                            number: 1
                        }
                    ]
                }
            ],
            extensionRange: [
                {
                    start: 1e3,
                    end: 536870912
                }
            ]
        },
        {
            name: "FieldDescriptorProto",
            field: [
                {
                    name: "name",
                    number: 1,
                    type: 9,
                    label: 1
                },
                {
                    name: "number",
                    number: 3,
                    type: 5,
                    label: 1
                },
                {
                    name: "label",
                    number: 4,
                    type: 14,
                    label: 1,
                    typeName: ".google.protobuf.FieldDescriptorProto.Label"
                },
                {
                    name: "type",
                    number: 5,
                    type: 14,
                    label: 1,
                    typeName: ".google.protobuf.FieldDescriptorProto.Type"
                },
                {
                    name: "type_name",
                    number: 6,
                    type: 9,
                    label: 1
                },
                {
                    name: "extendee",
                    number: 2,
                    type: 9,
                    label: 1
                },
                {
                    name: "default_value",
                    number: 7,
                    type: 9,
                    label: 1
                },
                {
                    name: "oneof_index",
                    number: 9,
                    type: 5,
                    label: 1
                },
                {
                    name: "json_name",
                    number: 10,
                    type: 9,
                    label: 1
                },
                {
                    name: "options",
                    number: 8,
                    type: 11,
                    label: 1,
                    typeName: ".google.protobuf.FieldOptions"
                },
                {
                    name: "proto3_optional",
                    number: 17,
                    type: 8,
                    label: 1
                }
            ],
            enumType: [
                {
                    name: "Type",
                    value: [
                        {
                            name: "TYPE_DOUBLE",
                            number: 1
                        },
                        {
                            name: "TYPE_FLOAT",
                            number: 2
                        },
                        {
                            name: "TYPE_INT64",
                            number: 3
                        },
                        {
                            name: "TYPE_UINT64",
                            number: 4
                        },
                        {
                            name: "TYPE_INT32",
                            number: 5
                        },
                        {
                            name: "TYPE_FIXED64",
                            number: 6
                        },
                        {
                            name: "TYPE_FIXED32",
                            number: 7
                        },
                        {
                            name: "TYPE_BOOL",
                            number: 8
                        },
                        {
                            name: "TYPE_STRING",
                            number: 9
                        },
                        {
                            name: "TYPE_GROUP",
                            number: 10
                        },
                        {
                            name: "TYPE_MESSAGE",
                            number: 11
                        },
                        {
                            name: "TYPE_BYTES",
                            number: 12
                        },
                        {
                            name: "TYPE_UINT32",
                            number: 13
                        },
                        {
                            name: "TYPE_ENUM",
                            number: 14
                        },
                        {
                            name: "TYPE_SFIXED32",
                            number: 15
                        },
                        {
                            name: "TYPE_SFIXED64",
                            number: 16
                        },
                        {
                            name: "TYPE_SINT32",
                            number: 17
                        },
                        {
                            name: "TYPE_SINT64",
                            number: 18
                        }
                    ]
                },
                {
                    name: "Label",
                    value: [
                        {
                            name: "LABEL_OPTIONAL",
                            number: 1
                        },
                        {
                            name: "LABEL_REPEATED",
                            number: 3
                        },
                        {
                            name: "LABEL_REQUIRED",
                            number: 2
                        }
                    ]
                }
            ]
        },
        {
            name: "OneofDescriptorProto",
            field: [
                {
                    name: "name",
                    number: 1,
                    type: 9,
                    label: 1
                },
                {
                    name: "options",
                    number: 2,
                    type: 11,
                    label: 1,
                    typeName: ".google.protobuf.OneofOptions"
                }
            ]
        },
        {
            name: "EnumDescriptorProto",
            field: [
                {
                    name: "name",
                    number: 1,
                    type: 9,
                    label: 1
                },
                {
                    name: "value",
                    number: 2,
                    type: 11,
                    label: 3,
                    typeName: ".google.protobuf.EnumValueDescriptorProto"
                },
                {
                    name: "options",
                    number: 3,
                    type: 11,
                    label: 1,
                    typeName: ".google.protobuf.EnumOptions"
                },
                {
                    name: "reserved_range",
                    number: 4,
                    type: 11,
                    label: 3,
                    typeName: ".google.protobuf.EnumDescriptorProto.EnumReservedRange"
                },
                {
                    name: "reserved_name",
                    number: 5,
                    type: 9,
                    label: 3
                },
                {
                    name: "visibility",
                    number: 6,
                    type: 14,
                    label: 1,
                    typeName: ".google.protobuf.SymbolVisibility"
                }
            ],
            nestedType: [
                {
                    name: "EnumReservedRange",
                    field: [
                        {
                            name: "start",
                            number: 1,
                            type: 5,
                            label: 1
                        },
                        {
                            name: "end",
                            number: 2,
                            type: 5,
                            label: 1
                        }
                    ]
                }
            ]
        },
        {
            name: "EnumValueDescriptorProto",
            field: [
                {
                    name: "name",
                    number: 1,
                    type: 9,
                    label: 1
                },
                {
                    name: "number",
                    number: 2,
                    type: 5,
                    label: 1
                },
                {
                    name: "options",
                    number: 3,
                    type: 11,
                    label: 1,
                    typeName: ".google.protobuf.EnumValueOptions"
                }
            ]
        },
        {
            name: "ServiceDescriptorProto",
            field: [
                {
                    name: "name",
                    number: 1,
                    type: 9,
                    label: 1
                },
                {
                    name: "method",
                    number: 2,
                    type: 11,
                    label: 3,
                    typeName: ".google.protobuf.MethodDescriptorProto"
                },
                {
                    name: "options",
                    number: 3,
                    type: 11,
                    label: 1,
                    typeName: ".google.protobuf.ServiceOptions"
                }
            ]
        },
        {
            name: "MethodDescriptorProto",
            field: [
                {
                    name: "name",
                    number: 1,
                    type: 9,
                    label: 1
                },
                {
                    name: "input_type",
                    number: 2,
                    type: 9,
                    label: 1
                },
                {
                    name: "output_type",
                    number: 3,
                    type: 9,
                    label: 1
                },
                {
                    name: "options",
                    number: 4,
                    type: 11,
                    label: 1,
                    typeName: ".google.protobuf.MethodOptions"
                },
                {
                    name: "client_streaming",
                    number: 5,
                    type: 8,
                    label: 1,
                    defaultValue: "false"
                },
                {
                    name: "server_streaming",
                    number: 6,
                    type: 8,
                    label: 1,
                    defaultValue: "false"
                }
            ]
        },
        {
            name: "FileOptions",
            field: [
                {
                    name: "java_package",
                    number: 1,
                    type: 9,
                    label: 1
                },
                {
                    name: "java_outer_classname",
                    number: 8,
                    type: 9,
                    label: 1
                },
                {
                    name: "java_multiple_files",
                    number: 10,
                    type: 8,
                    label: 1,
                    defaultValue: "false",
                    options: {}
                },
                {
                    name: "java_generate_equals_and_hash",
                    number: 20,
                    type: 8,
                    label: 1,
                    options: {
                        deprecated: true
                    }
                },
                {
                    name: "java_string_check_utf8",
                    number: 27,
                    type: 8,
                    label: 1,
                    defaultValue: "false"
                },
                {
                    name: "optimize_for",
                    number: 9,
                    type: 14,
                    label: 1,
                    typeName: ".google.protobuf.FileOptions.OptimizeMode",
                    defaultValue: "SPEED"
                },
                {
                    name: "go_package",
                    number: 11,
                    type: 9,
                    label: 1
                },
                {
                    name: "cc_generic_services",
                    number: 16,
                    type: 8,
                    label: 1,
                    defaultValue: "false"
                },
                {
                    name: "java_generic_services",
                    number: 17,
                    type: 8,
                    label: 1,
                    defaultValue: "false"
                },
                {
                    name: "py_generic_services",
                    number: 18,
                    type: 8,
                    label: 1,
                    defaultValue: "false"
                },
                {
                    name: "deprecated",
                    number: 23,
                    type: 8,
                    label: 1,
                    defaultValue: "false"
                },
                {
                    name: "cc_enable_arenas",
                    number: 31,
                    type: 8,
                    label: 1,
                    defaultValue: "true"
                },
                {
                    name: "objc_class_prefix",
                    number: 36,
                    type: 9,
                    label: 1
                },
                {
                    name: "csharp_namespace",
                    number: 37,
                    type: 9,
                    label: 1
                },
                {
                    name: "swift_prefix",
                    number: 39,
                    type: 9,
                    label: 1
                },
                {
                    name: "php_class_prefix",
                    number: 40,
                    type: 9,
                    label: 1
                },
                {
                    name: "php_namespace",
                    number: 41,
                    type: 9,
                    label: 1
                },
                {
                    name: "php_metadata_namespace",
                    number: 44,
                    type: 9,
                    label: 1
                },
                {
                    name: "ruby_package",
                    number: 45,
                    type: 9,
                    label: 1
                },
                {
                    name: "features",
                    number: 50,
                    type: 11,
                    label: 1,
                    typeName: ".google.protobuf.FeatureSet"
                },
                {
                    name: "uninterpreted_option",
                    number: 999,
                    type: 11,
                    label: 3,
                    typeName: ".google.protobuf.UninterpretedOption"
                }
            ],
            enumType: [
                {
                    name: "OptimizeMode",
                    value: [
                        {
                            name: "SPEED",
                            number: 1
                        },
                        {
                            name: "CODE_SIZE",
                            number: 2
                        },
                        {
                            name: "LITE_RUNTIME",
                            number: 3
                        }
                    ]
                }
            ],
            extensionRange: [
                {
                    start: 1e3,
                    end: 536870912
                }
            ]
        },
        {
            name: "MessageOptions",
            field: [
                {
                    name: "message_set_wire_format",
                    number: 1,
                    type: 8,
                    label: 1,
                    defaultValue: "false"
                },
                {
                    name: "no_standard_descriptor_accessor",
                    number: 2,
                    type: 8,
                    label: 1,
                    defaultValue: "false"
                },
                {
                    name: "deprecated",
                    number: 3,
                    type: 8,
                    label: 1,
                    defaultValue: "false"
                },
                {
                    name: "map_entry",
                    number: 7,
                    type: 8,
                    label: 1
                },
                {
                    name: "deprecated_legacy_json_field_conflicts",
                    number: 11,
                    type: 8,
                    label: 1,
                    options: {
                        deprecated: true
                    }
                },
                {
                    name: "features",
                    number: 12,
                    type: 11,
                    label: 1,
                    typeName: ".google.protobuf.FeatureSet"
                },
                {
                    name: "uninterpreted_option",
                    number: 999,
                    type: 11,
                    label: 3,
                    typeName: ".google.protobuf.UninterpretedOption"
                }
            ],
            extensionRange: [
                {
                    start: 1e3,
                    end: 536870912
                }
            ]
        },
        {
            name: "FieldOptions",
            field: [
                {
                    name: "ctype",
                    number: 1,
                    type: 14,
                    label: 1,
                    typeName: ".google.protobuf.FieldOptions.CType",
                    defaultValue: "STRING"
                },
                {
                    name: "packed",
                    number: 2,
                    type: 8,
                    label: 1
                },
                {
                    name: "jstype",
                    number: 6,
                    type: 14,
                    label: 1,
                    typeName: ".google.protobuf.FieldOptions.JSType",
                    defaultValue: "JS_NORMAL"
                },
                {
                    name: "lazy",
                    number: 5,
                    type: 8,
                    label: 1,
                    defaultValue: "false"
                },
                {
                    name: "unverified_lazy",
                    number: 15,
                    type: 8,
                    label: 1,
                    defaultValue: "false"
                },
                {
                    name: "deprecated",
                    number: 3,
                    type: 8,
                    label: 1,
                    defaultValue: "false"
                },
                {
                    name: "weak",
                    number: 10,
                    type: 8,
                    label: 1,
                    defaultValue: "false",
                    options: {
                        deprecated: true
                    }
                },
                {
                    name: "debug_redact",
                    number: 16,
                    type: 8,
                    label: 1,
                    defaultValue: "false"
                },
                {
                    name: "retention",
                    number: 17,
                    type: 14,
                    label: 1,
                    typeName: ".google.protobuf.FieldOptions.OptionRetention"
                },
                {
                    name: "targets",
                    number: 19,
                    type: 14,
                    label: 3,
                    typeName: ".google.protobuf.FieldOptions.OptionTargetType"
                },
                {
                    name: "edition_defaults",
                    number: 20,
                    type: 11,
                    label: 3,
                    typeName: ".google.protobuf.FieldOptions.EditionDefault"
                },
                {
                    name: "features",
                    number: 21,
                    type: 11,
                    label: 1,
                    typeName: ".google.protobuf.FeatureSet"
                },
                {
                    name: "feature_support",
                    number: 22,
                    type: 11,
                    label: 1,
                    typeName: ".google.protobuf.FieldOptions.FeatureSupport"
                },
                {
                    name: "uninterpreted_option",
                    number: 999,
                    type: 11,
                    label: 3,
                    typeName: ".google.protobuf.UninterpretedOption"
                }
            ],
            nestedType: [
                {
                    name: "EditionDefault",
                    field: [
                        {
                            name: "edition",
                            number: 3,
                            type: 14,
                            label: 1,
                            typeName: ".google.protobuf.Edition"
                        },
                        {
                            name: "value",
                            number: 2,
                            type: 9,
                            label: 1
                        }
                    ]
                },
                {
                    name: "FeatureSupport",
                    field: [
                        {
                            name: "edition_introduced",
                            number: 1,
                            type: 14,
                            label: 1,
                            typeName: ".google.protobuf.Edition"
                        },
                        {
                            name: "edition_deprecated",
                            number: 2,
                            type: 14,
                            label: 1,
                            typeName: ".google.protobuf.Edition"
                        },
                        {
                            name: "deprecation_warning",
                            number: 3,
                            type: 9,
                            label: 1
                        },
                        {
                            name: "edition_removed",
                            number: 4,
                            type: 14,
                            label: 1,
                            typeName: ".google.protobuf.Edition"
                        },
                        {
                            name: "removal_error",
                            number: 5,
                            type: 9,
                            label: 1
                        }
                    ]
                }
            ],
            enumType: [
                {
                    name: "CType",
                    value: [
                        {
                            name: "STRING",
                            number: 0
                        },
                        {
                            name: "CORD",
                            number: 1
                        },
                        {
                            name: "STRING_PIECE",
                            number: 2
                        }
                    ]
                },
                {
                    name: "JSType",
                    value: [
                        {
                            name: "JS_NORMAL",
                            number: 0
                        },
                        {
                            name: "JS_STRING",
                            number: 1
                        },
                        {
                            name: "JS_NUMBER",
                            number: 2
                        }
                    ]
                },
                {
                    name: "OptionRetention",
                    value: [
                        {
                            name: "RETENTION_UNKNOWN",
                            number: 0
                        },
                        {
                            name: "RETENTION_RUNTIME",
                            number: 1
                        },
                        {
                            name: "RETENTION_SOURCE",
                            number: 2
                        }
                    ]
                },
                {
                    name: "OptionTargetType",
                    value: [
                        {
                            name: "TARGET_TYPE_UNKNOWN",
                            number: 0
                        },
                        {
                            name: "TARGET_TYPE_FILE",
                            number: 1
                        },
                        {
                            name: "TARGET_TYPE_EXTENSION_RANGE",
                            number: 2
                        },
                        {
                            name: "TARGET_TYPE_MESSAGE",
                            number: 3
                        },
                        {
                            name: "TARGET_TYPE_FIELD",
                            number: 4
                        },
                        {
                            name: "TARGET_TYPE_ONEOF",
                            number: 5
                        },
                        {
                            name: "TARGET_TYPE_ENUM",
                            number: 6
                        },
                        {
                            name: "TARGET_TYPE_ENUM_ENTRY",
                            number: 7
                        },
                        {
                            name: "TARGET_TYPE_SERVICE",
                            number: 8
                        },
                        {
                            name: "TARGET_TYPE_METHOD",
                            number: 9
                        }
                    ]
                }
            ],
            extensionRange: [
                {
                    start: 1e3,
                    end: 536870912
                }
            ]
        },
        {
            name: "OneofOptions",
            field: [
                {
                    name: "features",
                    number: 1,
                    type: 11,
                    label: 1,
                    typeName: ".google.protobuf.FeatureSet"
                },
                {
                    name: "uninterpreted_option",
                    number: 999,
                    type: 11,
                    label: 3,
                    typeName: ".google.protobuf.UninterpretedOption"
                }
            ],
            extensionRange: [
                {
                    start: 1e3,
                    end: 536870912
                }
            ]
        },
        {
            name: "EnumOptions",
            field: [
                {
                    name: "allow_alias",
                    number: 2,
                    type: 8,
                    label: 1
                },
                {
                    name: "deprecated",
                    number: 3,
                    type: 8,
                    label: 1,
                    defaultValue: "false"
                },
                {
                    name: "deprecated_legacy_json_field_conflicts",
                    number: 6,
                    type: 8,
                    label: 1,
                    options: {
                        deprecated: true
                    }
                },
                {
                    name: "features",
                    number: 7,
                    type: 11,
                    label: 1,
                    typeName: ".google.protobuf.FeatureSet"
                },
                {
                    name: "uninterpreted_option",
                    number: 999,
                    type: 11,
                    label: 3,
                    typeName: ".google.protobuf.UninterpretedOption"
                }
            ],
            extensionRange: [
                {
                    start: 1e3,
                    end: 536870912
                }
            ]
        },
        {
            name: "EnumValueOptions",
            field: [
                {
                    name: "deprecated",
                    number: 1,
                    type: 8,
                    label: 1,
                    defaultValue: "false"
                },
                {
                    name: "features",
                    number: 2,
                    type: 11,
                    label: 1,
                    typeName: ".google.protobuf.FeatureSet"
                },
                {
                    name: "debug_redact",
                    number: 3,
                    type: 8,
                    label: 1,
                    defaultValue: "false"
                },
                {
                    name: "feature_support",
                    number: 4,
                    type: 11,
                    label: 1,
                    typeName: ".google.protobuf.FieldOptions.FeatureSupport"
                },
                {
                    name: "uninterpreted_option",
                    number: 999,
                    type: 11,
                    label: 3,
                    typeName: ".google.protobuf.UninterpretedOption"
                }
            ],
            extensionRange: [
                {
                    start: 1e3,
                    end: 536870912
                }
            ]
        },
        {
            name: "ServiceOptions",
            field: [
                {
                    name: "features",
                    number: 34,
                    type: 11,
                    label: 1,
                    typeName: ".google.protobuf.FeatureSet"
                },
                {
                    name: "deprecated",
                    number: 33,
                    type: 8,
                    label: 1,
                    defaultValue: "false"
                },
                {
                    name: "uninterpreted_option",
                    number: 999,
                    type: 11,
                    label: 3,
                    typeName: ".google.protobuf.UninterpretedOption"
                }
            ],
            extensionRange: [
                {
                    start: 1e3,
                    end: 536870912
                }
            ]
        },
        {
            name: "MethodOptions",
            field: [
                {
                    name: "deprecated",
                    number: 33,
                    type: 8,
                    label: 1,
                    defaultValue: "false"
                },
                {
                    name: "idempotency_level",
                    number: 34,
                    type: 14,
                    label: 1,
                    typeName: ".google.protobuf.MethodOptions.IdempotencyLevel",
                    defaultValue: "IDEMPOTENCY_UNKNOWN"
                },
                {
                    name: "features",
                    number: 35,
                    type: 11,
                    label: 1,
                    typeName: ".google.protobuf.FeatureSet"
                },
                {
                    name: "uninterpreted_option",
                    number: 999,
                    type: 11,
                    label: 3,
                    typeName: ".google.protobuf.UninterpretedOption"
                }
            ],
            enumType: [
                {
                    name: "IdempotencyLevel",
                    value: [
                        {
                            name: "IDEMPOTENCY_UNKNOWN",
                            number: 0
                        },
                        {
                            name: "NO_SIDE_EFFECTS",
                            number: 1
                        },
                        {
                            name: "IDEMPOTENT",
                            number: 2
                        }
                    ]
                }
            ],
            extensionRange: [
                {
                    start: 1e3,
                    end: 536870912
                }
            ]
        },
        {
            name: "UninterpretedOption",
            field: [
                {
                    name: "name",
                    number: 2,
                    type: 11,
                    label: 3,
                    typeName: ".google.protobuf.UninterpretedOption.NamePart"
                },
                {
                    name: "identifier_value",
                    number: 3,
                    type: 9,
                    label: 1
                },
                {
                    name: "positive_int_value",
                    number: 4,
                    type: 4,
                    label: 1
                },
                {
                    name: "negative_int_value",
                    number: 5,
                    type: 3,
                    label: 1
                },
                {
                    name: "double_value",
                    number: 6,
                    type: 1,
                    label: 1
                },
                {
                    name: "string_value",
                    number: 7,
                    type: 12,
                    label: 1
                },
                {
                    name: "aggregate_value",
                    number: 8,
                    type: 9,
                    label: 1
                }
            ],
            nestedType: [
                {
                    name: "NamePart",
                    field: [
                        {
                            name: "name_part",
                            number: 1,
                            type: 9,
                            label: 2
                        },
                        {
                            name: "is_extension",
                            number: 2,
                            type: 8,
                            label: 2
                        }
                    ]
                }
            ]
        },
        {
            name: "FeatureSet",
            field: [
                {
                    name: "field_presence",
                    number: 1,
                    type: 14,
                    label: 1,
                    typeName: ".google.protobuf.FeatureSet.FieldPresence",
                    options: {
                        retention: 1,
                        targets: [
                            4,
                            1
                        ],
                        editionDefaults: [
                            {
                                value: "EXPLICIT",
                                edition: 900
                            },
                            {
                                value: "IMPLICIT",
                                edition: 999
                            },
                            {
                                value: "EXPLICIT",
                                edition: 1e3
                            }
                        ]
                    }
                },
                {
                    name: "enum_type",
                    number: 2,
                    type: 14,
                    label: 1,
                    typeName: ".google.protobuf.FeatureSet.EnumType",
                    options: {
                        retention: 1,
                        targets: [
                            6,
                            1
                        ],
                        editionDefaults: [
                            {
                                value: "CLOSED",
                                edition: 900
                            },
                            {
                                value: "OPEN",
                                edition: 999
                            }
                        ]
                    }
                },
                {
                    name: "repeated_field_encoding",
                    number: 3,
                    type: 14,
                    label: 1,
                    typeName: ".google.protobuf.FeatureSet.RepeatedFieldEncoding",
                    options: {
                        retention: 1,
                        targets: [
                            4,
                            1
                        ],
                        editionDefaults: [
                            {
                                value: "EXPANDED",
                                edition: 900
                            },
                            {
                                value: "PACKED",
                                edition: 999
                            }
                        ]
                    }
                },
                {
                    name: "utf8_validation",
                    number: 4,
                    type: 14,
                    label: 1,
                    typeName: ".google.protobuf.FeatureSet.Utf8Validation",
                    options: {
                        retention: 1,
                        targets: [
                            4,
                            1
                        ],
                        editionDefaults: [
                            {
                                value: "NONE",
                                edition: 900
                            },
                            {
                                value: "VERIFY",
                                edition: 999
                            }
                        ]
                    }
                },
                {
                    name: "message_encoding",
                    number: 5,
                    type: 14,
                    label: 1,
                    typeName: ".google.protobuf.FeatureSet.MessageEncoding",
                    options: {
                        retention: 1,
                        targets: [
                            4,
                            1
                        ],
                        editionDefaults: [
                            {
                                value: "LENGTH_PREFIXED",
                                edition: 900
                            }
                        ]
                    }
                },
                {
                    name: "json_format",
                    number: 6,
                    type: 14,
                    label: 1,
                    typeName: ".google.protobuf.FeatureSet.JsonFormat",
                    options: {
                        retention: 1,
                        targets: [
                            3,
                            6,
                            1
                        ],
                        editionDefaults: [
                            {
                                value: "LEGACY_BEST_EFFORT",
                                edition: 900
                            },
                            {
                                value: "ALLOW",
                                edition: 999
                            }
                        ]
                    }
                },
                {
                    name: "enforce_naming_style",
                    number: 7,
                    type: 14,
                    label: 1,
                    typeName: ".google.protobuf.FeatureSet.EnforceNamingStyle",
                    options: {
                        retention: 2,
                        targets: [
                            1,
                            2,
                            3,
                            4,
                            5,
                            6,
                            7,
                            8,
                            9
                        ],
                        editionDefaults: [
                            {
                                value: "STYLE_LEGACY",
                                edition: 900
                            },
                            {
                                value: "STYLE2024",
                                edition: 1001
                            }
                        ]
                    }
                },
                {
                    name: "default_symbol_visibility",
                    number: 8,
                    type: 14,
                    label: 1,
                    typeName: ".google.protobuf.FeatureSet.VisibilityFeature.DefaultSymbolVisibility",
                    options: {
                        retention: 2,
                        targets: [
                            1
                        ],
                        editionDefaults: [
                            {
                                value: "EXPORT_ALL",
                                edition: 900
                            },
                            {
                                value: "EXPORT_TOP_LEVEL",
                                edition: 1001
                            }
                        ]
                    }
                }
            ],
            nestedType: [
                {
                    name: "VisibilityFeature",
                    enumType: [
                        {
                            name: "DefaultSymbolVisibility",
                            value: [
                                {
                                    name: "DEFAULT_SYMBOL_VISIBILITY_UNKNOWN",
                                    number: 0
                                },
                                {
                                    name: "EXPORT_ALL",
                                    number: 1
                                },
                                {
                                    name: "EXPORT_TOP_LEVEL",
                                    number: 2
                                },
                                {
                                    name: "LOCAL_ALL",
                                    number: 3
                                },
                                {
                                    name: "STRICT",
                                    number: 4
                                }
                            ]
                        }
                    ]
                }
            ],
            enumType: [
                {
                    name: "FieldPresence",
                    value: [
                        {
                            name: "FIELD_PRESENCE_UNKNOWN",
                            number: 0
                        },
                        {
                            name: "EXPLICIT",
                            number: 1
                        },
                        {
                            name: "IMPLICIT",
                            number: 2
                        },
                        {
                            name: "LEGACY_REQUIRED",
                            number: 3
                        }
                    ]
                },
                {
                    name: "EnumType",
                    value: [
                        {
                            name: "ENUM_TYPE_UNKNOWN",
                            number: 0
                        },
                        {
                            name: "OPEN",
                            number: 1
                        },
                        {
                            name: "CLOSED",
                            number: 2
                        }
                    ]
                },
                {
                    name: "RepeatedFieldEncoding",
                    value: [
                        {
                            name: "REPEATED_FIELD_ENCODING_UNKNOWN",
                            number: 0
                        },
                        {
                            name: "PACKED",
                            number: 1
                        },
                        {
                            name: "EXPANDED",
                            number: 2
                        }
                    ]
                },
                {
                    name: "Utf8Validation",
                    value: [
                        {
                            name: "UTF8_VALIDATION_UNKNOWN",
                            number: 0
                        },
                        {
                            name: "VERIFY",
                            number: 2
                        },
                        {
                            name: "NONE",
                            number: 3
                        }
                    ]
                },
                {
                    name: "MessageEncoding",
                    value: [
                        {
                            name: "MESSAGE_ENCODING_UNKNOWN",
                            number: 0
                        },
                        {
                            name: "LENGTH_PREFIXED",
                            number: 1
                        },
                        {
                            name: "DELIMITED",
                            number: 2
                        }
                    ]
                },
                {
                    name: "JsonFormat",
                    value: [
                        {
                            name: "JSON_FORMAT_UNKNOWN",
                            number: 0
                        },
                        {
                            name: "ALLOW",
                            number: 1
                        },
                        {
                            name: "LEGACY_BEST_EFFORT",
                            number: 2
                        }
                    ]
                },
                {
                    name: "EnforceNamingStyle",
                    value: [
                        {
                            name: "ENFORCE_NAMING_STYLE_UNKNOWN",
                            number: 0
                        },
                        {
                            name: "STYLE2024",
                            number: 1
                        },
                        {
                            name: "STYLE_LEGACY",
                            number: 2
                        }
                    ]
                }
            ],
            extensionRange: [
                {
                    start: 1e3,
                    end: 9995
                },
                {
                    start: 9995,
                    end: 1e4
                },
                {
                    start: 1e4,
                    end: 10001
                }
            ]
        },
        {
            name: "FeatureSetDefaults",
            field: [
                {
                    name: "defaults",
                    number: 1,
                    type: 11,
                    label: 3,
                    typeName: ".google.protobuf.FeatureSetDefaults.FeatureSetEditionDefault"
                },
                {
                    name: "minimum_edition",
                    number: 4,
                    type: 14,
                    label: 1,
                    typeName: ".google.protobuf.Edition"
                },
                {
                    name: "maximum_edition",
                    number: 5,
                    type: 14,
                    label: 1,
                    typeName: ".google.protobuf.Edition"
                }
            ],
            nestedType: [
                {
                    name: "FeatureSetEditionDefault",
                    field: [
                        {
                            name: "edition",
                            number: 3,
                            type: 14,
                            label: 1,
                            typeName: ".google.protobuf.Edition"
                        },
                        {
                            name: "overridable_features",
                            number: 4,
                            type: 11,
                            label: 1,
                            typeName: ".google.protobuf.FeatureSet"
                        },
                        {
                            name: "fixed_features",
                            number: 5,
                            type: 11,
                            label: 1,
                            typeName: ".google.protobuf.FeatureSet"
                        }
                    ]
                }
            ]
        },
        {
            name: "SourceCodeInfo",
            field: [
                {
                    name: "location",
                    number: 1,
                    type: 11,
                    label: 3,
                    typeName: ".google.protobuf.SourceCodeInfo.Location"
                }
            ],
            nestedType: [
                {
                    name: "Location",
                    field: [
                        {
                            name: "path",
                            number: 1,
                            type: 5,
                            label: 3,
                            options: {
                                packed: true
                            }
                        },
                        {
                            name: "span",
                            number: 2,
                            type: 5,
                            label: 3,
                            options: {
                                packed: true
                            }
                        },
                        {
                            name: "leading_comments",
                            number: 3,
                            type: 9,
                            label: 1
                        },
                        {
                            name: "trailing_comments",
                            number: 4,
                            type: 9,
                            label: 1
                        },
                        {
                            name: "leading_detached_comments",
                            number: 6,
                            type: 9,
                            label: 3
                        }
                    ]
                }
            ],
            extensionRange: [
                {
                    start: 536e6,
                    end: 536000001
                }
            ]
        },
        {
            name: "GeneratedCodeInfo",
            field: [
                {
                    name: "annotation",
                    number: 1,
                    type: 11,
                    label: 3,
                    typeName: ".google.protobuf.GeneratedCodeInfo.Annotation"
                }
            ],
            nestedType: [
                {
                    name: "Annotation",
                    field: [
                        {
                            name: "path",
                            number: 1,
                            type: 5,
                            label: 3,
                            options: {
                                packed: true
                            }
                        },
                        {
                            name: "source_file",
                            number: 2,
                            type: 9,
                            label: 1
                        },
                        {
                            name: "begin",
                            number: 3,
                            type: 5,
                            label: 1
                        },
                        {
                            name: "end",
                            number: 4,
                            type: 5,
                            label: 1
                        },
                        {
                            name: "semantic",
                            number: 5,
                            type: 14,
                            label: 1,
                            typeName: ".google.protobuf.GeneratedCodeInfo.Annotation.Semantic"
                        }
                    ],
                    enumType: [
                        {
                            name: "Semantic",
                            value: [
                                {
                                    name: "NONE",
                                    number: 0
                                },
                                {
                                    name: "SET",
                                    number: 1
                                },
                                {
                                    name: "ALIAS",
                                    number: 2
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    enumType: [
        {
            name: "Edition",
            value: [
                {
                    name: "EDITION_UNKNOWN",
                    number: 0
                },
                {
                    name: "EDITION_LEGACY",
                    number: 900
                },
                {
                    name: "EDITION_PROTO2",
                    number: 998
                },
                {
                    name: "EDITION_PROTO3",
                    number: 999
                },
                {
                    name: "EDITION_2023",
                    number: 1e3
                },
                {
                    name: "EDITION_2024",
                    number: 1001
                },
                {
                    name: "EDITION_UNSTABLE",
                    number: 9999
                },
                {
                    name: "EDITION_1_TEST_ONLY",
                    number: 1
                },
                {
                    name: "EDITION_2_TEST_ONLY",
                    number: 2
                },
                {
                    name: "EDITION_99997_TEST_ONLY",
                    number: 99997
                },
                {
                    name: "EDITION_99998_TEST_ONLY",
                    number: 99998
                },
                {
                    name: "EDITION_99999_TEST_ONLY",
                    number: 99999
                },
                {
                    name: "EDITION_MAX",
                    number: 2147483647
                }
            ]
        },
        {
            name: "SymbolVisibility",
            value: [
                {
                    name: "VISIBILITY_UNSET",
                    number: 0
                },
                {
                    name: "VISIBILITY_LOCAL",
                    number: 1
                },
                {
                    name: "VISIBILITY_EXPORT",
                    number: 2
                }
            ]
        }
    ]
}), pl = /* @__PURE__ */ Rn(Rl, 1);
var Ie;
(function(e) {
    e[e.DECLARATION = 0] = "DECLARATION", e[e.UNVERIFIED = 1] = "UNVERIFIED";
})(Ie || (Ie = {}));
var Xe;
(function(e) {
    e[e.DOUBLE = 1] = "DOUBLE", e[e.FLOAT = 2] = "FLOAT", e[e.INT64 = 3] = "INT64", e[e.UINT64 = 4] = "UINT64", e[e.INT32 = 5] = "INT32", e[e.FIXED64 = 6] = "FIXED64", e[e.FIXED32 = 7] = "FIXED32", e[e.BOOL = 8] = "BOOL", e[e.STRING = 9] = "STRING", e[e.GROUP = 10] = "GROUP", e[e.MESSAGE = 11] = "MESSAGE", e[e.BYTES = 12] = "BYTES", e[e.UINT32 = 13] = "UINT32", e[e.ENUM = 14] = "ENUM", e[e.SFIXED32 = 15] = "SFIXED32", e[e.SFIXED64 = 16] = "SFIXED64", e[e.SINT32 = 17] = "SINT32", e[e.SINT64 = 18] = "SINT64";
})(Xe || (Xe = {}));
var Se;
(function(e) {
    e[e.OPTIONAL = 1] = "OPTIONAL", e[e.REPEATED = 3] = "REPEATED", e[e.REQUIRED = 2] = "REQUIRED";
})(Se || (Se = {}));
var Ye;
(function(e) {
    e[e.SPEED = 1] = "SPEED", e[e.CODE_SIZE = 2] = "CODE_SIZE", e[e.LITE_RUNTIME = 3] = "LITE_RUNTIME";
})(Ye || (Ye = {}));
var Ue;
(function(e) {
    e[e.STRING = 0] = "STRING", e[e.CORD = 1] = "CORD", e[e.STRING_PIECE = 2] = "STRING_PIECE";
})(Ue || (Ue = {}));
var We;
(function(e) {
    e[e.JS_NORMAL = 0] = "JS_NORMAL", e[e.JS_STRING = 1] = "JS_STRING", e[e.JS_NUMBER = 2] = "JS_NUMBER";
})(We || (We = {}));
var Fe;
(function(e) {
    e[e.RETENTION_UNKNOWN = 0] = "RETENTION_UNKNOWN", e[e.RETENTION_RUNTIME = 1] = "RETENTION_RUNTIME", e[e.RETENTION_SOURCE = 2] = "RETENTION_SOURCE";
})(Fe || (Fe = {}));
var Te;
(function(e) {
    e[e.TARGET_TYPE_UNKNOWN = 0] = "TARGET_TYPE_UNKNOWN", e[e.TARGET_TYPE_FILE = 1] = "TARGET_TYPE_FILE", e[e.TARGET_TYPE_EXTENSION_RANGE = 2] = "TARGET_TYPE_EXTENSION_RANGE", e[e.TARGET_TYPE_MESSAGE = 3] = "TARGET_TYPE_MESSAGE", e[e.TARGET_TYPE_FIELD = 4] = "TARGET_TYPE_FIELD", e[e.TARGET_TYPE_ONEOF = 5] = "TARGET_TYPE_ONEOF", e[e.TARGET_TYPE_ENUM = 6] = "TARGET_TYPE_ENUM", e[e.TARGET_TYPE_ENUM_ENTRY = 7] = "TARGET_TYPE_ENUM_ENTRY", e[e.TARGET_TYPE_SERVICE = 8] = "TARGET_TYPE_SERVICE", e[e.TARGET_TYPE_METHOD = 9] = "TARGET_TYPE_METHOD";
})(Te || (Te = {}));
var Le;
(function(e) {
    e[e.IDEMPOTENCY_UNKNOWN = 0] = "IDEMPOTENCY_UNKNOWN", e[e.NO_SIDE_EFFECTS = 1] = "NO_SIDE_EFFECTS", e[e.IDEMPOTENT = 2] = "IDEMPOTENT";
})(Le || (Le = {}));
var Ce;
(function(e) {
    e[e.DEFAULT_SYMBOL_VISIBILITY_UNKNOWN = 0] = "DEFAULT_SYMBOL_VISIBILITY_UNKNOWN", e[e.EXPORT_ALL = 1] = "EXPORT_ALL", e[e.EXPORT_TOP_LEVEL = 2] = "EXPORT_TOP_LEVEL", e[e.LOCAL_ALL = 3] = "LOCAL_ALL", e[e.STRICT = 4] = "STRICT";
})(Ce || (Ce = {}));
var we;
(function(e) {
    e[e.FIELD_PRESENCE_UNKNOWN = 0] = "FIELD_PRESENCE_UNKNOWN", e[e.EXPLICIT = 1] = "EXPLICIT", e[e.IMPLICIT = 2] = "IMPLICIT", e[e.LEGACY_REQUIRED = 3] = "LEGACY_REQUIRED";
})(we || (we = {}));
var Je;
(function(e) {
    e[e.ENUM_TYPE_UNKNOWN = 0] = "ENUM_TYPE_UNKNOWN", e[e.OPEN = 1] = "OPEN", e[e.CLOSED = 2] = "CLOSED";
})(Je || (Je = {}));
var He;
(function(e) {
    e[e.REPEATED_FIELD_ENCODING_UNKNOWN = 0] = "REPEATED_FIELD_ENCODING_UNKNOWN", e[e.PACKED = 1] = "PACKED", e[e.EXPANDED = 2] = "EXPANDED";
})(He || (He = {}));
var je;
(function(e) {
    e[e.UTF8_VALIDATION_UNKNOWN = 0] = "UTF8_VALIDATION_UNKNOWN", e[e.VERIFY = 2] = "VERIFY", e[e.NONE = 3] = "NONE";
})(je || (je = {}));
var Qe;
(function(e) {
    e[e.MESSAGE_ENCODING_UNKNOWN = 0] = "MESSAGE_ENCODING_UNKNOWN", e[e.LENGTH_PREFIXED = 1] = "LENGTH_PREFIXED", e[e.DELIMITED = 2] = "DELIMITED";
})(Qe || (Qe = {}));
var ke;
(function(e) {
    e[e.JSON_FORMAT_UNKNOWN = 0] = "JSON_FORMAT_UNKNOWN", e[e.ALLOW = 1] = "ALLOW", e[e.LEGACY_BEST_EFFORT = 2] = "LEGACY_BEST_EFFORT";
})(ke || (ke = {}));
var Me;
(function(e) {
    e[e.ENFORCE_NAMING_STYLE_UNKNOWN = 0] = "ENFORCE_NAMING_STYLE_UNKNOWN", e[e.STYLE2024 = 1] = "STYLE2024", e[e.STYLE_LEGACY = 2] = "STYLE_LEGACY";
})(Me || (Me = {}));
var ze;
(function(e) {
    e[e.NONE = 0] = "NONE", e[e.SET = 1] = "SET", e[e.ALIAS = 2] = "ALIAS";
})(ze || (ze = {}));
var Oe;
(function(e) {
    e[e.EDITION_UNKNOWN = 0] = "EDITION_UNKNOWN", e[e.EDITION_LEGACY = 900] = "EDITION_LEGACY", e[e.EDITION_PROTO2 = 998] = "EDITION_PROTO2", e[e.EDITION_PROTO3 = 999] = "EDITION_PROTO3", e[e.EDITION_2023 = 1e3] = "EDITION_2023", e[e.EDITION_2024 = 1001] = "EDITION_2024", e[e.EDITION_UNSTABLE = 9999] = "EDITION_UNSTABLE", e[e.EDITION_1_TEST_ONLY = 1] = "EDITION_1_TEST_ONLY", e[e.EDITION_2_TEST_ONLY = 2] = "EDITION_2_TEST_ONLY", e[e.EDITION_99997_TEST_ONLY = 99997] = "EDITION_99997_TEST_ONLY", e[e.EDITION_99998_TEST_ONLY = 99998] = "EDITION_99998_TEST_ONLY", e[e.EDITION_99999_TEST_ONLY = 99999] = "EDITION_99999_TEST_ONLY", e[e.EDITION_MAX = 2147483647] = "EDITION_MAX";
})(Oe || (Oe = {}));
var Ke;
(function(e) {
    e[e.VISIBILITY_UNSET = 0] = "VISIBILITY_UNSET", e[e.VISIBILITY_LOCAL = 1] = "VISIBILITY_LOCAL", e[e.VISIBILITY_EXPORT = 2] = "VISIBILITY_EXPORT";
})(Ke || (Ke = {}));
function Zl(e) {
    return Object.assign(Object.assign({
        readUnknownFields: true,
        recursionLimit: 100
    }, e), {
        depth: 0
    });
}
function Nl(e, n, t) {
    const l = se(e, undefined, false);
    return pn(l, new nl(n), Zl(t), false, n.byteLength), l.message;
}
function pn(e, n, t, l, o) {
    var c;
    if (++t.depth > t.recursionLimit) throw new Error(`cannot decode ${e.desc} from binary: maximum recursion depth of ${t.recursionLimit} reached`);
    const u = l ? n.len : n.pos + o;
    let a, m;
    const d = (c = e.getUnknown()) !== null && c !== undefined ? c : [];
    for(; n.pos < u && ([a, m] = n.tag(), !(l && m == g.EndGroup));){
        const r = e.findNumber(a);
        if (!r) {
            const E = t.recursionLimit - t.depth, p = n.skip(m, a, E);
            t.readUnknownFields && d.push({
                no: a,
                wireType: m,
                data: p
            });
            continue;
        }
        gl(e, n, r, m, t);
    }
    if (l && (m != g.EndGroup || a !== o)) throw new Error("invalid end group tag");
    d.length > 0 && e.setUnknown(d), t.depth--;
}
function gl(e, n, t, l, o) {
    var c;
    switch(t.fieldKind){
        case "scalar":
            e.set(t, I(n, t.scalar, t.utf8Validation));
            break;
        case "enum":
            const u = I(n, s.INT32);
            if (t.enum.open) e.set(t, u);
            else if (t.enum.values.some((m)=>m.number === u)) e.set(t, u);
            else if (o.readUnknownFields) {
                const m = [];
                ot(u, m);
                const d = (c = e.getUnknown()) !== null && c !== undefined ? c : [];
                d.push({
                    no: t.number,
                    wireType: l,
                    data: new Uint8Array(m)
                }), e.setUnknown(d);
            }
            break;
        case "message":
            e.set(t, be(n, o, t, e.get(t)));
            break;
        case "list":
            yl(n, l, e.get(t), o);
            break;
        case "map":
            vl(n, e.get(t), o);
            break;
    }
}
function vl(e, n, t) {
    const l = n.field();
    let o, c;
    const u = e.uint32(), a = e.pos + u;
    for(; e.pos < a;){
        const [m] = e.tag();
        switch(m){
            case 1:
                o = I(e, l.mapKey, l.utf8Validation);
                break;
            case 2:
                switch(l.mapKind){
                    case "scalar":
                        c = I(e, l.scalar, l.utf8Validation);
                        break;
                    case "enum":
                        c = e.int32();
                        break;
                    case "message":
                        c = be(e, t, l);
                        break;
                }
                break;
        }
    }
    if (o === undefined && (o = U(l.mapKey, false)), c === undefined) switch(l.mapKind){
        case "scalar":
            c = U(l.scalar, false);
            break;
        case "enum":
            c = l.enum.values[0].number;
            break;
        case "message":
            c = se(l.message, undefined, false);
            break;
    }
    n.set(o, c);
}
function yl(e, n, t, l) {
    var o;
    const c = t.field();
    if (c.listKind === "message") {
        t.add(be(e, l, c));
        return;
    }
    const u = (o = c.scalar) !== null && o !== undefined ? o : s.INT32;
    if (!(n == g.LengthDelimited && u != s.STRING && u != s.BYTES)) {
        t.add(I(e, u, c.utf8Validation));
        return;
    }
    const m = e.uint32() + e.pos;
    for(; e.pos < m;)t.add(I(e, u, c.utf8Validation));
}
function be(e, n, t, l) {
    const o = t.delimitedEncoding, c = l ?? se(t.message, undefined, false);
    return pn(c, e, n, o, o ? t.number : e.uint32()), c;
}
function I(e, n, t = false) {
    switch(n){
        case s.STRING:
            return e.string(t);
        case s.BOOL:
            return e.bool();
        case s.DOUBLE:
            return e.double();
        case s.FLOAT:
            return e.float();
        case s.INT32:
            return e.int32();
        case s.INT64:
            return e.int64();
        case s.UINT64:
            return e.uint64();
        case s.FIXED64:
            return e.fixed64();
        case s.BYTES:
            return e.bytes();
        case s.FIXED32:
            return e.fixed32();
        case s.SFIXED32:
            return e.sfixed32();
        case s.SFIXED64:
            return e.sfixed64();
        case s.SINT64:
            return e.sint64();
        case s.UINT32:
            return e.uint32();
        case s.SINT32:
            return e.sint32();
    }
}
function i(e, n) {
    var t;
    const l = Nl(pl, Ot(e));
    return l.messageType.forEach(te), l.dependency = (t = n?.map((c)=>c.proto.name)) !== null && t !== undefined ? t : [], qe(l, (c)=>n?.find((u)=>u.proto.name === c)).getFile(l.name);
}
const Al = /* @__PURE__ */ i("CjpldmVudHNfdjEvY29tcG9uZW50cy9zb3VyY2UvdHlwZS9mbGlwcF9hcHAvZmxpcHBfYXBwLnByb3RvEipldmVudHNfdjEuY29tcG9uZW50cy5zb3VyY2UudHlwZS5mbGlwcF9hcHAiYAoIRmxpcHBBcHASGAoLcG9zdGFsX2NvZGUYASABKAlIAIgBARIZCgxjb3VudHJ5X2NvZGUYAiABKAlIAYgBAUIOCgxfcG9zdGFsX2NvZGVCDwoNX2NvdW50cnlfY29kZWIGcHJvdG8z"), _l = /* @__PURE__ */ i("CjpldmVudHNfdjEvY29tcG9uZW50cy9zb3VyY2UvdHlwZS9mbGlwcF93ZWIvZmxpcHBfd2ViLnByb3RvEipldmVudHNfdjEuY29tcG9uZW50cy5zb3VyY2UudHlwZS5mbGlwcF93ZWIiYAoIRmxpcHBXZWISGAoLcG9zdGFsX2NvZGUYASABKAlIAIgBARIZCgxjb3VudHJ5X2NvZGUYAiABKAlIAYgBAUIOCgxfcG9zdGFsX2NvZGVCDwoNX2NvdW50cnlfY29kZWIGcHJvdG8z"), hl = /* @__PURE__ */ i("CjRldmVudHNfdjEvY29tcG9uZW50cy9zb3VyY2UvdHlwZS9ob3N0ZWQvaG9zdGVkLnByb3RvEidldmVudHNfdjEuY29tcG9uZW50cy5zb3VyY2UudHlwZS5ob3N0ZWQiCAoGSG9zdGVkYgZwcm90bzM"), Gl = /* @__PURE__ */ i("CjxldmVudHNfdjEvY29tcG9uZW50cy9zb3VyY2UvdHlwZS9yZWViZWVfYXBwL3JlZWJlZV9hcHAucHJvdG8SK2V2ZW50c192MS5jb21wb25lbnRzLnNvdXJjZS50eXBlLnJlZWJlZV9hcHAiYQoJUmVlYmVlQXBwEhgKC3Bvc3RhbF9jb2RlGAEgASgJSACIAQESGQoMY291bnRyeV9jb2RlGAIgASgJSAGIAQFCDgoMX3Bvc3RhbF9jb2RlQg8KDV9jb3VudHJ5X2NvZGViBnByb3RvMw"), Bl = /* @__PURE__ */ i("CkhldmVudHNfdjEvY29tcG9uZW50cy9zb3VyY2UvdHlwZS9zaG9wcGVyX3BsYXRmb3JtL3Nob3BwZXJfcGxhdGZvcm0ucHJvdG8SMWV2ZW50c192MS5jb21wb25lbnRzLnNvdXJjZS50eXBlLnNob3BwZXJfcGxhdGZvcm0iEQoPU2hvcHBlclBsYXRmb3JtYgZwcm90bzM"), Il = /* @__PURE__ */ i("CjpldmVudHNfdjEvY29tcG9uZW50cy9zb3VyY2UvdHlwZS9zaG9wZnVsbHkvc2hvcGZ1bGx5LnByb3RvEipldmVudHNfdjEuY29tcG9uZW50cy5zb3VyY2UudHlwZS5zaG9wZnVsbHkiYQoJU2hvcGZ1bGx5EhgKC3Byb3BlcnR5X2lkGAEgASgJSACIAQESGQoMY291bnRyeV9jb2RlGAIgASgJSAGIAQFCDgoMX3Byb3BlcnR5X2lkQg8KDV9jb3VudHJ5X2NvZGViBnByb3RvMw"), Xl = /* @__PURE__ */ i("CjJldmVudHNfdjEvY29tcG9uZW50cy9zb3VyY2UvdHlwZS9zb3VyY2VfdHlwZS5wcm90bxIgZXZlbnRzX3YxLmNvbXBvbmVudHMuc291cmNlLnR5cGUi7gMKClNvdXJjZVR5cGUSXgoQc2hvcHBlcl9wbGF0Zm9ybRgBIAEoCzJCLmV2ZW50c192MS5jb21wb25lbnRzLnNvdXJjZS50eXBlLnNob3BwZXJfcGxhdGZvcm0uU2hvcHBlclBsYXRmb3JtSAASSQoJZmxpcHBfYXBwGAIgASgLMjQuZXZlbnRzX3YxLmNvbXBvbmVudHMuc291cmNlLnR5cGUuZmxpcHBfYXBwLkZsaXBwQXBwSAASSgoJc2hvcGZ1bGx5GAMgASgLMjUuZXZlbnRzX3YxLmNvbXBvbmVudHMuc291cmNlLnR5cGUuc2hvcGZ1bGx5LlNob3BmdWxseUgAEkkKCWZsaXBwX3dlYhgEIAEoCzI0LmV2ZW50c192MS5jb21wb25lbnRzLnNvdXJjZS50eXBlLmZsaXBwX3dlYi5GbGlwcFdlYkgAEkEKBmhvc3RlZBgFIAEoCzIvLmV2ZW50c192MS5jb21wb25lbnRzLnNvdXJjZS50eXBlLmhvc3RlZC5Ib3N0ZWRIABJMCgpyZWViZWVfYXBwGAYgASgLMjYuZXZlbnRzX3YxLmNvbXBvbmVudHMuc291cmNlLnR5cGUucmVlYmVlX2FwcC5SZWViZWVBcHBIAEINCgthcHBsaWNhdGlvbmIGcHJvdG8z", [
    Al,
    _l,
    hl,
    Gl,
    Bl,
    Il
]), Zn = /* @__PURE__ */ i("Ci1ldmVudHNfdjEvY29tcG9uZW50cy9zb3VyY2UvZW52aXJvbm1lbnQucHJvdG8SG2V2ZW50c192MS5jb21wb25lbnRzLnNvdXJjZSp5CgtFbnZpcm9ubWVudBIbChdFTlZJUk9OTUVOVF9VTlNQRUNJRklFRBAAEhoKFkVOVklST05NRU5UX1BST0RVQ1RJT04QARIbChdFTlZJUk9OTUVOVF9ERVZFTE9QTUVOVBACEhQKEEVOVklST05NRU5UX1RFU1QQA2IGcHJvdG8z"), Sl = /* @__PURE__ */ b(Zn, 0), Bc = /* @__PURE__ */ f(Sl), Nn = /* @__PURE__ */ i("CihldmVudHNfdjEvY29tcG9uZW50cy9zb3VyY2Uvc291cmNlLnByb3RvEhtldmVudHNfdjEuY29tcG9uZW50cy5zb3VyY2Ui7QEKBlNvdXJjZRI6CgR0eXBlGAEgASgLMiwuZXZlbnRzX3YxLmNvbXBvbmVudHMuc291cmNlLnR5cGUuU291cmNlVHlwZRI9CgtlbnZpcm9ubWVudBgCIAEoDjIoLmV2ZW50c192MS5jb21wb25lbnRzLnNvdXJjZS5FbnZpcm9ubWVudBIUCgd2ZXJzaW9uGAMgASgJSACIAQESEwoGYXBwX2lkGAQgASgJSAGIAQESFwoKaW5zdGFsbF9pZBgFIAEoCUgCiAEBQgoKCF92ZXJzaW9uQgkKB19hcHBfaWRCDQoLX2luc3RhbGxfaWRiBnByb3RvMw", [
    Xl,
    Zn
]), gn = /* @__PURE__ */ i("CipldmVudHNfdjEvY29tcG9uZW50cy9zZXNzaW9uL3Nlc3Npb24ucHJvdG8SHGV2ZW50c192MS5jb21wb25lbnRzLnNlc3Npb24iFQoHU2Vzc2lvbhIKCgJpZBgBIAEoCWIGcHJvdG8z"), vn = /* @__PURE__ */ i("CjBldmVudHNfdjEvY29tcG9uZW50cy9kZXZpY2UvZGV2aWNlX2lkX3R5cGUucHJvdG8SG2V2ZW50c192MS5jb21wb25lbnRzLmRldmljZSpnCgxEZXZpY2VJRFR5cGUSHgoaREVWSUNFX0lEX1RZUEVfVU5TUEVDSUZJRUQQABIeChpERVZJQ0VfSURfVFlQRV9BRFZFUlRJU0lORxABEhcKE0RFVklDRV9JRF9UWVBFX1VVSUQQAmIGcHJvdG8z"), Yl = /* @__PURE__ */ b(vn, 0), Ic = /* @__PURE__ */ f(Yl), yn = /* @__PURE__ */ i("Ci1ldmVudHNfdjEvY29tcG9uZW50cy9kZXZpY2UvZGV2aWNlX3R5cGUucHJvdG8SG2V2ZW50c192MS5jb21wb25lbnRzLmRldmljZSqUAQoKRGV2aWNlVHlwZRIbChdERVZJQ0VfVFlQRV9VTlNQRUNJRklFRBAAEhYKEkRFVklDRV9UWVBFX01PQklMRRABEhYKEkRFVklDRV9UWVBFX1RBQkxFVBACEiAKHERFVklDRV9UWVBFX01PQklMRV9PUl9UQUJMRVQQAxIXChNERVZJQ0VfVFlQRV9ERVNLVE9QEARiBnByb3RvMw"), Ul = /* @__PURE__ */ b(yn, 0), Xc = /* @__PURE__ */ f(Ul), An = /* @__PURE__ */ i("Ci1ldmVudHNfdjEvY29tcG9uZW50cy9kZXZpY2Uvb3JpZW50YXRpb24ucHJvdG8SG2V2ZW50c192MS5jb21wb25lbnRzLmRldmljZSpfCgtPcmllbnRhdGlvbhIbChdPUklFTlRBVElPTl9VTlNQRUNJRklFRBAAEhgKFE9SSUVOVEFUSU9OX1BPUlRSQUlUEAESGQoVT1JJRU5UQVRJT05fTEFORFNDQVBFEAJiBnByb3RvMw"), Wl = /* @__PURE__ */ b(An, 0), Sc = /* @__PURE__ */ f(Wl), _n = /* @__PURE__ */ i("CipldmVudHNfdjEvY29tcG9uZW50cy9kZXZpY2UvcGxhdGZvcm0ucHJvdG8SG2V2ZW50c192MS5jb21wb25lbnRzLmRldmljZSpeCghQbGF0Zm9ybRIYChRQTEFURk9STV9VTlNQRUNJRklFRBAAEhQKEFBMQVRGT1JNX0FORFJPSUQQARIQCgxQTEFURk9STV9JT1MQAhIQCgxQTEFURk9STV9XRUIQA2IGcHJvdG8z"), Fl = /* @__PURE__ */ b(_n, 0), Yc = /* @__PURE__ */ f(Fl), hn = /* @__PURE__ */ i("CiJldmVudHNfdjEvY29tcG9uZW50cy91aS9zaXplLnByb3RvEhdldmVudHNfdjEuY29tcG9uZW50cy51aSIlCgRTaXplEg0KBXdpZHRoGAEgASgCEg4KBmhlaWdodBgCIAEoAmIGcHJvdG8z"), Tl = /* @__PURE__ */ i("CipldmVudHNfdjEvY29tcG9uZW50cy9kZXZpY2Uvdmlld3BvcnQucHJvdG8SG2V2ZW50c192MS5jb21wb25lbnRzLmRldmljZSKVAQoIVmlld3BvcnQSKwoEc2l6ZRgBIAEoCzIdLmV2ZW50c192MS5jb21wb25lbnRzLnVpLlNpemUSNwoLaWZyYW1lX3NpemUYAiABKAsyHS5ldmVudHNfdjEuY29tcG9uZW50cy51aS5TaXplSACIAQESEwoLcGl4ZWxfcmF0aW8YAyABKAJCDgoMX2lmcmFtZV9zaXplYgZwcm90bzM", [
    hn
]), Gn = /* @__PURE__ */ i("CihldmVudHNfdjEvY29tcG9uZW50cy9kZXZpY2UvZGV2aWNlLnByb3RvEhtldmVudHNfdjEuY29tcG9uZW50cy5kZXZpY2UingQKBkRldmljZRIPCgJpZBgBIAEoCUgAiAEBEj8KB2lkX3R5cGUYAiABKA4yKS5ldmVudHNfdjEuY29tcG9uZW50cy5kZXZpY2UuRGV2aWNlSURUeXBlSAGIAQESNQoEdHlwZRgDIAEoDjInLmV2ZW50c192MS5jb21wb25lbnRzLmRldmljZS5EZXZpY2VUeXBlEjcKCHBsYXRmb3JtGAwgASgOMiUuZXZlbnRzX3YxLmNvbXBvbmVudHMuZGV2aWNlLlBsYXRmb3JtEg8KB29zX25hbWUYBCABKAkSEgoKb3NfdmVyc2lvbhgFIAEoCRISCgVtb2RlbBgGIAEoCUgCiAEBEhMKBmxvY2FsZRgHIAEoCUgDiAEBEjwKCHZpZXdwb3J0GAggASgLMiUuZXZlbnRzX3YxLmNvbXBvbmVudHMuZGV2aWNlLlZpZXdwb3J0SASIAQESPQoLb3JpZW50YXRpb24YCSABKA4yKC5ldmVudHNfdjEuY29tcG9uZW50cy5kZXZpY2UuT3JpZW50YXRpb24SFAoHYnJvd3NlchgKIAEoCUgFiAEBEhwKD2Jyb3dzZXJfdmVyc2lvbhgLIAEoCUgGiAEBQgUKA19pZEIKCghfaWRfdHlwZUIICgZfbW9kZWxCCQoHX2xvY2FsZUILCglfdmlld3BvcnRCCgoIX2Jyb3dzZXJCEgoQX2Jyb3dzZXJfdmVyc2lvbmIGcHJvdG8z", [
    vn,
    yn,
    An,
    _n,
    Tl
]), Bn = /* @__PURE__ */ i("CjNldmVudHNfdjEvY29tcG9uZW50cy9sb2NhdGlvbi9sb2NhdGlvbl9zb3VyY2UucHJvdG8SHWV2ZW50c192MS5jb21wb25lbnRzLmxvY2F0aW9uKrkBCg5Mb2NhdGlvblNvdXJjZRIfChtMT0NBVElPTl9TT1VSQ0VfVU5TUEVDSUZJRUQQABIhCh1MT0NBVElPTl9TT1VSQ0VfVVNFUl9TVVBQTElFRBABEhkKFUxPQ0FUSU9OX1NPVVJDRV9HRU9JUBACEigKJExPQ0FUSU9OX1NPVVJDRV9BUFBMSUNBVElPTl9TRVRUSU5HUxADEh4KGkxPQ0FUSU9OX1NPVVJDRV9BVVRPTE9DQVRFEARiBnByb3RvMw"), Ll = /* @__PURE__ */ b(Bn, 0), Uc = /* @__PURE__ */ f(Ll), Cl = /* @__PURE__ */ i("Chhnb29nbGUvdHlwZS9sYXRsbmcucHJvdG8SC2dvb2dsZS50eXBlIi0KBkxhdExuZxIQCghsYXRpdHVkZRgBIAEoARIRCglsb25naXR1ZGUYAiABKAFCYwoPY29tLmdvb2dsZS50eXBlQgtMYXRMbmdQcm90b1ABWjhnb29nbGUuZ29sYW5nLm9yZy9nZW5wcm90by9nb29nbGVhcGlzL3R5cGUvbGF0bG5nO2xhdGxuZ/gBAaICA0dUUGIGcHJvdG8z"), In = /* @__PURE__ */ i("CjFldmVudHNfdjEvY29tcG9uZW50cy9kZXZpY2UvZGV2aWNlX2xvY2F0aW9uLnByb3RvEhtldmVudHNfdjEuY29tcG9uZW50cy5kZXZpY2Ui0AIKDkRldmljZUxvY2F0aW9uEi0KC2Nvb3JkaW5hdGVzGAEgASgLMhMuZ29vZ2xlLnR5cGUuTGF0TG5nSACIAQESKAobY29vcmRpbmF0ZXNfYWNjdXJhY3lfbWV0ZXJzGAMgASgBSAGIAQESGAoLcG9zdGFsX2NvZGUYAiABKAlIAogBARIZCgxjb3VudHJ5X2NvZGUYBiABKAlIA4gBARJLCg9sb2NhdGlvbl9zb3VyY2UYByABKA4yLS5ldmVudHNfdjEuY29tcG9uZW50cy5sb2NhdGlvbi5Mb2NhdGlvblNvdXJjZUgEiAEBQg4KDF9jb29yZGluYXRlc0IeChxfY29vcmRpbmF0ZXNfYWNjdXJhY3lfbWV0ZXJzQg4KDF9wb3N0YWxfY29kZUIPCg1fY291bnRyeV9jb2RlQhIKEF9sb2NhdGlvbl9zb3VyY2ViBnByb3RvMw", [
    Bn,
    Cl
]), Xn = /* @__PURE__ */ i("Ci1ldmVudHNfdjEvY29tcG9uZW50cy91c2VyL3VzZXJfcHJvdmlkZXIucHJvdG8SGWV2ZW50c192MS5jb21wb25lbnRzLnVzZXIqfwoMVXNlclByb3ZpZGVyEh0KGVVTRVJfUFJPVklERVJfVU5TUEVDSUZJRUQQABIXChNVU0VSX1BST1ZJREVSX0ZMSVBQEAESGwoXVVNFUl9QUk9WSURFUl9TSE9QRlVMTFkQAhIaChZVU0VSX1BST1ZJREVSX05BVElWRV9YEANiBnByb3RvMw"), wl = /* @__PURE__ */ b(Xn, 0), Wc = /* @__PURE__ */ f(wl), Sn = /* @__PURE__ */ i("CiRldmVudHNfdjEvY29tcG9uZW50cy91c2VyL3VzZXIucHJvdG8SGWV2ZW50c192MS5jb21wb25lbnRzLnVzZXIirQEKBFVzZXISCgoCaWQYASABKAkSHQoQaXNfYXV0aGVudGljYXRlZBgCIAEoCEgAiAEBEjkKCHByb3ZpZGVyGAMgASgOMicuZXZlbnRzX3YxLmNvbXBvbmVudHMudXNlci5Vc2VyUHJvdmlkZXISGQoMYW5vbnltb3VzX2lkGAQgASgJSAGIAQFCEwoRX2lzX2F1dGhlbnRpY2F0ZWRCDwoNX2Fub255bW91c19pZGIGcHJvdG8z", [
    Xn
]), Jl = /* @__PURE__ */ i("ChZldmVudHNfdjEvaGVhZGVyLnByb3RvEglldmVudHNfdjEi9wIKBkhlYWRlchI4CgZzb3VyY2UYASABKAsyIy5ldmVudHNfdjEuY29tcG9uZW50cy5zb3VyY2UuU291cmNlSACIAQESOwoHc2Vzc2lvbhgCIAEoCzIlLmV2ZW50c192MS5jb21wb25lbnRzLnNlc3Npb24uU2Vzc2lvbkgBiAEBEjgKBmRldmljZRgDIAEoCzIjLmV2ZW50c192MS5jb21wb25lbnRzLmRldmljZS5EZXZpY2VIAogBARJJCg9kZXZpY2VfbG9jYXRpb24YBCABKAsyKy5ldmVudHNfdjEuY29tcG9uZW50cy5kZXZpY2UuRGV2aWNlTG9jYXRpb25IA4gBARIyCgR1c2VyGAUgASgLMh8uZXZlbnRzX3YxLmNvbXBvbmVudHMudXNlci5Vc2VySASIAQFCCQoHX3NvdXJjZUIKCghfc2Vzc2lvbkIJCgdfZGV2aWNlQhIKEF9kZXZpY2VfbG9jYXRpb25CBwoFX3VzZXJiBnByb3RvMw", [
    Nn,
    gn,
    Gn,
    In,
    Sn
]), fe = /* @__PURE__ */ i("CixldmVudHNfdjEvY29tcG9uZW50cy9hZC9hZF9pZF9wcm92aWRlci5wcm90bxIXZXZlbnRzX3YxLmNvbXBvbmVudHMuYWQqegoMQWRJRFByb3ZpZGVyEh4KGkFEX0lEX1BST1ZJREVSX1VOU1BFQ0lGSUVEEAASGAoUQURfSURfUFJPVklERVJfS0VWRUwQARIYChRBRF9JRF9QUk9WSURFUl9GTElQUBACEhYKEkFEX0lEX1BST1ZJREVSX0dBTRADYgZwcm90bzM"), Hl = /* @__PURE__ */ b(fe, 0), Fc = /* @__PURE__ */ f(Hl), jl = /* @__PURE__ */ i("CiZldmVudHNfdjEvY29tcG9uZW50cy9hZC9jYW1wYWlnbi5wcm90bxIXZXZlbnRzX3YxLmNvbXBvbmVudHMuYWQijQIKCENhbXBhaWduEjcKCHByb3ZpZGVyGAEgASgOMiUuZXZlbnRzX3YxLmNvbXBvbmVudHMuYWQuQWRJRFByb3ZpZGVyEhgKC2NhbXBhaWduX2lkGAIgASgJSACIAQESGAoLY3JlYXRpdmVfaWQYAyABKAlIAYgBARIaCg1hZHZlcnRpc2VyX2lkGAQgASgJSAKIAQESFgoJZmxpZ2h0X2lkGAUgASgJSAOIAQESFAoHZGVhbF9pZBgMIAEoCUgEiAEBQg4KDF9jYW1wYWlnbl9pZEIOCgxfY3JlYXRpdmVfaWRCEAoOX2FkdmVydGlzZXJfaWRCDAoKX2ZsaWdodF9pZEIKCghfZGVhbF9pZGIGcHJvdG8z", [
    fe
]), Ql = /* @__PURE__ */ i("CiFldmVudHNfdjEvY29tcG9uZW50cy9hZC9hcHAucHJvdG8SF2V2ZW50c192MS5jb21wb25lbnRzLmFkIoMBCgNBcHASCgoCaWQYASABKAkSEQoEbmFtZRgCIAEoCUgAiAEBEg4KBmJ1bmRsZRgDIAEoCRITCgZkb21haW4YBCABKAlIAYgBARIWCglzdG9yZV91cmwYBSABKAlIAogBAUIHCgVfbmFtZUIJCgdfZG9tYWluQgwKCl9zdG9yZV91cmxiBnByb3RvMw"), kl = /* @__PURE__ */ i("CiJldmVudHNfdjEvY29tcG9uZW50cy9hZC9zaXRlLnByb3RvEhdldmVudHNfdjEuY29tcG9uZW50cy5hZCKJAQoEU2l0ZRIKCgJpZBgBIAEoCRIMCgRuYW1lGAIgASgJEg4KBmRvbWFpbhgDIAEoCRIMCgRwYWdlGAQgASgJEhAKCHJlZmVycmVyGAUgASgJEg4KBnNlYXJjaBgGIAEoCRIQCghrZXl3b3JkcxgHIAEoCRIVCg1rZXl3b3JkX2FycmF5GAggAygJYgZwcm90bzM"), Ml = /* @__PURE__ */ i("CjJldmVudHNfdjEvY29tcG9uZW50cy9hZC9kaXN0cmlidXRpb25fY2hhbm5lbC5wcm90bxIXZXZlbnRzX3YxLmNvbXBvbmVudHMuYWQifAoTRGlzdHJpYnV0aW9uQ2hhbm5lbBItCgRzaXRlGAEgASgLMh0uZXZlbnRzX3YxLmNvbXBvbmVudHMuYWQuU2l0ZUgAEisKA2FwcBgCIAEoCzIcLmV2ZW50c192MS5jb21wb25lbnRzLmFkLkFwcEgAQgkKB2NoYW5uZWxiBnByb3RvMw", [
    Ql,
    kl
]), zl = /* @__PURE__ */ i("CidldmVudHNfdjEvY29tcG9uZW50cy9hZC9wdWJsaXNoZXIucHJvdG8SF2V2ZW50c192MS5jb21wb25lbnRzLmFkIpIDCglQdWJsaXNoZXISNwoIcHJvdmlkZXIYASABKA4yJS5ldmVudHNfdjEuY29tcG9uZW50cy5hZC5BZElEUHJvdmlkZXISGQoMcHVibGlzaGVyX2lkGAIgASgJSACIAQESEwoGZG9tYWluGAMgASgJSAGIAQESFAoHc2xvdF9pZBgEIAEoCUgCiAEBEh0KEGludGVncmF0aW9uX3R5cGUYBSABKAlIA4gBARIcCg9hdHRyaWJ1dGlvbl90YWcYBiABKAlIBIgBARIUCgdkZWFsX2lkGAkgASgJSAWIAQESSgoUZGlzdHJpYnV0aW9uX2NoYW5uZWwYCiABKAsyLC5ldmVudHNfdjEuY29tcG9uZW50cy5hZC5EaXN0cmlidXRpb25DaGFubmVsQg8KDV9wdWJsaXNoZXJfaWRCCQoHX2RvbWFpbkIKCghfc2xvdF9pZEITChFfaW50ZWdyYXRpb25fdHlwZUISChBfYXR0cmlidXRpb25fdGFnQgoKCF9kZWFsX2lkSgQIBxAISgQICBAJYgZwcm90bzM", [
    fe,
    Ml
]), Yn = /* @__PURE__ */ i("CiVldmVudHNfdjEvY29tcG9uZW50cy9hZC9hZF9zaWRlLnByb3RvEhdldmVudHNfdjEuY29tcG9uZW50cy5hZCpJCgZBZFNpZGUSFwoTQURfU0lERV9VTlNQRUNJRklFRBAAEhIKDkFEX1NJREVfU1VQUExZEAESEgoOQURfU0lERV9ERU1BTkQQAmIGcHJvdG8z"), Un = /* @__PURE__ */ i("CiNldmVudHNfdjEvY29tcG9uZW50cy9hZC9wcmljZS5wcm90bxIXZXZlbnRzX3YxLmNvbXBvbmVudHMuYWQiswEKBVByaWNlEjoKCXJhdGVfdHlwZRgBIAEoDjInLmV2ZW50c192MS5jb21wb25lbnRzLmFkLlByaWNlLlJhdGVUeXBlEg0KBXByaWNlGAIgASgBEhIKCmVjcG1fcHJpY2UYAyABKAEiSwoIUmF0ZVR5cGUSGQoVUkFURV9UWVBFX1VOU1BFQ0lGSUVEEAASEQoNUkFURV9UWVBFX0NQTRABEhEKDVJBVEVfVFlQRV9DUEMQAmIGcHJvdG8z"), xl = /* @__PURE__ */ i("CiBldmVudHNfdjEvY29tcG9uZW50cy9hZC9hZC5wcm90bxIXZXZlbnRzX3YxLmNvbXBvbmVudHMuYWQiqQMKAkFkEjUKCXB1Ymxpc2hlchgBIAEoCzIiLmV2ZW50c192MS5jb21wb25lbnRzLmFkLlB1Ymxpc2hlchI4CghjYW1wYWlnbhgCIAEoCzIhLmV2ZW50c192MS5jb21wb25lbnRzLmFkLkNhbXBhaWduSACIAQESGwoOb3Bwb3J0dW5pdHlfaWQYAyABKAlIAYgBARIYCgtkZWNpc2lvbl9pZBgEIAEoCUgCiAEBEjIKBHNpZGUYBSABKA4yHy5ldmVudHNfdjEuY29tcG9uZW50cy5hZC5BZFNpZGVIA4gBARIaCg1leGNoYW5nZV9uYW1lGAYgASgJSASIAQESFQoIZHNwX25hbWUYByABKAlIBYgBARIyCgVwcmljZRgIIAEoCzIeLmV2ZW50c192MS5jb21wb25lbnRzLmFkLlByaWNlSAaIAQFCCwoJX2NhbXBhaWduQhEKD19vcHBvcnR1bml0eV9pZEIOCgxfZGVjaXNpb25faWRCBwoFX3NpZGVCEAoOX2V4Y2hhbmdlX25hbWVCCwoJX2RzcF9uYW1lQggKBl9wcmljZWIGcHJvdG8z", [
    jl,
    zl,
    Yn,
    Un
]), Wn = /* @__PURE__ */ i("CkVldmVudHNfdjEvY29tcG9uZW50cy9hY3Rpb24vdHlwZS9hZF9kZWNpc2lvbi9hZF9kZWNpc2lvbl9zdGF0dXMucHJvdG8SLGV2ZW50c192MS5jb21wb25lbnRzLmFjdGlvbi50eXBlLmFkX2RlY2lzaW9uKpgBChBBZERlY2lzaW9uU3RhdHVzEiIKHkFEX0RFQ0lTSU9OX1NUQVRVU19VTlNQRUNJRklFRBAAEh4KGkFEX0RFQ0lTSU9OX1NUQVRVU19TVUNDRVNTEAESHgoaQURfREVDSVNJT05fU1RBVFVTX0ZBSUxVUkUQAhIgChxBRF9ERUNJU0lPTl9TVEFUVVNfUkVRVUVTVEVEEANiBnByb3RvMw"), Pl = /* @__PURE__ */ i("Cj5ldmVudHNfdjEvY29tcG9uZW50cy9hY3Rpb24vdHlwZS9hZF9kZWNpc2lvbi9hZF9kZWNpc2lvbi5wcm90bxIsZXZlbnRzX3YxLmNvbXBvbmVudHMuYWN0aW9uLnR5cGUuYWRfZGVjaXNpb24iXAoKQWREZWNpc2lvbhJOCgZzdGF0dXMYASABKA4yPi5ldmVudHNfdjEuY29tcG9uZW50cy5hY3Rpb24udHlwZS5hZF9kZWNpc2lvbi5BZERlY2lzaW9uU3RhdHVzYgZwcm90bzM", [
    Wn
]), $l = /* @__PURE__ */ i("Cj5ldmVudHNfdjEvY29tcG9uZW50cy9hY3Rpb24vdHlwZS9hZGRfdG9fbGlzdC9hZGRfdG9fbGlzdC5wcm90bxIsZXZlbnRzX3YxLmNvbXBvbmVudHMuYWN0aW9uLnR5cGUuYWRkX3RvX2xpc3QiCwoJQWRkVG9MaXN0YgZwcm90bzM"), ql = /* @__PURE__ */ i("CjhldmVudHNfdjEvY29tcG9uZW50cy9hY3Rpb24vdHlwZS9kZXNlbGVjdC9kZXNlbGVjdC5wcm90bxIpZXZlbnRzX3YxLmNvbXBvbmVudHMuYWN0aW9uLnR5cGUuZGVzZWxlY3QiCgoIRGVzZWxlY3RiBnByb3RvMw"), eo = /* @__PURE__ */ i("CkJldmVudHNfdjEvY29tcG9uZW50cy9hY3Rpb24vdHlwZS9lbmdhZ2VkX3Zpc2l0L2VuZ2FnZWRfdmlzaXQucHJvdG8SLmV2ZW50c192MS5jb21wb25lbnRzLmFjdGlvbi50eXBlLmVuZ2FnZWRfdmlzaXQidgoMRW5nYWdlZFZpc2l0Eh4KEXRocmVzaG9sZF92ZXJzaW9uGAEgASgJSACIAQESHAoPZWxhcHNlZF9zZWNvbmRzGAIgASgBSAGIAQFCFAoSX3RocmVzaG9sZF92ZXJzaW9uQhIKEF9lbGFwc2VkX3NlY29uZHNiBnByb3RvMw"), no = /* @__PURE__ */ i("CjRldmVudHNfdjEvY29tcG9uZW50cy9hY3Rpb24vdHlwZS9leHBhbmQvZXhwYW5kLnByb3RvEidldmVudHNfdjEuY29tcG9uZW50cy5hY3Rpb24udHlwZS5leHBhbmQiCAoGRXhwYW5kYgZwcm90bzM"), Fn = /* @__PURE__ */ i("Cj5ldmVudHNfdjEvY29tcG9uZW50cy9hY3Rpb24vdHlwZS9leHBvc3VyZS9leHBvc3VyZV9zdGFnZS5wcm90bxIpZXZlbnRzX3YxLmNvbXBvbmVudHMuYWN0aW9uLnR5cGUuZXhwb3N1cmUqgwEKDUV4cG9zdXJlU3RhZ2USHgoaRVhQT1NVUkVfU1RBR0VfVU5TUEVDSUZJRUQQABIZChVFWFBPU1VSRV9TVEFHRV9TRVJWRUQQARIaChZFWFBPU1VSRV9TVEFHRV9JTl9WSUVXEAISGwoXRVhQT1NVUkVfU1RBR0VfVklFV0FCTEUQA2IGcHJvdG8z"), to = /* @__PURE__ */ b(Fn, 0), wc = /* @__PURE__ */ f(to), lo = /* @__PURE__ */ i("CjhldmVudHNfdjEvY29tcG9uZW50cy9hY3Rpb24vdHlwZS9leHBvc3VyZS9leHBvc3VyZS5wcm90bxIpZXZlbnRzX3YxLmNvbXBvbmVudHMuYWN0aW9uLnR5cGUuZXhwb3N1cmUiYgoIRXhwb3N1cmUSTAoFc3RhZ2UYASABKA4yOC5ldmVudHNfdjEuY29tcG9uZW50cy5hY3Rpb24udHlwZS5leHBvc3VyZS5FeHBvc3VyZVN0YWdlSACIAQFCCAoGX3N0YWdlYgZwcm90bzM", [
    Fn
]), oo = /* @__PURE__ */ i("CjpldmVudHNfdjEvY29tcG9uZW50cy9hY3Rpb24vdHlwZS9oZWFydGJlYXQvaGVhcnRiZWF0LnByb3RvEipldmVudHNfdjEuY29tcG9uZW50cy5hY3Rpb24udHlwZS5oZWFydGJlYXQiPQoJSGVhcnRiZWF0EhwKD2VsYXBzZWRfc2Vjb25kcxgBIAEoAUgAiAEBQhIKEF9lbGFwc2VkX3NlY29uZHNiBnByb3RvMw"), co = /* @__PURE__ */ i("CjRldmVudHNfdjEvY29tcG9uZW50cy9hY3Rpb24vdHlwZS9pbnZva2UvaW52b2tlLnByb3RvEidldmVudHNfdjEuY29tcG9uZW50cy5hY3Rpb24udHlwZS5pbnZva2UiCAoGSW52b2tlYgZwcm90bzM"), uo = /* @__PURE__ */ i("CjBldmVudHNfdjEvY29tcG9uZW50cy9hY3Rpb24vdHlwZS9vcGVuL29wZW4ucHJvdG8SJWV2ZW50c192MS5jb21wb25lbnRzLmFjdGlvbi50eXBlLm9wZW4iPAoET3BlbhIeChF0aHJlc2hvbGRfdmVyc2lvbhgBIAEoCUgAiAEBQhQKEl90aHJlc2hvbGRfdmVyc2lvbmIGcHJvdG8z"), ao = /* @__PURE__ */ i("CkhldmVudHNfdjEvY29tcG9uZW50cy9hY3Rpb24vdHlwZS9yZW1vdmVfZnJvbV9saXN0L3JlbW92ZV9mcm9tX2xpc3QucHJvdG8SMWV2ZW50c192MS5jb21wb25lbnRzLmFjdGlvbi50eXBlLnJlbW92ZV9mcm9tX2xpc3QiEAoOUmVtb3ZlRnJvbUxpc3RiBnByb3RvMw"), so = /* @__PURE__ */ i("CjZldmVudHNfdjEvY29tcG9uZW50cy9hY3Rpb24vdHlwZS9yZXF1ZXN0L3JlcXVlc3QucHJvdG8SKGV2ZW50c192MS5jb21wb25lbnRzLmFjdGlvbi50eXBlLnJlcXVlc3QiCQoHUmVxdWVzdGIGcHJvdG8z"), io = /* @__PURE__ */ i("CjRldmVudHNfdjEvY29tcG9uZW50cy9hY3Rpb24vdHlwZS9zZWxlY3Qvc2VsZWN0LnByb3RvEidldmVudHNfdjEuY29tcG9uZW50cy5hY3Rpb24udHlwZS5zZWxlY3QiCAoGU2VsZWN0YgZwcm90bzM"), mo = /* @__PURE__ */ i("CjdldmVudHNfdjEvY29tcG9uZW50cy9hY3Rpb24vdHlwZS9zaGFyZS9zaGFyZV9tb2RlLnByb3RvEiZldmVudHNfdjEuY29tcG9uZW50cy5hY3Rpb24udHlwZS5zaGFyZSr4AQoJU2hhcmVNb2RlEhoKFlNIQVJFX01PREVfVU5TUEVDSUZJRUQQABITCg9TSEFSRV9NT0RFX0xJTksQARISCg5TSEFSRV9NT0RFX1NNUxACEhQKEFNIQVJFX01PREVfRU1BSUwQAxIXChNTSEFSRV9NT0RFX0ZBQ0VCT09LEAQSFQoRU0hBUkVfTU9ERV9HT09HTEUQBRIWChJTSEFSRV9NT0RFX1RXSVRURVIQBhIYChRTSEFSRV9NT0RFX0lOU1RBR1JBTRAHEhQKEFNIQVJFX01PREVfT1RIRVIQCBIYChRTSEFSRV9NT0RFX1BJTlRFUkVTVBAJYgZwcm90bzM"), ro = /* @__PURE__ */ i("CjJldmVudHNfdjEvY29tcG9uZW50cy9hY3Rpb24vdHlwZS9zaGFyZS9zaGFyZS5wcm90bxImZXZlbnRzX3YxLmNvbXBvbmVudHMuYWN0aW9uLnR5cGUuc2hhcmUicAoFU2hhcmUSPwoEbW9kZRgBIAEoDjIxLmV2ZW50c192MS5jb21wb25lbnRzLmFjdGlvbi50eXBlLnNoYXJlLlNoYXJlTW9kZRIXCgpzaGFyZWRfdXJsGAIgASgJSACIAQFCDQoLX3NoYXJlZF91cmxiBnByb3RvMw", [
    mo
]), bo = /* @__PURE__ */ i("CjRldmVudHNfdjEvY29tcG9uZW50cy9hY3Rpb24vdHlwZS9zdWJtaXQvc3VibWl0LnByb3RvEidldmVudHNfdjEuY29tcG9uZW50cy5hY3Rpb24udHlwZS5zdWJtaXQiCAoGU3VibWl0YgZwcm90bzM"), fo = /* @__PURE__ */ i("ClBldmVudHNfdjEvY29tcG9uZW50cy9hY3Rpb24vdHlwZS90cmFuc2Zlcl90b19tZXJjaGFudC90cmFuc2Zlcl90b19tZXJjaGFudC5wcm90bxI1ZXZlbnRzX3YxLmNvbXBvbmVudHMuYWN0aW9uLnR5cGUudHJhbnNmZXJfdG9fbWVyY2hhbnQiFAoSVHJhbnNmZXJUb01lcmNoYW50YgZwcm90bzM"), Eo = /* @__PURE__ */ i("CjRldmVudHNfdjEvY29tcG9uZW50cy9hY3Rpb24vdHlwZS91cGRhdGUvdXBkYXRlLnByb3RvEidldmVudHNfdjEuY29tcG9uZW50cy5hY3Rpb24udHlwZS51cGRhdGUiCAoGVXBkYXRlYgZwcm90bzM"), Vo = /* @__PURE__ */ i("CjJldmVudHNfdjEvY29tcG9uZW50cy9hY3Rpb24vdHlwZS9hY3Rpb25fdHlwZS5wcm90bxIgZXZlbnRzX3YxLmNvbXBvbmVudHMuYWN0aW9uLnR5cGUiyAkKCkFjdGlvblR5cGUSRwoIZXhwb3N1cmUYASABKAsyMy5ldmVudHNfdjEuY29tcG9uZW50cy5hY3Rpb24udHlwZS5leHBvc3VyZS5FeHBvc3VyZUgAEjsKBG9wZW4YAiABKAsyKy5ldmVudHNfdjEuY29tcG9uZW50cy5hY3Rpb24udHlwZS5vcGVuLk9wZW5IABJKCgloZWFydGJlYXQYAyABKAsyNS5ldmVudHNfdjEuY29tcG9uZW50cy5hY3Rpb24udHlwZS5oZWFydGJlYXQuSGVhcnRiZWF0SAASTwoLYWRfZGVjaXNpb24YBCABKAsyOC5ldmVudHNfdjEuY29tcG9uZW50cy5hY3Rpb24udHlwZS5hZF9kZWNpc2lvbi5BZERlY2lzaW9uSAASVQoNZW5nYWdlZF92aXNpdBgFIAEoCzI8LmV2ZW50c192MS5jb21wb25lbnRzLmFjdGlvbi50eXBlLmVuZ2FnZWRfdmlzaXQuRW5nYWdlZFZpc2l0SAASTgoLYWRkX3RvX2xpc3QYBiABKAsyNy5ldmVudHNfdjEuY29tcG9uZW50cy5hY3Rpb24udHlwZS5hZGRfdG9fbGlzdC5BZGRUb0xpc3RIABJdChByZW1vdmVfZnJvbV9saXN0GAcgASgLMkEuZXZlbnRzX3YxLmNvbXBvbmVudHMuYWN0aW9uLnR5cGUucmVtb3ZlX2Zyb21fbGlzdC5SZW1vdmVGcm9tTGlzdEgAEkEKBnNlbGVjdBgIIAEoCzIvLmV2ZW50c192MS5jb21wb25lbnRzLmFjdGlvbi50eXBlLnNlbGVjdC5TZWxlY3RIABJHCghkZXNlbGVjdBgJIAEoCzIzLmV2ZW50c192MS5jb21wb25lbnRzLmFjdGlvbi50eXBlLmRlc2VsZWN0LkRlc2VsZWN0SAASQQoGZXhwYW5kGAogASgLMi8uZXZlbnRzX3YxLmNvbXBvbmVudHMuYWN0aW9uLnR5cGUuZXhwYW5kLkV4cGFuZEgAEkEKBmludm9rZRgLIAEoCzIvLmV2ZW50c192MS5jb21wb25lbnRzLmFjdGlvbi50eXBlLmludm9rZS5JbnZva2VIABJpChR0cmFuc2Zlcl90b19tZXJjaGFudBgMIAEoCzJJLmV2ZW50c192MS5jb21wb25lbnRzLmFjdGlvbi50eXBlLnRyYW5zZmVyX3RvX21lcmNoYW50LlRyYW5zZmVyVG9NZXJjaGFudEgAEj4KBXNoYXJlGA0gASgLMi0uZXZlbnRzX3YxLmNvbXBvbmVudHMuYWN0aW9uLnR5cGUuc2hhcmUuU2hhcmVIABJBCgZ1cGRhdGUYDiABKAsyLy5ldmVudHNfdjEuY29tcG9uZW50cy5hY3Rpb24udHlwZS51cGRhdGUuVXBkYXRlSAASRAoHcmVxdWVzdBgPIAEoCzIxLmV2ZW50c192MS5jb21wb25lbnRzLmFjdGlvbi50eXBlLnJlcXVlc3QuUmVxdWVzdEgAEkEKBnN1Ym1pdBgQIAEoCzIvLmV2ZW50c192MS5jb21wb25lbnRzLmFjdGlvbi50eXBlLnN1Ym1pdC5TdWJtaXRIAEIICgZhY3Rpb25iBnByb3RvMw", [
    Pl,
    $l,
    ql,
    eo,
    no,
    lo,
    oo,
    co,
    uo,
    ao,
    so,
    io,
    ro,
    bo,
    fo,
    Eo
]), Ro = /* @__PURE__ */ i("CihldmVudHNfdjEvY29tcG9uZW50cy9hY3Rpb24vYWN0aW9uLnByb3RvEhtldmVudHNfdjEuY29tcG9uZW50cy5hY3Rpb24iRAoGQWN0aW9uEjoKBHR5cGUYASABKAsyLC5ldmVudHNfdjEuY29tcG9uZW50cy5hY3Rpb24udHlwZS5BY3Rpb25UeXBlYgZwcm90bzM", [
    Vo
]), po = /* @__PURE__ */ i("CihldmVudHNfdjEvY29tcG9uZW50cy9iYXNlL21ldGFkYXRhLnByb3RvEhlldmVudHNfdjEuY29tcG9uZW50cy5iYXNlIngKCE1ldGFkYXRhEh0KEGlzX2RvdWJsZV9maXJpbmcYASABKAhIAIgBARIgChNvcmlnaW5hbF9ldmVudF9uYW1lGAIgASgJSAGIAQFCEwoRX2lzX2RvdWJsZV9maXJpbmdCFgoUX29yaWdpbmFsX2V2ZW50X25hbWViBnByb3RvMw"), Zo = /* @__PURE__ */ i("CiRldmVudHNfdjEvY29tcG9uZW50cy9iYXNlL2Jhc2UucHJvdG8SGWV2ZW50c192MS5jb21wb25lbnRzLmJhc2UiigEKBEJhc2USCgoCaWQYASABKAkSGAoQY2xpZW50X3RpbWVzdGFtcBgCIAEoARITCgtzZXF1ZW5jZV9pZBgDIAEoAxI6CghtZXRhZGF0YRgEIAEoCzIjLmV2ZW50c192MS5jb21wb25lbnRzLmJhc2UuTWV0YWRhdGFIAIgBAUILCglfbWV0YWRhdGFiBnByb3RvMw", [
    po
]), No = /* @__PURE__ */ i("CjpldmVudHNfdjEvY29tcG9uZW50cy9pbnRlcmFjdGlvbi90eXBlL2F1dG9fdHJpZ2dlcmVkLnByb3RvEiVldmVudHNfdjEuY29tcG9uZW50cy5pbnRlcmFjdGlvbi50eXBlIg8KDUF1dG9UcmlnZ2VyZWRiBnByb3RvMw"), go = /* @__PURE__ */ i("CjFldmVudHNfdjEvY29tcG9uZW50cy9pbnRlcmFjdGlvbi90eXBlL2NsaWNrLnByb3RvEiVldmVudHNfdjEuY29tcG9uZW50cy5pbnRlcmFjdGlvbi50eXBlIgcKBUNsaWNrYgZwcm90bzM"), vo = /* @__PURE__ */ i("CjBldmVudHNfdjEvY29tcG9uZW50cy9pbnRlcmFjdGlvbi90eXBlL2RyYWcucHJvdG8SJWV2ZW50c192MS5jb21wb25lbnRzLmludGVyYWN0aW9uLnR5cGUiBgoERHJhZ2IGcHJvdG8z"), yo = /* @__PURE__ */ i("CjZldmVudHNfdjEvY29tcG9uZW50cy9pbnRlcmFjdGlvbi90eXBlL2ltcHJlc3Npb24ucHJvdG8SJWV2ZW50c192MS5jb21wb25lbnRzLmludGVyYWN0aW9uLnR5cGUiDAoKSW1wcmVzc2lvbmIGcHJvdG8z"), Ao = /* @__PURE__ */ i("CjBldmVudHNfdjEvY29tcG9uZW50cy9pbnRlcmFjdGlvbi90eXBlL2xvYWQucHJvdG8SJWV2ZW50c192MS5jb21wb25lbnRzLmludGVyYWN0aW9uLnR5cGUiBgoETG9hZGIGcHJvdG8z"), _o = /* @__PURE__ */ i("CjZldmVudHNfdjEvY29tcG9uZW50cy9pbnRlcmFjdGlvbi90eXBlL2xvbmdfcHJlc3MucHJvdG8SJWV2ZW50c192MS5jb21wb25lbnRzLmludGVyYWN0aW9uLnR5cGUiCwoJTG9uZ1ByZXNzYgZwcm90bzM"), ho = /* @__PURE__ */ i("CjFldmVudHNfdjEvY29tcG9uZW50cy9pbnRlcmFjdGlvbi90eXBlL3N3aXBlLnByb3RvEiVldmVudHNfdjEuY29tcG9uZW50cy5pbnRlcmFjdGlvbi50eXBlImQKBVN3aXBlEk0KCWRpcmVjdGlvbhgBIAEoDjI1LmV2ZW50c192MS5jb21wb25lbnRzLmludGVyYWN0aW9uLnR5cGUuU3dpcGVEaXJlY3Rpb25IAIgBAUIMCgpfZGlyZWN0aW9uKpgBCg5Td2lwZURpcmVjdGlvbhIfChtTV0lQRV9ESVJFQ1RJT05fVU5TUEVDSUZJRUQQABIWChJTV0lQRV9ESVJFQ1RJT05fVVAQARIYChRTV0lQRV9ESVJFQ1RJT05fRE9XThACEhgKFFNXSVBFX0RJUkVDVElPTl9MRUZUEAMSGQoVU1dJUEVfRElSRUNUSU9OX1JJR0hUEARiBnByb3RvMw"), Go = /* @__PURE__ */ i("CjBldmVudHNfdjEvY29tcG9uZW50cy9pbnRlcmFjdGlvbi90eXBlL3ZpZXcucHJvdG8SJWV2ZW50c192MS5jb21wb25lbnRzLmludGVyYWN0aW9uLnR5cGUiBgoEVmlld2IGcHJvdG8z"), Bo = /* @__PURE__ */ i("CjxldmVudHNfdjEvY29tcG9uZW50cy9pbnRlcmFjdGlvbi90eXBlL2ludGVyYWN0aW9uX3R5cGUucHJvdG8SJWV2ZW50c192MS5jb21wb25lbnRzLmludGVyYWN0aW9uLnR5cGUisAQKD0ludGVyYWN0aW9uVHlwZRJOCg5hdXRvX3RyaWdnZXJlZBgBIAEoCzI0LmV2ZW50c192MS5jb21wb25lbnRzLmludGVyYWN0aW9uLnR5cGUuQXV0b1RyaWdnZXJlZEgAEj0KBWNsaWNrGAIgASgLMiwuZXZlbnRzX3YxLmNvbXBvbmVudHMuaW50ZXJhY3Rpb24udHlwZS5DbGlja0gAEkcKCmltcHJlc3Npb24YAyABKAsyMS5ldmVudHNfdjEuY29tcG9uZW50cy5pbnRlcmFjdGlvbi50eXBlLkltcHJlc3Npb25IABI7CgR2aWV3GAQgASgLMisuZXZlbnRzX3YxLmNvbXBvbmVudHMuaW50ZXJhY3Rpb24udHlwZS5WaWV3SAASOwoEbG9hZBgFIAEoCzIrLmV2ZW50c192MS5jb21wb25lbnRzLmludGVyYWN0aW9uLnR5cGUuTG9hZEgAEkYKCmxvbmdfcHJlc3MYBiABKAsyMC5ldmVudHNfdjEuY29tcG9uZW50cy5pbnRlcmFjdGlvbi50eXBlLkxvbmdQcmVzc0gAEjsKBGRyYWcYByABKAsyKy5ldmVudHNfdjEuY29tcG9uZW50cy5pbnRlcmFjdGlvbi50eXBlLkRyYWdIABI9CgVzd2lwZRgIIAEoCzIsLmV2ZW50c192MS5jb21wb25lbnRzLmludGVyYWN0aW9uLnR5cGUuU3dpcGVIAEIHCgVncm91cGIGcHJvdG8z", [
    No,
    go,
    vo,
    yo,
    Ao,
    _o,
    ho,
    Go
]), Io = /* @__PURE__ */ i("CjJldmVudHNfdjEvY29tcG9uZW50cy9pbnRlcmFjdGlvbi9pbnRlcmFjdGlvbi5wcm90bxIgZXZlbnRzX3YxLmNvbXBvbmVudHMuaW50ZXJhY3Rpb24iUwoLSW50ZXJhY3Rpb24SRAoEdHlwZRgBIAEoCzI2LmV2ZW50c192MS5jb21wb25lbnRzLmludGVyYWN0aW9uLnR5cGUuSW50ZXJhY3Rpb25UeXBlYgZwcm90bzM", [
    Bo
]), Xo = /* @__PURE__ */ i("CjhldmVudHNfdjEvY29tcG9uZW50cy9uYXZpZ2F0aW9uL25hdmlnYXRpb25faGFuZGxlci5wcm90bxIfZXZlbnRzX3YxLmNvbXBvbmVudHMubmF2aWdhdGlvbiqdAQoRTmF2aWdhdGlvbkhhbmRsZXISIgoeTkFWSUdBVElPTl9IQU5ETEVSX1VOU1BFQ0lGSUVEEAASHgoaTkFWSUdBVElPTl9IQU5ETEVSX0RFRkFVTFQQARIfChtOQVZJR0FUSU9OX0hBTkRMRVJfV0VCX1ZJRVcQAhIjCh9OQVZJR0FUSU9OX0hBTkRMRVJfRVhURVJOQUxfQVBQEANiBnByb3RvMw"), So = /* @__PURE__ */ i("CjVldmVudHNfdjEvY29tcG9uZW50cy9uYXZpZ2F0aW9uL25hdmlnYXRpb25fdHlwZS5wcm90bxIfZXZlbnRzX3YxLmNvbXBvbmVudHMubmF2aWdhdGlvbiqKAQoOTmF2aWdhdGlvblR5cGUSHwobTkFWSUdBVElPTl9UWVBFX1VOU1BFQ0lGSUVEEAASGgoWTkFWSUdBVElPTl9UWVBFX0lOX0FQUBABEh0KGU5BVklHQVRJT05fVFlQRV9ERUVQX0xJTksQAhIcChhOQVZJR0FUSU9OX1RZUEVfRVhURVJOQUwQA2IGcHJvdG8z"), Yo = /* @__PURE__ */ i("CjBldmVudHNfdjEvY29tcG9uZW50cy9uYXZpZ2F0aW9uL25hdmlnYXRpb24ucHJvdG8SH2V2ZW50c192MS5jb21wb25lbnRzLm5hdmlnYXRpb24ikAEKCk5hdmlnYXRpb24SPQoEdHlwZRgBIAEoDjIvLmV2ZW50c192MS5jb21wb25lbnRzLm5hdmlnYXRpb24uTmF2aWdhdGlvblR5cGUSQwoHaGFuZGxlchgCIAEoDjIyLmV2ZW50c192MS5jb21wb25lbnRzLm5hdmlnYXRpb24uTmF2aWdhdGlvbkhhbmRsZXJiBnByb3RvMw", [
    Xo,
    So
]), Uo = /* @__PURE__ */ i("CihldmVudHNfdjEvY29tcG9uZW50cy9zZWFyY2gvc2VhcmNoLnByb3RvEhtldmVudHNfdjEuY29tcG9uZW50cy5zZWFyY2giJQoGU2VhcmNoEg0KBXF1ZXJ5GAEgASgJEgwKBGd1aWQYAiABKAliBnByb3RvMw"), Tn = /* @__PURE__ */ i("CjlldmVudHNfdjEvY29tcG9uZW50cy90YXJnZXQvZ3JvdXAvYWQvYWRfdGFyZ2V0X3R5cGUucHJvdG8SJGV2ZW50c192MS5jb21wb25lbnRzLnRhcmdldC5ncm91cC5hZCqJAQoMQWRUYXJnZXRUeXBlEh4KGkFEX1RBUkdFVF9UWVBFX1VOU1BFQ0lGSUVEEAASHAoYQURfVEFSR0VUX1RZUEVfUExBQ0VNRU5UEAESHgoaQURfVEFSR0VUX1RZUEVfT1BQT1JUVU5JVFkQAhIbChdBRF9UQVJHRVRfVFlQRV9DUkVBVElWRRADYgZwcm90bzM"), Wo = /* @__PURE__ */ b(Tn, 0), Jc = /* @__PURE__ */ f(Wo), Ln = /* @__PURE__ */ i("CkZldmVudHNfdjEvY29tcG9uZW50cy90YXJnZXQvZ3JvdXAvY29udGVudC9jb250ZW50X3YxX3RhcmdldF90eXBlLnByb3RvEilldmVudHNfdjEuY29tcG9uZW50cy50YXJnZXQuZ3JvdXAuY29udGVudCqGAQoTQ29udGVudFYxVGFyZ2V0VHlwZRImCiJDT05URU5UX1YxX1RBUkdFVF9UWVBFX1VOU1BFQ0lGSUVEEAASIAocQ09OVEVOVF9WMV9UQVJHRVRfVFlQRV9GTFlFUhABEiUKIUNPTlRFTlRfVjFfVEFSR0VUX1RZUEVfRkxZRVJfSVRFTRACYgZwcm90bzM"), Fo = /* @__PURE__ */ b(Ln, 0), Hc = /* @__PURE__ */ f(Fo), Cn = /* @__PURE__ */ i("CkZldmVudHNfdjEvY29tcG9uZW50cy90YXJnZXQvZ3JvdXAvY29udGVudC9jb250ZW50X3YyX3RhcmdldF90eXBlLnByb3RvEilldmVudHNfdjEuY29tcG9uZW50cy50YXJnZXQuZ3JvdXAuY29udGVudCqHAQoTQ29udGVudFYyVGFyZ2V0VHlwZRImCiJDT05URU5UX1YyX1RBUkdFVF9UWVBFX1VOU1BFQ0lGSUVEEAASIAocQ09OVEVOVF9WMl9UQVJHRVRfVFlQRV9PRkZFUhABEiYKIkNPTlRFTlRfVjJfVEFSR0VUX1RZUEVfUFVCTElDQVRJT04QAmIGcHJvdG8z"), To = /* @__PURE__ */ b(Cn, 0), jc = /* @__PURE__ */ f(To), Lo = /* @__PURE__ */ i("CklldmVudHNfdjEvY29tcG9uZW50cy90YXJnZXQvZ3JvdXAvbmF2aWdhdGlvbi9uYXZpZ2F0aW9uX3RhcmdldF90eXBlLnByb3RvEixldmVudHNfdjEuY29tcG9uZW50cy50YXJnZXQuZ3JvdXAubmF2aWdhdGlvbirNAQoUTmF2aWdhdGlvblRhcmdldFR5cGUSJgoiTkFWSUdBVElPTl9UQVJHRVRfVFlQRV9VTlNQRUNJRklFRBAAEiEKHU5BVklHQVRJT05fVEFSR0VUX1RZUEVfSU5fQVBQEAESHwobTkFWSUdBVElPTl9UQVJHRVRfVFlQRV9MSU5LEAISJAogTkFWSUdBVElPTl9UQVJHRVRfVFlQRV9ERUVQX0xJTksQAxIjCh9OQVZJR0FUSU9OX1RBUkdFVF9UWVBFX0VYVEVSTkFMEARiBnByb3RvMw"), Co = /* @__PURE__ */ i("CkNldmVudHNfdjEvY29tcG9uZW50cy90YXJnZXQvZ3JvdXAvbWVzc2FnZS9tZXNzYWdlX3RhcmdldF90eXBlLnByb3RvEilldmVudHNfdjEuY29tcG9uZW50cy50YXJnZXQuZ3JvdXAubWVzc2FnZSpgChFNZXNzYWdlVGFyZ2V0VHlwZRIjCh9NRVNTQUdFX1RBUkdFVF9UWVBFX1VOU1BFQ0lGSUVEEAASJgoiTUVTU0FHRV9UQVJHRVRfVFlQRV9VUEdSQURFX1BST01QVBABYgZwcm90bzM"), wo = /* @__PURE__ */ i("ClFldmVudHNfdjEvY29tcG9uZW50cy90YXJnZXQvZ3JvdXAvc291cmNlX3NldHRpbmcvc291cmNlX3NldHRpbmdfdGFyZ2V0X3R5cGUucHJvdG8SMGV2ZW50c192MS5jb21wb25lbnRzLnRhcmdldC5ncm91cC5zb3VyY2Vfc2V0dGluZypxChdTb3VyY2VTZXR0aW5nVGFyZ2V0VHlwZRIqCiZTT1VSQ0VfU0VUVElOR19UQVJHRVRfVFlQRV9VTlNQRUNJRklFRBAAEioKJlNPVVJDRV9TRVRUSU5HX1RBUkdFVF9UWVBFX1BPU1RBTF9DT0RFEAFiBnByb3RvMw"), wn = /* @__PURE__ */ i("CkFldmVudHNfdjEvY29tcG9uZW50cy90YXJnZXQvZ3JvdXAvc3lzdGVtL3N5c3RlbV90YXJnZXRfdHlwZS5wcm90bxIoZXZlbnRzX3YxLmNvbXBvbmVudHMudGFyZ2V0Lmdyb3VwLnN5c3RlbSpWChBTeXN0ZW1UYXJnZXRUeXBlEiIKHlNZU1RFTV9UQVJHRVRfVFlQRV9VTlNQRUNJRklFRBAAEh4KGlNZU1RFTV9UQVJHRVRfVFlQRV9XRUJTSVRFEAFiBnByb3RvMw"), Jo = /* @__PURE__ */ b(wn, 0), Qc = /* @__PURE__ */ f(Jo), Ho = /* @__PURE__ */ i("CjRldmVudHNfdjEvY29tcG9uZW50cy90YXJnZXQvZ3JvdXAvdGFyZ2V0X2dyb3VwLnByb3RvEiFldmVudHNfdjEuY29tcG9uZW50cy50YXJnZXQuZ3JvdXAi4QQKC1RhcmdldEdyb3VwElQKCmNvbnRlbnRfdjEYASABKA4yPi5ldmVudHNfdjEuY29tcG9uZW50cy50YXJnZXQuZ3JvdXAuY29udGVudC5Db250ZW50VjFUYXJnZXRUeXBlSAASVAoKY29udGVudF92MhgCIAEoDjI+LmV2ZW50c192MS5jb21wb25lbnRzLnRhcmdldC5ncm91cC5jb250ZW50LkNvbnRlbnRWMlRhcmdldFR5cGVIABJACgJhZBgDIAEoDjIyLmV2ZW50c192MS5jb21wb25lbnRzLnRhcmdldC5ncm91cC5hZC5BZFRhcmdldFR5cGVIABJjCg5zb3VyY2Vfc2V0dGluZxgEIAEoDjJJLmV2ZW50c192MS5jb21wb25lbnRzLnRhcmdldC5ncm91cC5zb3VyY2Vfc2V0dGluZy5Tb3VyY2VTZXR0aW5nVGFyZ2V0VHlwZUgAElgKCm5hdmlnYXRpb24YBSABKA4yQi5ldmVudHNfdjEuY29tcG9uZW50cy50YXJnZXQuZ3JvdXAubmF2aWdhdGlvbi5OYXZpZ2F0aW9uVGFyZ2V0VHlwZUgAEk8KB21lc3NhZ2UYBiABKA4yPC5ldmVudHNfdjEuY29tcG9uZW50cy50YXJnZXQuZ3JvdXAubWVzc2FnZS5NZXNzYWdlVGFyZ2V0VHlwZUgAEkwKBnN5c3RlbRgHIAEoDjI6LmV2ZW50c192MS5jb21wb25lbnRzLnRhcmdldC5ncm91cC5zeXN0ZW0uU3lzdGVtVGFyZ2V0VHlwZUgAQgYKBHR5cGViBnByb3RvMw", [
    Tn,
    Ln,
    Cn,
    Lo,
    Co,
    wo,
    wn
]), jo = /* @__PURE__ */ i("Cj9ldmVudHNfdjEvY29tcG9uZW50cy90YXJnZXQvZGV0YWlscy9jb250ZW50L3YxL2ZseWVyX2l0ZW0ucHJvdG8SLmV2ZW50c192MS5jb21wb25lbnRzLnRhcmdldC5kZXRhaWxzLmNvbnRlbnQudjEiFwoJRmx5ZXJJdGVtEgoKAmlkGAEgASgDYgZwcm90bzM"), Qo = /* @__PURE__ */ i("CjpldmVudHNfdjEvY29tcG9uZW50cy90YXJnZXQvZGV0YWlscy9jb250ZW50L3YxL2ZseWVyLnByb3RvEi5ldmVudHNfdjEuY29tcG9uZW50cy50YXJnZXQuZGV0YWlscy5jb250ZW50LnYxIoABCgVGbHllchIKCgJpZBgBIAEoAxIOCgZydW5faWQYAiABKAMSDwoHdHlwZV9pZBgDIAEoAxIVCghzdG9yZV9pZBgEIAEoA0gAiAEBEhcKCmlzX3ByZW1pdW0YBSABKAhIAYgBAUILCglfc3RvcmVfaWRCDQoLX2lzX3ByZW1pdW1iBnByb3RvMw"), ko = /* @__PURE__ */ i("Cj1ldmVudHNfdjEvY29tcG9uZW50cy90YXJnZXQvZGV0YWlscy9jb250ZW50L3YxL21lcmNoYW50LnByb3RvEi5ldmVudHNfdjEuY29tcG9uZW50cy50YXJnZXQuZGV0YWlscy5jb250ZW50LnYxIhYKCE1lcmNoYW50EgoKAmlkGAEgASgDYgZwcm90bzM"), Mo = /* @__PURE__ */ i("CjpldmVudHNfdjEvY29tcG9uZW50cy90YXJnZXQvZGV0YWlscy9jb250ZW50L3YyL29mZmVyLnByb3RvEi5ldmVudHNfdjEuY29tcG9uZW50cy50YXJnZXQuZGV0YWlscy5jb250ZW50LnYyIhMKBU9mZmVyEgoKAmlkGAEgASgJYgZwcm90bzM"), zo = /* @__PURE__ */ i("CkBldmVudHNfdjEvY29tcG9uZW50cy90YXJnZXQvZGV0YWlscy9jb250ZW50L3YyL3B1YmxpY2F0aW9uLnByb3RvEi5ldmVudHNfdjEuY29tcG9uZW50cy50YXJnZXQuZGV0YWlscy5jb250ZW50LnYyIhkKC1B1YmxpY2F0aW9uEgoKAmlkGAEgASgJYgZwcm90bzM"), Oo = /* @__PURE__ */ i("CjlldmVudHNfdjEvY29tcG9uZW50cy90YXJnZXQvZGV0YWlscy9jb250ZW50L2NvbnRlbnQucHJvdG8SK2V2ZW50c192MS5jb21wb25lbnRzLnRhcmdldC5kZXRhaWxzLmNvbnRlbnQiqQEKB0NvbnRlbnQSRwoCdjEYASABKAsyNi5ldmVudHNfdjEuY29tcG9uZW50cy50YXJnZXQuZGV0YWlscy5jb250ZW50LkNvbnRlbnRWMUgAiAEBEkcKAnYyGAIgASgLMjYuZXZlbnRzX3YxLmNvbXBvbmVudHMudGFyZ2V0LmRldGFpbHMuY29udGVudC5Db250ZW50VjJIAYgBAUIFCgNfdjFCBQoDX3YyIqECCglDb250ZW50VjESUgoKZmx5ZXJfaXRlbRgBIAEoCzI5LmV2ZW50c192MS5jb21wb25lbnRzLnRhcmdldC5kZXRhaWxzLmNvbnRlbnQudjEuRmx5ZXJJdGVtSACIAQESSQoFZmx5ZXIYAiABKAsyNS5ldmVudHNfdjEuY29tcG9uZW50cy50YXJnZXQuZGV0YWlscy5jb250ZW50LnYxLkZseWVySAGIAQESTwoIbWVyY2hhbnQYAyABKAsyOC5ldmVudHNfdjEuY29tcG9uZW50cy50YXJnZXQuZGV0YWlscy5jb250ZW50LnYxLk1lcmNoYW50SAKIAQFCDQoLX2ZseWVyX2l0ZW1CCAoGX2ZseWVyQgsKCV9tZXJjaGFudCLHAQoJQ29udGVudFYyEkkKBW9mZmVyGAEgASgLMjUuZXZlbnRzX3YxLmNvbXBvbmVudHMudGFyZ2V0LmRldGFpbHMuY29udGVudC52Mi5PZmZlckgAiAEBElUKC3B1YmxpY2F0aW9uGAIgASgLMjsuZXZlbnRzX3YxLmNvbXBvbmVudHMudGFyZ2V0LmRldGFpbHMuY29udGVudC52Mi5QdWJsaWNhdGlvbkgBiAEBQggKBl9vZmZlckIOCgxfcHVibGljYXRpb25iBnByb3RvMw", [
    jo,
    Qo,
    ko,
    Mo,
    zo
]), Ko = /* @__PURE__ */ i("CkBldmVudHNfdjEvY29tcG9uZW50cy90YXJnZXQvZGV0YWlscy9tZXNzYWdlL3VwZ3JhZGVfcHJvbXB0LnByb3RvEitldmVudHNfdjEuY29tcG9uZW50cy50YXJnZXQuZGV0YWlscy5tZXNzYWdlIqMBCg1VcGdyYWRlUHJvbXB0EkwKBHR5cGUYASABKA4yPi5ldmVudHNfdjEuY29tcG9uZW50cy50YXJnZXQuZGV0YWlscy5tZXNzYWdlLlVwZ3JhZGVQcm9tcHRUeXBlEiYKGW1pbmltdW1fc3VwcG9ydGVkX3ZlcnNpb24YAiABKAlIAIgBAUIcChpfbWluaW11bV9zdXBwb3J0ZWRfdmVyc2lvbip8ChFVcGdyYWRlUHJvbXB0VHlwZRIjCh9VUEdSQURFX1BST01QVF9UWVBFX1VOU1BFQ0lGSUVEEAASIgoeVVBHUkFERV9QUk9NUFRfVFlQRV9FTkNPVVJBR0VEEAESHgoaVVBHUkFERV9QUk9NUFRfVFlQRV9GT1JDRUQQAmIGcHJvdG8z"), xo = /* @__PURE__ */ i("CjlldmVudHNfdjEvY29tcG9uZW50cy90YXJnZXQvZGV0YWlscy9tZXNzYWdlL21lc3NhZ2UucHJvdG8SK2V2ZW50c192MS5jb21wb25lbnRzLnRhcmdldC5kZXRhaWxzLm1lc3NhZ2UidQoHTWVzc2FnZRJXCg51cGdyYWRlX3Byb21wdBgBIAEoCzI6LmV2ZW50c192MS5jb21wb25lbnRzLnRhcmdldC5kZXRhaWxzLm1lc3NhZ2UuVXBncmFkZVByb21wdEgAiAEBQhEKD191cGdyYWRlX3Byb21wdGIGcHJvdG8z", [
    Ko
]), Do = /* @__PURE__ */ i("CjhldmVudHNfdjEvY29tcG9uZW50cy90YXJnZXQvZGV0YWlscy90YXJnZXRfZGV0YWlscy5wcm90bxIjZXZlbnRzX3YxLmNvbXBvbmVudHMudGFyZ2V0LmRldGFpbHMivwEKDVRhcmdldERldGFpbHMSSgoHY29udGVudBgBIAEoCzI0LmV2ZW50c192MS5jb21wb25lbnRzLnRhcmdldC5kZXRhaWxzLmNvbnRlbnQuQ29udGVudEgAiAEBEkoKB21lc3NhZ2UYAiABKAsyNC5ldmVudHNfdjEuY29tcG9uZW50cy50YXJnZXQuZGV0YWlscy5tZXNzYWdlLk1lc3NhZ2VIAYgBAUIKCghfY29udGVudEIKCghfbWVzc2FnZWIGcHJvdG8z", [
    Oo,
    xo
]), Po = /* @__PURE__ */ i("CihldmVudHNfdjEvY29tcG9uZW50cy90YXJnZXQvdGFyZ2V0LnByb3RvEhtldmVudHNfdjEuY29tcG9uZW50cy50YXJnZXQipAEKBlRhcmdldBIPCgJpZBgBIAEoCUgAiAEBEj0KBWdyb3VwGAIgASgLMi4uZXZlbnRzX3YxLmNvbXBvbmVudHMudGFyZ2V0Lmdyb3VwLlRhcmdldEdyb3VwEkMKB2RldGFpbHMYAyABKAsyMi5ldmVudHNfdjEuY29tcG9uZW50cy50YXJnZXQuZGV0YWlscy5UYXJnZXREZXRhaWxzQgUKA19pZGIGcHJvdG8z", [
    Ho,
    Do
]), Jn = /* @__PURE__ */ i("Ck9ldmVudHNfdjEvY29tcG9uZW50cy91aS9kZXRhaWxzL3Nob3BwZXJfcGxhdGZvcm0vc2hvcHBlcl9wbGF0Zm9ybV9hZF92aWV3LnByb3RvEjBldmVudHNfdjEuY29tcG9uZW50cy51aS5kZXRhaWxzLnNob3BwZXJfcGxhdGZvcm0q3AEKFVNob3BwZXJQbGF0Zm9ybUFkVmlldxIoCiRTSE9QUEVSX1BMQVRGT1JNX0FEX1ZJRVdfVU5TUEVDSUZJRUQQABIkCiBTSE9QUEVSX1BMQVRGT1JNX0FEX1ZJRVdfREVGQVVMVBABEiYKIlNIT1BQRVJfUExBVEZPUk1fQURfVklFV19TQUZFRlJBTUUQAhIkCiBTSE9QUEVSX1BMQVRGT1JNX0FEX1ZJRVdfRU5BQkxFUhADEiUKIVNIT1BQRVJfUExBVEZPUk1fQURfVklFV19XRUJfVklFVxAEYgZwcm90bzM"), $o = /* @__PURE__ */ b(Jn, 0), kc = /* @__PURE__ */ f($o), Hn = /* @__PURE__ */ i("CldldmVudHNfdjEvY29tcG9uZW50cy91aS9kZXRhaWxzL3Nob3BwZXJfcGxhdGZvcm0vc2hvcHBlcl9wbGF0Zm9ybV9leHBlcmllbmNlX3R5cGUucHJvdG8SMGV2ZW50c192MS5jb21wb25lbnRzLnVpLmRldGFpbHMuc2hvcHBlcl9wbGF0Zm9ybSr2AgodU2hvcHBlclBsYXRmb3JtRXhwZXJpZW5jZVR5cGUSMAosU0hPUFBFUl9QTEFURk9STV9FWFBFUklFTkNFX1RZUEVfVU5TUEVDSUZJRUQQABIsCihTSE9QUEVSX1BMQVRGT1JNX0VYUEVSSUVOQ0VfVFlQRV9DT01QQUNUEAESLAooU0hPUFBFUl9QTEFURk9STV9FWFBFUklFTkNFX1RZUEVfQ0xBU1NJQxACEjMKL1NIT1BQRVJfUExBVEZPUk1fRVhQRVJJRU5DRV9UWVBFX01VTFRJX1NUQU5EQVJEEAMSMQotU0hPUFBFUl9QTEFURk9STV9FWFBFUklFTkNFX1RZUEVfRklYRURfSEVJR0hUEAQSLAooU0hPUFBFUl9QTEFURk9STV9FWFBFUklFTkNFX1RZUEVfVU5LTk9XThAFEjEKLVNIT1BQRVJfUExBVEZPUk1fRVhQRVJJRU5DRV9UWVBFX01PQklMRV9TV0lQRRAGYgZwcm90bzM"), qo = /* @__PURE__ */ b(Hn, 0), Mc = /* @__PURE__ */ f(qo), jn = /* @__PURE__ */ i("CkpldmVudHNfdjEvY29tcG9uZW50cy91aS9kZXRhaWxzL3Nob3BwZXJfcGxhdGZvcm0vc2hvcHBlcl9wbGF0Zm9ybV91eC5wcm90bxIwZXZlbnRzX3YxLmNvbXBvbmVudHMudWkuZGV0YWlscy5zaG9wcGVyX3BsYXRmb3JtKrIBChFTaG9wcGVyUGxhdGZvcm1VeBIjCh9TSE9QUEVSX1BMQVRGT1JNX1VYX1VOU1BFQ0lGSUVEEAASKQolU0hPUFBFUl9QTEFURk9STV9VWF9TVE9SRUZST05UX0lOTElORRABEisKJ1NIT1BQRVJfUExBVEZPUk1fVVhfU1RPUkVGUk9OVF9FWFBBTkRFRBACEiAKHFNIT1BQRVJfUExBVEZPUk1fVVhfRVhQQU5ERUQQA2IGcHJvdG8z"), ec = /* @__PURE__ */ b(jn, 0), zc = /* @__PURE__ */ f(ec), nc = /* @__PURE__ */ i("ClJldmVudHNfdjEvY29tcG9uZW50cy91aS9kZXRhaWxzL3Nob3BwZXJfcGxhdGZvcm0vc2hvcHBlcl9wbGF0Zm9ybV91aV9kZXRhaWxzLnByb3RvEjBldmVudHNfdjEuY29tcG9uZW50cy51aS5kZXRhaWxzLnNob3BwZXJfcGxhdGZvcm0i5QIKGFNob3BwZXJQbGF0Zm9ybVVJRGV0YWlscxJdCgdhZF92aWV3GAEgASgOMkcuZXZlbnRzX3YxLmNvbXBvbmVudHMudWkuZGV0YWlscy5zaG9wcGVyX3BsYXRmb3JtLlNob3BwZXJQbGF0Zm9ybUFkVmlld0gAiAEBElQKAnV4GAIgASgOMkMuZXZlbnRzX3YxLmNvbXBvbmVudHMudWkuZGV0YWlscy5zaG9wcGVyX3BsYXRmb3JtLlNob3BwZXJQbGF0Zm9ybVV4SAGIAQESbQoPZXhwZXJpZW5jZV90eXBlGAMgASgOMk8uZXZlbnRzX3YxLmNvbXBvbmVudHMudWkuZGV0YWlscy5zaG9wcGVyX3BsYXRmb3JtLlNob3BwZXJQbGF0Zm9ybUV4cGVyaWVuY2VUeXBlSAKIAQFCCgoIX2FkX3ZpZXdCBQoDX3V4QhIKEF9leHBlcmllbmNlX3R5cGViBnByb3RvMw", [
    Jn,
    Hn,
    jn
]), tc = /* @__PURE__ */ i("CjBldmVudHNfdjEvY29tcG9uZW50cy91aS9kZXRhaWxzL3VpX2RldGFpbHMucHJvdG8SH2V2ZW50c192MS5jb21wb25lbnRzLnVpLmRldGFpbHMifQoJVUlEZXRhaWxzEmYKEHNob3BwZXJfcGxhdGZvcm0YASABKAsySi5ldmVudHNfdjEuY29tcG9uZW50cy51aS5kZXRhaWxzLnNob3BwZXJfcGxhdGZvcm0uU2hvcHBlclBsYXRmb3JtVUlEZXRhaWxzSABCCAoGc291cmNlYgZwcm90bzM", [
    nc
]), lc = /* @__PURE__ */ i("CiNldmVudHNfdjEvY29tcG9uZW50cy91aS9wb2ludC5wcm90bxIXZXZlbnRzX3YxLmNvbXBvbmVudHMudWkiHQoFUG9pbnQSCQoBeBgBIAEoAhIJCgF5GAIgASgCYgZwcm90bzM"), oc = /* @__PURE__ */ i("CiJldmVudHNfdjEvY29tcG9uZW50cy91aS9yZWN0LnByb3RvEhdldmVudHNfdjEuY29tcG9uZW50cy51aSJjCgRSZWN0Ei4KBm9yaWdpbhgBIAEoCzIeLmV2ZW50c192MS5jb21wb25lbnRzLnVpLlBvaW50EisKBHNpemUYAiABKAsyHS5ldmVudHNfdjEuY29tcG9uZW50cy51aS5TaXplYgZwcm90bzM", [
    lc,
    hn
]), cc = /* @__PURE__ */ i("CiZldmVudHNfdjEvY29tcG9uZW50cy91aS9wb3NpdGlvbi5wcm90bxIXZXZlbnRzX3YxLmNvbXBvbmVudHMudWkigwIKCFBvc2l0aW9uEhYKCXJvd19pbmRleBgBIAEoBUgAiAEBEhYKCWNvbF9pbmRleBgCIAEoBUgBiAEBEhEKBHJhbmsYAyABKAVIAogBARIcCg9jb2xsZWN0aW9uX3NpemUYBCABKAVIA4gBARIVCghyb3dfc2l6ZRgFIAEoBUgEiAEBEjAKBHJlY3QYBiABKAsyHS5ldmVudHNfdjEuY29tcG9uZW50cy51aS5SZWN0SAWIAQFCDAoKX3Jvd19pbmRleEIMCgpfY29sX2luZGV4QgcKBV9yYW5rQhIKEF9jb2xsZWN0aW9uX3NpemVCCwoJX3Jvd19zaXplQgcKBV9yZWN0YgZwcm90bzM", [
    oc
]), uc = /* @__PURE__ */ i("ClJldmVudHNfdjEvY29tcG9uZW50cy91aS9zdXJmYWNlL2RldGFpbHMvc3RvcmVmcm9udC9zdG9yZWZyb250X3JlbmRlcmluZ19tb2RlLnByb3RvEjJldmVudHNfdjEuY29tcG9uZW50cy51aS5zdXJmYWNlLmRldGFpbHMuc3RvcmVmcm9udCqLAQoXU3RvcmVmcm9udFJlbmRlcmluZ01vZGUSKQolU1RPUkVGUk9OVF9SRU5ERVJJTkdfTU9ERV9VTlNQRUNJRklFRBAAEiIKHlNUT1JFRlJPTlRfUkVOREVSSU5HX01PREVfU0ZNTBABEiEKHVNUT1JFRlJPTlRfUkVOREVSSU5HX01PREVfRFZNEAJiBnByb3RvMw"), ac = /* @__PURE__ */ i("CktldmVudHNfdjEvY29tcG9uZW50cy91aS9zdXJmYWNlL2RldGFpbHMvc3RvcmVmcm9udC9zdG9yZWZyb250X3N1cmZhY2UucHJvdG8SMmV2ZW50c192MS5jb21wb25lbnRzLnVpLnN1cmZhY2UuZGV0YWlscy5zdG9yZWZyb250IngKEVN0b3JlZnJvbnRTdXJmYWNlEmMKDnJlbmRlcmluZ19tb2RlGAEgASgOMksuZXZlbnRzX3YxLmNvbXBvbmVudHMudWkuc3VyZmFjZS5kZXRhaWxzLnN0b3JlZnJvbnQuU3RvcmVmcm9udFJlbmRlcmluZ01vZGViBnByb3RvMw", [
    uc
]), sc = /* @__PURE__ */ i("Cj1ldmVudHNfdjEvY29tcG9uZW50cy91aS9zdXJmYWNlL2RldGFpbHMvc3VyZmFjZV9kZXRhaWxzLnByb3RvEidldmVudHNfdjEuY29tcG9uZW50cy51aS5zdXJmYWNlLmRldGFpbHMieAoOU3VyZmFjZURldGFpbHMSWwoKc3RvcmVmcm9udBgBIAEoCzJFLmV2ZW50c192MS5jb21wb25lbnRzLnVpLnN1cmZhY2UuZGV0YWlscy5zdG9yZWZyb250LlN0b3JlZnJvbnRTdXJmYWNlSABCCQoHc3VyZmFjZWIGcHJvdG8z", [
    ac
]), Qn = /* @__PURE__ */ i("CjJldmVudHNfdjEvY29tcG9uZW50cy91aS9zdXJmYWNlL3N1cmZhY2VfdHlwZS5wcm90bxIfZXZlbnRzX3YxLmNvbXBvbmVudHMudWkuc3VyZmFjZSrdAgoLU3VyZmFjZVR5cGUSHAoYU1VSRkFDRV9UWVBFX1VOU1BFQ0lGSUVEEAASGwoXU1VSRkFDRV9UWVBFX1NUT1JFRlJPTlQQARIYChRTVVJGQUNFX1RZUEVfREVUQUlMUxACEh8KG1NVUkZBQ0VfVFlQRV9EWU5BTUlDX01PRFVMRRADEh4KGlNVUkZBQ0VfVFlQRV9TSE9QUElOR19MSVNUEAQSGwoXU1VSRkFDRV9UWVBFX1dBVENIX0xJU1QQBRIXChNTVVJGQUNFX1RZUEVfU0VBUkNIEAYSHQoZU1VSRkFDRV9UWVBFX01JTklfREVUQUlMUxAHEhgKFFNVUkZBQ0VfVFlQRV9MQU5ESU5HEAgSFwoTU1VSRkFDRV9UWVBFX0JST1dTRRAJEhYKElNVUkZBQ0VfVFlQRV9NT0RBTBAKEhgKFFNVUkZBQ0VfVFlQRV9XRUJTSVRFEAtiBnByb3RvMw"), ic = /* @__PURE__ */ b(Qn, 0), Oc = /* @__PURE__ */ f(ic), dc = /* @__PURE__ */ i("Ci1ldmVudHNfdjEvY29tcG9uZW50cy91aS9zdXJmYWNlL3N1cmZhY2UucHJvdG8SH2V2ZW50c192MS5jb21wb25lbnRzLnVpLnN1cmZhY2Ui2gEKB1N1cmZhY2USOgoEdHlwZRgBIAEoDjIsLmV2ZW50c192MS5jb21wb25lbnRzLnVpLnN1cmZhY2UuU3VyZmFjZVR5cGUSDwoCaWQYAiABKAlIAIgBARIUCgd2ZXJzaW9uGAMgASgJSAGIAQESTQoHZGV0YWlscxgEIAEoCzI3LmV2ZW50c192MS5jb21wb25lbnRzLnVpLnN1cmZhY2UuZGV0YWlscy5TdXJmYWNlRGV0YWlsc0gCiAEBQgUKA19pZEIKCghfdmVyc2lvbkIKCghfZGV0YWlsc2IGcHJvdG8z", [
    sc,
    Qn
]), kn = /* @__PURE__ */ i("CixldmVudHNfdjEvY29tcG9uZW50cy91aS9jb250YWluZXJfdHlwZS5wcm90bxIXZXZlbnRzX3YxLmNvbXBvbmVudHMudWkqtAEKDUNvbnRhaW5lclR5cGUSHgoaQ09OVEFJTkVSX1RZUEVfVU5TUEVDSUZJRUQQABIZChVDT05UQUlORVJfVFlQRV9TQ1JFRU4QARIZChVDT05UQUlORVJfVFlQRV9NT0RVTEUQAhIXChNDT05UQUlORVJfVFlQRV9MSVNUEAMSFwoTQ09OVEFJTkVSX1RZUEVfR1JJRBAEEhsKF0NPTlRBSU5FUl9UWVBFX0NBUk9VU0VMEAViBnByb3RvMw"), mc = /* @__PURE__ */ b(kn, 0), Kc = /* @__PURE__ */ f(mc), rc = /* @__PURE__ */ i("CjJldmVudHNfdjEvY29tcG9uZW50cy91aS9jb250cm9sL2NvbnRyb2xfdHlwZS5wcm90bxIfZXZlbnRzX3YxLmNvbXBvbmVudHMudWkuY29udHJvbCpECgtDb250cm9sVHlwZRIcChhDT05UUk9MX1RZUEVfVU5TUEVDSUZJRUQQABIXChNDT05UUk9MX1RZUEVfQlVUVE9OEAFiBnByb3RvMw"), bc = /* @__PURE__ */ i("Ci1ldmVudHNfdjEvY29tcG9uZW50cy91aS9jb250cm9sL2NvbnRyb2wucHJvdG8SH2V2ZW50c192MS5jb21wb25lbnRzLnVpLmNvbnRyb2wiYQoHQ29udHJvbBI6CgR0eXBlGAEgASgOMiwuZXZlbnRzX3YxLmNvbXBvbmVudHMudWkuY29udHJvbC5Db250cm9sVHlwZRIRCgRuYW1lGAIgASgJSACIAQFCBwoFX25hbWViBnByb3RvMw", [
    rc
]), fc = /* @__PURE__ */ i("CiBldmVudHNfdjEvY29tcG9uZW50cy91aS91aS5wcm90bxIXZXZlbnRzX3YxLmNvbXBvbmVudHMudWki3AMKAlVJEjkKB3N1cmZhY2UYASABKAsyKC5ldmVudHNfdjEuY29tcG9uZW50cy51aS5zdXJmYWNlLlN1cmZhY2USSgoTZGVzdGluYXRpb25fc3VyZmFjZRgCIAEoCzIoLmV2ZW50c192MS5jb21wb25lbnRzLnVpLnN1cmZhY2UuU3VyZmFjZUgAiAEBEjgKCHBvc2l0aW9uGAMgASgLMiEuZXZlbnRzX3YxLmNvbXBvbmVudHMudWkuUG9zaXRpb25IAYgBARJACgdkZXRhaWxzGAQgASgLMiouZXZlbnRzX3YxLmNvbXBvbmVudHMudWkuZGV0YWlscy5VSURldGFpbHNIAogBARJDCg5jb250YWluZXJfdHlwZRgFIAEoDjImLmV2ZW50c192MS5jb21wb25lbnRzLnVpLkNvbnRhaW5lclR5cGVIA4gBARI+Cgdjb250cm9sGAYgASgLMiguZXZlbnRzX3YxLmNvbXBvbmVudHMudWkuY29udHJvbC5Db250cm9sSASIAQFCFgoUX2Rlc3RpbmF0aW9uX3N1cmZhY2VCCwoJX3Bvc2l0aW9uQgoKCF9kZXRhaWxzQhEKD19jb250YWluZXJfdHlwZUIKCghfY29udHJvbGIGcHJvdG8z", [
    tc,
    cc,
    dc,
    kn,
    bc
]), Ec = /* @__PURE__ */ i("CipldmVudHNfdjEvY29tcG9uZW50cy9hdHRyaWJ1dGlvbi91dG0ucHJvdG8SIGV2ZW50c192MS5jb21wb25lbnRzLmF0dHJpYnV0aW9uIqcBCgNVdG0SEwoGc291cmNlGAEgASgJSACIAQESEwoGbWVkaXVtGAIgASgJSAGIAQESFQoIY2FtcGFpZ24YAyABKAlIAogBARIUCgdjb250ZW50GAQgASgJSAOIAQESEQoEdGVybRgFIAEoCUgEiAEBQgkKB19zb3VyY2VCCQoHX21lZGl1bUILCglfY2FtcGFpZ25CCgoIX2NvbnRlbnRCBwoFX3Rlcm1iBnByb3RvMw"), Vc = /* @__PURE__ */ i("Ci9ldmVudHNfdjEvY29tcG9uZW50cy9hdHRyaWJ1dGlvbi9yZWZlcnJlci5wcm90bxIgZXZlbnRzX3YxLmNvbXBvbmVudHMuYXR0cmlidXRpb24iXAoIUmVmZXJyZXISEAoDdXJsGAEgASgJSACIAQESEQoEaG9zdBgCIAEoCUgBiAEBEhEKBHR5cGUYAyABKAlIAogBAUIGCgRfdXJsQgcKBV9ob3N0QgcKBV90eXBlYgZwcm90bzM"), Rc = /* @__PURE__ */ i("Ci5ldmVudHNfdjEvY29tcG9uZW50cy9hdHRyaWJ1dGlvbi9jaGFubmVsLnByb3RvEiBldmVudHNfdjEuY29tcG9uZW50cy5hdHRyaWJ1dGlvbiqOAgoLQ2hhbm5lbFR5cGUSHAoYQ0hBTk5FTF9UWVBFX1VOU1BFQ0lGSUVEEAASFwoTQ0hBTk5FTF9UWVBFX0RJUkVDVBABEh8KG0NIQU5ORUxfVFlQRV9PUkdBTklDX1NFQVJDSBACEhwKGENIQU5ORUxfVFlQRV9QQUlEX1NFQVJDSBADEh8KG0NIQU5ORUxfVFlQRV9PUkdBTklDX1NPQ0lBTBAEEhwKGENIQU5ORUxfVFlQRV9QQUlEX1NPQ0lBTBAFEhYKEkNIQU5ORUxfVFlQRV9FTUFJTBAGEhoKFkNIQU5ORUxfVFlQRV9BRkZJTElBVEUQBxIWChJDSEFOTkVMX1RZUEVfT1RIRVIQCGIGcHJvdG8z"), pc = /* @__PURE__ */ i("CjJldmVudHNfdjEvY29tcG9uZW50cy9hdHRyaWJ1dGlvbi9hdHRyaWJ1dGlvbi5wcm90bxIgZXZlbnRzX3YxLmNvbXBvbmVudHMuYXR0cmlidXRpb24i7wEKC0F0dHJpYnV0aW9uEjcKA3V0bRgBIAEoCzIlLmV2ZW50c192MS5jb21wb25lbnRzLmF0dHJpYnV0aW9uLlV0bUgAiAEBEkEKCHJlZmVycmVyGAIgASgLMiouZXZlbnRzX3YxLmNvbXBvbmVudHMuYXR0cmlidXRpb24uUmVmZXJyZXJIAYgBARJDCgdjaGFubmVsGAMgASgOMi0uZXZlbnRzX3YxLmNvbXBvbmVudHMuYXR0cmlidXRpb24uQ2hhbm5lbFR5cGVIAogBAUIGCgRfdXRtQgsKCV9yZWZlcnJlckIKCghfY2hhbm5lbGIGcHJvdG8z", [
    Ec,
    Vc,
    Rc
]), Zc = /* @__PURE__ */ i("ChVldmVudHNfdjEvZXZlbnQucHJvdG8SCWV2ZW50c192MSKwBwoFRXZlbnQSLQoEYmFzZRgBIAEoCzIfLmV2ZW50c192MS5jb21wb25lbnRzLmJhc2UuQmFzZRJCCgtpbnRlcmFjdGlvbhgCIAEoCzItLmV2ZW50c192MS5jb21wb25lbnRzLmludGVyYWN0aW9uLkludGVyYWN0aW9uEjMKBmFjdGlvbhgDIAEoCzIjLmV2ZW50c192MS5jb21wb25lbnRzLmFjdGlvbi5BY3Rpb24SMwoGdGFyZ2V0GAQgASgLMiMuZXZlbnRzX3YxLmNvbXBvbmVudHMudGFyZ2V0LlRhcmdldBI7CgdzZXNzaW9uGAYgASgLMiUuZXZlbnRzX3YxLmNvbXBvbmVudHMuc2Vzc2lvbi5TZXNzaW9uSACIAQESOAoGc291cmNlGAcgASgLMiMuZXZlbnRzX3YxLmNvbXBvbmVudHMuc291cmNlLlNvdXJjZUgBiAEBEjgKBmRldmljZRgIIAEoCzIjLmV2ZW50c192MS5jb21wb25lbnRzLmRldmljZS5EZXZpY2VIAogBARJJCg9kZXZpY2VfbG9jYXRpb24YCSABKAsyKy5ldmVudHNfdjEuY29tcG9uZW50cy5kZXZpY2UuRGV2aWNlTG9jYXRpb25IA4gBARIyCgR1c2VyGAogASgLMh8uZXZlbnRzX3YxLmNvbXBvbmVudHMudXNlci5Vc2VySASIAQESLAoCYWQYCyABKAsyGy5ldmVudHNfdjEuY29tcG9uZW50cy5hZC5BZEgFiAEBEiwKAnVpGAwgASgLMhsuZXZlbnRzX3YxLmNvbXBvbmVudHMudWkuVUlIBogBARI4CgZzZWFyY2gYDSABKAsyIy5ldmVudHNfdjEuY29tcG9uZW50cy5zZWFyY2guU2VhcmNoSAeIAQESRAoKbmF2aWdhdGlvbhgOIAEoCzIrLmV2ZW50c192MS5jb21wb25lbnRzLm5hdmlnYXRpb24uTmF2aWdhdGlvbkgIiAEBEkcKC2F0dHJpYnV0aW9uGA8gASgLMi0uZXZlbnRzX3YxLmNvbXBvbmVudHMuYXR0cmlidXRpb24uQXR0cmlidXRpb25ICYgBAUIKCghfc2Vzc2lvbkIJCgdfc291cmNlQgkKB19kZXZpY2VCEgoQX2RldmljZV9sb2NhdGlvbkIHCgVfdXNlckIFCgNfYWRCBQoDX3VpQgkKB19zZWFyY2hCDQoLX25hdmlnYXRpb25CDgoMX2F0dHJpYnV0aW9uYgZwcm90bzM", [
    xl,
    Ro,
    Zo,
    Gn,
    In,
    Io,
    Yo,
    Uo,
    gn,
    Nn,
    Po,
    fc,
    Sn,
    pc
]), Nc = /* @__PURE__ */ i("Ch9ldmVudHNfdjEvcmVxdWVzdF9wYXlsb2FkLnByb3RvEglldmVudHNfdjEiZQoOUmVxdWVzdFBheWxvYWQSJgoGaGVhZGVyGAEgASgLMhEuZXZlbnRzX3YxLkhlYWRlckgAiAEBEiAKBmV2ZW50cxgCIAMoCzIQLmV2ZW50c192MS5FdmVudEIJCgdfaGVhZGVyYgZwcm90bzM", [
    Jl,
    Zc
]), xe = /* @__PURE__ */ Rn(Nc, 0);
function gc(e) {
    return toBinary(xe, create(xe, {
        header: {},
        events: e
    }));
}
function vc(e, n) {
    try {
        if (navigator.sendBeacon(e.toString(), n)) return !0;
    } catch  {}
    return false;
}
const yc = 64 * 1024;
async function Ac(e, n) {
    const t = await fetch(e, {
        method: "POST",
        headers: {
            "Content-Type": "application/protobuf"
        },
        body: n,
        // `body` is a Uint8Array, so `.length` is the byte length. keepalive lets the
        // request outlive the page (important on unload) but is capped at 64KB.
        keepalive: n.length < yc
    });
    if (!t.ok) throw new Error(`Failed to send events via fetch: ${t.status} ${t.statusText}`);
    return t;
}
const _c = (e)=>new Promise((n)=>setTimeout(n, e));
// @__NO_SIDE_EFFECTS__
function xc(e) {
    const n = {
        ...Pn,
        ...e
    }, t = qn(n.url, n.signingKey), l = typeof window < "u", o = [];
    let c;
    const u = async (E, p)=>{
        const R = p ? 1 : n.maxRetries + 1;
        for(let v = 0; v < R; v++)try {
            await Ac(t(), E);
            return;
        } catch (Z) {
            if (v === R - 1) {
                n.logLevel > Kn && n.logFunction(`EventQueue: Failed to send events: ${Z?.message}`);
                return;
            }
            n.logLevel >= Dn && n.logFunction(`EventQueue: Retrying send (attempt ${v + 1}/${n.maxRetries}): ${Z?.message}`), await _c(n.retryBackoffMs * 2 ** v);
        }
    }, a = async (E = false)=>{
        if (o.length < 1) return;
        const p = gc(o.splice(0, n.maxSize));
        vc(t(), p) || await u(p, E), clearTimeout(c), c = o.length > 0 ? setTimeout(a, n.delayBetweenBatches) : undefined;
    }, m = (E)=>{
        o.push(E), c || (c = setTimeout(a, n.batchWaitTime));
    }, d = ()=>{
        a(true);
    };
    return n.fireOnPageHide && l && window.addEventListener("pagehide", d), n.fireOnVisibilityChange && l && window.addEventListener("visibilitychange", d), {
        enqueue: m,
        flush: ()=>a(),
        length: ()=>o.length,
        destroy: ()=>{
            l && (window.removeEventListener("pagehide", d), window.removeEventListener("visibilitychange", d)), clearTimeout(c), c = undefined, a();
        }
    };
}
function Dc() {
    let e = BigInt(0);
    return function() {
        return e += BigInt(1), e;
    };
}

var enTranslations = {
    example: 'Example',
    valid_from_to: function(c) {
        return "Valid ".concat(c['from'], " - ").concat(c['to']);
    },
    you_save: 'You Save',
    see_more: 'See More',
    shop_now: 'Shop Now',
    view_it: 'View Deals',
    save_deal: 'Save Deal',
    percent_off: function(c) {
        return "".concat(c['percent'], "% off");
    },
    item_disclaimer: 'In the event of disagreement between the circular and this popup, the circular shall take precedence.',
    features: 'Features',
    specs: 'Specs',
    click_to_visit_m: function(c) {
        return "Click to visit ".concat(c['m'], ".");
    },
    seconds_to_expand: 'Expanding in',
    seconds_to_expand_mobile: 'Expands in',
    valid: 'Valid',
    try_again: "We couldn't load this item. Please try again.",
    days_left: function(c) {
        var d = c['days'];
        if (d === '0') {
            return 'Last Day';
        } else if (d === '1') {
            return '1 Day Left';
        } else {
            return "".concat(d, " Days Left");
        }
    },
    days_until: function(c) {
        var d = c['days'];
        if (d === '0') {
            return 'Starts Today';
        } else if (d === '1') {
            return 'Starts Tomorrow';
        } else {
            return "Starts in ".concat(d, " Days");
        }
    },
    select_stores: 'Selected stores in ',
    thank_you_for_response: 'Thank you for your response!'
};

var deTranslations = {
    example: 'Beispiel',
    valid_from_to: function(c) {
        return "G\u00FCltig ".concat(c['from'], " - ").concat(c['to']);
    },
    you_save: 'Jetzt sparen',
    see_more: 'Mehr erfahren',
    shop_now: 'Jetzt einkaufen',
    view_it: 'Angebote ansehen',
    save_deal: 'Angebot speichern',
    percent_off: function(c) {
        return "".concat(c['percent'], "% sparen");
    },
    item_disclaimer: 'Bei Unstimmigkeiten zwischen dieser Anzeige und dem Prospekt gilt der Prospekt als maßgeblich.',
    features: 'Funktionen',
    specs: 'Spezifikationen',
    click_to_visit_m: function(c) {
        return "Klicken, um mehr zu erfahren ".concat(c['m'], ".");
    },
    seconds_to_expand: 'Vergrößert sich in',
    seconds_to_expand_mobile: 'Vergrößert sich in',
    valid: 'Gültig',
    try_again: 'Dieser Artikel konnte nicht geladen werden. Bitte versuchen Sie es erneut.',
    days_left: function(c) {
        var d = c['days'];
        if (d === '0') {
            return 'Letzter Tag';
        } else if (d === '1') {
            return 'noch 1 Tag gültig';
        } else {
            return "".concat(d, " Tage g\u00FCltig");
        }
    },
    days_until: function(c) {
        var d = c['days'];
        if (d === '0') {
            return 'Ab heute';
        } else if (d === '1') {
            return 'Ab morgen';
        } else {
            return "G\u00FCltig in ".concat(d, " Tagen");
        }
    },
    select_stores: 'Nur in ausgewählten Filialen',
    thank_you_for_response: 'Vielen Dank für Ihre Antwort!'
};

var esTranslations = {
    example: 'Ejemplo',
    valid_from_to: function(c) {
        return "V\u00E1lido del ".concat(c['from'], " al ").concat(c['to']);
    },
    you_save: 'Ahorras',
    see_more: 'Ver más',
    shop_now: 'Comprar ahora',
    view_it: 'Ver ofertas',
    save_deal: 'Guardar oferta',
    percent_off: function(c) {
        return "".concat(c['percent'], "% de descuento");
    },
    item_disclaimer: 'En caso de discrepancia entre el folleto y este mensaje emergente, prevalecerá el folleto.',
    features: 'Características',
    specs: 'Especificaciones',
    click_to_visit_m: function(c) {
        return "Haz clic para visitar ".concat(c['m'], ".");
    },
    seconds_to_expand: 'Se expandirá en',
    seconds_to_expand_mobile: 'Se expande en',
    valid: 'Válido',
    try_again: 'No pudimos cargar este artículo. Por favor, inténtalo de nuevo.',
    days_left: function(c) {
        var d = c['days'];
        if (d === '0') {
            return 'Último día';
        } else if (d === '1') {
            return 'Falta 1 día';
        } else {
            return "Faltan ".concat(d, " d\u00EDas");
        }
    },
    days_until: function(c) {
        var d = c['days'];
        if (d === '0') {
            return 'Empieza hoy';
        } else if (d === '1') {
            return 'Empieza mañana';
        } else {
            return "Empieza en ".concat(d, " d\u00EDas");
        }
    },
    select_stores: 'Tiendas seleccionadas en ',
    thank_you_for_response: 'Gracias por su respuesta!'
};

var frTranslations = {
    example: 'Exemple',
    valid_from_to: function(c) {
        return "Valide du ".concat(c['from'], " au ").concat(c['to']);
    },
    you_save: 'Vous économisez',
    see_more: 'Voir Plus',
    shop_now: 'Acheter',
    view_it: 'Voir Plus',
    save_deal: 'Sauvegarder',
    percent_off: function(c) {
        return "Rabais de ".concat(c['percent'], "%");
    },
    item_disclaimer: 'En cas de différence entre la circulaire et cette fenêtre surgissante, la circulaire a préséance.',
    features: 'Caractéristiques',
    specs: 'Spécifications',
    click_to_visit_m: function(c) {
        return "Cliquez pour visiter ".concat(c['m'], ".");
    },
    seconds_to_expand: 'Plus à',
    seconds_to_expand_mobile: 'Plus en',
    valid: 'Valide du',
    try_again: 'Nous n’avons pas pu charger cet article. Veuillez réessayer.',
    days_left: function(c) {
        var d = c['days'];
        if (d === '0') {
            return 'Dernier Jour';
        } else if (d === '1') {
            return '1 Jour Restant';
        } else {
            return "".concat(d, " Jours Restants");
        }
    },
    days_until: function(c) {
        var d = c['days'];
        if (d === '0') {
            return "Commence Aujourd'hui";
        } else if (d === '1') {
            return 'Commence Demain';
        } else {
            return "Commence Dans ".concat(d, " Jours");
        }
    },
    select_stores: 'Magasins sélectionnés: ',
    thank_you_for_response: 'Merci pour votre réponse!'
};

var ptTranslations = {
    example: 'Exemplo',
    valid_from_to: function(c) {
        return "V\u00E1lido de ".concat(c['from'], " at\u00E9 ").concat(c['to']);
    },
    you_save: 'Economize',
    see_more: 'Saiba mais',
    shop_now: 'Compre agora',
    view_it: 'Ver ofertas',
    save_deal: 'Salvar oferta',
    percent_off: function(c) {
        return "".concat(c['percent'], "% de desconto");
    },
    item_disclaimer: 'Em caso de divergência entre este anúncio e o encarte, prevalecerá o encarte.',
    features: 'Características',
    specs: 'Especificações',
    click_to_visit_m: function(c) {
        return "Clique para saber mais ".concat(c['m'], ".");
    },
    seconds_to_expand: 'Expande em',
    seconds_to_expand_mobile: 'Expande em',
    valid: 'Válido',
    try_again: 'Não foi possível carregar este item. Por favor, tente novamente.',
    days_left: function(c) {
        var d = c['days'];
        if (d === '0') {
            return 'Último dia';
        } else if (d === '1') {
            return 'Válido por mais 1 dia';
        } else {
            return "V\u00E1lido por ".concat(d, " dias");
        }
    },
    days_until: function(c) {
        var d = c['days'];
        if (d === '0') {
            return 'A partir de hoje';
        } else if (d === '1') {
            return 'A partir de amanhã';
        } else {
            return "V\u00E1lido em ".concat(d, " dias");
        }
    },
    select_stores: 'Apenas em lojas selecionadas',
    thank_you_for_response: 'Obrigado pela sua resposta!'
};

var esCoTranslations = {
    example: 'Ejemplo',
    valid_from_to: function(c) {
        return "V\u00E1lido del ".concat(c['from'], " al ").concat(c['to']);
    },
    you_save: 'Ahorra',
    see_more: 'Ver más',
    shop_now: 'Compra ahora',
    view_it: 'Ver ofertas',
    save_deal: 'Guardar oferta',
    percent_off: function(c) {
        return "".concat(c['percent'], "% de descuento");
    },
    item_disclaimer: 'En caso de discrepancias entre este anuncio y el folleto, prevalecerá el folleto.',
    features: 'Características',
    specs: 'Especificaciones',
    click_to_visit_m: function(c) {
        return "Haz clic para conocer m\u00E1s ".concat(c['m'], ".");
    },
    seconds_to_expand: 'Se expandirá en',
    seconds_to_expand_mobile: 'Se expandirá en',
    valid: 'Válido',
    add_to_list: 'Agregar a la lista',
    try_again: 'No pudimos cargar este artículo. Por favor, inténtalo de nuevo.',
    days_left: function(c) {
        var d = c['days'];
        if (d === '0') {
            return 'Último día';
        } else if (d === '1') {
            return 'Válido por 1 día más';
        } else {
            return "V\u00E1lido por ".concat(d, " d\u00EDas");
        }
    },
    days_until: function(c) {
        var d = c['days'];
        if (d === '0') {
            return 'Desde hoy';
        } else if (d === '1') {
            return 'Desde mañana';
        } else {
            return "V\u00E1lido en ".concat(d, " d\u00EDas");
        }
    },
    select_stores: 'Solo en tiendas seleccionadas',
    thank_you_for_response: 'Gracias por su respuesta!'
};

var esMxTranslations = {
    example: 'Ejemplo',
    valid_from_to: function(c) {
        return "V\u00E1lido del ".concat(c['from'], " al ").concat(c['to']);
    },
    you_save: 'Ahorra',
    see_more: 'Ver más',
    shop_now: 'Compra ahora',
    view_it: 'Ver ofertas',
    save_deal: 'Guardar oferta',
    percent_off: function(c) {
        return "".concat(c['percent'], "% de descuento");
    },
    item_disclaimer: 'En caso de discrepancias entre este anuncio y el folleto, prevalecerá el folleto.',
    features: 'Características',
    specs: 'Especificaciones',
    click_to_visit_m: function(c) {
        return "Haz clic para saber m\u00E1s ".concat(c['m'], ".");
    },
    seconds_to_expand: 'Se expandirá en',
    seconds_to_expand_mobile: 'Se expandirá en',
    valid: 'Válido',
    add_to_list: 'Agregar a la lista',
    try_again: 'No pudimos cargar este artículo. Por favor, inténtalo de nuevo.',
    days_left: function(c) {
        var d = c['days'];
        if (d === '0') {
            return 'Último día';
        } else if (d === '1') {
            return 'Válido por 1 día más';
        } else {
            return "V\u00E1lido por ".concat(d, " d\u00EDas");
        }
    },
    days_until: function(c) {
        var d = c['days'];
        if (d === '0') {
            return 'Desde hoy';
        } else if (d === '1') {
            return 'Desde mañana';
        } else {
            return "V\u00E1lido en ".concat(d, " d\u00EDas");
        }
    },
    select_stores: 'Solo en tiendas seleccionadas',
    thank_you_for_response: 'Gracias por su respuesta!'
};

var frFrTranslations = {
    example: 'Exemple',
    valid_from_to: function(c) {
        return "Valide du ".concat(c['from'], " au ").concat(c['to']);
    },
    you_save: 'Économisez',
    see_more: 'En savoir plus',
    shop_now: 'Acheter maintenant',
    view_it: 'Voir les offres',
    save_deal: "Enregistrer l'offre",
    percent_off: function(c) {
        return "".concat(c['percent'], "% de r\u00E9duction");
    },
    item_disclaimer: 'En cas de divergence entre cette annonce et le prospectus, le prospectus fait foi.',
    features: 'Caractéristiques',
    specs: 'Spécifications',
    click_to_visit_m: function(c) {
        return "Cliquez pour en savoir plus ".concat(c['m'], ".");
    },
    seconds_to_expand: "S'agrandit dans",
    seconds_to_expand_mobile: "S'agrandit dans",
    valid: 'Valide',
    add_to_list: 'Ajouter à la liste',
    try_again: 'Impossible de charger cet article. Veuillez réessayer.',
    days_left: function(c) {
        var d = c['days'];
        if (d === '0') {
            return 'Dernier jour';
        } else if (d === '1') {
            return 'Valide encore 1 jour';
        } else {
            return "Valide encore ".concat(d, " jours");
        }
    },
    days_until: function(c) {
        var d = c['days'];
        if (d === '0') {
            return "À partir d'aujourd'hui";
        } else if (d === '1') {
            return 'À partir de demain';
        } else {
            return "Valide dans ".concat(d, " jours");
        }
    },
    select_stores: 'Uniquement dans certains magasins',
    thank_you_for_response: 'Merci pour votre réponse!'
};

var ptBrTranslations = {
    example: 'Exemplo',
    valid_from_to: function(c) {
        return "V\u00E1lido de ".concat(c['from'], " at\u00E9 ").concat(c['to']);
    },
    you_save: 'Economize',
    see_more: 'Saiba mais',
    shop_now: 'Compre agora',
    view_it: 'Ver ofertas',
    save_deal: 'Salvar oferta',
    percent_off: function(c) {
        return "".concat(c['percent'], "% de desconto");
    },
    item_disclaimer: 'Em caso de divergência entre este anúncio e o encarte, prevalecerá o encarte.',
    features: 'Características',
    specs: 'Especificações',
    click_to_visit_m: function(c) {
        return "Clique para saber mais ".concat(c['m'], ".");
    },
    seconds_to_expand: 'Expande em',
    seconds_to_expand_mobile: 'Expande em',
    valid: 'Válido',
    add_to_list: 'Adicionar à lista',
    try_again: 'Não foi possível carregar este item. Por favor, tente novamente.',
    days_left: function(c) {
        var d = c['days'];
        if (d === '0') {
            return 'Último dia';
        } else if (d === '1') {
            return 'Válido por mais 1 dia';
        } else {
            return "V\u00E1lido por ".concat(d, " dias");
        }
    },
    days_until: function(c) {
        var d = c['days'];
        if (d === '0') {
            return 'A partir de hoje';
        } else if (d === '1') {
            return 'A partir de amanhã';
        } else {
            return "V\u00E1lido em ".concat(d, " dias");
        }
    },
    select_stores: 'Apenas em lojas selecionadas',
    thank_you_for_response: 'Obrigado pela sua resposta!'
};

var resourceTranslations = {
    en: enTranslations,
    fr: frTranslations,
    de: deTranslations,
    es: esTranslations,
    pt: ptTranslations,
    'es-CO': esCoTranslations,
    'es-MX': esMxTranslations,
    'fr-FR': frFrTranslations,
    'pt-BR': ptBrTranslations
};
function getClientLocale() {
    var _a;
    return ((_a = navigator === null || navigator === undefined ? undefined : navigator.languages) === null || _a === undefined ? undefined : _a[0]) || (navigator === null || navigator === undefined ? undefined : navigator.language) || 'en-US';
}
function getLanguageFromLocale(locale) {
    var _a, _b;
    var localeRegex = /([a-z]{2,4})[_-]*([a-z]{0,3})/i;
    var regexMatch = localeRegex.exec(locale);
    return (_b = (_a = regexMatch === null || regexMatch === undefined ? undefined : regexMatch[1]) === null || _a === undefined ? undefined : _a.toLowerCase()) !== null && _b !== undefined ? _b : locale;
}
/**
 * Normalizes a locale string to BCP 47 format.
 * Examples: fr_FR -> fr-FR, FR-fr -> fr-FR, pt -> pt
 */ function normalizeLocale(locale) {
    if (!locale) return locale;
    var parts = locale.split(/[-_]/).filter(Boolean);
    if (parts.length === 0) return locale;
    var lang = parts[0].toLowerCase();
    if (parts.length === 1) return lang;
    var region = parts[1].toUpperCase();
    return "".concat(lang, "-").concat(region);
}
function getTranslation(translations, _a) {
    var _b;
    var _c = _a === undefined ? {} : _a, language = _c.language, fallbackLanguage = _c.fallbackLanguage;
    // If explicitly provided, treat it as a direct key
    if (language) {
        return (_b = translations[language]) !== null && _b !== undefined ? _b : fallbackLanguage ? translations[fallbackLanguage] : undefined;
    }
    var normalized = normalizeLocale(getClientLocale());
    // 1) try exact locale key first (e.g. fr-FR, es-MX, pt-BR)
    var exact = translations[normalized];
    if (exact !== undefined) return exact;
    // 2) try generic language (e.g. fr for fr-CA; es for es-AR)
    var base = getLanguageFromLocale(normalized);
    var generic = translations[base];
    if (generic !== undefined) return generic;
    // 3) final fallback
    return fallbackLanguage ? translations[fallbackLanguage] : undefined;
}
function i18n(key, context) {
    var _a, _b;
    var dict = (_a = getTranslation(resourceTranslations, {
        fallbackLanguage: 'en'
    })) !== null && _a !== undefined ? _a : {};
    var value = (_b = dict[key]) !== null && _b !== undefined ? _b : key;
    if (typeof value === 'string') {
        return value;
    }
    if (!context) {
        return key;
    }
    return value(context);
}

var CONTROL_TYPE_BUTTON = 1;
var ControlName;
(function(ControlName) {
    ControlName["ShopNow"] = "shop_now";
    ControlName["VisitMerchant"] = "visit_merchant";
})(ControlName || (ControlName = {}));
// DM clicks pass template alt text as the name
var buttonControl = function(name) {
    return {
        type: CONTROL_TYPE_BUTTON,
        name: name
    };
};
// Maps each V2 beacon to the name of the legacy V1 Avro event
var ORIGINAL_EVENT_NAMES = {
    appInitialized: 'flipp.avro.ShopperPlatform.AppInitialized',
    viewableImpression: 'flipp.avro.ShopperPlatform.StorefrontOpenFlyer',
    engagedVisit: 'flipp.avro.ShopperPlatform.StorefrontEngagedVisitFlyer',
    clickFlyerItemDetails: 'flipp.avro.ShopperPlatform.StorefrontClickFlyerItemDetails',
    clickSaveFlyerItemDetails: 'flipp.avro.ShopperPlatform.ItemDetailsClickSave',
    clickItemDetailsTransferToMerchant: 'flipp.avro.ShopperPlatform.ItemDetailsClickTransferToMerchant',
    impressionFlyerItem: 'flipp.avro.ShopperPlatform.StorefrontImpressionFlyerItem',
    decisionResponseSuccess: 'flipp.avro.ShopperPlatform.DecisionResponseSuccess',
    slotImpressionExperience: 'flipp.avro.ShopperPlatform.SlotImpressionExperience',
    containerViewableImpression: 'flipp.avro.ShopperPlatform.ContainerViewableImpression',
    dynamicModuleInView: 'flipp.avro.ShopperPlatform.DynamicModuleInView',
    dynamicModuleImpressionMerchantItem: 'flipp.avro.ShopperPlatform.DynamicModuleImpressionMerchantItem',
    dynamicModuleImpressionCoupon: 'flipp.avro.ShopperPlatform.DynamicModuleImpressionCoupon',
    dynamicModuleClickMerchantItemTransferToMerchant: 'flipp.avro.ShopperPlatform.DynamicModuleClickMerchantItemTransferToMerchant',
    dynamicModuleClickCouponTransferToMerchant: 'flipp.avro.ShopperPlatform.DynamicModuleClickCouponTransferToMerchant',
    dynamicModuleClickBannerSection: 'flipp.avro.ShopperPlatform.DynamicModuleClickBannerSection',
    dynamicModuleVideoAdImpression: 'flipp.avro.ShopperPlatform.DynamicModuleVideoAdImpression',
    dynamicModuleVideoAdHeartbeat: 'flipp.avro.ShopperPlatform.DynamicModuleVideoAdHeartbeat'
};
var createV2BeaconGenerator = function(configGetter) {
    var getConfig = typeof configGetter === 'function' ? configGetter : function() {
        return configGetter;
    };
    var nextSequence = Dc();
    // eslint-disable-next-line functional/no-let
    var _enqueue;
    var enqueue = function(event) {
        if (!_enqueue) {
            var _a = getConfig(), v2SchemaEndpoint = _a.v2SchemaEndpoint, signingKey = _a.signingKey;
            _enqueue = xc(__assign({
                maxSize: 1,
                url: v2SchemaEndpoint
            }, signingKey !== undefined ? {
                signingKey: signingKey
            } : {})).enqueue;
        }
        return _enqueue(event);
    };
    var getAdField = function() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
        var config = getConfig();
        return {
            campaign: {
                campaignId: (_b = (_a = config.decision) === null || _a === undefined ? undefined : _a.campaignId) === null || _b === undefined ? undefined : _b.toString(),
                advertiserId: (_d = (_c = config.decision) === null || _c === undefined ? undefined : _c.advertiserId) === null || _d === undefined ? undefined : _d.toString(),
                provider: Fc.AD_ID_PROVIDER_KEVEL,
                creativeId: (_f = (_e = config.decision) === null || _e === undefined ? undefined : _e.creativeId) === null || _f === undefined ? undefined : _f.toString(),
                dealId: (_h = (_g = config.decision) === null || _g === undefined ? undefined : _g.flightId) === null || _h === undefined ? undefined : _h.toString(),
                flightId: (_k = (_j = config.decision) === null || _j === undefined ? undefined : _j.flightId) === null || _k === undefined ? undefined : _k.toString()
            },
            decisionId: (_m = (_l = config.decision) === null || _l === undefined ? undefined : _l.adId) === null || _m === undefined ? undefined : _m.toString(),
            opportunityId: (_p = (_o = config.decision) === null || _o === undefined ? undefined : _o.campaignId) === null || _p === undefined ? undefined : _p.toString(),
            publisher: {
                provider: Fc.AD_ID_PROVIDER_KEVEL,
                attributionTag: (_r = (_q = config.decision) === null || _q === undefined ? undefined : _q.creativeId) === null || _r === undefined ? undefined : _r.toString(),
                domain: config.site,
                integrationType: config.integrationType,
                publisherId: (_t = (_s = config.decision) === null || _s === undefined ? undefined : _s.siteId) === null || _t === undefined ? undefined : _t.toString(),
                slotId: (_v = (_u = config.decision) === null || _u === undefined ? undefined : _u.zoneId) === null || _v === undefined ? undefined : _v.toString()
            }
        };
    };
    var getDeviceOrientation = function() {
        return window.innerHeight > window.innerWidth ? Sc.PORTRAIT : Sc.LANDSCAPE;
    };
    var getEnvironment = function() {
        switch(environment){
            case 'production':
                return Bc.PRODUCTION;
            case 'staging':
                return Bc.TEST;
            case 'development':
                return Bc.DEVELOPMENT;
            default:
                return Bc.UNSPECIFIED;
        }
    };
    var getExperienceType = function() {
        var _a, _b;
        var config = getConfig();
        if (config.mobileSwipe) {
            return Mc.MOBILE_SWIPE;
        }
        if (config.startCompact) {
            return Mc.COMPACT;
        }
        if (((_a = config.decision) === null || _a === undefined ? undefined : _a.positionIndex) != null) {
            return Mc.MULTI_STANDARD;
        }
        if (config.fixedHeightUnit) {
            return Mc.FIXED_HEIGHT;
        }
        if (((_b = config.dynamicModule) === null || _b === undefined ? undefined : _b.type) === DynamicModuleType.VIDEO_AD) {
            return Mc.UNKNOWN;
        }
        return Mc.CLASSIC;
    };
    var getDeviceType = function() {
        var type = DeviceService.getDeviceInfo().type;
        switch(type){
            case 'mobile':
                return Xc.MOBILE;
            case 'tablet':
                return Xc.TABLET;
            case 'desktop':
                return Xc.DESKTOP;
            default:
                return Xc.DESKTOP;
        }
    };
    var getPlatformFromOSName = function(osName) {
        switch(osName){
            case 'Android':
                return Yc.ANDROID;
            case 'iOS':
                return Yc.IOS;
            case undefined:
            default:
                return Yc.WEB;
        }
    };
    var getDeviceField = function() {
        var _a;
        var _b = DeviceService.getDeviceInfo(), system = _b.system, systemVersion = _b.systemVersion, systemModel = _b.systemModel, browser = _b.browser, browserVersion = _b.browserVersion, screenWidth = _b.screenWidth, screenHeight = _b.screenHeight;
        return {
            orientation: getDeviceOrientation(),
            viewport: {
                pixelRatio: window.devicePixelRatio || 1.0,
                iframeSize: {
                    height: window.innerHeight,
                    width: window.innerWidth
                },
                size: {
                    height: screenHeight,
                    width: screenWidth
                }
            },
            osName: system,
            osVersion: systemVersion,
            platform: getPlatformFromOSName(system),
            model: systemModel,
            locale: getClientLocale().replace(/-/g, '_'),
            browser: browser,
            browserVersion: browserVersion,
            id: (_a = getUserKey()) !== null && _a !== undefined ? _a : undefined,
            idType: Ic.DEVICE_ID_TYPE_UUID,
            type: getDeviceType()
        };
    };
    var getDeviceLocationField = function() {
        var _a, _b, _c;
        var config = getConfig();
        return {
            coordinates: {
                latitude: (_a = config.latitude) !== null && _a !== undefined ? _a : 0,
                longitude: (_b = config.longitude) !== null && _b !== undefined ? _b : 0
            },
            coordinatesAccuracyMeters: (_c = config.accuracyRadius) !== null && _c !== undefined ? _c : 0,
            countryCode: config.country,
            locationSource: Uc.GEOIP,
            postalCode: config.userPostalCode
        };
    };
    var getTargetGroup = function() {
        var config = getConfig();
        return {
            type: config.publicationGlobalId ? {
                value: jc.PUBLICATION,
                case: 'contentV2'
            } : {
                value: Hc.FLYER,
                case: 'contentV1'
            }
        };
    };
    var getFlyerItemTargetGroup = function(offerGlobalId) {
        return {
            type: offerGlobalId ? {
                value: jc.OFFER,
                case: 'contentV2'
            } : {
                value: Hc.FLYER_ITEM,
                case: 'contentV1'
            }
        };
    };
    var getTargetContentV1 = function(storefront) {
        var _a, _b, _c, _d;
        if (!storefront) return undefined;
        return {
            flyer: {
                id: BigInt((_a = storefront.flyer_id) !== null && _a !== undefined ? _a : 0),
                runId: BigInt((_b = storefront.flyer_run_id) !== null && _b !== undefined ? _b : 0),
                typeId: BigInt((_c = storefront.flyer_type_id) !== null && _c !== undefined ? _c : 0),
                isPremium: false
            },
            merchant: {
                id: BigInt((_d = storefront.merchant_id) !== null && _d !== undefined ? _d : 0)
            },
            flyerItem: undefined
        };
    };
    var getTargetContentV2 = function() {
        var config = getConfig();
        if (!config.publicationGlobalId) return undefined;
        return {
            publication: {
                id: config.publicationGlobalId
            }
        };
    };
    var getTargetFlyerItemContentV1 = function(storefront, flyerItemIdV1) {
        var _a, _b, _c, _d;
        if (!storefront) return undefined;
        return {
            merchant: {
                id: BigInt((_a = storefront.merchant_id) !== null && _a !== undefined ? _a : 0)
            },
            flyer: {
                id: BigInt((_b = storefront.flyer_id) !== null && _b !== undefined ? _b : 0),
                runId: BigInt((_c = storefront.flyer_run_id) !== null && _c !== undefined ? _c : 0),
                typeId: BigInt((_d = storefront.flyer_type_id) !== null && _d !== undefined ? _d : 0),
                isPremium: false
            },
            flyerItem: asNumber(flyerItemIdV1) > 0 ? {
                id: BigInt(flyerItemIdV1 !== null && flyerItemIdV1 !== undefined ? flyerItemIdV1 : 0)
            } : undefined
        };
    };
    var getTargetFlyerItemContentV2 = function(offerGlobalId) {
        var config = getConfig();
        if (!offerGlobalId || !config.publicationGlobalId) return undefined;
        return {
            offer: {
                id: offerGlobalId
            },
            publication: {
                id: config.publicationGlobalId
            }
        };
    };
    var getAdTargetField = function(adTargetType) {
        if (adTargetType === undefined) {
            adTargetType = Jc.PLACEMENT;
        }
        var config = getConfig();
        return {
            group: {
                type: {
                    case: 'ad',
                    value: adTargetType
                }
            },
            details: {
                content: {
                    v1: getTargetContentV1(config.storefrontConfig),
                    v2: getTargetContentV2()
                }
            }
        };
    };
    var getAppTargetField = function() {
        return {
            group: {
                type: {
                    case: 'system',
                    value: Qc.WEBSITE
                }
            }
        };
    };
    var getFlyerTargetField = function() {
        var _a, _b, _c;
        var config = getConfig();
        return {
            id: (_a = config.publicationGlobalId) !== null && _a !== undefined ? _a : (_c = (_b = config.decision) === null || _b === undefined ? undefined : _b.adId) === null || _c === undefined ? undefined : _c.toString(),
            group: getTargetGroup(),
            details: {
                content: {
                    v1: getTargetContentV1(config.storefrontConfig),
                    v2: getTargetContentV2()
                }
            }
        };
    };
    var getFlyerItemTargetField = function(flyerItemIdV1, flyerItemGlobalIdV2) {
        var config = getConfig();
        var primaryId = flyerItemGlobalIdV2 !== null && flyerItemGlobalIdV2 !== undefined ? flyerItemGlobalIdV2 : flyerItemIdV1 === null || flyerItemIdV1 === undefined ? undefined : flyerItemIdV1.toString();
        return {
            id: primaryId,
            group: getFlyerItemTargetGroup(flyerItemGlobalIdV2),
            details: {
                content: {
                    v1: getTargetFlyerItemContentV1(config.storefrontConfig, flyerItemIdV1),
                    v2: getTargetFlyerItemContentV2(flyerItemGlobalIdV2)
                }
            }
        };
    };
    // DM offers live in the DM's own publication
    var getDynamicModuleOfferTargetField = function(_a) {
        var offerGlobalId = _a.offerGlobalId, publicationGlobalId = _a.publicationGlobalId;
        var pubId = publicationGlobalId !== null && publicationGlobalId !== undefined ? publicationGlobalId : getConfig().publicationGlobalId;
        return {
            id: offerGlobalId,
            group: getFlyerItemTargetGroup(offerGlobalId),
            details: {
                content: {
                    v2: {
                        offer: {
                            id: offerGlobalId
                        },
                        publication: pubId ? {
                            id: pubId
                        } : undefined
                    }
                }
            }
        };
    };
    var getDynamicModulePublicationTargetField = function(publicationGlobalId) {
        var pubId = publicationGlobalId !== null && publicationGlobalId !== undefined ? publicationGlobalId : getConfig().publicationGlobalId;
        if (!pubId) return getFlyerTargetField();
        return {
            id: pubId,
            group: {
                type: {
                    value: jc.PUBLICATION,
                    case: 'contentV2'
                }
            },
            details: {
                content: {
                    v2: {
                        publication: {
                            id: pubId
                        }
                    }
                }
            }
        };
    };
    var getShopperPlatformUx = function() {
        var config = getConfig();
        if (config.mobileSwipe) {
            return zc.STOREFRONT_INLINE;
        }
        if (config.ux == null || config.ux === UXType.INLINE) {
            return zc.STOREFRONT_INLINE;
        }
        return zc.STOREFRONT_EXPANDED;
    };
    var getUIField = function(surfaceType, destinationSurfaceType, containerType, control) {
        if (surfaceType === undefined) {
            surfaceType = Oc.STOREFRONT;
        }
        if (destinationSurfaceType === undefined) {
            destinationSurfaceType = surfaceType;
        }
        var config = getConfig();
        var storefront = config.storefrontConfig;
        var surface = {
            id: storefront === null || storefront === undefined ? undefined : storefront.sfml_uuid,
            type: surfaceType,
            version: undefined
        };
        return {
            destinationSurface: destinationSurfaceType !== null ? {
                id: storefront === null || storefront === undefined ? undefined : storefront.sfml_uuid,
                type: destinationSurfaceType,
                version: undefined
            } : undefined,
            position: undefined,
            surface: surface,
            containerType: containerType,
            control: control,
            details: {
                source: {
                    case: 'shopperPlatform',
                    value: {
                        adView: kc.DEFAULT,
                        experienceType: getExperienceType(),
                        ux: getShopperPlatformUx()
                    }
                }
            }
        };
    };
    var getBaseEvent = function(v1BeaconID, originalEventName) {
        var _a, _b;
        var config = getConfig();
        var isDoubleFiring = v1BeaconID !== undefined;
        return {
            base: {
                sequenceId: nextSequence(),
                id: v1BeaconID !== null && v1BeaconID !== undefined ? v1BeaconID : generateUUID(),
                clientTimestamp: Math.floor(Date.now() / 1000),
                metadata: {
                    isDoubleFiring: isDoubleFiring,
                    originalEventName: isDoubleFiring ? originalEventName : undefined
                }
            },
            ad: getAdField(),
            device: getDeviceField(),
            deviceLocation: getDeviceLocationField(),
            session: {
                id: getSessionId()
            },
            source: {
                environment: getEnvironment(),
                version: config.appVersion || 'unknown',
                type: {
                    application: {
                        case: 'shopperPlatform',
                        value: {}
                    }
                }
            },
            user: {
                id: (_b = (_a = config.uid) !== null && _a !== undefined ? _a : getUserKey()) !== null && _b !== undefined ? _b : '',
                isAuthenticated: false,
                provider: Wc.UNSPECIFIED
            }
        };
    };
    /**
     * This event is fired when the snippet is executed by a user before we
     * display anything or request any ad decisions.
     */ var sendAppInitialized = function(v1BeaconID) {
        var beacon = __assign(__assign({}, getBaseEvent(v1BeaconID, ORIGINAL_EVENT_NAMES.appInitialized)), {
            ui: getUIField(Oc.WEBSITE, null),
            action: {
                type: {
                    action: {
                        case: 'open',
                        value: {}
                    }
                }
            },
            target: getAppTargetField(),
            interaction: {
                type: {
                    group: {
                        case: 'load',
                        value: {}
                    }
                }
            }
        });
        Logger.debug('Sending app initialized beacon', beacon);
        enqueue(beacon);
    };
    var sendViewableImpression = function(v1BeaconID) {
        var beacon = __assign(__assign({}, getBaseEvent(v1BeaconID, ORIGINAL_EVENT_NAMES.viewableImpression)), {
            ui: getUIField(undefined, undefined, Kc.SCREEN),
            action: {
                type: {
                    action: {
                        case: 'exposure',
                        value: {
                            stage: wc.VIEWABLE
                        }
                    }
                }
            },
            target: getAdTargetField(),
            interaction: {
                type: {
                    group: {
                        case: 'impression',
                        value: {}
                    }
                }
            }
        });
        Logger.debug('Sending viewable impression beacon', beacon);
        enqueue(beacon);
    };
    var sendEngagedVisit = function(v1BeaconID) {
        var _a = getConfig(), creativeEvTimerMs = _a.creativeEvTimerMs, evTimerMs = _a.evTimerMs;
        var beacon = __assign(__assign({}, getBaseEvent(v1BeaconID, ORIGINAL_EVENT_NAMES.engagedVisit)), {
            ui: getUIField(),
            action: {
                type: {
                    action: {
                        case: 'engagedVisit',
                        value: {
                            thresholdVersion: 'v1.0.0',
                            elapsedSeconds: asNumber(creativeEvTimerMs || evTimerMs) / 1000
                        }
                    }
                }
            },
            target: getFlyerTargetField(),
            interaction: {
                type: {
                    group: {
                        case: 'view',
                        value: {}
                    }
                }
            }
        });
        Logger.debug('Sending engaged visit beacon', beacon);
        enqueue(beacon);
    };
    /**
     * Fired when a user clicks and holds until the Item Details pop up for the selected item.
     */ var sendClickFlyerItemDetails = function(v1BeaconID, flyerItemIdV1, flyerItemGlobalIdV2) {
        var beacon = __assign(__assign({}, getBaseEvent(v1BeaconID, ORIGINAL_EVENT_NAMES.clickFlyerItemDetails)), {
            ui: getUIField(Oc.DETAILS),
            action: {
                type: {
                    action: {
                        case: 'invoke',
                        value: {
                            thresholdVersion: 'v1.0.0'
                        }
                    }
                }
            },
            target: getFlyerItemTargetField(-1, flyerItemGlobalIdV2),
            interaction: {
                type: {
                    group: {
                        case: 'click',
                        value: {}
                    }
                }
            }
        });
        Logger.debug('Sending click flyer item details', beacon);
        enqueue(beacon);
    };
    /**
     * Fired when a user clicks the Save Deal button on ItemDetails screen to share the item.
     */ var sendClickSaveFlyerItemDetails = function(v1BeaconID, flyerItemIdV1, flyerItemGlobalIdV2, shareUrl) {
        var beacon = __assign(__assign({}, getBaseEvent(v1BeaconID, ORIGINAL_EVENT_NAMES.clickSaveFlyerItemDetails)), {
            ui: getUIField(Oc.DETAILS),
            action: {
                type: {
                    action: {
                        case: 'share',
                        value: {
                            mode: 1,
                            sharedUrl: shareUrl
                        }
                    }
                }
            },
            target: getFlyerItemTargetField(-1, flyerItemGlobalIdV2),
            interaction: {
                type: {
                    group: {
                        case: 'click',
                        value: {}
                    }
                }
            }
        });
        Logger.debug('Sending click save flyer item details', beacon);
        enqueue(beacon);
    };
    /**
     * Fired when a user transfers to merchant through the ItemDetails screen.
     */ var sendClickItemDetailsTransferToMerchant = function(v1BeaconID, flyerItemIdV1, flyerItemGlobalIdV2, controlName) {
        var beacon = __assign(__assign({}, getBaseEvent(v1BeaconID, ORIGINAL_EVENT_NAMES.clickItemDetailsTransferToMerchant)), {
            ui: getUIField(Oc.DETAILS, undefined, undefined, controlName ? buttonControl(controlName) : undefined),
            action: {
                type: {
                    action: {
                        case: 'transferToMerchant',
                        value: {
                            thresholdVersion: 'v1.0.0'
                        }
                    }
                }
            },
            target: getFlyerItemTargetField(flyerItemIdV1, flyerItemGlobalIdV2),
            interaction: {
                type: {
                    group: {
                        case: 'click',
                        value: {}
                    }
                }
            }
        });
        Logger.debug('Sending click item details transfer to merchant', beacon);
        enqueue(beacon);
    };
    /**
     * Fired when at least one flyer item remains in view for a dwell time of 500ms
     * and meets one of the following visibility conditions:
     *   1) At least 50% of the item is visible within the user's viewport, or
     *   2) The item occupies more than 50% of the user's viewport.
     */ var sendImpressionFlyerItem = function(v1BeaconID, flyerItemsV1, flyerItemGlobalIdV2) {
        var beacon = __assign(__assign({}, getBaseEvent(v1BeaconID, ORIGINAL_EVENT_NAMES.impressionFlyerItem)), {
            ui: getUIField(),
            action: {
                type: {
                    action: {
                        case: 'exposure',
                        value: {
                            stage: wc.VIEWABLE
                        }
                    }
                }
            },
            target: getFlyerItemTargetField(-1, flyerItemGlobalIdV2),
            interaction: {
                type: {
                    group: {
                        case: 'impression',
                        value: {}
                    }
                }
            }
        });
        Logger.debug('Sending send impression flyer item', beacon);
        enqueue(beacon);
    };
    /**
     * Fired when an ad slot impression experience is recorded after an ad decision
     * is successfully returned.
     */ var sendSlotImpressionExperience = function(v1BeaconID) {
        var beacon = __assign(__assign({}, getBaseEvent(v1BeaconID, ORIGINAL_EVENT_NAMES.slotImpressionExperience)), {
            ui: getUIField(),
            action: {
                type: {
                    action: {
                        case: 'exposure',
                        value: {
                            stage: wc.SERVED
                        }
                    }
                }
            },
            target: getAdTargetField(),
            interaction: {
                type: {
                    group: {
                        case: 'impression',
                        value: {}
                    }
                }
            }
        });
        Logger.debug('Sending slot impression experience beacon', beacon);
        enqueue(beacon);
    };
    // Ad container viewable: >=50% for 1s continuous.
    var sendContainerViewableImpression = function(v1BeaconID) {
        var beacon = __assign(__assign({}, getBaseEvent(v1BeaconID, ORIGINAL_EVENT_NAMES.containerViewableImpression)), {
            ui: getUIField(undefined, undefined, Kc.MODULE),
            action: {
                type: {
                    action: {
                        case: 'exposure',
                        value: {
                            stage: wc.VIEWABLE
                        }
                    }
                }
            },
            target: getAdTargetField(),
            interaction: {
                type: {
                    group: {
                        case: 'impression',
                        value: {}
                    }
                }
            }
        });
        Logger.debug('Sending container viewable impression beacon', beacon);
        enqueue(beacon);
    };
    /**
     * Fired when 1px of the dynamic module container
     * enters the viewport.
     */ var sendDynamicModuleInView = function(v1BeaconID) {
        var beacon = __assign(__assign({}, getBaseEvent(v1BeaconID, ORIGINAL_EVENT_NAMES.dynamicModuleInView)), {
            ui: getUIField(Oc.DYNAMIC_MODULE, undefined, Kc.MODULE),
            action: {
                type: {
                    action: {
                        case: 'exposure',
                        value: {
                            stage: wc.IN_VIEW
                        }
                    }
                }
            },
            // TODO: ui_component/module once in schema
            target: getAdTargetField(),
            interaction: {
                type: {
                    group: {
                        case: 'impression',
                        value: {}
                    }
                }
            }
        });
        Logger.debug('Sending dynamic module in view beacon', beacon);
        enqueue(beacon);
    };
    /**
     * Fired on a viewable impression of a dynamic
     * module item or coupon.
     */ var sendDynamicModuleImpressionOffer = function(offer, v1BeaconID) {
        var beacon = __assign(__assign({}, getBaseEvent(v1BeaconID, offer.isCoupon ? ORIGINAL_EVENT_NAMES.dynamicModuleImpressionCoupon : ORIGINAL_EVENT_NAMES.dynamicModuleImpressionMerchantItem)), {
            ui: getUIField(Oc.DYNAMIC_MODULE),
            action: {
                type: {
                    action: {
                        case: 'exposure',
                        value: {
                            stage: wc.VIEWABLE
                        }
                    }
                }
            },
            target: getDynamicModuleOfferTargetField(offer),
            interaction: {
                type: {
                    group: {
                        case: 'impression',
                        value: {}
                    }
                }
            }
        });
        Logger.debug('Sending dynamic module impression offer', beacon);
        enqueue(beacon);
    };
    /**
     * Fired when a dynamic module item or coupon click
     * transfers the user to the merchant.
     */ var sendDynamicModuleClickOfferTransferToMerchant = function(offer, v1BeaconID) {
        var beacon = __assign(__assign({}, getBaseEvent(v1BeaconID, offer.isCoupon ? ORIGINAL_EVENT_NAMES.dynamicModuleClickCouponTransferToMerchant : ORIGINAL_EVENT_NAMES.dynamicModuleClickMerchantItemTransferToMerchant)), {
            ui: getUIField(Oc.DYNAMIC_MODULE),
            action: {
                type: {
                    action: {
                        case: 'transferToMerchant',
                        value: {
                            thresholdVersion: 'v1.0.0'
                        }
                    }
                }
            },
            target: getDynamicModuleOfferTargetField(offer),
            interaction: {
                type: {
                    group: {
                        case: 'click',
                        value: {}
                    }
                }
            }
        });
        Logger.debug('Sending dynamic module click offer TTM', beacon);
        enqueue(beacon);
    };
    /**
     * Fired when a dynamic module banner or CTA click
     * transfers the user to the merchant. controlName
     * tells the clicked area apart.
     */ var sendDynamicModuleClickCreativeTransferToMerchant = function(controlName, v1BeaconID) {
        var beacon = __assign(__assign({}, getBaseEvent(v1BeaconID, ORIGINAL_EVENT_NAMES.dynamicModuleClickBannerSection)), {
            ui: getUIField(Oc.DYNAMIC_MODULE, undefined, undefined, buttonControl(controlName)),
            action: {
                type: {
                    action: {
                        case: 'transferToMerchant',
                        value: {
                            thresholdVersion: 'v1.0.0'
                        }
                    }
                }
            },
            target: getAdTargetField(Jc.CREATIVE),
            interaction: {
                type: {
                    group: {
                        case: 'click',
                        value: {}
                    }
                }
            }
        });
        Logger.debug('Sending dynamic module click creative TTM', beacon);
        enqueue(beacon);
    };
    /**
     * Fired once the video ad has played >=50% in
     * view for 2s (MRC video threshold).
     */ var sendDynamicModuleVideoAdImpression = function(v1BeaconID) {
        var beacon = __assign(__assign({}, getBaseEvent(v1BeaconID, ORIGINAL_EVENT_NAMES.dynamicModuleVideoAdImpression)), {
            ui: getUIField(Oc.DYNAMIC_MODULE, undefined, Kc.MODULE),
            action: {
                type: {
                    action: {
                        case: 'exposure',
                        value: {
                            stage: wc.VIEWABLE
                        }
                    }
                }
            },
            target: getAdTargetField(),
            interaction: {
                type: {
                    group: {
                        case: 'impression',
                        value: {}
                    }
                }
            }
        });
        Logger.debug('Sending dynamic module video ad impression', beacon);
        enqueue(beacon);
    };
    /**
     * Fired at each heartbeat mark of accumulated
     * in-view video time.
     */ var sendDynamicModuleVideoAdHeartbeat = function(elapsedSeconds, publicationGlobalId, v1BeaconID) {
        var beacon = __assign(__assign({}, getBaseEvent(v1BeaconID, ORIGINAL_EVENT_NAMES.dynamicModuleVideoAdHeartbeat)), {
            ui: getUIField(Oc.DYNAMIC_MODULE, undefined, Kc.MODULE),
            action: {
                type: {
                    action: {
                        case: 'heartbeat',
                        value: {
                            elapsedSeconds: elapsedSeconds
                        }
                    }
                }
            },
            target: getDynamicModulePublicationTargetField(publicationGlobalId),
            interaction: {
                type: {
                    group: {
                        case: 'autoTriggered',
                        value: {}
                    }
                }
            }
        });
        Logger.debug('Sending dynamic module video ad heartbeat', beacon);
        enqueue(beacon);
    };
    /**
     * Fired when we receive a successful response from the decision API.
     */ var sendDecisionResponseSuccess = function(v1BeaconID) {
        var beacon = __assign(__assign({}, getBaseEvent(v1BeaconID, ORIGINAL_EVENT_NAMES.decisionResponseSuccess)), {
            ui: getUIField(),
            action: {
                type: {
                    action: {
                        case: 'adDecision',
                        value: {
                            status: 1
                        }
                    }
                }
            },
            target: getAdTargetField(),
            interaction: {
                type: {
                    group: {
                        case: 'autoTriggered',
                        value: {}
                    }
                }
            }
        });
        Logger.debug('Sending decision response success beacon', beacon);
        enqueue(beacon);
        return beacon;
    };
    return {
        enqueue: enqueue,
        sendAppInitialized: sendAppInitialized,
        sendViewableImpression: sendViewableImpression,
        sendEngagedVisit: sendEngagedVisit,
        sendClickFlyerItemDetails: sendClickFlyerItemDetails,
        sendClickSaveFlyerItemDetails: sendClickSaveFlyerItemDetails,
        sendClickItemDetailsTransferToMerchant: sendClickItemDetailsTransferToMerchant,
        sendImpressionFlyerItem: sendImpressionFlyerItem,
        sendDecisionResponseSuccess: sendDecisionResponseSuccess,
        sendSlotImpressionExperience: sendSlotImpressionExperience,
        sendContainerViewableImpression: sendContainerViewableImpression,
        sendDynamicModuleInView: sendDynamicModuleInView,
        sendDynamicModuleImpressionOffer: sendDynamicModuleImpressionOffer,
        sendDynamicModuleClickOfferTransferToMerchant: sendDynamicModuleClickOfferTransferToMerchant,
        sendDynamicModuleClickCreativeTransferToMerchant: sendDynamicModuleClickCreativeTransferToMerchant,
        sendDynamicModuleVideoAdImpression: sendDynamicModuleVideoAdImpression,
        sendDynamicModuleVideoAdHeartbeat: sendDynamicModuleVideoAdHeartbeat
    };
};

var executeBeaconCallback = function(beaconEventCallbacks, callback) {
    var _a, _b;
    if (beaconEventCallbacks === null || beaconEventCallbacks === undefined ? undefined : beaconEventCallbacks.includes(callback)) {
        if (callback === 'servedImpression') {
            if ((_a = window.flippxp.analyticsCallbacks) === null || _a === undefined ? undefined : _a.sImp) {
                return (_b = window.flippxp.analyticsCallbacks) === null || _b === undefined ? undefined : _b.sImp();
            }
        }
    }
};

function withLibraryImportGuard(fn, context) {
    var _this = this;
    // eslint-disable-next-line functional/functional-parameters
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++){
            args[_i] = arguments[_i];
        }
        return __awaiter(_this, undefined, undefined, function() {
            return __generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    fn.apply(undefined, args)
                ];
            });
        });
    };
}
var detectBotByUa = withLibraryImportGuard(function() {
    var args_1 = [];
    for(var _i = 0; _i < arguments.length; _i++){
        args_1[_i] = arguments[_i];
    }
    return __awaiter(undefined, __spreadArray([], args_1, true), undefined, function(userAgent) {
        var isbot;
        if (userAgent === undefined) {
            userAgent = navigator.userAgent;
        }
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        Promise.resolve().then(function () { return index$1; })
                    ];
                case 1:
                    isbot = _a.sent().isbot;
                    return [
                        2 /*return*/ ,
                        isbot(userAgent)
                    ];
            }
        });
    });
});
var detectBotWithBotd = withLibraryImportGuard(function() {
    return __awaiter(undefined, undefined, undefined, function() {
        var load, botd, result;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        Promise.resolve().then(function () { return botd_esm; })
                    ];
                case 1:
                    load = _a.sent().load;
                    return [
                        4 /*yield*/ ,
                        load()
                    ];
                case 2:
                    botd = _a.sent();
                    result = botd.detect();
                    return [
                        2 /*return*/ ,
                        result.bot
                    ];
            }
        });
    });
});
function detectBot() {
    return __awaiter(this, undefined, undefined, function() {
        var isBotBotD, isBotByUa, result;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        detectBotWithBotd()
                    ];
                case 1:
                    isBotBotD = _a.sent();
                    return [
                        4 /*yield*/ ,
                        detectBotByUa()
                    ];
                case 2:
                    isBotByUa = _a.sent();
                    result = {
                        isBotBotD: isBotBotD,
                        isBotByUa: isBotByUa
                    };
                    Logger.debug('Bot detection result:', result);
                    return [
                        2 /*return*/ ,
                        result
                    ];
            }
        });
    });
}
var logBotDetection = function(_a) {
    var isBotBotD = _a.isBotBotD, isBotByUa = _a.isBotByUa;
    if (isBotBotD || isBotByUa) {
        void logError('Bot was detected', "isBotBotD - ".concat(isBotBotD, ", isBotByUa - ").concat(isBotByUa), undefined, CLOUD_WATCH_SERVICES.shopperAdWebBotd);
    }
};
var logTrafficBlock = function(detectionResults) {
    var blockReasons = Object.entries(detectionResults).filter(function(res) {
        return res[1];
    }).map(function(_a) {
        var key = _a[0];
        return key;
    });
    var blockStack = blockReasons.map(function(key) {
        return "".concat(key, " - true");
    }).join(', ');
    void logError('Traffic was blocked', blockStack, undefined, CLOUD_WATCH_SERVICES.shopperAdWebBlockedTraffic);
};

var isIntersectionObserverSupported = function() {
    return 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'isIntersecting' in window.IntersectionObserverEntry.prototype;
};

var InlineObject = {
    adId: 278479768,
    advertiserId: 2115892,
    campaignId: 89720721,
    clickUrl: 'https://r.gif',
    contents: [
        {
            body: '<script></script>',
            customTemplate: '<script></script>',
            data: {
                customData: {
                    campaignConfigUrl: 'https://1.json',
                    campaignNameIdentifier: 'Kroger Michigan P1 2022_c5cc54c5',
                    dwellTimerMs: 10000,
                    experienceLimit: 1,
                    standardHeight: 2100,
                    withNearestStore: false
                },
                height: 1800,
                width: 300
            },
            type: 'raw'
        }
    ],
    creativeId: 106718216,
    flightId: 269949989,
    height: 1800,
    impressionUrl: 'https://i.gif',
    priorityId: 232453,
    storefront: {
        campaignConfig: {
            fallbackImageUrl: 'https://f.png',
            fallbackLinkUrl: 'https://www.kroger.com/weeklyad',
            tags: {
                advertiser: {
                    open: [
                        'https://advertiseropen.gif'
                    ],
                    impression: [
                        'https://advertiserimpression.gif'
                    ],
                    engagement: [
                        'https://advertiserengageament.gif'
                    ]
                }
            }
        },
        flyer_id: 6354268,
        flyer_run_id: 965726,
        flyer_type_id: 2826,
        is_fallback: true,
        merchant: 'Kroger',
        merchant_id: 2778,
        name: ' Weekly Ad',
        skuList: [],
        storefront_logo_url: 'https://logo.jpeg',
        storefront_payload_url: 'https://paload.json',
        valid_from: '2024-02-28 05:00:00 +0000 UTC',
        valid_to: '2024-03-06 04:59:59 +0000 UTC'
    },
    width: 300
};
var LocationObject = {
    accuracy_radius: 5,
    city: 'Surrey',
    country: 'CA',
    ip: '207.81.217.189',
    latitude: 49.1049,
    longitude: -122.824,
    postal_code: 'V3Z',
    region: 'BC',
    region_name: 'British Columbia'
};

var validHexColor = function(color) {
    var regex = /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i;
    return regex.test(color);
};

var getCustomContent = function(config) {
    return __awaiter(undefined, undefined, undefined, function() {
        var content;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    content = null;
                    if (!(config === null || config === undefined ? undefined : config.customContentS3)) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        fetchContentFromS3(config.customContentS3)
                    ];
                case 1:
                    content = _a.sent();
                    if (!content) {
                        console.error('Failed to load custom content from S3 or content is empty.');
                        return [
                            2 /*return*/ ,
                            null
                        ];
                    }
                    _a.label = 2;
                case 2:
                    if (!content && (config === null || config === undefined ? undefined : config.customContentHtml)) {
                        try {
                            content = atob(config.customContentHtml);
                        } catch (error) {
                            console.error('Failed to decode customContentHtml:', error);
                            return [
                                2 /*return*/ ,
                                null
                            ];
                        }
                    }
                    return [
                        2 /*return*/ ,
                        content
                    ];
            }
        });
    });
};
// Fetch content from S3
var fetchContentFromS3 = function(s3Url) {
    return __awaiter(undefined, undefined, undefined, function() {
        var response, error_1;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    _a.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4 /*yield*/ ,
                        fetch(s3Url)
                    ];
                case 1:
                    response = _a.sent();
                    if (!response.ok) {
                        console.error('Error fetching S3 content:', response.statusText);
                        return [
                            2 /*return*/ ,
                            null
                        ];
                    }
                    return [
                        4 /*yield*/ ,
                        response.text()
                    ];
                case 2:
                    return [
                        2 /*return*/ ,
                        _a.sent()
                    ];
                case 3:
                    error_1 = _a.sent();
                    console.error('Error fetching S3 content:', error_1);
                    return [
                        2 /*return*/ ,
                        null
                    ];
                case 4:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
};
var injectCustomContent = function(iframe, kevelConfig) {
    return __awaiter(undefined, undefined, undefined, function() {
        var content, iframeDoc;
        var _a;
        return __generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        getCustomContent(kevelConfig)
                    ];
                case 1:
                    content = _b.sent();
                    if (!content) {
                        console.error('No custom content source provided or available.');
                        return [
                            2 /*return*/ 
                        ];
                    }
                    iframeDoc = iframe.contentDocument || ((_a = iframe.contentWindow) === null || _a === undefined ? undefined : _a.document);
                    if (iframeDoc) {
                        iframeDoc.open();
                        iframeDoc.write(content);
                        iframeDoc.close();
                    }
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
};
var createIntersectionObserver = function(callback) {
    return new IntersectionObserver(callback, {
        threshold: 0.5
    });
};
var createCustomContentWrapper = function(customContentContainer) {
    var wrapper = document.createElement('div');
    wrapper.id = 'wrapper-kargo';
    wrapper.style.position = 'relative';
    wrapper.appendChild(customContentContainer);
    return wrapper;
};
// Create a custom content container
var createCustomContentIframe = function(customContentHeight) {
    var customContentContainer = document.createElement('iframe');
    if (customContentHeight) {
        customContentContainer.height = String(customContentHeight);
    }
    return customContentContainer;
};
var attachClickEvent = function(iframe, clickListener, resizeCallback) {
    var parent = iframe.parentElement;
    // Create the overlay element
    var overlay = document.createElement('div');
    overlay.id = 'overlay-kargo';
    // Position the overlay exactly over the iframe
    overlay.style.position = 'absolute';
    overlay.style.top = '0';
    overlay.style.left = '0';
    overlay.style.cursor = 'pointer';
    var updateOverlaySize = function() {
        var rect = iframe.getBoundingClientRect();
        overlay.style.width = "".concat(rect.width, "px");
        overlay.style.height = "".concat(rect.height, "px");
    };
    // Set initial size
    updateOverlaySize();
    if (resizeCallback) {
        window.addEventListener('resize', updateOverlaySize);
    }
    // Use the passed click listener
    overlay.addEventListener('click', clickListener);
    parent === null || parent === undefined ? undefined : parent.appendChild(overlay);
    return overlay;
};
var attachObserver = function(customContentContainer, impressionCallback) {
    var callback = function(entry) {
        if (entry.isIntersecting) {
            impressionCallback();
            return true;
        }
        return false;
    };
    var handleEntries = function(entries, observer) {
        entries.forEach(function(entry) {
            if (callback(entry)) {
                observer.unobserve(entry.target);
            }
        });
    };
    var observer = createIntersectionObserver(handleEntries);
    observer.observe(customContentContainer);
};
var getBeaconPayload = function(adId, campaignNameIdentifier, customContentSize, customContentSection) {
    return {
        id: adId,
        name: campaignNameIdentifier || '',
        ad_size: customContentSize,
        ad_page: customContentSection == -1 ? 'END' : customContentSection
    };
};

var convertToISOString = function(str) {
    if (!str) {
        return '';
    }
    var date = str.replace(' ', 'T').replace(' +0000 UTC', 'Z').split(' +')[0];
    return new Date(date).toISOString();
};

var getFlyerLegacyIds = function(legacyIds, publicationGlobalId) {
    var fallback = publicationGlobalId ? LEGACY_ID_FALLBACK : -1;
    return {
        flyerId: asNumber(legacyIds === null || legacyIds === undefined ? undefined : legacyIds.flyer_id, fallback),
        flyerRunId: asNumber(legacyIds === null || legacyIds === undefined ? undefined : legacyIds.flyer_run_id, fallback),
        flyerTypeId: asNumber(legacyIds === null || legacyIds === undefined ? undefined : legacyIds.flyer_type_id, fallback)
    };
};

var isContentCodePresent = function(search) {
    if (search === undefined) {
        search = window.location.search;
    }
    return new URLSearchParams(search).has('flipp-content-code');
};

var toStr = function(v) {
    var _a;
    return typeof v === 'string' ? v : (_a = JSON.stringify(v)) !== null && _a !== undefined ? _a : '';
};
// Equality that tolerates number/string id mismatches.
var looseEqual = function(a, b) {
    return a === b || toStr(a) === toStr(b);
};
var COMPARATORS = {
    COMPARATOR_EQUAL: looseEqual,
    COMPARATOR_NOT_EQUAL: function(a, b) {
        return !looseEqual(a, b);
    },
    COMPARATOR_GREATER_THAN: function(a, b) {
        return a > b;
    },
    COMPARATOR_LESS_THAN: function(a, b) {
        return a < b;
    },
    COMPARATOR_GREATER_THAN_EQUAL_TO: function(a, b) {
        return a >= b;
    },
    COMPARATOR_LESS_THAN_EQUAL_TO: function(a, b) {
        return a <= b;
    },
    COMPARATOR_CONTAINS: function(a, b) {
        return toStr(a).toLowerCase().includes(toStr(b).toLowerCase());
    },
    COMPARATOR_NOT_CONTAINS: function(a, b) {
        return !toStr(a).toLowerCase().includes(toStr(b).toLowerCase());
    }
};
var categoryLevel = function(paths, level) {
    return paths.flatMap(function(path) {
        var val = path.data[level];
        return val !== undefined ? [
            val
        ] : [];
    });
};
// SKU lives in product ids or details additional_info.
var collectSkus = function(atom) {
    var _a, _b, _c, _d, _e;
    var additionalInfo = (_a = atom.details) === null || _a === undefined ? undefined : _a.additionalInfo;
    var candidates = __spreadArray([
        additionalInfo === null || additionalInfo === undefined ? undefined : additionalInfo.sku,
        (_c = (_b = atom.product) === null || _b === undefined ? undefined : _b.additionalIds) === null || _c === undefined ? undefined : _c.sku
    ], ((_e = (_d = atom.offer) === null || _d === undefined ? undefined : _d.products) !== null && _e !== undefined ? _e : []).map(function(p) {
        var _a;
        return (_a = p.additionalIds) === null || _a === undefined ? undefined : _a.sku;
    }), true);
    return candidates.filter(function(s) {
        return typeof s === 'string';
    });
};
// Brand IDs live on offer or product metadata.
var collectBrandIds = function(atom) {
    var _a, _b, _c, _d, _e;
    var ids = __spreadArray(__spreadArray([], (_c = (_b = (_a = atom.offer) === null || _a === undefined ? undefined : _a.metadata) === null || _b === undefined ? undefined : _b.brandIds) !== null && _c !== undefined ? _c : [], true), [
        (_e = (_d = atom.product) === null || _d === undefined ? undefined : _d.metadata) === null || _e === undefined ? undefined : _e.brand
    ], false);
    return ids.filter(function(id) {
        return typeof id === 'number';
    });
};
var getFieldValue = function(atom, field) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    var googleCats = (_c = (_b = (_a = atom.offer) === null || _a === undefined ? undefined : _a.categories) === null || _b === undefined ? undefined : _b.googleCategories) !== null && _c !== undefined ? _c : [];
    var merchantCats = (_f = (_e = (_d = atom.offer) === null || _d === undefined ? undefined : _d.categories) === null || _e === undefined ? undefined : _e.merchantCategories) !== null && _f !== undefined ? _f : [];
    switch(field){
        case 'FIELD_PRICE':
            return (_j = (_h = (_g = atom.offer) === null || _g === undefined ? undefined : _g.pricing) === null || _h === undefined ? undefined : _h.price) !== null && _j !== undefined ? _j : (_l = (_k = atom.offer) === null || _k === undefined ? undefined : _k.pricing) === null || _l === undefined ? undefined : _l.salePrice;
        case 'FIELD_MERCHANT_ID':
            return (_m = atom.offer) === null || _m === undefined ? undefined : _m.merchantId;
        case 'FIELD_CATEGORY_L1':
            return categoryLevel(googleCats, 0);
        case 'FIELD_CATEGORY_L2':
            return categoryLevel(googleCats, 1);
        case 'FIELD_CATEGORY_L3':
            return categoryLevel(googleCats, 2);
        case 'FIELD_CATEGORY_L4':
            return categoryLevel(googleCats, 3);
        case 'FIELD_CATEGORY_L5':
            return categoryLevel(googleCats, 4);
        case 'FIELD_CATEGORY_L6':
            return categoryLevel(googleCats, 5);
        case 'FIELD_CATEGORY_L7':
            return categoryLevel(googleCats, 6);
        case 'FIELD_MERCHANT_CATEGORY':
            return merchantCats.flatMap(function(path) {
                return path.data;
            });
        case 'FIELD_SKU':
            return collectSkus(atom);
        case 'FIELD_BRAND_ID':
            return collectBrandIds(atom);
        case 'FIELD_SALE_STORY':
            return (_p = (_o = atom.offer) === null || _o === undefined ? undefined : _o.offerDetails) === null || _p === undefined ? undefined : _p.saleStory;
        default:
            return undefined;
    }
};
// NOT_* over a multi-valued field must hold for
// every value, matching OpenSearch must_not.
var NEGATIVE_COMPARATORS = new Set([
    'COMPARATOR_NOT_EQUAL',
    'COMPARATOR_NOT_CONTAINS'
]);
var applyComparator = function(atomValue, operator, filterValue) {
    var _a, _b;
    if (Array.isArray(atomValue)) {
        var compare = function(v) {
            var _a, _b;
            return (_b = (_a = COMPARATORS[operator]) === null || _a === undefined ? undefined : _a.call(COMPARATORS, v, filterValue)) !== null && _b !== undefined ? _b : true;
        };
        // An empty field matches nothing positively
        // but passes NOT_* vacuously.
        if (NEGATIVE_COMPARATORS.has(operator)) return atomValue.every(compare);
        if (atomValue.length === 0) return false;
        return atomValue.some(compare);
    }
    return (_b = (_a = COMPARATORS[operator]) === null || _a === undefined ? undefined : _a.call(COMPARATORS, atomValue, filterValue)) !== null && _b !== undefined ? _b : true;
};
var matchesFilter = function(atom, filter) {
    var _a, _b;
    if (filter.fieldFilter) {
        var fieldFilter = filter.fieldFilter;
        var atomValue = getFieldValue(atom, fieldFilter.field);
        if (atomValue === undefined) return false;
        return applyComparator(atomValue, fieldFilter.operator, fieldFilter.value);
    }
    if (filter.additionalInfoFieldFilter) {
        var aif = filter.additionalInfoFieldFilter;
        var atomValue = (_b = (_a = atom.details) === null || _a === undefined ? undefined : _a.additionalInfo) === null || _b === undefined ? undefined : _b[aif.field];
        if (atomValue === undefined) return false;
        return applyComparator(atomValue, aif.operator, aif.value);
    }
    if (filter.filterGroup) {
        return matchesFilterGroup(atom, filter.filterGroup);
    }
    return true;
};
var matchesFilterGroup = function(atom, group) {
    var operator = group.operator, filters = group.filters;
    if (operator === 'BOOLEAN_OPERATOR_OR') {
        return filters.some(function(f) {
            return matchesFilter(atom, f);
        });
    }
    return filters.every(function(f) {
        return matchesFilter(atom, f);
    });
};
var getAtomName = function(atom) {
    var _a, _b, _c, _d;
    return (((_a = atom.details) === null || _a === undefined ? undefined : _a.name) || ((_d = (_c = (_b = atom.offer) === null || _b === undefined ? undefined : _b.products) === null || _c === undefined ? undefined : _c[0]) === null || _d === undefined ? undefined : _d.descriptor) || '').toLowerCase();
};
var matchesKeywords = function(atom, keywords) {
    if (!keywords.length) return true;
    var name = getAtomName(atom);
    return keywords.some(function(kw) {
        return name.includes(kw.toLowerCase());
    });
};
var passesExcludeKeywords = function(atom, excludeKeywords) {
    if (!excludeKeywords.length) return true;
    var name = getAtomName(atom);
    return excludeKeywords.every(function(kw) {
        return !name.includes(kw.toLowerCase());
    });
};
var toQueryRequests = function(requests) {
    return requests.map(function(r) {
        return r.queryRequest;
    }).filter(function(q) {
        return q !== undefined;
    });
};
// True when the atom satisfies a single query request.
var matchesRequest = function(atom, request) {
    var _a, _b, _c;
    return matchesKeywords(atom, (_a = request.keywords) !== null && _a !== undefined ? _a : []) && passesExcludeKeywords(atom, (_b = request.excludeKeywords) !== null && _b !== undefined ? _b : []) && ((_c = request.filters) !== null && _c !== undefined ? _c : []).every(function(f) {
        return matchesFilter(atom, f);
    });
};
// An atom qualifies as priced via a numeric price field or, for
// merchants that leave those empty, a non-empty sale story.
var isPricedAtom = function(atom) {
    var _a, _b, _c;
    var pricing = (_a = atom.offer) === null || _a === undefined ? undefined : _a.pricing;
    var saleStory = (_c = (_b = atom.offer) === null || _b === undefined ? undefined : _b.offerDetails) === null || _c === undefined ? undefined : _c.saleStory;
    return typeof (pricing === null || pricing === undefined ? undefined : pricing.price) === 'number' && pricing.price > 0 || typeof (pricing === null || pricing === undefined ? undefined : pricing.salePrice) === 'number' && pricing.salePrice > 0 || typeof (pricing === null || pricing === undefined ? undefined : pricing.amountOff) === 'number' && pricing.amountOff > 0 || typeof (pricing === null || pricing === undefined ? undefined : pricing.percentOff) === 'number' && pricing.percentOff > 0 || typeof saleStory === 'string' && saleStory.length > 0;
};
var selectSectionsByIndex = function(sections, include, exclude) {
    // Empty include list = every index eligible.
    var isKept = function(index) {
        return (!(include === null || include === undefined ? undefined : include.length) || include.includes(index)) && !(exclude === null || exclude === undefined ? undefined : exclude.includes(index));
    };
    var kept = [];
    var excluded = [];
    sections.forEach(function(section, index) {
        if (isKept(index)) kept.push(section);
        else excluded.push(section);
    });
    Logger.debug('[Collection Ads]' + excluded.length + ' sections are excluded');
    Logger.debug(excluded);
    return kept;
};
var excludeAtomsByFilter = function(atoms, requests) {
    var queryRequests = toQueryRequests(requests);
    if (!queryRequests.length) return __spreadArray([], atoms, true);
    var kept = [];
    var excluded = [];
    var _loop_1 = function(atom) {
        if (queryRequests.some(function(request) {
            return matchesRequest(atom, request);
        })) {
            excluded.push(atom);
        } else {
            kept.push(atom);
        }
    };
    for(var _i = 0, atoms_1 = atoms; _i < atoms_1.length; _i++){
        var atom = atoms_1[_i];
        _loop_1(atom);
    }
    Logger.debug('[Collection Ads]' + excluded.length + ' items are excluded');
    Logger.debug(excluded);
    return kept;
};
var filterAtoms = function(atoms, requests, limit) {
    var queryRequests = toQueryRequests(requests);
    if (!queryRequests.length) return __spreadArray([], atoms, true);
    var seen = new Set();
    var result = [];
    for(var _i = 0, queryRequests_1 = queryRequests; _i < queryRequests_1.length; _i++){
        var request = queryRequests_1[_i];
        for(var _a = 0, atoms_2 = atoms; _a < atoms_2.length; _a++){
            var atom = atoms_2[_a];
            if (seen.has(atom.globalId)) continue;
            if (!matchesRequest(atom, request)) continue;
            seen.add(atom.globalId);
            result.push(atom);
        }
    }
    Logger.debug('[Collection Ads]' + result.length + ' items are selected');
    Logger.debug(result);
    return limit !== undefined ? result.slice(0, limit) : result;
};

var FALLBACK_FIELDS = [
    'name',
    'description',
    'imageUrl'
];
var productDetails = function(atom, language) {
    var _a, _b, _c, _d;
    var details = (_c = (_b = (_a = atom.offer) === null || _a === undefined ? undefined : _a.products) === null || _b === undefined ? undefined : _b[0]) === null || _c === undefined ? undefined : _c.details;
    return (_d = details === null || details === undefined ? undefined : details[language]) !== null && _d !== undefined ? _d : details === null || details === undefined ? undefined : details.en;
};
// Catalog offers only carry details on the product,
// so fill blank atom fields from offer, then product.
var withFallbackDetails = function(atom, language) {
    var _a;
    if (language === undefined) {
        language = 'en';
    }
    var sources = [
        atom.details,
        (_a = atom.offer) === null || _a === undefined ? undefined : _a.details,
        productDetails(atom, language)
    ];
    var pick = function(field) {
        return sources.map(function(source) {
            return source === null || source === undefined ? undefined : source[field];
        }).find(function(value) {
            return !!value;
        });
    };
    var missing = FALLBACK_FIELDS.filter(function(field) {
        var _a;
        return !((_a = atom.details) === null || _a === undefined ? undefined : _a[field]);
    });
    if (!missing.length) return atom;
    var filled = Object.fromEntries(missing.map(function(field) {
        return [
            field,
            pick(field)
        ];
    }).filter(function(_a) {
        var value = _a[1];
        return value !== undefined;
    }));
    if (!Object.keys(filled).length) return atom;
    return __assign(__assign({}, atom), {
        details: __assign(__assign({
            additionalInfo: undefined,
            additionalMedia: []
        }, atom.details), filled)
    });
};
// Applies withFallbackDetails to every atom
var withPayloadFallbackDetails = function(payload, fallbackLanguage) {
    var _a;
    if (fallbackLanguage === undefined) {
        fallbackLanguage = 'en';
    }
    var language = payload.language || fallbackLanguage;
    return __assign(__assign({}, payload), {
        sections: ((_a = payload.sections) !== null && _a !== undefined ? _a : []).map(function(section) {
            var _a;
            return __assign(__assign({}, section), {
                atoms: ((_a = section.atoms) !== null && _a !== undefined ? _a : []).map(function(atom) {
                    return withFallbackDetails(atom, language);
                })
            });
        })
    });
};

// src/patterns.json
var patterns_default = [
    " daum[ /]",
    " deusu/",
    "(?:^|[^g])news(?!sapphire)",
    "(?<! (?:channel/|google/))google(?!(app|/google| pixel))",
    "(?<! cu)bots?(?:\\b|_)",
    "(?<!(?:lib))http",
    "(?<![hg]m)score",
    "(?<!cam)scan",
    "@[a-z][\\w-]+\\.",
    "\\(\\)",
    "\\.com\\b",
    "\\btime/",
    "\\|",
    "^<",
    "^[\\w \\.\\-\\(?:\\):%]+(?:/v?\\d+(?:\\.\\d+)?(?:\\.\\d{1,10})*?)?(?:,|$)",
    "^[^ ]{50,}$",
    "^\\d+\\b",
    "^\\w*search\\b",
    "^\\w+/[\\w\\(\\)]*$",
    "^active",
    "^ad muncher",
    "^amaya",
    "^avsdevicesdk/",
    "^azure",
    "^biglotron",
    "^bot",
    "^bw/",
    "^clamav[ /]",
    "^client/",
    "^cobweb/",
    "^custom",
    "^ddg[_-]android",
    "^discourse",
    "^dispatch/\\d",
    "^downcast/",
    "^duckduckgo",
    "^email",
    "^facebook",
    "^getright/",
    "^gozilla/",
    "^hobbit",
    "^hotzonu",
    "^hwcdn/",
    "^igetter/",
    "^jeode/",
    "^jetty/",
    "^jigsaw",
    "^microsoft bits",
    "^movabletype",
    "^mozilla/\\d\\.\\d\\s[\\w\\.-]+$",
    "^mozilla/\\d\\.\\d\\s\\(compatible;?(?:\\s\\w+\\/\\d+\\.\\d+)?\\)$",
    "^navermailapp",
    "^netsurf",
    "^offline",
    "^openai/",
    "^owler",
    "^php",
    "^postman",
    "^python",
    "^rank",
    "^read",
    "^reed",
    "^rest",
    "^rss",
    "^snapchat",
    "^space bison",
    "^svn",
    "^swcd ",
    "^taringa",
    "^thumbor/",
    "^track",
    "^w3c",
    "^webbandit/",
    "^webcopier",
    "^wget",
    "^whatsapp",
    "^wordpress",
    "^xenu link sleuth",
    "^yahoo",
    "^yandex",
    "^zdm/\\d",
    "^zoom marketplace/",
    "agent",
    "analyzer",
    "archive",
    "ask jeeves/teoma",
    "audit",
    "bit\\.ly/",
    "bluecoat drtr",
    "browsex",
    "burpcollaborator",
    "capture",
    "catch",
    "check\\b",
    "checker",
    "chrome-lighthouse",
    "chromeframe",
    "classifier",
    "cloudflare",
    "convertify",
    "crawl",
    "cypress/",
    "dareboost",
    "datanyze",
    "dejaclick",
    "detect",
    "dmbrowser",
    "download",
    "evc-batch/",
    "exaleadcloudview",
    "feed",
    "fetcher",
    "firephp",
    "functionize",
    "grab",
    "headless",
    "httrack",
    "hubspot marketing grader",
    "hydra",
    "ibisbrowser",
    "infrawatch",
    "insight",
    "inspect",
    "iplabel",
    "java(?!;)",
    "library",
    "linkcheck",
    "mail\\.ru/",
    "manager",
    "measure",
    "neustar wpm",
    "node",
    "nutch",
    "offbyone",
    "onetrust",
    "optimize",
    "pageburst",
    "pagespeed",
    "parser",
    "perl",
    "phantomjs",
    "pingdom",
    "powermarks",
    "preview",
    "proxy",
    "ptst[ /]\\d",
    "retriever",
    "rexx;",
    "rigor",
    "rss\\b",
    "scrape",
    "server",
    "sogou",
    "sparkler/",
    "speedcurve",
    "spider",
    "splash",
    "statuscake",
    "supercleaner",
    "synapse",
    "synthetic",
    "tools",
    "torrent",
    "transcoder",
    "url",
    "validator",
    "virtuoso",
    "wappalyzer",
    "webglance",
    "webkit2png",
    "whatcms/",
    "xtate/"
];
// src/pattern.ts
var fullPattern = " daum[ /]| deusu/|(?:^|[^g])news(?!sapphire)|(?<! (?:channel/|google/))google(?!(app|/google| pixel))|(?<! cu)bots?(?:\\b|_)|(?<!(?:lib))http|(?<![hg]m)score|(?<!cam)scan|@[a-z][\\w-]+\\.|\\(\\)|\\.com\\b|\\btime/|\\||^<|^[\\w \\.\\-\\(?:\\):%]+(?:/v?\\d+(?:\\.\\d+)?(?:\\.\\d{1,10})*?)?(?:,|$)|^[^ ]{50,}$|^\\d+\\b|^\\w*search\\b|^\\w+/[\\w\\(\\)]*$|^active|^ad muncher|^amaya|^avsdevicesdk/|^azure|^biglotron|^bot|^bw/|^clamav[ /]|^client/|^cobweb/|^custom|^ddg[_-]android|^discourse|^dispatch/\\d|^downcast/|^duckduckgo|^email|^facebook|^getright/|^gozilla/|^hobbit|^hotzonu|^hwcdn/|^igetter/|^jeode/|^jetty/|^jigsaw|^microsoft bits|^movabletype|^mozilla/\\d\\.\\d\\s[\\w\\.-]+$|^mozilla/\\d\\.\\d\\s\\(compatible;?(?:\\s\\w+\\/\\d+\\.\\d+)?\\)$|^navermailapp|^netsurf|^offline|^openai/|^owler|^php|^postman|^python|^rank|^read|^reed|^rest|^rss|^snapchat|^space bison|^svn|^swcd |^taringa|^thumbor/|^track|^w3c|^webbandit/|^webcopier|^wget|^whatsapp|^wordpress|^xenu link sleuth|^yahoo|^yandex|^zdm/\\d|^zoom marketplace/|agent|analyzer|archive|ask jeeves/teoma|audit|bit\\.ly/|bluecoat drtr|browsex|burpcollaborator|capture|catch|check\\b|checker|chrome-lighthouse|chromeframe|classifier|cloudflare|convertify|crawl|cypress/|dareboost|datanyze|dejaclick|detect|dmbrowser|download|evc-batch/|exaleadcloudview|feed|fetcher|firephp|functionize|grab|headless|httrack|hubspot marketing grader|hydra|ibisbrowser|infrawatch|insight|inspect|iplabel|java(?!;)|library|linkcheck|mail\\.ru/|manager|measure|neustar wpm|node|nutch|offbyone|onetrust|optimize|pageburst|pagespeed|parser|perl|phantomjs|pingdom|powermarks|preview|proxy|ptst[ /]\\d|retriever|rexx;|rigor|rss\\b|scrape|server|sogou|sparkler/|speedcurve|spider|splash|statuscake|supercleaner|synapse|synthetic|tools|torrent|transcoder|url|validator|virtuoso|wappalyzer|webglance|webkit2png|whatcms/|xtate/";
// src/index.ts
var naivePattern = /bot|crawl|http|lighthouse|scan|search|spider/i;
var pattern;
function getPattern() {
    if (pattern instanceof RegExp) {
        return pattern;
    }
    try {
        pattern = new RegExp(fullPattern, "i");
    } catch (error) {
        pattern = naivePattern;
    }
    return pattern;
}
var list = patterns_default;
var isbotNaive = (userAgent)=>Boolean(userAgent) && naivePattern.test(userAgent);
function isbot(userAgent) {
    return Boolean(userAgent) && getPattern().test(userAgent);
}
var createIsbot = (customPattern)=>(userAgent)=>Boolean(userAgent) && customPattern.test(userAgent);
var createIsbotFromList = (list2)=>{
    const pattern2 = new RegExp(list2.join("|"), "i");
    return (userAgent)=>Boolean(userAgent) && pattern2.test(userAgent);
};
var isbotMatch = (userAgent)=>{
    var _a, _b;
    return (_b = (_a = userAgent == null ? undefined : userAgent.match(getPattern())) == null ? undefined : _a[0]) != null ? _b : null;
};
var isbotMatches = (userAgent)=>list.map((part)=>{
        var _a;
        return (_a = userAgent == null ? undefined : userAgent.match(new RegExp(part, "i"))) == null ? undefined : _a[0];
    }).filter(Boolean);
var isbotPattern = (userAgent)=>{
    var _a;
    return userAgent ? (_a = list.find((pattern2)=>new RegExp(pattern2, "i").test(userAgent))) != null ? _a : null : null;
};
var isbotPatterns = (userAgent)=>userAgent ? list.filter((pattern2)=>new RegExp(pattern2, "i").test(userAgent)) : [];

var index$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    createIsbot: createIsbot,
    createIsbotFromList: createIsbotFromList,
    getPattern: getPattern,
    isbot: isbot,
    isbotMatch: isbotMatch,
    isbotMatches: isbotMatches,
    isbotNaive: isbotNaive,
    isbotPattern: isbotPattern,
    isbotPatterns: isbotPatterns,
    list: list
});

var version = "1.9.1";
/**
 * Enum for types of bots.
 * Specific types of bots come first, followed by automation technologies.
 *
 * @readonly
 * @enum {string}
 */ var BotKind = {
    // Object is used instead of Typescript enum to avoid emitting IIFE which might be affected by further tree-shaking.
    // See example of compiled enums https://stackoverflow.com/q/47363996)
    Awesomium: 'awesomium',
    Cef: 'cef',
    CefSharp: 'cefsharp',
    CoachJS: 'coachjs',
    Electron: 'electron',
    FMiner: 'fminer',
    Geb: 'geb',
    NightmareJS: 'nightmarejs',
    Phantomas: 'phantomas',
    PhantomJS: 'phantomjs',
    Rhino: 'rhino',
    Selenium: 'selenium',
    Sequentum: 'sequentum',
    SlimerJS: 'slimerjs',
    WebDriverIO: 'webdriverio',
    WebDriver: 'webdriver',
    HeadlessChrome: 'headless_chrome',
    Unknown: 'unknown'
};
/**
 * Bot detection error.
 */ var BotdError = /** @class */ function(_super) {
    __extends(BotdError, _super);
    /**
     * Creates a new BotdError.
     *
     * @class
     */ function BotdError(state, message) {
        var _this = _super.call(this, message) || this;
        _this.state = state;
        _this.name = 'BotdError';
        Object.setPrototypeOf(_this, BotdError.prototype);
        return _this;
    }
    return BotdError;
}(Error);
function detect(components, detectors) {
    var detections = {};
    var finalDetection = {
        bot: false
    };
    for(var detectorName in detectors){
        var detector = detectors[detectorName];
        var detectorRes = detector(components);
        var detection = {
            bot: false
        };
        if (typeof detectorRes === 'string') {
            detection = {
                bot: true,
                botKind: detectorRes
            };
        } else if (detectorRes) {
            detection = {
                bot: true,
                botKind: BotKind.Unknown
            };
        }
        detections[detectorName] = detection;
        if (detection.bot) {
            finalDetection = detection;
        }
    }
    return [
        detections,
        finalDetection
    ];
}
function collect(sources) {
    return __awaiter(this, undefined, undefined, function() {
        var components, sourcesKeys;
        var _this = this;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    components = {};
                    sourcesKeys = Object.keys(sources);
                    return [
                        4 /*yield*/ ,
                        Promise.all(sourcesKeys.map(function(sourceKey) {
                            return __awaiter(_this, undefined, undefined, function() {
                                var res, _a, _b, error_1;
                                var _c;
                                return __generator(this, function(_d) {
                                    switch(_d.label){
                                        case 0:
                                            res = sources[sourceKey];
                                            _d.label = 1;
                                        case 1:
                                            _d.trys.push([
                                                1,
                                                3,
                                                ,
                                                4
                                            ]);
                                            _a = components;
                                            _b = sourceKey;
                                            _c = {};
                                            return [
                                                4 /*yield*/ ,
                                                res()
                                            ];
                                        case 2:
                                            _a[_b] = (_c.value = _d.sent(), _c.state = 0 /* State.Success */ , _c);
                                            return [
                                                3 /*break*/ ,
                                                4
                                            ];
                                        case 3:
                                            error_1 = _d.sent();
                                            if (error_1 instanceof BotdError) {
                                                components[sourceKey] = {
                                                    state: error_1.state,
                                                    error: "".concat(error_1.name, ": ").concat(error_1.message)
                                                };
                                            } else {
                                                components[sourceKey] = {
                                                    state: -3 /* State.UnexpectedBehaviour */ ,
                                                    error: error_1 instanceof Error ? "".concat(error_1.name, ": ").concat(error_1.message) : String(error_1)
                                                };
                                            }
                                            return [
                                                3 /*break*/ ,
                                                4
                                            ];
                                        case 4:
                                            return [
                                                2 /*return*/ 
                                            ];
                                    }
                                });
                            });
                        }))
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        components
                    ];
            }
        });
    });
}
function detectAppVersion(_a) {
    var appVersion = _a.appVersion;
    if (appVersion.state !== 0 /* State.Success */ ) return false;
    if (/headless/i.test(appVersion.value)) return BotKind.HeadlessChrome;
    if (/electron/i.test(appVersion.value)) return BotKind.Electron;
    if (/slimerjs/i.test(appVersion.value)) return BotKind.SlimerJS;
}
function arrayIncludes(arr, value) {
    return arr.indexOf(value) !== -1;
}
function strIncludes(str, value) {
    return str.indexOf(value) !== -1;
}
function arrayFind(array, callback) {
    if ('find' in array) return array.find(callback);
    for(var i = 0; i < array.length; i++){
        if (callback(array[i], i, array)) return array[i];
    }
    return undefined;
}
function getObjectProps(obj) {
    return Object.getOwnPropertyNames(obj);
}
function includes(arr) {
    var keys = [];
    for(var _i = 1; _i < arguments.length; _i++){
        keys[_i - 1] = arguments[_i];
    }
    var _loop_1 = function(key) {
        if (typeof key === 'string') {
            if (arrayIncludes(arr, key)) return {
                value: true
            };
        } else {
            var match = arrayFind(arr, function(value) {
                return key.test(value);
            });
            if (match != null) return {
                value: true
            };
        }
    };
    for(var _a = 0, keys_1 = keys; _a < keys_1.length; _a++){
        var key = keys_1[_a];
        var state_1 = _loop_1(key);
        if (typeof state_1 === "object") return state_1.value;
    }
    return false;
}
function countTruthy(values) {
    return values.reduce(function(sum, value) {
        return sum + (value ? 1 : 0);
    }, 0);
}
function detectDocumentAttributes(_a) {
    var documentElementKeys = _a.documentElementKeys;
    if (documentElementKeys.state !== 0 /* State.Success */ ) return false;
    if (includes(documentElementKeys.value, 'selenium', 'webdriver', 'driver')) {
        return BotKind.Selenium;
    }
}
function detectErrorTrace(_a) {
    var errorTrace = _a.errorTrace;
    if (errorTrace.state !== 0 /* State.Success */ ) return false;
    if (/PhantomJS/i.test(errorTrace.value)) return BotKind.PhantomJS;
}
function detectEvalLengthInconsistency(_a) {
    var evalLength = _a.evalLength, browserKind = _a.browserKind, browserEngineKind = _a.browserEngineKind;
    if (evalLength.state !== 0 /* State.Success */  || browserKind.state !== 0 /* State.Success */  || browserEngineKind.state !== 0 /* State.Success */ ) return;
    var length = evalLength.value;
    if (browserEngineKind.value === "unknown" /* BrowserEngineKind.Unknown */ ) return false;
    return length === 37 && !arrayIncludes([
        "webkit" /* BrowserEngineKind.Webkit */ ,
        "gecko" /* BrowserEngineKind.Gecko */ 
    ], browserEngineKind.value) || length === 39 && !arrayIncludes([
        "internet_explorer" /* BrowserKind.IE */ 
    ], browserKind.value) || length === 33 && !arrayIncludes([
        "chromium" /* BrowserEngineKind.Chromium */ 
    ], browserEngineKind.value);
}
function detectFunctionBind(_a) {
    var functionBind = _a.functionBind;
    if (functionBind.state === -2 /* State.NotFunction */ ) return BotKind.PhantomJS;
}
function detectLanguagesLengthInconsistency(_a) {
    var languages = _a.languages;
    if (languages.state === 0 /* State.Success */  && languages.value.length === 0) {
        return BotKind.HeadlessChrome;
    }
}
function detectMimeTypesConsistent(_a) {
    var mimeTypesConsistent = _a.mimeTypesConsistent;
    if (mimeTypesConsistent.state === 0 /* State.Success */  && !mimeTypesConsistent.value) {
        return BotKind.Unknown;
    }
}
function detectNotificationPermissions(_a) {
    var notificationPermissions = _a.notificationPermissions, browserKind = _a.browserKind;
    if (browserKind.state !== 0 /* State.Success */  || browserKind.value !== "chrome" /* BrowserKind.Chrome */ ) return false;
    if (notificationPermissions.state === 0 /* State.Success */  && notificationPermissions.value) {
        return BotKind.HeadlessChrome;
    }
}
function detectPluginsArray(_a) {
    var pluginsArray = _a.pluginsArray;
    if (pluginsArray.state === 0 /* State.Success */  && !pluginsArray.value) return BotKind.HeadlessChrome;
}
function detectPluginsLengthInconsistency(_a) {
    var pluginsLength = _a.pluginsLength, android = _a.android, browserKind = _a.browserKind, browserEngineKind = _a.browserEngineKind;
    if (pluginsLength.state !== 0 /* State.Success */  || android.state !== 0 /* State.Success */  || browserKind.state !== 0 /* State.Success */  || browserEngineKind.state !== 0 /* State.Success */ ) return;
    if (browserKind.value !== "chrome" /* BrowserKind.Chrome */  || android.value || browserEngineKind.value !== "chromium" /* BrowserEngineKind.Chromium */ ) return;
    if (pluginsLength.value === 0) return BotKind.HeadlessChrome;
}
function detectProcess(_a) {
    var _b;
    var process = _a.process;
    if (process.state !== 0 /* State.Success */ ) return false;
    if (process.value.type === 'renderer' || ((_b = process.value.versions) === null || _b === undefined ? undefined : _b.electron) != null) return BotKind.Electron;
}
function detectProductSub(_a) {
    var productSub = _a.productSub, browserKind = _a.browserKind;
    if (productSub.state !== 0 /* State.Success */  || browserKind.state !== 0 /* State.Success */ ) return false;
    if ((browserKind.value === "chrome" /* BrowserKind.Chrome */  || browserKind.value === "safari" /* BrowserKind.Safari */  || browserKind.value === "opera" /* BrowserKind.Opera */  || browserKind.value === "wechat" /* BrowserKind.WeChat */ ) && productSub.value !== '20030107') return BotKind.Unknown;
}
function detectUserAgent(_a) {
    var userAgent = _a.userAgent;
    if (userAgent.state !== 0 /* State.Success */ ) return false;
    if (/PhantomJS/i.test(userAgent.value)) return BotKind.PhantomJS;
    if (/Headless/i.test(userAgent.value)) return BotKind.HeadlessChrome;
    if (/Electron/i.test(userAgent.value)) return BotKind.Electron;
    if (/slimerjs/i.test(userAgent.value)) return BotKind.SlimerJS;
}
function detectWebDriver(_a) {
    var webDriver = _a.webDriver;
    if (webDriver.state === 0 /* State.Success */  && webDriver.value) return BotKind.HeadlessChrome;
}
function detectWebGL(_a) {
    var webGL = _a.webGL;
    if (webGL.state === 0 /* State.Success */ ) {
        var _b = webGL.value, vendor = _b.vendor, renderer = _b.renderer;
        if (vendor == 'Brian Paul' && renderer == 'Mesa OffScreen') {
            return BotKind.HeadlessChrome;
        }
    }
}
function detectWindowExternal(_a) {
    var windowExternal = _a.windowExternal;
    if (windowExternal.state !== 0 /* State.Success */ ) return false;
    if (/Sequentum/i.test(windowExternal.value)) return BotKind.Sequentum;
}
function detectWindowSize(_a) {
    var windowSize = _a.windowSize, documentFocus = _a.documentFocus;
    if (windowSize.state !== 0 /* State.Success */  || documentFocus.state !== 0 /* State.Success */ ) return false;
    var _b = windowSize.value, outerWidth = _b.outerWidth, outerHeight = _b.outerHeight;
    // When a page is opened in a new tab without focusing it right away, the window outer size is 0x0
    if (!documentFocus.value) return;
    if (outerWidth === 0 && outerHeight === 0) return BotKind.HeadlessChrome;
}
function detectDistinctiveProperties(_a) {
    var distinctiveProps = _a.distinctiveProps;
    if (distinctiveProps.state !== 0 /* State.Success */ ) return false;
    var value = distinctiveProps.value;
    var bot;
    for(bot in value)if (value[bot]) return bot;
}
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
var detectors = {
    detectAppVersion: detectAppVersion,
    detectDocumentAttributes: detectDocumentAttributes,
    detectErrorTrace: detectErrorTrace,
    detectEvalLengthInconsistency: detectEvalLengthInconsistency,
    detectFunctionBind: detectFunctionBind,
    detectLanguagesLengthInconsistency: detectLanguagesLengthInconsistency,
    detectNotificationPermissions: detectNotificationPermissions,
    detectPluginsArray: detectPluginsArray,
    detectPluginsLengthInconsistency: detectPluginsLengthInconsistency,
    detectProcess: detectProcess,
    detectUserAgent: detectUserAgent,
    detectWebDriver: detectWebDriver,
    detectWebGL: detectWebGL,
    detectWindowExternal: detectWindowExternal,
    detectWindowSize: detectWindowSize,
    detectMimeTypesConsistent: detectMimeTypesConsistent,
    detectProductSub: detectProductSub,
    detectDistinctiveProperties: detectDistinctiveProperties
};
function getAppVersion() {
    var appVersion = navigator.appVersion;
    if (appVersion == undefined) {
        throw new BotdError(-1 /* State.Undefined */ , 'navigator.appVersion is undefined');
    }
    return appVersion;
}
function getDocumentElementKeys() {
    if (document.documentElement === undefined) {
        throw new BotdError(-1 /* State.Undefined */ , 'document.documentElement is undefined');
    }
    var documentElement = document.documentElement;
    if (typeof documentElement.getAttributeNames !== 'function') {
        throw new BotdError(-2 /* State.NotFunction */ , 'document.documentElement.getAttributeNames is not a function');
    }
    return documentElement.getAttributeNames();
}
function getErrorTrace() {
    try {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        null[0]();
    } catch (error) {
        if (error instanceof Error && error['stack'] != null) {
            return error.stack.toString();
        }
    }
    throw new BotdError(-3 /* State.UnexpectedBehaviour */ , 'errorTrace signal unexpected behaviour');
}
function getEvalLength() {
    return eval.toString().length;
}
function getFunctionBind() {
    if (Function.prototype.bind === undefined) {
        throw new BotdError(-2 /* State.NotFunction */ , 'Function.prototype.bind is undefined');
    }
    return Function.prototype.bind.toString();
}
function getBrowserEngineKind() {
    var _a, _b;
    // Based on research in October 2020. Tested to detect Chromium 42-86.
    var w = window;
    var n = navigator;
    if (countTruthy([
        'webkitPersistentStorage' in n,
        'webkitTemporaryStorage' in n,
        n.vendor.indexOf('Google') === 0,
        'webkitResolveLocalFileSystemURL' in w,
        'BatteryManager' in w,
        'webkitMediaStream' in w,
        'webkitSpeechGrammar' in w
    ]) >= 5) {
        return "chromium" /* BrowserEngineKind.Chromium */ ;
    }
    if (countTruthy([
        'ApplePayError' in w,
        'CSSPrimitiveValue' in w,
        'Counter' in w,
        n.vendor.indexOf('Apple') === 0,
        'getStorageUpdates' in n,
        'WebKitMediaKeys' in w
    ]) >= 4) {
        return "webkit" /* BrowserEngineKind.Webkit */ ;
    }
    if (countTruthy([
        'buildID' in navigator,
        'MozAppearance' in ((_b = (_a = document.documentElement) === null || _a === undefined ? undefined : _a.style) !== null && _b !== undefined ? _b : {}),
        'onmozfullscreenchange' in w,
        'mozInnerScreenX' in w,
        'CSSMozDocumentRule' in w,
        'CanvasCaptureMediaStream' in w
    ]) >= 4) {
        return "gecko" /* BrowserEngineKind.Gecko */ ;
    }
    return "unknown" /* BrowserEngineKind.Unknown */ ;
}
function getBrowserKind() {
    var _a;
    var userAgent = (_a = navigator.userAgent) === null || _a === undefined ? undefined : _a.toLowerCase();
    if (strIncludes(userAgent, 'edg/')) {
        return "edge" /* BrowserKind.Edge */ ;
    } else if (strIncludes(userAgent, 'trident') || strIncludes(userAgent, 'msie')) {
        return "internet_explorer" /* BrowserKind.IE */ ;
    } else if (strIncludes(userAgent, 'wechat')) {
        return "wechat" /* BrowserKind.WeChat */ ;
    } else if (strIncludes(userAgent, 'firefox')) {
        return "firefox" /* BrowserKind.Firefox */ ;
    } else if (strIncludes(userAgent, 'opera') || strIncludes(userAgent, 'opr')) {
        return "opera" /* BrowserKind.Opera */ ;
    } else if (strIncludes(userAgent, 'chrome')) {
        return "chrome" /* BrowserKind.Chrome */ ;
    } else if (strIncludes(userAgent, 'safari')) {
        return "safari" /* BrowserKind.Safari */ ;
    } else {
        return "unknown" /* BrowserKind.Unknown */ ;
    }
}
// Source: https://github.com/fingerprintjs/fingerprintjs/blob/master/src/utils/browser.ts#L223
function isAndroid() {
    var browserEngineKind = getBrowserEngineKind();
    var isItChromium = browserEngineKind === "chromium" /* BrowserEngineKind.Chromium */ ;
    var isItGecko = browserEngineKind === "gecko" /* BrowserEngineKind.Gecko */ ;
    // Only 2 browser engines are presented on Android.
    // Actually, there is also Android 4.1 browser, but it's not worth detecting it at the moment.
    if (!isItChromium && !isItGecko) return false;
    var w = window;
    // Chrome removes all words "Android" from `navigator` when desktop version is requested
    // Firefox keeps "Android" in `navigator.appVersion` when desktop version is requested
    return countTruthy([
        'onorientationchange' in w,
        'orientation' in w,
        isItChromium && !('SharedWorker' in w),
        isItGecko && /android/i.test(navigator.appVersion)
    ]) >= 2;
}
function getDocumentFocus() {
    if (document.hasFocus === undefined) {
        return false;
    }
    return document.hasFocus();
}
function isChromium86OrNewer() {
    // Checked in Chrome 85 vs Chrome 86 both on desktop and Android
    var w = window;
    return countTruthy([
        !('MediaSettingsRange' in w),
        'RTCEncodedAudioFrame' in w,
        '' + w.Intl === '[object Intl]',
        '' + w.Reflect === '[object Reflect]'
    ]) >= 3;
}
function getLanguages() {
    var n = navigator;
    var result = [];
    var language = n.language || n.userLanguage || n.browserLanguage || n.systemLanguage;
    if (language !== undefined) {
        result.push([
            language
        ]);
    }
    if (Array.isArray(n.languages)) {
        var browserEngine = getBrowserEngineKind();
        // Starting from Chromium 86, there is only a single value in `navigator.language` in Incognito mode:
        // the value of `navigator.language`. Therefore, the value is ignored in this browser.
        if (!(browserEngine === "chromium" /* BrowserEngineKind.Chromium */  && isChromium86OrNewer())) {
            result.push(n.languages);
        }
    } else if (typeof n.languages === 'string') {
        var languages = n.languages;
        if (languages) {
            result.push(languages.split(','));
        }
    }
    return result;
}
function areMimeTypesConsistent() {
    if (navigator.mimeTypes === undefined) {
        throw new BotdError(-1 /* State.Undefined */ , 'navigator.mimeTypes is undefined');
    }
    var mimeTypes = navigator.mimeTypes;
    var isConsistent = Object.getPrototypeOf(mimeTypes) === MimeTypeArray.prototype;
    for(var i = 0; i < mimeTypes.length; i++){
        isConsistent && (isConsistent = Object.getPrototypeOf(mimeTypes[i]) === MimeType.prototype);
    }
    return isConsistent;
}
function getNotificationPermissions() {
    return __awaiter(this, undefined, undefined, function() {
        var permissions, permissionStatus;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (window.Notification === undefined) {
                        throw new BotdError(-1 /* State.Undefined */ , 'window.Notification is undefined');
                    }
                    if (navigator.permissions === undefined) {
                        throw new BotdError(-1 /* State.Undefined */ , 'navigator.permissions is undefined');
                    }
                    permissions = navigator.permissions;
                    if (typeof permissions.query !== 'function') {
                        throw new BotdError(-2 /* State.NotFunction */ , 'navigator.permissions.query is not a function');
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4 /*yield*/ ,
                        permissions.query({
                            name: 'notifications'
                        })
                    ];
                case 2:
                    permissionStatus = _a.sent();
                    return [
                        2 /*return*/ ,
                        window.Notification.permission === 'denied' && permissionStatus.state === 'prompt'
                    ];
                case 3:
                    _a.sent();
                    throw new BotdError(-3 /* State.UnexpectedBehaviour */ , 'notificationPermissions signal unexpected behaviour');
                case 4:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
function getPluginsArray() {
    if (navigator.plugins === undefined) {
        throw new BotdError(-1 /* State.Undefined */ , 'navigator.plugins is undefined');
    }
    if (window.PluginArray === undefined) {
        throw new BotdError(-1 /* State.Undefined */ , 'window.PluginArray is undefined');
    }
    return navigator.plugins instanceof PluginArray;
}
function getPluginsLength() {
    if (navigator.plugins === undefined) {
        throw new BotdError(-1 /* State.Undefined */ , 'navigator.plugins is undefined');
    }
    if (navigator.plugins.length === undefined) {
        throw new BotdError(-3 /* State.UnexpectedBehaviour */ , 'navigator.plugins.length is undefined');
    }
    return navigator.plugins.length;
}
function getProcess() {
    var process = window.process;
    var errorPrefix = 'window.process is';
    if (process === undefined) {
        throw new BotdError(-1 /* State.Undefined */ , "".concat(errorPrefix, " undefined"));
    }
    if (process && typeof process !== 'object') {
        throw new BotdError(-3 /* State.UnexpectedBehaviour */ , "".concat(errorPrefix, " not an object"));
    }
    return process;
}
function getProductSub() {
    var productSub = navigator.productSub;
    if (productSub === undefined) {
        throw new BotdError(-1 /* State.Undefined */ , 'navigator.productSub is undefined');
    }
    return productSub;
}
function getRTT() {
    if (navigator.connection === undefined) {
        throw new BotdError(-1 /* State.Undefined */ , 'navigator.connection is undefined');
    }
    if (navigator.connection.rtt === undefined) {
        throw new BotdError(-1 /* State.Undefined */ , 'navigator.connection.rtt is undefined');
    }
    return navigator.connection.rtt;
}
function getUserAgent() {
    return navigator.userAgent;
}
function getWebDriver() {
    if (navigator.webdriver == undefined) {
        throw new BotdError(-1 /* State.Undefined */ , 'navigator.webdriver is undefined');
    }
    return navigator.webdriver;
}
function getWebGL() {
    var canvasElement = document.createElement('canvas');
    if (typeof canvasElement.getContext !== 'function') {
        throw new BotdError(-2 /* State.NotFunction */ , 'HTMLCanvasElement.getContext is not a function');
    }
    var webGLContext = canvasElement.getContext('webgl');
    if (webGLContext === null) {
        throw new BotdError(-4 /* State.Null */ , 'WebGLRenderingContext is null');
    }
    if (typeof webGLContext.getParameter !== 'function') {
        throw new BotdError(-2 /* State.NotFunction */ , 'WebGLRenderingContext.getParameter is not a function');
    }
    var vendor = webGLContext.getParameter(webGLContext.VENDOR);
    var renderer = webGLContext.getParameter(webGLContext.RENDERER);
    return {
        vendor: vendor,
        renderer: renderer
    };
}
function getWindowExternal() {
    if (window.external === undefined) {
        throw new BotdError(-1 /* State.Undefined */ , 'window.external is undefined');
    }
    var external = window.external;
    if (typeof external.toString !== 'function') {
        throw new BotdError(-2 /* State.NotFunction */ , 'window.external.toString is not a function');
    }
    return external.toString();
}
function getWindowSize() {
    return {
        outerWidth: window.outerWidth,
        outerHeight: window.outerHeight,
        innerWidth: window.innerWidth,
        innerHeight: window.innerHeight
    };
}
function checkDistinctiveProperties() {
    var _a;
    // The order in the following list matters, because specific types of bots come first, followed by automation technologies.
    var distinctivePropsList = (_a = {}, _a[BotKind.Awesomium] = {
        window: [
            'awesomium'
        ]
    }, _a[BotKind.Cef] = {
        window: [
            'RunPerfTest'
        ]
    }, _a[BotKind.CefSharp] = {
        window: [
            'CefSharp'
        ]
    }, _a[BotKind.CoachJS] = {
        window: [
            'emit'
        ]
    }, _a[BotKind.FMiner] = {
        window: [
            'fmget_targets'
        ]
    }, _a[BotKind.Geb] = {
        window: [
            'geb'
        ]
    }, _a[BotKind.NightmareJS] = {
        window: [
            '__nightmare',
            'nightmare'
        ]
    }, _a[BotKind.Phantomas] = {
        window: [
            '__phantomas'
        ]
    }, _a[BotKind.PhantomJS] = {
        window: [
            'callPhantom',
            '_phantom'
        ]
    }, _a[BotKind.Rhino] = {
        window: [
            'spawn'
        ]
    }, _a[BotKind.Selenium] = {
        window: [
            '_Selenium_IDE_Recorder',
            '_selenium',
            'calledSelenium',
            /^([a-z]){3}_.*_(Array|Promise|Symbol)$/
        ],
        document: [
            '__selenium_evaluate',
            'selenium-evaluate',
            '__selenium_unwrapped'
        ]
    }, _a[BotKind.WebDriverIO] = {
        window: [
            'wdioElectron'
        ]
    }, _a[BotKind.WebDriver] = {
        window: [
            'webdriver',
            '__webdriverFunc',
            '__lastWatirAlert',
            '__lastWatirConfirm',
            '__lastWatirPrompt',
            '_WEBDRIVER_ELEM_CACHE',
            'ChromeDriverw'
        ],
        document: [
            '__webdriver_script_fn',
            '__driver_evaluate',
            '__webdriver_evaluate',
            '__fxdriver_evaluate',
            '__driver_unwrapped',
            '__webdriver_unwrapped',
            '__fxdriver_unwrapped',
            '__webdriver_script_fn',
            '__webdriver_script_func',
            '__webdriver_script_function',
            '$cdc_asdjflasutopfhvcZLmcf',
            '$cdc_asdjflasutopfhvcZLmcfl_',
            '$chrome_asyncScriptInfo',
            '__$webdriverAsyncExecutor'
        ]
    }, _a[BotKind.HeadlessChrome] = {
        window: [
            'domAutomation',
            'domAutomationController'
        ]
    }, _a);
    var botName;
    var result = {};
    var windowProps = getObjectProps(window);
    var documentProps = [];
    if (window.document !== undefined) documentProps = getObjectProps(window.document);
    for(botName in distinctivePropsList){
        var props = distinctivePropsList[botName];
        if (props !== undefined) {
            var windowContains = props.window === undefined ? false : includes.apply(undefined, __spreadArray([
                windowProps
            ], props.window, false));
            var documentContains = props.document === undefined || !documentProps.length ? false : includes.apply(undefined, __spreadArray([
                documentProps
            ], props.document, false));
            result[botName] = windowContains || documentContains;
        }
    }
    return result;
}
var sources = {
    android: isAndroid,
    browserKind: getBrowserKind,
    browserEngineKind: getBrowserEngineKind,
    documentFocus: getDocumentFocus,
    userAgent: getUserAgent,
    appVersion: getAppVersion,
    rtt: getRTT,
    windowSize: getWindowSize,
    pluginsLength: getPluginsLength,
    pluginsArray: getPluginsArray,
    errorTrace: getErrorTrace,
    productSub: getProductSub,
    windowExternal: getWindowExternal,
    mimeTypesConsistent: areMimeTypesConsistent,
    evalLength: getEvalLength,
    webGL: getWebGL,
    webDriver: getWebDriver,
    languages: getLanguages,
    notificationPermissions: getNotificationPermissions,
    documentElementKeys: getDocumentElementKeys,
    functionBind: getFunctionBind,
    process: getProcess,
    distinctiveProps: checkDistinctiveProperties
};
/**
 * Class representing a bot detector.
 *
 * @class
 * @implements {BotDetectorInterface}
 */ var BotDetector = /** @class */ function() {
    function BotDetector() {
        this.components = undefined;
        this.detections = undefined;
    }
    BotDetector.prototype.getComponents = function() {
        return this.components;
    };
    BotDetector.prototype.getDetections = function() {
        return this.detections;
    };
    /**
     * @inheritdoc
     */ BotDetector.prototype.detect = function() {
        if (this.components === undefined) {
            throw new Error("BotDetector.detect can't be called before BotDetector.collect");
        }
        var _a = detect(this.components, detectors), detections = _a[0], finalDetection = _a[1];
        this.detections = detections;
        return finalDetection;
    };
    /**
     * @inheritdoc
     */ BotDetector.prototype.collect = function() {
        return __awaiter(this, undefined, undefined, function() {
            var _a;
            return __generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _a = this;
                        return [
                            4 /*yield*/ ,
                            collect(sources)
                        ];
                    case 1:
                        _a.components = _b.sent();
                        return [
                            2 /*return*/ ,
                            this.components
                        ];
                }
            });
        });
    };
    return BotDetector;
}();
/**
 * Sends an unpersonalized AJAX request to collect installation statistics
 */ function monitor() {
    // The FingerprintJS CDN (https://github.com/fingerprintjs/cdn) replaces `window.__fpjs_d_m` with `true`
    if (window.__fpjs_d_m || Math.random() >= 0.001) {
        return;
    }
    try {
        var request = new XMLHttpRequest();
        request.open('get', "https://m1.openfpcdn.io/botd/v".concat(version, "/npm-monitoring"), true);
        request.send();
    } catch (error) {
        // console.error is ok here because it's an unexpected error handler
        // eslint-disable-next-line no-console
        console.error(error);
    }
}
function load(_a) {
    var _b = _a === undefined ? {} : _a, _c = _b.monitoring, monitoring = _c === undefined ? true : _c;
    return __awaiter(this, undefined, undefined, function() {
        var detector;
        return __generator(this, function(_d) {
            switch(_d.label){
                case 0:
                    if (monitoring) {
                        monitor();
                    }
                    detector = new BotDetector();
                    return [
                        4 /*yield*/ ,
                        detector.collect()
                    ];
                case 1:
                    _d.sent();
                    return [
                        2 /*return*/ ,
                        detector
                    ];
            }
        });
    });
}
var index = {
    load: load
};

var botd_esm = /*#__PURE__*/Object.freeze({
    __proto__: null,
    BotKind: BotKind,
    BotdError: BotdError,
    collect: collect,
    default: index,
    detect: detect,
    detectors: detectors,
    load: load,
    sources: sources
});

export { Beacons as AnalyticBeacons, analyticsQueue as AnalyticsQueue, BannerTypes, CLOUD_WATCH_SERVICES, CONTROL_TYPE_BUTTON, ControlName, DeviceService, DynamicModuleType, Environment, EventSubscription, ExperienceType, FixedHeightInteractionType, InlineObject, IntegrationType, LEGACY_ID_FALLBACK, LocationObject, Logger, NA_VALUE, PostMessageEvent, PostMessageService, REQUEST_PREFIX, Service$1 as Service, TagType, liveRampPayloadTags as Tags, TimedActionType, ULPMessageEvent, ULPMessageType, UNKNOWN_VALUE, UXType, asNumber, attachClickEvent, attachObserver, buildLiveRampTag, buttonControl, collectBrandIds, collectSkus, convertToISOString, createAppInitializedBeacon, createBaseBeacon, createBeaconCountry, createBiddingCallBidderBeacon, createBiddingHeaderLoadedBeacon, createBiddingResponseFailureBeacon, createBiddingResponseSuccessBeacon, createBiddingWonAuctionBeacon, createBlockedTrafficBeacon, createContainerViewableImpressionBeacon, createCustomContentIframe, createCustomContentWrapper, createDecisionRequestContextBeacon, createDecisionRequestMadeBeacon, createDecisionResponseFailureBeacon, createDecisionResponseSuccessBeacon, createExperienceMeasuredTestBeacon, createSlotImpressionExperienceBeacon, createUlpClickBeacon, createUlpClickSaveBeacon, createUlpEngagementBeacon, createUlpErrorBeacon, createUlpHeartbeatBeacon, createUlpItemImpressionBeacon, createUlpOpenBeacon, createUlpSeeAllDealsBeacon, createUlpViewBeacon, createV2BeaconGenerator, detectBot, detectBotByUa, detectBotWithBotd, environment, excludeAtomsByFilter, executeBeaconCallback, fetchContentFromS3, filterAtoms, findNearestStore, generateUUID, getBase, getBeaconPayload, getClientLocale, getClientParameters, getCountry, getCustomContent, getDecisionParameters, getEnvironment, getFlyerLegacyIds, getIntegrationType, getLanguageFromLocale, getPageUrl, getPlatform, getPostalCode, getQueryParamArray, getSchemaInfo, getSessionId, getShopperPlatformBase, getShopperPlatformCampaign, getSiteDomain, getTranslation, getULPSchemaId, getUlpItemType, getUserKey, getViewSize, i18n, injectCustomContent, isContentCodePresent, isFullScreenExperience, isInIframe, isIntersectionObserverSupported, isPricedAtom, logBotDetection, logError, logTrafficBlock, logUnknownError, normalizeLocale, processImpressionItemData, processItemData, resetPlatformCache, selectSectionsByIndex, setSessionId, translateDecisionToAvro, validHexColor, withFallbackDetails, withPayloadFallbackDetails };
//# sourceMappingURL=index.js.map
